export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Explicit DateTime scalar for debugging */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** JSON custom scalar type with Json typename */
  Json: any;
  /** Banking account number is a string of 5 to 17 alphanumeric values for representing an generic account number */
  AccountNumber: any;
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: any;
  /** The `Byte` scalar type represents byte value as a Buffer */
  Byte: any;
  /** A country code as defined by ISO 3166-1 alpha-2 */
  CountryCode: any;
  /** A country name (short name) as defined by ISO 3166-1 */
  CountryName: any;
  /** A field whose value conforms to the standard cuid format as specified in https://github.com/ericelliott/cuid#broken-down */
  Cuid: any;
  /** A field whose value is a Currency: https://en.wikipedia.org/wiki/ISO_4217. */
  Currency: any;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format
   * outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for
   * representation of dates and times using the Gregorian calendar.
   */
  Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the
   * `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO
   * 8601 standard for representation of dates and times using the Gregorian
   * calendar.This scalar is serialized to a string in ISO 8601 format and parsed
   * from a string in ISO 8601 format.
   */
  DateTimeISO: any;
  /** A field whose value conforms to the standard DeweyDecimal format as specified by the OCLC https://www.oclc.org/content/dam/oclc/dewey/resources/summaries/deweysummaries.pdf */
  DeweyDecimal: any;
  /** A field whose value conforms to the standard DID format as specified in did-core: https://www.w3.org/TR/did-core/. */
  DID: any;
  /** A string representing a duration conforming to the ISO8601 standard,
   * such as: P1W1DT13H23M34S
   * P is the duration designator (for period) placed at the start of the duration representation.
   * Y is the year designator that follows the value for the number of years.
   * M is the month designator that follows the value for the number of months.
   * W is the week designator that follows the value for the number of weeks.
   * D is the day designator that follows the value for the number of days.
   * T is the time designator that precedes the time components of the representation.
   * H is the hour designator that follows the value for the number of hours.
   * M is the minute designator that follows the value for the number of minutes.
   * S is the second designator that follows the value for the number of seconds.
   *
   * Note the time designator, T, that precedes the time value.
   *
   * Matches moment.js, Luxon and DateFns implementations
   * ,/. is valid for decimal places and +/- is a valid prefix
   */
  Duration: any;
  /** A field whose value conforms to the standard internet email address format as
   * specified in HTML Spec:
   * https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address.
   */
  EmailAddress: any;
  /** A GeoJSON object as defined by RFC 7946: https://datatracker.ietf.org/doc/html/rfc7946 */
  GeoJSON: any;
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  GUID: any;
  /** A field whose value is a hexadecimal: https://en.wikipedia.org/wiki/Hexadecimal. */
  Hexadecimal: any;
  /** A field whose value is a hex color code: https://en.wikipedia.org/wiki/Web_colors. */
  HexColorCode: any;
  /** A field whose value is a CSS HSL color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#hsl()_and_hsla(). */
  HSL: any;
  /** A field whose value is a CSS HSLA color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#hsl()_and_hsla(). */
  HSLA: any;
  /** A field whose value is an International Bank Account Number (IBAN):
   * https://en.wikipedia.org/wiki/International_Bank_Account_Number.
   */
  IBAN: any;
  /** A field whose value is either an IPv4 or IPv6 address: https://en.wikipedia.org/wiki/IP_address. */
  IP: any;
  /** A field whose value is an IPC Class Symbol within the International Patent
   * Classification System: https://www.wipo.int/classifications/ipc/en/
   */
  IPCPatent: any;
  /** A field whose value is a IPv4 address: https://en.wikipedia.org/wiki/IPv4. */
  IPv4: any;
  /** A field whose value is a IPv6 address: https://en.wikipedia.org/wiki/IPv6. */
  IPv6: any;
  /** A field whose value is a ISBN-10 or ISBN-13 number: https://en.wikipedia.org/wiki/International_Standard_Book_Number. */
  ISBN: any;
  /** A string representing a duration conforming to the ISO8601 standard,
   * such as: P1W1DT13H23M34S
   * P is the duration designator (for period) placed at the start of the duration representation.
   * Y is the year designator that follows the value for the number of years.
   * M is the month designator that follows the value for the number of months.
   * W is the week designator that follows the value for the number of weeks.
   * D is the day designator that follows the value for the number of days.
   * T is the time designator that precedes the time components of the representation.
   * H is the hour designator that follows the value for the number of hours.
   * M is the minute designator that follows the value for the number of minutes.
   * S is the second designator that follows the value for the number of seconds.
   *
   * Note the time designator, T, that precedes the time value.
   *
   * Matches moment.js, Luxon and DateFns implementations
   * ,/. is valid for decimal places and +/- is a valid prefix
   */
  ISO8601Duration: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** A field whose value is a JSON Web Token (JWT): https://jwt.io/introduction. */
  JWT: any;
  /** A field whose value is a valid decimal degrees latitude number (53.471): https://en.wikipedia.org/wiki/Latitude */
  Latitude: any;
  /** A field whose value conforms to the Library of Congress Subclass Format ttps://www.loc.gov/catdir/cpso/lcco/ */
  LCCSubclass: any;
  /** A local date string (i.e., with no associated timezone) in `YYYY-MM-DD` format, e.g. `2020-01-01`. */
  LocalDate: any;
  /** A local date-time string (i.e., with no associated timezone) in `YYYY-MM-DDTHH:mm:ss` format, e.g. `2020-01-01T00:00:00`. */
  LocalDateTime: any;
  /** The locale in the format of a BCP 47 (RFC 5646) standard string */
  Locale: any;
  /** A local time string (i.e., with no associated timezone) in 24-hr
   * `HH:mm[:ss[.SSS]]` format, e.g. `14:25` or `14:25:06` or `14:25:06.123`.  This
   * scalar is very similar to the `LocalTime`, with the only difference being that
   * `LocalEndTime` also allows `24:00` as a valid value to indicate midnight of the
   * following day.  This is useful when using the scalar to represent the exclusive
   * upper bound of a time block.
   */
  LocalEndTime: any;
  /** A local time string (i.e., with no associated timezone) in 24-hr
   * `HH:mm[:ss[.SSS]]` format, e.g. `14:25` or `14:25:06` or `14:25:06.123`.
   */
  LocalTime: any;
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  Long: any;
  /** A field whose value is a valid decimal degrees longitude number (53.471): https://en.wikipedia.org/wiki/Longitude */
  Longitude: any;
  /** A field whose value is a IEEE 802 48-bit MAC address: https://en.wikipedia.org/wiki/MAC_address. */
  MAC: any;
  /** Floats that will have a value less than 0. */
  NegativeFloat: any;
  /** Integers that will have a value less than 0. */
  NegativeInt: any;
  /** A string that cannot be passed as an empty value */
  NonEmptyString: any;
  /** Floats that will have a value of 0 or more. */
  NonNegativeFloat: any;
  /** Integers that will have a value of 0 or more. */
  NonNegativeInt: any;
  /** Floats that will have a value of 0 or less. */
  NonPositiveFloat: any;
  /** Integers that will have a value of 0 or less. */
  NonPositiveInt: any;
  /** A field whose value conforms with the standard mongodb object ID as described
   * here: https://docs.mongodb.com/manual/reference/method/ObjectId/#ObjectId.
   * Example: 5e5677d71bdc2ae76344968c
   */
  ObjectID: any;
  /** A field whose value conforms to the standard E.164 format as specified in:
   * https://en.wikipedia.org/wiki/E.164. Basically this is +17895551234.
   */
  PhoneNumber: any;
  /** A field whose value is a valid TCP port within the range of 0 to 65535:
   * https://en.wikipedia.org/wiki/Transmission_Control_Protocol#TCP_ports
   */
  Port: any;
  /** Floats that will have a value greater than 0. */
  PositiveFloat: any;
  /** Integers that will have a value greater than 0. */
  PositiveInt: any;
  /** A field whose value conforms to the standard postal code formats for United
   * States, United Kingdom, Germany, Canada, France, Italy, Australia, Netherlands,
   * Spain, Denmark, Sweden, Belgium, India, Austria, Portugal, Switzerland or Luxembourg.
   */
  PostalCode: any;
  /** A field whose value is a CSS RGB color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba(). */
  RGB: any;
  /** A field whose value is a CSS RGBA color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba(). */
  RGBA: any;
  /** In the US, an ABA routing transit number (`ABA RTN`) is a nine-digit code to identify the financial institution. */
  RoutingNumber: any;
  /** The `SafeInt` scalar type represents non-fractional signed whole numeric values
   * that are considered safe as defined by the ECMAScript specification.
   */
  SafeInt: any;
  /** A field whose value is a Semantic Version: https://semver.org */
  SemVer: any;
  /** A field whose value conforms to the standard personal number (personnummer) formats for Sweden */
  SESSN: any;
  /** A time string at UTC, such as 10:15:30Z, compliant with the `full-time` format
   * outlined in section 5.6 of the RFC 3339profile of the ISO 8601 standard for
   * representation of dates and times using the Gregorian calendar.
   */
  Time: any;
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: any;
  /** A field whose value exists in the standard IANA Time Zone Database: https://www.iana.org/time-zones */
  TimeZone: any;
  /** Floats that will have a value of 0 or more. */
  UnsignedFloat: any;
  /** Integers that will have a value of 0 or more. */
  UnsignedInt: any;
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: any;
  /** A currency string, such as $21.25 */
  USCurrency: any;
  /** A field whose value is a UTC Offset: https://en.wikipedia.org/wiki/List_of_tz_database_time_zones */
  UtcOffset: any;
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: any;
  /** Represents NULL values */
  Void: any;
};

export type AdminDashboard = {
  users?: Maybe<Scalars['Int']>;
  properties?: Maybe<Scalars['Int']>;
  events?: Maybe<Scalars['Int']>;
  accessEntries?: Maybe<Array<Maybe<Pass>>>;
};

export type Application = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  fields?: Maybe<Scalars['JSON']>;
  rejectReason?: Maybe<Scalars['String']>;
  document?: Maybe<File>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<Stakeholder>;
  propertyId?: Maybe<Scalars['String']>;
  property?: Maybe<Property>;
  status?: Maybe<ApplicationStatus>;
  type?: Maybe<ApplicationType>;
};

export type ApplicationCreateInput = {
  deletedAt?: Maybe<Scalars['DateTime']>;
  fields?: Maybe<Scalars['JSON']>;
  rejectReason?: Maybe<Scalars['String']>;
  document?: Maybe<FileCreateInput>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<StakeholderCreateInput>;
  propertyId?: Maybe<Scalars['String']>;
  property?: Maybe<PropertyCreateInput>;
  status?: Maybe<ApplicationStatus>;
  type?: Maybe<ApplicationType>;
};

export enum ApplicationOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  DeletedAtAsc = 'deletedAt_ASC',
  DeletedAtDesc = 'deletedAt_DESC',
  FieldsAsc = 'fields_ASC',
  FieldsDesc = 'fields_DESC',
  RejectReasonAsc = 'rejectReason_ASC',
  RejectReasonDesc = 'rejectReason_DESC',
  DocumentAsc = 'document_ASC',
  DocumentDesc = 'document_DESC',
  StakeholderIdAsc = 'stakeholderId_ASC',
  StakeholderIdDesc = 'stakeholderId_DESC',
  StakeholderAsc = 'stakeholder_ASC',
  StakeholderDesc = 'stakeholder_DESC',
  PropertyIdAsc = 'propertyId_ASC',
  PropertyIdDesc = 'propertyId_DESC',
  PropertyAsc = 'property_ASC',
  PropertyDesc = 'property_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
}

export enum ApplicationStatus {
  Approved = 'APPROVED',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  New = 'NEW',
  Preapproved = 'PREAPPROVED',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED',
}

export enum ApplicationType {
  BankDebitOrderInstruction = 'BANK_DEBIT_ORDER_INSTRUCTION',
  ContractorSecurityAccess = 'CONTRACTOR_SECURITY_ACCESS',
  SubcontractorSecurityAccess = 'SUBCONTRACTOR_SECURITY_ACCESS',
  FinanceDepartmentInformation = 'FINANCE_DEPARTMENT_INFORMATION',
  GolfMembership = 'GOLF_MEMBERSHIP',
  GymMembership = 'GYM_MEMBERSHIP',
  OwnerMainContractorSecurityAccessNomination = 'OWNER_MAIN_CONTRACTOR_SECURITY_ACCESS_NOMINATION',
  Pet = 'PET',
  Crimcheck = 'CRIMCHECK',
  ShuttleService = 'SHUTTLE_SERVICE',
  SpecialAccess = 'SPECIAL_ACCESS',
  ResidentsSecurityAccess = 'RESIDENTS_SECURITY_ACCESS',
  SecurityAccess = 'SECURITY_ACCESS',
  TennisMembership = 'TENNIS_MEMBERSHIP',
  VehicleSecurityAccess = 'VEHICLE_SECURITY_ACCESS',
}

export type ApplicationUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  fields?: Maybe<Scalars['JSON']>;
  rejectReason?: Maybe<Scalars['String']>;
  document?: Maybe<FileUpdateInput>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<StakeholderUpdateInput>;
  propertyId?: Maybe<Scalars['String']>;
  property?: Maybe<PropertyUpdateInput>;
  status?: Maybe<ApplicationStatus>;
  type?: Maybe<ApplicationType>;
};

export type ApplicationWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedAt_not?: Maybe<Scalars['DateTime']>;
  deletedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  deletedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  fields?: Maybe<Scalars['JSON']>;
  fields_not?: Maybe<Scalars['JSON']>;
  fields_in?: Maybe<Array<Scalars['JSON']>>;
  fields_not_in?: Maybe<Array<Scalars['JSON']>>;
  rejectReason?: Maybe<Scalars['String']>;
  rejectReason_not?: Maybe<Scalars['String']>;
  rejectReason_in?: Maybe<Array<Scalars['String']>>;
  rejectReason_not_in?: Maybe<Array<Scalars['String']>>;
  rejectReason_contains?: Maybe<Scalars['String']>;
  rejectReason_startsWith?: Maybe<Scalars['String']>;
  rejectReason_endsWith?: Maybe<Scalars['String']>;
  document?: Maybe<FileWhereInput>;
  document_not?: Maybe<FileWhereInput>;
  document_in?: Maybe<Array<FileWhereInput>>;
  document_not_in?: Maybe<Array<FileWhereInput>>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholderId_not?: Maybe<Scalars['String']>;
  stakeholderId_in?: Maybe<Array<Scalars['String']>>;
  stakeholderId_not_in?: Maybe<Array<Scalars['String']>>;
  stakeholderId_contains?: Maybe<Scalars['String']>;
  stakeholderId_startsWith?: Maybe<Scalars['String']>;
  stakeholderId_endsWith?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<StakeholderWhereInput>;
  stakeholder_not?: Maybe<StakeholderWhereInput>;
  stakeholder_in?: Maybe<Array<StakeholderWhereInput>>;
  stakeholder_not_in?: Maybe<Array<StakeholderWhereInput>>;
  propertyId?: Maybe<Scalars['String']>;
  propertyId_not?: Maybe<Scalars['String']>;
  propertyId_in?: Maybe<Array<Scalars['String']>>;
  propertyId_not_in?: Maybe<Array<Scalars['String']>>;
  propertyId_contains?: Maybe<Scalars['String']>;
  propertyId_startsWith?: Maybe<Scalars['String']>;
  propertyId_endsWith?: Maybe<Scalars['String']>;
  property?: Maybe<PropertyWhereInput>;
  property_not?: Maybe<PropertyWhereInput>;
  property_in?: Maybe<Array<PropertyWhereInput>>;
  property_not_in?: Maybe<Array<PropertyWhereInput>>;
  status?: Maybe<ApplicationStatus>;
  status_not?: Maybe<ApplicationStatus>;
  status_in?: Maybe<Array<ApplicationStatus>>;
  status_not_in?: Maybe<Array<ApplicationStatus>>;
  type?: Maybe<ApplicationType>;
  type_not?: Maybe<ApplicationType>;
  type_in?: Maybe<Array<ApplicationType>>;
  type_not_in?: Maybe<Array<ApplicationType>>;
  AND?: Maybe<Array<ApplicationWhereInput>>;
  OR?: Maybe<Array<ApplicationWhereInput>>;
  NOT?: Maybe<Array<ApplicationWhereInput>>;
};

export type Booking = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<BookingStatus>;
  note?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  stakeholders?: Maybe<Stakeholder>;
  passes?: Maybe<Pass>;
};

export type BookingCreateInput = {
  status?: Maybe<BookingStatus>;
  note?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  stakeholders?: Maybe<StakeholderCreateInput>;
  passes?: Maybe<PassCreateInput>;
};

export enum BookingOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  NoteAsc = 'note_ASC',
  NoteDesc = 'note_DESC',
  CostAsc = 'cost_ASC',
  CostDesc = 'cost_DESC',
  StartDateAsc = 'startDate_ASC',
  StartDateDesc = 'startDate_DESC',
  EndDateAsc = 'endDate_ASC',
  EndDateDesc = 'endDate_DESC',
  StakeholdersAsc = 'stakeholders_ASC',
  StakeholdersDesc = 'stakeholders_DESC',
  PassesAsc = 'passes_ASC',
  PassesDesc = 'passes_DESC',
}

export enum BookingStatus {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  Confirmed = 'CONFIRMED',
  Rejected = 'REJECTED',
}

export type BookingUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<BookingStatus>;
  note?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  stakeholders?: Maybe<StakeholderUpdateInput>;
  passes?: Maybe<PassUpdateInput>;
};

export type BookingWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  status?: Maybe<BookingStatus>;
  status_not?: Maybe<BookingStatus>;
  status_in?: Maybe<Array<BookingStatus>>;
  status_not_in?: Maybe<Array<BookingStatus>>;
  note?: Maybe<Scalars['String']>;
  note_not?: Maybe<Scalars['String']>;
  note_in?: Maybe<Array<Scalars['String']>>;
  note_not_in?: Maybe<Array<Scalars['String']>>;
  note_contains?: Maybe<Scalars['String']>;
  note_startsWith?: Maybe<Scalars['String']>;
  note_endsWith?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  cost_not?: Maybe<Scalars['Float']>;
  cost_in?: Maybe<Array<Scalars['Float']>>;
  cost_not_in?: Maybe<Array<Scalars['Float']>>;
  cost_lt?: Maybe<Scalars['Float']>;
  cost_lte?: Maybe<Scalars['Float']>;
  cost_gt?: Maybe<Scalars['Float']>;
  cost_gte?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['DateTime']>;
  startDate_not?: Maybe<Scalars['DateTime']>;
  startDate_in?: Maybe<Array<Scalars['DateTime']>>;
  startDate_not_in?: Maybe<Array<Scalars['DateTime']>>;
  endDate?: Maybe<Scalars['DateTime']>;
  endDate_not?: Maybe<Scalars['DateTime']>;
  endDate_in?: Maybe<Array<Scalars['DateTime']>>;
  endDate_not_in?: Maybe<Array<Scalars['DateTime']>>;
  stakeholders?: Maybe<StakeholderWhereInput>;
  stakeholders_not?: Maybe<StakeholderWhereInput>;
  stakeholders_in?: Maybe<Array<StakeholderWhereInput>>;
  stakeholders_not_in?: Maybe<Array<StakeholderWhereInput>>;
  passes?: Maybe<PassWhereInput>;
  passes_not?: Maybe<PassWhereInput>;
  passes_in?: Maybe<Array<PassWhereInput>>;
  passes_not_in?: Maybe<Array<PassWhereInput>>;
  AND?: Maybe<Array<BookingWhereInput>>;
  OR?: Maybe<Array<BookingWhereInput>>;
  NOT?: Maybe<Array<BookingWhereInput>>;
};

export type CalendarEvent = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  status?: Maybe<CalendarEventStatus>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  image?: Maybe<Scalars['String']>;
};

export type CalendarEventCreateInput = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  status?: Maybe<CalendarEventStatus>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  image?: Maybe<Scalars['String']>;
};

export enum CalendarEventOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  StartDateAsc = 'startDate_ASC',
  StartDateDesc = 'startDate_DESC',
  EndDateAsc = 'endDate_ASC',
  EndDateDesc = 'endDate_DESC',
  ImageAsc = 'image_ASC',
  ImageDesc = 'image_DESC',
}

export enum CalendarEventStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Archived = 'ARCHIVED',
}

export type CalendarEventUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  status?: Maybe<CalendarEventStatus>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  image?: Maybe<Scalars['String']>;
};

export type CalendarEventWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Scalars['String']>>;
  title_not_in?: Maybe<Array<Scalars['String']>>;
  title_contains?: Maybe<Scalars['String']>;
  title_startsWith?: Maybe<Scalars['String']>;
  title_endsWith?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  description_not?: Maybe<Scalars['String']>;
  description_in?: Maybe<Array<Scalars['String']>>;
  description_not_in?: Maybe<Array<Scalars['String']>>;
  description_contains?: Maybe<Scalars['String']>;
  description_startsWith?: Maybe<Scalars['String']>;
  description_endsWith?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  location_not?: Maybe<Scalars['String']>;
  location_in?: Maybe<Array<Scalars['String']>>;
  location_not_in?: Maybe<Array<Scalars['String']>>;
  location_contains?: Maybe<Scalars['String']>;
  location_startsWith?: Maybe<Scalars['String']>;
  location_endsWith?: Maybe<Scalars['String']>;
  status?: Maybe<CalendarEventStatus>;
  status_not?: Maybe<CalendarEventStatus>;
  status_in?: Maybe<Array<CalendarEventStatus>>;
  status_not_in?: Maybe<Array<CalendarEventStatus>>;
  startDate?: Maybe<Scalars['DateTime']>;
  startDate_not?: Maybe<Scalars['DateTime']>;
  startDate_in?: Maybe<Array<Scalars['DateTime']>>;
  startDate_not_in?: Maybe<Array<Scalars['DateTime']>>;
  endDate?: Maybe<Scalars['DateTime']>;
  endDate_not?: Maybe<Scalars['DateTime']>;
  endDate_in?: Maybe<Array<Scalars['DateTime']>>;
  endDate_not_in?: Maybe<Array<Scalars['DateTime']>>;
  image?: Maybe<Scalars['String']>;
  image_not?: Maybe<Scalars['String']>;
  image_in?: Maybe<Array<Scalars['String']>>;
  image_not_in?: Maybe<Array<Scalars['String']>>;
  image_contains?: Maybe<Scalars['String']>;
  image_startsWith?: Maybe<Scalars['String']>;
  image_endsWith?: Maybe<Scalars['String']>;
  AND?: Maybe<Array<CalendarEventWhereInput>>;
  OR?: Maybe<Array<CalendarEventWhereInput>>;
  NOT?: Maybe<Array<CalendarEventWhereInput>>;
};

export type Classified = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  viewTotal?: Maybe<Scalars['Int']>;
  status?: Maybe<ClassifiedStatus>;
  approvalDate?: Maybe<Scalars['DateTime']>;
  rejectReason?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  category?: Maybe<ClassifiedCategory>;
  subCategoryId?: Maybe<Scalars['String']>;
  subCategory?: Maybe<ClassifiedSubCategory>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<Stakeholder>;
  userId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  classifiedId?: Maybe<Scalars['String']>;
  classified?: Maybe<Classified>;
  relatedTo?: Maybe<Classified>;
  images?: Maybe<File>;
};

export type ClassifiedCategory = {
  id?: Maybe<Scalars['String']>;
  classifieds?: Maybe<Classified>;
};

export type ClassifiedCategoryCreateInput = {
  classifieds?: Maybe<ClassifiedCreateInput>;
};

export enum ClassifiedCategoryOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ClassifiedsAsc = 'classifieds_ASC',
  ClassifiedsDesc = 'classifieds_DESC',
}

export type ClassifiedCategoryUpdateInput = {
  id?: Maybe<Scalars['String']>;
  classifieds?: Maybe<ClassifiedUpdateInput>;
};

export type ClassifiedCategoryWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  classifieds?: Maybe<ClassifiedWhereInput>;
  classifieds_not?: Maybe<ClassifiedWhereInput>;
  classifieds_in?: Maybe<Array<ClassifiedWhereInput>>;
  classifieds_not_in?: Maybe<Array<ClassifiedWhereInput>>;
  AND?: Maybe<Array<ClassifiedCategoryWhereInput>>;
  OR?: Maybe<Array<ClassifiedCategoryWhereInput>>;
  NOT?: Maybe<Array<ClassifiedCategoryWhereInput>>;
};

export type ClassifiedCreateInput = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  viewTotal?: Maybe<Scalars['Int']>;
  status?: Maybe<ClassifiedStatus>;
  approvalDate?: Maybe<Scalars['DateTime']>;
  rejectReason?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  category?: Maybe<ClassifiedCategoryCreateInput>;
  subCategoryId?: Maybe<Scalars['String']>;
  subCategory?: Maybe<ClassifiedSubCategoryCreateInput>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<StakeholderCreateInput>;
  userId?: Maybe<Scalars['String']>;
  user?: Maybe<UserCreateInput>;
  classifiedId?: Maybe<Scalars['String']>;
  classified?: Maybe<Scalars['String']>;
  relatedTo?: Maybe<Scalars['String']>;
  images?: Maybe<FileCreateInput>;
};

export enum ClassifiedOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  PriceAsc = 'price_ASC',
  PriceDesc = 'price_DESC',
  ViewTotalAsc = 'viewTotal_ASC',
  ViewTotalDesc = 'viewTotal_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  ApprovalDateAsc = 'approvalDate_ASC',
  ApprovalDateDesc = 'approvalDate_DESC',
  RejectReasonAsc = 'rejectReason_ASC',
  RejectReasonDesc = 'rejectReason_DESC',
  CategoryIdAsc = 'categoryId_ASC',
  CategoryIdDesc = 'categoryId_DESC',
  CategoryAsc = 'category_ASC',
  CategoryDesc = 'category_DESC',
  SubCategoryIdAsc = 'subCategoryId_ASC',
  SubCategoryIdDesc = 'subCategoryId_DESC',
  SubCategoryAsc = 'subCategory_ASC',
  SubCategoryDesc = 'subCategory_DESC',
  StakeholderIdAsc = 'stakeholderId_ASC',
  StakeholderIdDesc = 'stakeholderId_DESC',
  StakeholderAsc = 'stakeholder_ASC',
  StakeholderDesc = 'stakeholder_DESC',
  UserIdAsc = 'userId_ASC',
  UserIdDesc = 'userId_DESC',
  UserAsc = 'user_ASC',
  UserDesc = 'user_DESC',
  ClassifiedIdAsc = 'classifiedId_ASC',
  ClassifiedIdDesc = 'classifiedId_DESC',
  ClassifiedAsc = 'classified_ASC',
  ClassifiedDesc = 'classified_DESC',
  RelatedToAsc = 'relatedTo_ASC',
  RelatedToDesc = 'relatedTo_DESC',
  ImagesAsc = 'images_ASC',
  ImagesDesc = 'images_DESC',
}

export enum ClassifiedStatus {
  Draft = 'DRAFT',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Approved = 'APPROVED',
  Sold = 'SOLD',
  Archived = 'ARCHIVED',
}

export type ClassifiedSubCategory = {
  id?: Maybe<Scalars['String']>;
  classifieds?: Maybe<Classified>;
};

export type ClassifiedSubCategoryCreateInput = {
  classifieds?: Maybe<ClassifiedCreateInput>;
};

export enum ClassifiedSubCategoryOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ClassifiedsAsc = 'classifieds_ASC',
  ClassifiedsDesc = 'classifieds_DESC',
}

export type ClassifiedSubCategoryUpdateInput = {
  id?: Maybe<Scalars['String']>;
  classifieds?: Maybe<ClassifiedUpdateInput>;
};

export type ClassifiedSubCategoryWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  classifieds?: Maybe<ClassifiedWhereInput>;
  classifieds_not?: Maybe<ClassifiedWhereInput>;
  classifieds_in?: Maybe<Array<ClassifiedWhereInput>>;
  classifieds_not_in?: Maybe<Array<ClassifiedWhereInput>>;
  AND?: Maybe<Array<ClassifiedSubCategoryWhereInput>>;
  OR?: Maybe<Array<ClassifiedSubCategoryWhereInput>>;
  NOT?: Maybe<Array<ClassifiedSubCategoryWhereInput>>;
};

export type ClassifiedUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  viewTotal?: Maybe<Scalars['Int']>;
  status?: Maybe<ClassifiedStatus>;
  approvalDate?: Maybe<Scalars['DateTime']>;
  rejectReason?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  category?: Maybe<ClassifiedCategoryUpdateInput>;
  subCategoryId?: Maybe<Scalars['String']>;
  subCategory?: Maybe<ClassifiedSubCategoryUpdateInput>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<StakeholderUpdateInput>;
  userId?: Maybe<Scalars['String']>;
  user?: Maybe<UserUpdateInput>;
  classifiedId?: Maybe<Scalars['String']>;
  classified?: Maybe<Scalars['String']>;
  relatedTo?: Maybe<Scalars['String']>;
  images?: Maybe<FileUpdateInput>;
};

export type ClassifiedWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Scalars['String']>>;
  title_not_in?: Maybe<Array<Scalars['String']>>;
  title_contains?: Maybe<Scalars['String']>;
  title_startsWith?: Maybe<Scalars['String']>;
  title_endsWith?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  description_not?: Maybe<Scalars['String']>;
  description_in?: Maybe<Array<Scalars['String']>>;
  description_not_in?: Maybe<Array<Scalars['String']>>;
  description_contains?: Maybe<Scalars['String']>;
  description_startsWith?: Maybe<Scalars['String']>;
  description_endsWith?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  price_not?: Maybe<Scalars['Float']>;
  price_in?: Maybe<Array<Scalars['Float']>>;
  price_not_in?: Maybe<Array<Scalars['Float']>>;
  price_lt?: Maybe<Scalars['Float']>;
  price_lte?: Maybe<Scalars['Float']>;
  price_gt?: Maybe<Scalars['Float']>;
  price_gte?: Maybe<Scalars['Float']>;
  viewTotal?: Maybe<Scalars['Int']>;
  viewTotal_not?: Maybe<Scalars['Int']>;
  viewTotal_in?: Maybe<Array<Scalars['Int']>>;
  viewTotal_not_in?: Maybe<Array<Scalars['Int']>>;
  viewTotal_lt?: Maybe<Scalars['Int']>;
  viewTotal_lte?: Maybe<Scalars['Int']>;
  viewTotal_gt?: Maybe<Scalars['Int']>;
  viewTotal_gte?: Maybe<Scalars['Int']>;
  status?: Maybe<ClassifiedStatus>;
  status_not?: Maybe<ClassifiedStatus>;
  status_in?: Maybe<Array<ClassifiedStatus>>;
  status_not_in?: Maybe<Array<ClassifiedStatus>>;
  approvalDate?: Maybe<Scalars['DateTime']>;
  approvalDate_not?: Maybe<Scalars['DateTime']>;
  approvalDate_in?: Maybe<Array<Scalars['DateTime']>>;
  approvalDate_not_in?: Maybe<Array<Scalars['DateTime']>>;
  rejectReason?: Maybe<Scalars['String']>;
  rejectReason_not?: Maybe<Scalars['String']>;
  rejectReason_in?: Maybe<Array<Scalars['String']>>;
  rejectReason_not_in?: Maybe<Array<Scalars['String']>>;
  rejectReason_contains?: Maybe<Scalars['String']>;
  rejectReason_startsWith?: Maybe<Scalars['String']>;
  rejectReason_endsWith?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  categoryId_not?: Maybe<Scalars['String']>;
  categoryId_in?: Maybe<Array<Scalars['String']>>;
  categoryId_not_in?: Maybe<Array<Scalars['String']>>;
  categoryId_contains?: Maybe<Scalars['String']>;
  categoryId_startsWith?: Maybe<Scalars['String']>;
  categoryId_endsWith?: Maybe<Scalars['String']>;
  category?: Maybe<ClassifiedCategoryWhereInput>;
  category_not?: Maybe<ClassifiedCategoryWhereInput>;
  category_in?: Maybe<Array<ClassifiedCategoryWhereInput>>;
  category_not_in?: Maybe<Array<ClassifiedCategoryWhereInput>>;
  subCategoryId?: Maybe<Scalars['String']>;
  subCategoryId_not?: Maybe<Scalars['String']>;
  subCategoryId_in?: Maybe<Array<Scalars['String']>>;
  subCategoryId_not_in?: Maybe<Array<Scalars['String']>>;
  subCategoryId_contains?: Maybe<Scalars['String']>;
  subCategoryId_startsWith?: Maybe<Scalars['String']>;
  subCategoryId_endsWith?: Maybe<Scalars['String']>;
  subCategory?: Maybe<ClassifiedSubCategoryWhereInput>;
  subCategory_not?: Maybe<ClassifiedSubCategoryWhereInput>;
  subCategory_in?: Maybe<Array<ClassifiedSubCategoryWhereInput>>;
  subCategory_not_in?: Maybe<Array<ClassifiedSubCategoryWhereInput>>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholderId_not?: Maybe<Scalars['String']>;
  stakeholderId_in?: Maybe<Array<Scalars['String']>>;
  stakeholderId_not_in?: Maybe<Array<Scalars['String']>>;
  stakeholderId_contains?: Maybe<Scalars['String']>;
  stakeholderId_startsWith?: Maybe<Scalars['String']>;
  stakeholderId_endsWith?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<StakeholderWhereInput>;
  stakeholder_not?: Maybe<StakeholderWhereInput>;
  stakeholder_in?: Maybe<Array<StakeholderWhereInput>>;
  stakeholder_not_in?: Maybe<Array<StakeholderWhereInput>>;
  userId?: Maybe<Scalars['String']>;
  userId_not?: Maybe<Scalars['String']>;
  userId_in?: Maybe<Array<Scalars['String']>>;
  userId_not_in?: Maybe<Array<Scalars['String']>>;
  userId_contains?: Maybe<Scalars['String']>;
  userId_startsWith?: Maybe<Scalars['String']>;
  userId_endsWith?: Maybe<Scalars['String']>;
  user?: Maybe<UserWhereInput>;
  user_not?: Maybe<UserWhereInput>;
  user_in?: Maybe<Array<UserWhereInput>>;
  user_not_in?: Maybe<Array<UserWhereInput>>;
  classifiedId?: Maybe<Scalars['String']>;
  classifiedId_not?: Maybe<Scalars['String']>;
  classifiedId_in?: Maybe<Array<Scalars['String']>>;
  classifiedId_not_in?: Maybe<Array<Scalars['String']>>;
  classifiedId_contains?: Maybe<Scalars['String']>;
  classifiedId_startsWith?: Maybe<Scalars['String']>;
  classifiedId_endsWith?: Maybe<Scalars['String']>;
  classified?: Maybe<Scalars['String']>;
  classified_not?: Maybe<Scalars['String']>;
  classified_in?: Maybe<Array<Scalars['String']>>;
  classified_not_in?: Maybe<Array<Scalars['String']>>;
  classified_contains?: Maybe<Scalars['String']>;
  classified_startsWith?: Maybe<Scalars['String']>;
  classified_endsWith?: Maybe<Scalars['String']>;
  relatedTo?: Maybe<Scalars['String']>;
  relatedTo_not?: Maybe<Scalars['String']>;
  relatedTo_in?: Maybe<Array<Scalars['String']>>;
  relatedTo_not_in?: Maybe<Array<Scalars['String']>>;
  relatedTo_contains?: Maybe<Scalars['String']>;
  relatedTo_startsWith?: Maybe<Scalars['String']>;
  relatedTo_endsWith?: Maybe<Scalars['String']>;
  images?: Maybe<FileWhereInput>;
  images_not?: Maybe<FileWhereInput>;
  images_in?: Maybe<Array<FileWhereInput>>;
  images_not_in?: Maybe<Array<FileWhereInput>>;
  AND?: Maybe<Array<ClassifiedWhereInput>>;
  OR?: Maybe<Array<ClassifiedWhereInput>>;
  NOT?: Maybe<Array<ClassifiedWhereInput>>;
};

export type Club = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  admin?: Maybe<Scalars['String']>;
  status?: Maybe<ClubStatus>;
  imageId?: Maybe<Scalars['String']>;
  image?: Maybe<File>;
  gallery?: Maybe<Scalars['JSON']>;
  members?: Maybe<Stakeholder>;
  comments?: Maybe<Comment>;
};

export type ClubCreateInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  admin?: Maybe<Scalars['String']>;
  status?: Maybe<ClubStatus>;
  imageId?: Maybe<Scalars['String']>;
  image?: Maybe<FileCreateInput>;
  gallery?: Maybe<Scalars['JSON']>;
  members?: Maybe<StakeholderCreateInput>;
  comments?: Maybe<CommentCreateInput>;
};

export enum ClubOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  CategoryAsc = 'category_ASC',
  CategoryDesc = 'category_DESC',
  AdminAsc = 'admin_ASC',
  AdminDesc = 'admin_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  ImageIdAsc = 'imageId_ASC',
  ImageIdDesc = 'imageId_DESC',
  ImageAsc = 'image_ASC',
  ImageDesc = 'image_DESC',
  GalleryAsc = 'gallery_ASC',
  GalleryDesc = 'gallery_DESC',
  MembersAsc = 'members_ASC',
  MembersDesc = 'members_DESC',
  CommentsAsc = 'comments_ASC',
  CommentsDesc = 'comments_DESC',
}

export enum ClubStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

export type ClubUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  admin?: Maybe<Scalars['String']>;
  status?: Maybe<ClubStatus>;
  imageId?: Maybe<Scalars['String']>;
  image?: Maybe<FileUpdateInput>;
  gallery?: Maybe<Scalars['JSON']>;
  members?: Maybe<StakeholderUpdateInput>;
  comments?: Maybe<CommentUpdateInput>;
};

export type ClubWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  name?: Maybe<Scalars['String']>;
  name_not?: Maybe<Scalars['String']>;
  name_in?: Maybe<Array<Scalars['String']>>;
  name_not_in?: Maybe<Array<Scalars['String']>>;
  name_contains?: Maybe<Scalars['String']>;
  name_startsWith?: Maybe<Scalars['String']>;
  name_endsWith?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  description_not?: Maybe<Scalars['String']>;
  description_in?: Maybe<Array<Scalars['String']>>;
  description_not_in?: Maybe<Array<Scalars['String']>>;
  description_contains?: Maybe<Scalars['String']>;
  description_startsWith?: Maybe<Scalars['String']>;
  description_endsWith?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  category_not?: Maybe<Scalars['String']>;
  category_in?: Maybe<Array<Scalars['String']>>;
  category_not_in?: Maybe<Array<Scalars['String']>>;
  category_contains?: Maybe<Scalars['String']>;
  category_startsWith?: Maybe<Scalars['String']>;
  category_endsWith?: Maybe<Scalars['String']>;
  admin?: Maybe<Scalars['String']>;
  admin_not?: Maybe<Scalars['String']>;
  admin_in?: Maybe<Array<Scalars['String']>>;
  admin_not_in?: Maybe<Array<Scalars['String']>>;
  admin_contains?: Maybe<Scalars['String']>;
  admin_startsWith?: Maybe<Scalars['String']>;
  admin_endsWith?: Maybe<Scalars['String']>;
  status?: Maybe<ClubStatus>;
  status_not?: Maybe<ClubStatus>;
  status_in?: Maybe<Array<ClubStatus>>;
  status_not_in?: Maybe<Array<ClubStatus>>;
  imageId?: Maybe<Scalars['String']>;
  imageId_not?: Maybe<Scalars['String']>;
  imageId_in?: Maybe<Array<Scalars['String']>>;
  imageId_not_in?: Maybe<Array<Scalars['String']>>;
  imageId_contains?: Maybe<Scalars['String']>;
  imageId_startsWith?: Maybe<Scalars['String']>;
  imageId_endsWith?: Maybe<Scalars['String']>;
  image?: Maybe<FileWhereInput>;
  image_not?: Maybe<FileWhereInput>;
  image_in?: Maybe<Array<FileWhereInput>>;
  image_not_in?: Maybe<Array<FileWhereInput>>;
  gallery?: Maybe<Scalars['JSON']>;
  gallery_not?: Maybe<Scalars['JSON']>;
  gallery_in?: Maybe<Array<Scalars['JSON']>>;
  gallery_not_in?: Maybe<Array<Scalars['JSON']>>;
  members?: Maybe<StakeholderWhereInput>;
  members_not?: Maybe<StakeholderWhereInput>;
  members_in?: Maybe<Array<StakeholderWhereInput>>;
  members_not_in?: Maybe<Array<StakeholderWhereInput>>;
  comments?: Maybe<CommentWhereInput>;
  comments_not?: Maybe<CommentWhereInput>;
  comments_in?: Maybe<Array<CommentWhereInput>>;
  comments_not_in?: Maybe<Array<CommentWhereInput>>;
  AND?: Maybe<Array<ClubWhereInput>>;
  OR?: Maybe<Array<ClubWhereInput>>;
  NOT?: Maybe<Array<ClubWhereInput>>;
};

export type Comment = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  body?: Maybe<Scalars['String']>;
  status?: Maybe<CommentStatus>;
  clubId?: Maybe<Scalars['String']>;
  club?: Maybe<Club>;
  authorId?: Maybe<Scalars['String']>;
  author?: Maybe<Stakeholder>;
  adminId?: Maybe<Scalars['String']>;
  admin?: Maybe<User>;
};

export type CommentCreateInput = {
  body?: Maybe<Scalars['String']>;
  status?: Maybe<CommentStatus>;
  clubId?: Maybe<Scalars['String']>;
  club?: Maybe<ClubCreateInput>;
  authorId?: Maybe<Scalars['String']>;
  author?: Maybe<StakeholderCreateInput>;
  adminId?: Maybe<Scalars['String']>;
  admin?: Maybe<UserCreateInput>;
};

export enum CommentOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  BodyAsc = 'body_ASC',
  BodyDesc = 'body_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  ClubIdAsc = 'clubId_ASC',
  ClubIdDesc = 'clubId_DESC',
  ClubAsc = 'club_ASC',
  ClubDesc = 'club_DESC',
  AuthorIdAsc = 'authorId_ASC',
  AuthorIdDesc = 'authorId_DESC',
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  AdminIdAsc = 'adminId_ASC',
  AdminIdDesc = 'adminId_DESC',
  AdminAsc = 'admin_ASC',
  AdminDesc = 'admin_DESC',
}

export enum CommentStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

export type CommentUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  body?: Maybe<Scalars['String']>;
  status?: Maybe<CommentStatus>;
  clubId?: Maybe<Scalars['String']>;
  club?: Maybe<ClubUpdateInput>;
  authorId?: Maybe<Scalars['String']>;
  author?: Maybe<StakeholderUpdateInput>;
  adminId?: Maybe<Scalars['String']>;
  admin?: Maybe<UserUpdateInput>;
};

export type CommentWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  body?: Maybe<Scalars['String']>;
  body_not?: Maybe<Scalars['String']>;
  body_in?: Maybe<Array<Scalars['String']>>;
  body_not_in?: Maybe<Array<Scalars['String']>>;
  body_contains?: Maybe<Scalars['String']>;
  body_startsWith?: Maybe<Scalars['String']>;
  body_endsWith?: Maybe<Scalars['String']>;
  status?: Maybe<CommentStatus>;
  status_not?: Maybe<CommentStatus>;
  status_in?: Maybe<Array<CommentStatus>>;
  status_not_in?: Maybe<Array<CommentStatus>>;
  clubId?: Maybe<Scalars['String']>;
  clubId_not?: Maybe<Scalars['String']>;
  clubId_in?: Maybe<Array<Scalars['String']>>;
  clubId_not_in?: Maybe<Array<Scalars['String']>>;
  clubId_contains?: Maybe<Scalars['String']>;
  clubId_startsWith?: Maybe<Scalars['String']>;
  clubId_endsWith?: Maybe<Scalars['String']>;
  club?: Maybe<ClubWhereInput>;
  club_not?: Maybe<ClubWhereInput>;
  club_in?: Maybe<Array<ClubWhereInput>>;
  club_not_in?: Maybe<Array<ClubWhereInput>>;
  authorId?: Maybe<Scalars['String']>;
  authorId_not?: Maybe<Scalars['String']>;
  authorId_in?: Maybe<Array<Scalars['String']>>;
  authorId_not_in?: Maybe<Array<Scalars['String']>>;
  authorId_contains?: Maybe<Scalars['String']>;
  authorId_startsWith?: Maybe<Scalars['String']>;
  authorId_endsWith?: Maybe<Scalars['String']>;
  author?: Maybe<StakeholderWhereInput>;
  author_not?: Maybe<StakeholderWhereInput>;
  author_in?: Maybe<Array<StakeholderWhereInput>>;
  author_not_in?: Maybe<Array<StakeholderWhereInput>>;
  adminId?: Maybe<Scalars['String']>;
  adminId_not?: Maybe<Scalars['String']>;
  adminId_in?: Maybe<Array<Scalars['String']>>;
  adminId_not_in?: Maybe<Array<Scalars['String']>>;
  adminId_contains?: Maybe<Scalars['String']>;
  adminId_startsWith?: Maybe<Scalars['String']>;
  adminId_endsWith?: Maybe<Scalars['String']>;
  admin?: Maybe<UserWhereInput>;
  admin_not?: Maybe<UserWhereInput>;
  admin_in?: Maybe<Array<UserWhereInput>>;
  admin_not_in?: Maybe<Array<UserWhereInput>>;
  AND?: Maybe<Array<CommentWhereInput>>;
  OR?: Maybe<Array<CommentWhereInput>>;
  NOT?: Maybe<Array<CommentWhereInput>>;
};

export type ContactUs = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  status?: Maybe<ContactUsStatus>;
};

export type ContactUsCreateInput = {
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  status?: Maybe<ContactUsStatus>;
};

export enum ContactUsOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  NumberAsc = 'number_ASC',
  NumberDesc = 'number_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
}

export enum ContactUsStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

export type ContactUsUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  status?: Maybe<ContactUsStatus>;
};

export type ContactUsWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  name?: Maybe<Scalars['String']>;
  name_not?: Maybe<Scalars['String']>;
  name_in?: Maybe<Array<Scalars['String']>>;
  name_not_in?: Maybe<Array<Scalars['String']>>;
  name_contains?: Maybe<Scalars['String']>;
  name_startsWith?: Maybe<Scalars['String']>;
  name_endsWith?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  number_not?: Maybe<Scalars['String']>;
  number_in?: Maybe<Array<Scalars['String']>>;
  number_not_in?: Maybe<Array<Scalars['String']>>;
  number_contains?: Maybe<Scalars['String']>;
  number_startsWith?: Maybe<Scalars['String']>;
  number_endsWith?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  email_not?: Maybe<Scalars['String']>;
  email_in?: Maybe<Array<Scalars['String']>>;
  email_not_in?: Maybe<Array<Scalars['String']>>;
  email_contains?: Maybe<Scalars['String']>;
  email_startsWith?: Maybe<Scalars['String']>;
  email_endsWith?: Maybe<Scalars['String']>;
  status?: Maybe<ContactUsStatus>;
  status_not?: Maybe<ContactUsStatus>;
  status_in?: Maybe<Array<ContactUsStatus>>;
  status_not_in?: Maybe<Array<ContactUsStatus>>;
  AND?: Maybe<Array<ContactUsWhereInput>>;
  OR?: Maybe<Array<ContactUsWhereInput>>;
  NOT?: Maybe<Array<ContactUsWhereInput>>;
};

export type Document = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  billing?: Maybe<Scalars['Boolean']>;
  status?: Maybe<DocumentStatus>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<Stakeholder>;
  propertyId?: Maybe<Scalars['String']>;
  property?: Maybe<Property>;
  file?: Maybe<File>;
};

export type DocumentCreateInput = {
  name?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  billing?: Maybe<Scalars['Boolean']>;
  status?: Maybe<DocumentStatus>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<StakeholderCreateInput>;
  propertyId?: Maybe<Scalars['String']>;
  property?: Maybe<PropertyCreateInput>;
  file?: Maybe<FileCreateInput>;
};

export enum DocumentOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  DueDateAsc = 'dueDate_ASC',
  DueDateDesc = 'dueDate_DESC',
  BillingAsc = 'billing_ASC',
  BillingDesc = 'billing_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  StakeholderIdAsc = 'stakeholderId_ASC',
  StakeholderIdDesc = 'stakeholderId_DESC',
  StakeholderAsc = 'stakeholder_ASC',
  StakeholderDesc = 'stakeholder_DESC',
  PropertyIdAsc = 'propertyId_ASC',
  PropertyIdDesc = 'propertyId_DESC',
  PropertyAsc = 'property_ASC',
  PropertyDesc = 'property_DESC',
  FileAsc = 'file_ASC',
  FileDesc = 'file_DESC',
}

export enum DocumentStatus {
  New = 'NEW',
  Paid = 'PAID',
  Archived = 'ARCHIVED',
}

export type DocumentUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  billing?: Maybe<Scalars['Boolean']>;
  status?: Maybe<DocumentStatus>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<StakeholderUpdateInput>;
  propertyId?: Maybe<Scalars['String']>;
  property?: Maybe<PropertyUpdateInput>;
  file?: Maybe<FileUpdateInput>;
};

export type DocumentWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  name?: Maybe<Scalars['String']>;
  name_not?: Maybe<Scalars['String']>;
  name_in?: Maybe<Array<Scalars['String']>>;
  name_not_in?: Maybe<Array<Scalars['String']>>;
  name_contains?: Maybe<Scalars['String']>;
  name_startsWith?: Maybe<Scalars['String']>;
  name_endsWith?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  dueDate_not?: Maybe<Scalars['DateTime']>;
  dueDate_in?: Maybe<Array<Scalars['DateTime']>>;
  dueDate_not_in?: Maybe<Array<Scalars['DateTime']>>;
  billing?: Maybe<Scalars['Boolean']>;
  billing_not?: Maybe<Scalars['Boolean']>;
  billing_in?: Maybe<Array<Scalars['Boolean']>>;
  billing_not_in?: Maybe<Array<Scalars['Boolean']>>;
  status?: Maybe<DocumentStatus>;
  status_not?: Maybe<DocumentStatus>;
  status_in?: Maybe<Array<DocumentStatus>>;
  status_not_in?: Maybe<Array<DocumentStatus>>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholderId_not?: Maybe<Scalars['String']>;
  stakeholderId_in?: Maybe<Array<Scalars['String']>>;
  stakeholderId_not_in?: Maybe<Array<Scalars['String']>>;
  stakeholderId_contains?: Maybe<Scalars['String']>;
  stakeholderId_startsWith?: Maybe<Scalars['String']>;
  stakeholderId_endsWith?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<StakeholderWhereInput>;
  stakeholder_not?: Maybe<StakeholderWhereInput>;
  stakeholder_in?: Maybe<Array<StakeholderWhereInput>>;
  stakeholder_not_in?: Maybe<Array<StakeholderWhereInput>>;
  propertyId?: Maybe<Scalars['String']>;
  propertyId_not?: Maybe<Scalars['String']>;
  propertyId_in?: Maybe<Array<Scalars['String']>>;
  propertyId_not_in?: Maybe<Array<Scalars['String']>>;
  propertyId_contains?: Maybe<Scalars['String']>;
  propertyId_startsWith?: Maybe<Scalars['String']>;
  propertyId_endsWith?: Maybe<Scalars['String']>;
  property?: Maybe<PropertyWhereInput>;
  property_not?: Maybe<PropertyWhereInput>;
  property_in?: Maybe<Array<PropertyWhereInput>>;
  property_not_in?: Maybe<Array<PropertyWhereInput>>;
  file?: Maybe<FileWhereInput>;
  file_not?: Maybe<FileWhereInput>;
  file_in?: Maybe<Array<FileWhereInput>>;
  file_not_in?: Maybe<Array<FileWhereInput>>;
  AND?: Maybe<Array<DocumentWhereInput>>;
  OR?: Maybe<Array<DocumentWhereInput>>;
  NOT?: Maybe<Array<DocumentWhereInput>>;
};

export type Eatery = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<EateryStatus>;
  description?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  telephoneNumber?: Maybe<Scalars['String']>;
  whatsappNumber?: Maybe<Scalars['String']>;
  menus?: Maybe<Scalars['JSON']>;
  mondayHours?: Maybe<Scalars['String']>;
  tuesdayHours?: Maybe<Scalars['String']>;
  wednesdayHours?: Maybe<Scalars['String']>;
  thursdayHours?: Maybe<Scalars['String']>;
  fridayHours?: Maybe<Scalars['String']>;
  saturdayHours?: Maybe<Scalars['String']>;
  sundayHours?: Maybe<Scalars['String']>;
  tradingHours?: Maybe<Scalars['String']>;
  xtradingHours?: Maybe<Scalars['String']>;
};

export type EateryCreateInput = {
  name?: Maybe<Scalars['String']>;
  status?: Maybe<EateryStatus>;
  description?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  telephoneNumber?: Maybe<Scalars['String']>;
  whatsappNumber?: Maybe<Scalars['String']>;
  menus?: Maybe<Scalars['JSON']>;
  mondayHours?: Maybe<Scalars['String']>;
  tuesdayHours?: Maybe<Scalars['String']>;
  wednesdayHours?: Maybe<Scalars['String']>;
  thursdayHours?: Maybe<Scalars['String']>;
  fridayHours?: Maybe<Scalars['String']>;
  saturdayHours?: Maybe<Scalars['String']>;
  sundayHours?: Maybe<Scalars['String']>;
  tradingHours?: Maybe<Scalars['String']>;
  xtradingHours?: Maybe<Scalars['String']>;
};

export enum EateryOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  LogoAsc = 'logo_ASC',
  LogoDesc = 'logo_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  WhatsappNumberAsc = 'whatsappNumber_ASC',
  WhatsappNumberDesc = 'whatsappNumber_DESC',
  MenusAsc = 'menus_ASC',
  MenusDesc = 'menus_DESC',
  MondayHoursAsc = 'mondayHours_ASC',
  MondayHoursDesc = 'mondayHours_DESC',
  TuesdayHoursAsc = 'tuesdayHours_ASC',
  TuesdayHoursDesc = 'tuesdayHours_DESC',
  WednesdayHoursAsc = 'wednesdayHours_ASC',
  WednesdayHoursDesc = 'wednesdayHours_DESC',
  ThursdayHoursAsc = 'thursdayHours_ASC',
  ThursdayHoursDesc = 'thursdayHours_DESC',
  FridayHoursAsc = 'fridayHours_ASC',
  FridayHoursDesc = 'fridayHours_DESC',
  SaturdayHoursAsc = 'saturdayHours_ASC',
  SaturdayHoursDesc = 'saturdayHours_DESC',
  SundayHoursAsc = 'sundayHours_ASC',
  SundayHoursDesc = 'sundayHours_DESC',
  TradingHoursAsc = 'tradingHours_ASC',
  TradingHoursDesc = 'tradingHours_DESC',
  XtradingHoursAsc = 'xtradingHours_ASC',
  XtradingHoursDesc = 'xtradingHours_DESC',
}

export enum EateryStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Archived = 'ARCHIVED',
}

export type EateryUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<EateryStatus>;
  description?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  telephoneNumber?: Maybe<Scalars['String']>;
  whatsappNumber?: Maybe<Scalars['String']>;
  menus?: Maybe<Scalars['JSON']>;
  mondayHours?: Maybe<Scalars['String']>;
  tuesdayHours?: Maybe<Scalars['String']>;
  wednesdayHours?: Maybe<Scalars['String']>;
  thursdayHours?: Maybe<Scalars['String']>;
  fridayHours?: Maybe<Scalars['String']>;
  saturdayHours?: Maybe<Scalars['String']>;
  sundayHours?: Maybe<Scalars['String']>;
  tradingHours?: Maybe<Scalars['String']>;
  xtradingHours?: Maybe<Scalars['String']>;
};

export type EateryWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  name?: Maybe<Scalars['String']>;
  name_not?: Maybe<Scalars['String']>;
  name_in?: Maybe<Array<Scalars['String']>>;
  name_not_in?: Maybe<Array<Scalars['String']>>;
  name_contains?: Maybe<Scalars['String']>;
  name_startsWith?: Maybe<Scalars['String']>;
  name_endsWith?: Maybe<Scalars['String']>;
  status?: Maybe<EateryStatus>;
  status_not?: Maybe<EateryStatus>;
  status_in?: Maybe<Array<EateryStatus>>;
  status_not_in?: Maybe<Array<EateryStatus>>;
  description?: Maybe<Scalars['String']>;
  description_not?: Maybe<Scalars['String']>;
  description_in?: Maybe<Array<Scalars['String']>>;
  description_not_in?: Maybe<Array<Scalars['String']>>;
  description_contains?: Maybe<Scalars['String']>;
  description_startsWith?: Maybe<Scalars['String']>;
  description_endsWith?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  logo_not?: Maybe<Scalars['String']>;
  logo_in?: Maybe<Array<Scalars['String']>>;
  logo_not_in?: Maybe<Array<Scalars['String']>>;
  logo_contains?: Maybe<Scalars['String']>;
  logo_startsWith?: Maybe<Scalars['String']>;
  logo_endsWith?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  email_not?: Maybe<Scalars['String']>;
  email_in?: Maybe<Array<Scalars['String']>>;
  email_not_in?: Maybe<Array<Scalars['String']>>;
  email_contains?: Maybe<Scalars['String']>;
  email_startsWith?: Maybe<Scalars['String']>;
  email_endsWith?: Maybe<Scalars['String']>;
  telephoneNumber?: Maybe<Scalars['String']>;
  telephoneNumber_not?: Maybe<Scalars['String']>;
  telephoneNumber_in?: Maybe<Array<Scalars['String']>>;
  telephoneNumber_not_in?: Maybe<Array<Scalars['String']>>;
  telephoneNumber_contains?: Maybe<Scalars['String']>;
  telephoneNumber_startsWith?: Maybe<Scalars['String']>;
  telephoneNumber_endsWith?: Maybe<Scalars['String']>;
  whatsappNumber?: Maybe<Scalars['String']>;
  whatsappNumber_not?: Maybe<Scalars['String']>;
  whatsappNumber_in?: Maybe<Array<Scalars['String']>>;
  whatsappNumber_not_in?: Maybe<Array<Scalars['String']>>;
  whatsappNumber_contains?: Maybe<Scalars['String']>;
  whatsappNumber_startsWith?: Maybe<Scalars['String']>;
  whatsappNumber_endsWith?: Maybe<Scalars['String']>;
  menus?: Maybe<Scalars['JSON']>;
  menus_not?: Maybe<Scalars['JSON']>;
  menus_in?: Maybe<Array<Scalars['JSON']>>;
  menus_not_in?: Maybe<Array<Scalars['JSON']>>;
  mondayHours?: Maybe<Scalars['String']>;
  mondayHours_not?: Maybe<Scalars['String']>;
  mondayHours_in?: Maybe<Array<Scalars['String']>>;
  mondayHours_not_in?: Maybe<Array<Scalars['String']>>;
  mondayHours_contains?: Maybe<Scalars['String']>;
  mondayHours_startsWith?: Maybe<Scalars['String']>;
  mondayHours_endsWith?: Maybe<Scalars['String']>;
  tuesdayHours?: Maybe<Scalars['String']>;
  tuesdayHours_not?: Maybe<Scalars['String']>;
  tuesdayHours_in?: Maybe<Array<Scalars['String']>>;
  tuesdayHours_not_in?: Maybe<Array<Scalars['String']>>;
  tuesdayHours_contains?: Maybe<Scalars['String']>;
  tuesdayHours_startsWith?: Maybe<Scalars['String']>;
  tuesdayHours_endsWith?: Maybe<Scalars['String']>;
  wednesdayHours?: Maybe<Scalars['String']>;
  wednesdayHours_not?: Maybe<Scalars['String']>;
  wednesdayHours_in?: Maybe<Array<Scalars['String']>>;
  wednesdayHours_not_in?: Maybe<Array<Scalars['String']>>;
  wednesdayHours_contains?: Maybe<Scalars['String']>;
  wednesdayHours_startsWith?: Maybe<Scalars['String']>;
  wednesdayHours_endsWith?: Maybe<Scalars['String']>;
  thursdayHours?: Maybe<Scalars['String']>;
  thursdayHours_not?: Maybe<Scalars['String']>;
  thursdayHours_in?: Maybe<Array<Scalars['String']>>;
  thursdayHours_not_in?: Maybe<Array<Scalars['String']>>;
  thursdayHours_contains?: Maybe<Scalars['String']>;
  thursdayHours_startsWith?: Maybe<Scalars['String']>;
  thursdayHours_endsWith?: Maybe<Scalars['String']>;
  fridayHours?: Maybe<Scalars['String']>;
  fridayHours_not?: Maybe<Scalars['String']>;
  fridayHours_in?: Maybe<Array<Scalars['String']>>;
  fridayHours_not_in?: Maybe<Array<Scalars['String']>>;
  fridayHours_contains?: Maybe<Scalars['String']>;
  fridayHours_startsWith?: Maybe<Scalars['String']>;
  fridayHours_endsWith?: Maybe<Scalars['String']>;
  saturdayHours?: Maybe<Scalars['String']>;
  saturdayHours_not?: Maybe<Scalars['String']>;
  saturdayHours_in?: Maybe<Array<Scalars['String']>>;
  saturdayHours_not_in?: Maybe<Array<Scalars['String']>>;
  saturdayHours_contains?: Maybe<Scalars['String']>;
  saturdayHours_startsWith?: Maybe<Scalars['String']>;
  saturdayHours_endsWith?: Maybe<Scalars['String']>;
  sundayHours?: Maybe<Scalars['String']>;
  sundayHours_not?: Maybe<Scalars['String']>;
  sundayHours_in?: Maybe<Array<Scalars['String']>>;
  sundayHours_not_in?: Maybe<Array<Scalars['String']>>;
  sundayHours_contains?: Maybe<Scalars['String']>;
  sundayHours_startsWith?: Maybe<Scalars['String']>;
  sundayHours_endsWith?: Maybe<Scalars['String']>;
  tradingHours?: Maybe<Scalars['String']>;
  tradingHours_not?: Maybe<Scalars['String']>;
  tradingHours_in?: Maybe<Array<Scalars['String']>>;
  tradingHours_not_in?: Maybe<Array<Scalars['String']>>;
  tradingHours_contains?: Maybe<Scalars['String']>;
  tradingHours_startsWith?: Maybe<Scalars['String']>;
  tradingHours_endsWith?: Maybe<Scalars['String']>;
  xtradingHours?: Maybe<Scalars['String']>;
  xtradingHours_not?: Maybe<Scalars['String']>;
  xtradingHours_in?: Maybe<Array<Scalars['String']>>;
  xtradingHours_not_in?: Maybe<Array<Scalars['String']>>;
  xtradingHours_contains?: Maybe<Scalars['String']>;
  xtradingHours_startsWith?: Maybe<Scalars['String']>;
  xtradingHours_endsWith?: Maybe<Scalars['String']>;
  AND?: Maybe<Array<EateryWhereInput>>;
  OR?: Maybe<Array<EateryWhereInput>>;
  NOT?: Maybe<Array<EateryWhereInput>>;
};

export type EstateInfo = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  pdf?: Maybe<Scalars['String']>;
  status?: Maybe<EstateInfoStatus>;
};

export type EstateInfoCreateInput = {
  title?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  pdf?: Maybe<Scalars['String']>;
  status?: Maybe<EstateInfoStatus>;
};

export enum EstateInfoOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ImageAsc = 'image_ASC',
  ImageDesc = 'image_DESC',
  PdfAsc = 'pdf_ASC',
  PdfDesc = 'pdf_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
}

export enum EstateInfoStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

export type EstateInfoUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  pdf?: Maybe<Scalars['String']>;
  status?: Maybe<EstateInfoStatus>;
};

export type EstateInfoWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Scalars['String']>>;
  title_not_in?: Maybe<Array<Scalars['String']>>;
  title_contains?: Maybe<Scalars['String']>;
  title_startsWith?: Maybe<Scalars['String']>;
  title_endsWith?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  image_not?: Maybe<Scalars['String']>;
  image_in?: Maybe<Array<Scalars['String']>>;
  image_not_in?: Maybe<Array<Scalars['String']>>;
  image_contains?: Maybe<Scalars['String']>;
  image_startsWith?: Maybe<Scalars['String']>;
  image_endsWith?: Maybe<Scalars['String']>;
  pdf?: Maybe<Scalars['String']>;
  pdf_not?: Maybe<Scalars['String']>;
  pdf_in?: Maybe<Array<Scalars['String']>>;
  pdf_not_in?: Maybe<Array<Scalars['String']>>;
  pdf_contains?: Maybe<Scalars['String']>;
  pdf_startsWith?: Maybe<Scalars['String']>;
  pdf_endsWith?: Maybe<Scalars['String']>;
  status?: Maybe<EstateInfoStatus>;
  status_not?: Maybe<EstateInfoStatus>;
  status_in?: Maybe<Array<EstateInfoStatus>>;
  status_not_in?: Maybe<Array<EstateInfoStatus>>;
  AND?: Maybe<Array<EstateInfoWhereInput>>;
  OR?: Maybe<Array<EstateInfoWhereInput>>;
  NOT?: Maybe<Array<EstateInfoWhereInput>>;
};

export type Event = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  host?: Maybe<Scalars['String']>;
  hostLogo?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  accessStartDate?: Maybe<Scalars['DateTime']>;
  accessEndDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  reminders?: Maybe<Scalars['Boolean']>;
  links?: Maybe<Scalars['JSON']>;
  children?: Maybe<Scalars['JSON']>;
  status?: Maybe<EventStatus>;
  type?: Maybe<EventType>;
  imageId?: Maybe<Scalars['String']>;
  image?: Maybe<File>;
  attendees?: Maybe<Stakeholder>;
  tickets?: Maybe<Ticket>;
  orders?: Maybe<Order>;
  products?: Maybe<Product>;
  fileId?: Maybe<Scalars['String']>;
};

export type EventCreateInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  host?: Maybe<Scalars['String']>;
  hostLogo?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  accessStartDate?: Maybe<Scalars['DateTime']>;
  accessEndDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  reminders?: Maybe<Scalars['Boolean']>;
  links?: Maybe<Scalars['JSON']>;
  children?: Maybe<Scalars['JSON']>;
  status?: Maybe<EventStatus>;
  type?: Maybe<EventType>;
  imageId?: Maybe<Scalars['String']>;
  image?: Maybe<FileCreateInput>;
  attendees?: Maybe<StakeholderCreateInput>;
  tickets?: Maybe<TicketCreateInput>;
  orders?: Maybe<OrderCreateInput>;
  products?: Maybe<ProductCreateInput>;
  fileId?: Maybe<Scalars['String']>;
};

export enum EventOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  HostAsc = 'host_ASC',
  HostDesc = 'host_DESC',
  HostLogoAsc = 'hostLogo_ASC',
  HostLogoDesc = 'hostLogo_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  StartDateAsc = 'startDate_ASC',
  StartDateDesc = 'startDate_DESC',
  AccessStartDateAsc = 'accessStartDate_ASC',
  AccessStartDateDesc = 'accessStartDate_DESC',
  AccessEndDateAsc = 'accessEndDate_ASC',
  AccessEndDateDesc = 'accessEndDate_DESC',
  EndDateAsc = 'endDate_ASC',
  EndDateDesc = 'endDate_DESC',
  RemindersAsc = 'reminders_ASC',
  RemindersDesc = 'reminders_DESC',
  LinksAsc = 'links_ASC',
  LinksDesc = 'links_DESC',
  ChildrenAsc = 'children_ASC',
  ChildrenDesc = 'children_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  ImageIdAsc = 'imageId_ASC',
  ImageIdDesc = 'imageId_DESC',
  ImageAsc = 'image_ASC',
  ImageDesc = 'image_DESC',
  AttendeesAsc = 'attendees_ASC',
  AttendeesDesc = 'attendees_DESC',
  TicketsAsc = 'tickets_ASC',
  TicketsDesc = 'tickets_DESC',
  OrdersAsc = 'orders_ASC',
  OrdersDesc = 'orders_DESC',
  ProductsAsc = 'products_ASC',
  ProductsDesc = 'products_DESC',
  FileIdAsc = 'fileId_ASC',
  FileIdDesc = 'fileId_DESC',
}

export enum EventStatus {
  Draft = 'DRAFT',
  Archived = 'ARCHIVED',
  Cancelled = 'CANCELLED',
  Published = 'PUBLISHED',
}

export enum EventType {
  Public = 'PUBLIC',
  Private = 'PRIVATE',
}

export type EventUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  host?: Maybe<Scalars['String']>;
  hostLogo?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  accessStartDate?: Maybe<Scalars['DateTime']>;
  accessEndDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  reminders?: Maybe<Scalars['Boolean']>;
  links?: Maybe<Scalars['JSON']>;
  children?: Maybe<Scalars['JSON']>;
  status?: Maybe<EventStatus>;
  type?: Maybe<EventType>;
  imageId?: Maybe<Scalars['String']>;
  image?: Maybe<FileUpdateInput>;
  attendees?: Maybe<StakeholderUpdateInput>;
  tickets?: Maybe<TicketUpdateInput>;
  orders?: Maybe<OrderUpdateInput>;
  products?: Maybe<ProductUpdateInput>;
  fileId?: Maybe<Scalars['String']>;
};

export type EventWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  name?: Maybe<Scalars['String']>;
  name_not?: Maybe<Scalars['String']>;
  name_in?: Maybe<Array<Scalars['String']>>;
  name_not_in?: Maybe<Array<Scalars['String']>>;
  name_contains?: Maybe<Scalars['String']>;
  name_startsWith?: Maybe<Scalars['String']>;
  name_endsWith?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  description_not?: Maybe<Scalars['String']>;
  description_in?: Maybe<Array<Scalars['String']>>;
  description_not_in?: Maybe<Array<Scalars['String']>>;
  description_contains?: Maybe<Scalars['String']>;
  description_startsWith?: Maybe<Scalars['String']>;
  description_endsWith?: Maybe<Scalars['String']>;
  host?: Maybe<Scalars['String']>;
  host_not?: Maybe<Scalars['String']>;
  host_in?: Maybe<Array<Scalars['String']>>;
  host_not_in?: Maybe<Array<Scalars['String']>>;
  host_contains?: Maybe<Scalars['String']>;
  host_startsWith?: Maybe<Scalars['String']>;
  host_endsWith?: Maybe<Scalars['String']>;
  hostLogo?: Maybe<Scalars['String']>;
  hostLogo_not?: Maybe<Scalars['String']>;
  hostLogo_in?: Maybe<Array<Scalars['String']>>;
  hostLogo_not_in?: Maybe<Array<Scalars['String']>>;
  hostLogo_contains?: Maybe<Scalars['String']>;
  hostLogo_startsWith?: Maybe<Scalars['String']>;
  hostLogo_endsWith?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  location_not?: Maybe<Scalars['String']>;
  location_in?: Maybe<Array<Scalars['String']>>;
  location_not_in?: Maybe<Array<Scalars['String']>>;
  location_contains?: Maybe<Scalars['String']>;
  location_startsWith?: Maybe<Scalars['String']>;
  location_endsWith?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  startDate_not?: Maybe<Scalars['DateTime']>;
  startDate_in?: Maybe<Array<Scalars['DateTime']>>;
  startDate_not_in?: Maybe<Array<Scalars['DateTime']>>;
  accessStartDate?: Maybe<Scalars['DateTime']>;
  accessStartDate_not?: Maybe<Scalars['DateTime']>;
  accessStartDate_in?: Maybe<Array<Scalars['DateTime']>>;
  accessStartDate_not_in?: Maybe<Array<Scalars['DateTime']>>;
  accessEndDate?: Maybe<Scalars['DateTime']>;
  accessEndDate_not?: Maybe<Scalars['DateTime']>;
  accessEndDate_in?: Maybe<Array<Scalars['DateTime']>>;
  accessEndDate_not_in?: Maybe<Array<Scalars['DateTime']>>;
  endDate?: Maybe<Scalars['DateTime']>;
  endDate_not?: Maybe<Scalars['DateTime']>;
  endDate_in?: Maybe<Array<Scalars['DateTime']>>;
  endDate_not_in?: Maybe<Array<Scalars['DateTime']>>;
  reminders?: Maybe<Scalars['Boolean']>;
  reminders_not?: Maybe<Scalars['Boolean']>;
  reminders_in?: Maybe<Array<Scalars['Boolean']>>;
  reminders_not_in?: Maybe<Array<Scalars['Boolean']>>;
  links?: Maybe<Scalars['JSON']>;
  links_not?: Maybe<Scalars['JSON']>;
  links_in?: Maybe<Array<Scalars['JSON']>>;
  links_not_in?: Maybe<Array<Scalars['JSON']>>;
  children?: Maybe<Scalars['JSON']>;
  children_not?: Maybe<Scalars['JSON']>;
  children_in?: Maybe<Array<Scalars['JSON']>>;
  children_not_in?: Maybe<Array<Scalars['JSON']>>;
  status?: Maybe<EventStatus>;
  status_not?: Maybe<EventStatus>;
  status_in?: Maybe<Array<EventStatus>>;
  status_not_in?: Maybe<Array<EventStatus>>;
  type?: Maybe<EventType>;
  type_not?: Maybe<EventType>;
  type_in?: Maybe<Array<EventType>>;
  type_not_in?: Maybe<Array<EventType>>;
  imageId?: Maybe<Scalars['String']>;
  imageId_not?: Maybe<Scalars['String']>;
  imageId_in?: Maybe<Array<Scalars['String']>>;
  imageId_not_in?: Maybe<Array<Scalars['String']>>;
  imageId_contains?: Maybe<Scalars['String']>;
  imageId_startsWith?: Maybe<Scalars['String']>;
  imageId_endsWith?: Maybe<Scalars['String']>;
  image?: Maybe<FileWhereInput>;
  image_not?: Maybe<FileWhereInput>;
  image_in?: Maybe<Array<FileWhereInput>>;
  image_not_in?: Maybe<Array<FileWhereInput>>;
  attendees?: Maybe<StakeholderWhereInput>;
  attendees_not?: Maybe<StakeholderWhereInput>;
  attendees_in?: Maybe<Array<StakeholderWhereInput>>;
  attendees_not_in?: Maybe<Array<StakeholderWhereInput>>;
  tickets?: Maybe<TicketWhereInput>;
  tickets_not?: Maybe<TicketWhereInput>;
  tickets_in?: Maybe<Array<TicketWhereInput>>;
  tickets_not_in?: Maybe<Array<TicketWhereInput>>;
  orders?: Maybe<OrderWhereInput>;
  orders_not?: Maybe<OrderWhereInput>;
  orders_in?: Maybe<Array<OrderWhereInput>>;
  orders_not_in?: Maybe<Array<OrderWhereInput>>;
  products?: Maybe<ProductWhereInput>;
  products_not?: Maybe<ProductWhereInput>;
  products_in?: Maybe<Array<ProductWhereInput>>;
  products_not_in?: Maybe<Array<ProductWhereInput>>;
  fileId?: Maybe<Scalars['String']>;
  fileId_not?: Maybe<Scalars['String']>;
  fileId_in?: Maybe<Array<Scalars['String']>>;
  fileId_not_in?: Maybe<Array<Scalars['String']>>;
  fileId_contains?: Maybe<Scalars['String']>;
  fileId_startsWith?: Maybe<Scalars['String']>;
  fileId_endsWith?: Maybe<Scalars['String']>;
  AND?: Maybe<Array<EventWhereInput>>;
  OR?: Maybe<Array<EventWhereInput>>;
  NOT?: Maybe<Array<EventWhereInput>>;
};

export type Facility = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<FacilityStatus>;
  description?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  telephoneNumber?: Maybe<Scalars['String']>;
  whatsappNumber?: Maybe<Scalars['String']>;
  menus?: Maybe<Scalars['JSON']>;
  mondayHours?: Maybe<Scalars['String']>;
  tuesdayHours?: Maybe<Scalars['String']>;
  wednesdayHours?: Maybe<Scalars['String']>;
  thursdayHours?: Maybe<Scalars['String']>;
  fridayHours?: Maybe<Scalars['String']>;
  saturdayHours?: Maybe<Scalars['String']>;
  sundayHours?: Maybe<Scalars['String']>;
  tradingHours?: Maybe<Scalars['String']>;
};

export type FacilityCreateInput = {
  name?: Maybe<Scalars['String']>;
  status?: Maybe<FacilityStatus>;
  description?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  telephoneNumber?: Maybe<Scalars['String']>;
  whatsappNumber?: Maybe<Scalars['String']>;
  menus?: Maybe<Scalars['JSON']>;
  mondayHours?: Maybe<Scalars['String']>;
  tuesdayHours?: Maybe<Scalars['String']>;
  wednesdayHours?: Maybe<Scalars['String']>;
  thursdayHours?: Maybe<Scalars['String']>;
  fridayHours?: Maybe<Scalars['String']>;
  saturdayHours?: Maybe<Scalars['String']>;
  sundayHours?: Maybe<Scalars['String']>;
  tradingHours?: Maybe<Scalars['String']>;
};

export enum FacilityOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  LogoAsc = 'logo_ASC',
  LogoDesc = 'logo_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  WhatsappNumberAsc = 'whatsappNumber_ASC',
  WhatsappNumberDesc = 'whatsappNumber_DESC',
  MenusAsc = 'menus_ASC',
  MenusDesc = 'menus_DESC',
  MondayHoursAsc = 'mondayHours_ASC',
  MondayHoursDesc = 'mondayHours_DESC',
  TuesdayHoursAsc = 'tuesdayHours_ASC',
  TuesdayHoursDesc = 'tuesdayHours_DESC',
  WednesdayHoursAsc = 'wednesdayHours_ASC',
  WednesdayHoursDesc = 'wednesdayHours_DESC',
  ThursdayHoursAsc = 'thursdayHours_ASC',
  ThursdayHoursDesc = 'thursdayHours_DESC',
  FridayHoursAsc = 'fridayHours_ASC',
  FridayHoursDesc = 'fridayHours_DESC',
  SaturdayHoursAsc = 'saturdayHours_ASC',
  SaturdayHoursDesc = 'saturdayHours_DESC',
  SundayHoursAsc = 'sundayHours_ASC',
  SundayHoursDesc = 'sundayHours_DESC',
  TradingHoursAsc = 'tradingHours_ASC',
  TradingHoursDesc = 'tradingHours_DESC',
}

export enum FacilityStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Archived = 'ARCHIVED',
}

export type FacilityUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<FacilityStatus>;
  description?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  telephoneNumber?: Maybe<Scalars['String']>;
  whatsappNumber?: Maybe<Scalars['String']>;
  menus?: Maybe<Scalars['JSON']>;
  mondayHours?: Maybe<Scalars['String']>;
  tuesdayHours?: Maybe<Scalars['String']>;
  wednesdayHours?: Maybe<Scalars['String']>;
  thursdayHours?: Maybe<Scalars['String']>;
  fridayHours?: Maybe<Scalars['String']>;
  saturdayHours?: Maybe<Scalars['String']>;
  sundayHours?: Maybe<Scalars['String']>;
  tradingHours?: Maybe<Scalars['String']>;
};

export type FacilityWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  name?: Maybe<Scalars['String']>;
  name_not?: Maybe<Scalars['String']>;
  name_in?: Maybe<Array<Scalars['String']>>;
  name_not_in?: Maybe<Array<Scalars['String']>>;
  name_contains?: Maybe<Scalars['String']>;
  name_startsWith?: Maybe<Scalars['String']>;
  name_endsWith?: Maybe<Scalars['String']>;
  status?: Maybe<FacilityStatus>;
  status_not?: Maybe<FacilityStatus>;
  status_in?: Maybe<Array<FacilityStatus>>;
  status_not_in?: Maybe<Array<FacilityStatus>>;
  description?: Maybe<Scalars['String']>;
  description_not?: Maybe<Scalars['String']>;
  description_in?: Maybe<Array<Scalars['String']>>;
  description_not_in?: Maybe<Array<Scalars['String']>>;
  description_contains?: Maybe<Scalars['String']>;
  description_startsWith?: Maybe<Scalars['String']>;
  description_endsWith?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  logo_not?: Maybe<Scalars['String']>;
  logo_in?: Maybe<Array<Scalars['String']>>;
  logo_not_in?: Maybe<Array<Scalars['String']>>;
  logo_contains?: Maybe<Scalars['String']>;
  logo_startsWith?: Maybe<Scalars['String']>;
  logo_endsWith?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  email_not?: Maybe<Scalars['String']>;
  email_in?: Maybe<Array<Scalars['String']>>;
  email_not_in?: Maybe<Array<Scalars['String']>>;
  email_contains?: Maybe<Scalars['String']>;
  email_startsWith?: Maybe<Scalars['String']>;
  email_endsWith?: Maybe<Scalars['String']>;
  telephoneNumber?: Maybe<Scalars['String']>;
  telephoneNumber_not?: Maybe<Scalars['String']>;
  telephoneNumber_in?: Maybe<Array<Scalars['String']>>;
  telephoneNumber_not_in?: Maybe<Array<Scalars['String']>>;
  telephoneNumber_contains?: Maybe<Scalars['String']>;
  telephoneNumber_startsWith?: Maybe<Scalars['String']>;
  telephoneNumber_endsWith?: Maybe<Scalars['String']>;
  whatsappNumber?: Maybe<Scalars['String']>;
  whatsappNumber_not?: Maybe<Scalars['String']>;
  whatsappNumber_in?: Maybe<Array<Scalars['String']>>;
  whatsappNumber_not_in?: Maybe<Array<Scalars['String']>>;
  whatsappNumber_contains?: Maybe<Scalars['String']>;
  whatsappNumber_startsWith?: Maybe<Scalars['String']>;
  whatsappNumber_endsWith?: Maybe<Scalars['String']>;
  menus?: Maybe<Scalars['JSON']>;
  menus_not?: Maybe<Scalars['JSON']>;
  menus_in?: Maybe<Array<Scalars['JSON']>>;
  menus_not_in?: Maybe<Array<Scalars['JSON']>>;
  mondayHours?: Maybe<Scalars['String']>;
  mondayHours_not?: Maybe<Scalars['String']>;
  mondayHours_in?: Maybe<Array<Scalars['String']>>;
  mondayHours_not_in?: Maybe<Array<Scalars['String']>>;
  mondayHours_contains?: Maybe<Scalars['String']>;
  mondayHours_startsWith?: Maybe<Scalars['String']>;
  mondayHours_endsWith?: Maybe<Scalars['String']>;
  tuesdayHours?: Maybe<Scalars['String']>;
  tuesdayHours_not?: Maybe<Scalars['String']>;
  tuesdayHours_in?: Maybe<Array<Scalars['String']>>;
  tuesdayHours_not_in?: Maybe<Array<Scalars['String']>>;
  tuesdayHours_contains?: Maybe<Scalars['String']>;
  tuesdayHours_startsWith?: Maybe<Scalars['String']>;
  tuesdayHours_endsWith?: Maybe<Scalars['String']>;
  wednesdayHours?: Maybe<Scalars['String']>;
  wednesdayHours_not?: Maybe<Scalars['String']>;
  wednesdayHours_in?: Maybe<Array<Scalars['String']>>;
  wednesdayHours_not_in?: Maybe<Array<Scalars['String']>>;
  wednesdayHours_contains?: Maybe<Scalars['String']>;
  wednesdayHours_startsWith?: Maybe<Scalars['String']>;
  wednesdayHours_endsWith?: Maybe<Scalars['String']>;
  thursdayHours?: Maybe<Scalars['String']>;
  thursdayHours_not?: Maybe<Scalars['String']>;
  thursdayHours_in?: Maybe<Array<Scalars['String']>>;
  thursdayHours_not_in?: Maybe<Array<Scalars['String']>>;
  thursdayHours_contains?: Maybe<Scalars['String']>;
  thursdayHours_startsWith?: Maybe<Scalars['String']>;
  thursdayHours_endsWith?: Maybe<Scalars['String']>;
  fridayHours?: Maybe<Scalars['String']>;
  fridayHours_not?: Maybe<Scalars['String']>;
  fridayHours_in?: Maybe<Array<Scalars['String']>>;
  fridayHours_not_in?: Maybe<Array<Scalars['String']>>;
  fridayHours_contains?: Maybe<Scalars['String']>;
  fridayHours_startsWith?: Maybe<Scalars['String']>;
  fridayHours_endsWith?: Maybe<Scalars['String']>;
  saturdayHours?: Maybe<Scalars['String']>;
  saturdayHours_not?: Maybe<Scalars['String']>;
  saturdayHours_in?: Maybe<Array<Scalars['String']>>;
  saturdayHours_not_in?: Maybe<Array<Scalars['String']>>;
  saturdayHours_contains?: Maybe<Scalars['String']>;
  saturdayHours_startsWith?: Maybe<Scalars['String']>;
  saturdayHours_endsWith?: Maybe<Scalars['String']>;
  sundayHours?: Maybe<Scalars['String']>;
  sundayHours_not?: Maybe<Scalars['String']>;
  sundayHours_in?: Maybe<Array<Scalars['String']>>;
  sundayHours_not_in?: Maybe<Array<Scalars['String']>>;
  sundayHours_contains?: Maybe<Scalars['String']>;
  sundayHours_startsWith?: Maybe<Scalars['String']>;
  sundayHours_endsWith?: Maybe<Scalars['String']>;
  tradingHours?: Maybe<Scalars['String']>;
  tradingHours_not?: Maybe<Scalars['String']>;
  tradingHours_in?: Maybe<Array<Scalars['String']>>;
  tradingHours_not_in?: Maybe<Array<Scalars['String']>>;
  tradingHours_contains?: Maybe<Scalars['String']>;
  tradingHours_startsWith?: Maybe<Scalars['String']>;
  tradingHours_endsWith?: Maybe<Scalars['String']>;
  AND?: Maybe<Array<FacilityWhereInput>>;
  OR?: Maybe<Array<FacilityWhereInput>>;
  NOT?: Maybe<Array<FacilityWhereInput>>;
};

export type File = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  original?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  scaled?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  document?: Maybe<Document>;
  property?: Maybe<Property>;
  stakeholder?: Maybe<Stakeholder>;
  applicationId?: Maybe<Scalars['String']>;
  application?: Maybe<Application>;
  postId?: Maybe<Scalars['String']>;
  post?: Maybe<Post>;
  userId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  propertyListingId?: Maybe<Scalars['String']>;
  PropertyListing?: Maybe<PropertyListing>;
  classifiedId?: Maybe<Scalars['String']>;
  classified?: Maybe<Classified>;
  neighbourhoodServiceProvider?: Maybe<NeighbourhoodServiceProvider>;
  membership?: Maybe<Membership>;
  club?: Maybe<Club>;
  event?: Maybe<Event>;
  serviceReferences?: Maybe<NeighbourhoodServiceReference>;
};

export type FileCreateInput = {
  original?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  scaled?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  document?: Maybe<DocumentCreateInput>;
  property?: Maybe<PropertyCreateInput>;
  stakeholder?: Maybe<StakeholderCreateInput>;
  applicationId?: Maybe<Scalars['String']>;
  application?: Maybe<ApplicationCreateInput>;
  postId?: Maybe<Scalars['String']>;
  post?: Maybe<PostCreateInput>;
  userId?: Maybe<Scalars['String']>;
  user?: Maybe<UserCreateInput>;
  propertyListingId?: Maybe<Scalars['String']>;
  PropertyListing?: Maybe<PropertyListingCreateInput>;
  classifiedId?: Maybe<Scalars['String']>;
  classified?: Maybe<ClassifiedCreateInput>;
  neighbourhoodServiceProvider?: Maybe<NeighbourhoodServiceProviderCreateInput>;
  membership?: Maybe<MembershipCreateInput>;
  club?: Maybe<ClubCreateInput>;
  event?: Maybe<EventCreateInput>;
  serviceReferences?: Maybe<NeighbourhoodServiceReferenceCreateInput>;
};

export enum FileOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  OriginalAsc = 'original_ASC',
  OriginalDesc = 'original_DESC',
  ThumbnailAsc = 'thumbnail_ASC',
  ThumbnailDesc = 'thumbnail_DESC',
  ScaledAsc = 'scaled_ASC',
  ScaledDesc = 'scaled_DESC',
  DocumentIdAsc = 'documentId_ASC',
  DocumentIdDesc = 'documentId_DESC',
  DocumentAsc = 'document_ASC',
  DocumentDesc = 'document_DESC',
  PropertyAsc = 'property_ASC',
  PropertyDesc = 'property_DESC',
  StakeholderAsc = 'stakeholder_ASC',
  StakeholderDesc = 'stakeholder_DESC',
  ApplicationIdAsc = 'applicationId_ASC',
  ApplicationIdDesc = 'applicationId_DESC',
  ApplicationAsc = 'application_ASC',
  ApplicationDesc = 'application_DESC',
  PostIdAsc = 'postId_ASC',
  PostIdDesc = 'postId_DESC',
  PostAsc = 'post_ASC',
  PostDesc = 'post_DESC',
  UserIdAsc = 'userId_ASC',
  UserIdDesc = 'userId_DESC',
  UserAsc = 'user_ASC',
  UserDesc = 'user_DESC',
  PropertyListingIdAsc = 'propertyListingId_ASC',
  PropertyListingIdDesc = 'propertyListingId_DESC',
  PropertyListingAsc = 'PropertyListing_ASC',
  PropertyListingDesc = 'PropertyListing_DESC',
  ClassifiedIdAsc = 'classifiedId_ASC',
  ClassifiedIdDesc = 'classifiedId_DESC',
  ClassifiedAsc = 'classified_ASC',
  ClassifiedDesc = 'classified_DESC',
  NeighbourhoodServiceProviderAsc = 'neighbourhoodServiceProvider_ASC',
  NeighbourhoodServiceProviderDesc = 'neighbourhoodServiceProvider_DESC',
  MembershipAsc = 'membership_ASC',
  MembershipDesc = 'membership_DESC',
  ClubAsc = 'club_ASC',
  ClubDesc = 'club_DESC',
  EventAsc = 'event_ASC',
  EventDesc = 'event_DESC',
  ServiceReferencesAsc = 'serviceReferences_ASC',
  ServiceReferencesDesc = 'serviceReferences_DESC',
}

export type FileUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  original?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  scaled?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  document?: Maybe<DocumentUpdateInput>;
  property?: Maybe<PropertyUpdateInput>;
  stakeholder?: Maybe<StakeholderUpdateInput>;
  applicationId?: Maybe<Scalars['String']>;
  application?: Maybe<ApplicationUpdateInput>;
  postId?: Maybe<Scalars['String']>;
  post?: Maybe<PostUpdateInput>;
  userId?: Maybe<Scalars['String']>;
  user?: Maybe<UserUpdateInput>;
  propertyListingId?: Maybe<Scalars['String']>;
  PropertyListing?: Maybe<PropertyListingUpdateInput>;
  classifiedId?: Maybe<Scalars['String']>;
  classified?: Maybe<ClassifiedUpdateInput>;
  neighbourhoodServiceProvider?: Maybe<NeighbourhoodServiceProviderUpdateInput>;
  membership?: Maybe<MembershipUpdateInput>;
  club?: Maybe<ClubUpdateInput>;
  event?: Maybe<EventUpdateInput>;
  serviceReferences?: Maybe<NeighbourhoodServiceReferenceUpdateInput>;
};

export type FileWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  original?: Maybe<Scalars['String']>;
  original_not?: Maybe<Scalars['String']>;
  original_in?: Maybe<Array<Scalars['String']>>;
  original_not_in?: Maybe<Array<Scalars['String']>>;
  original_contains?: Maybe<Scalars['String']>;
  original_startsWith?: Maybe<Scalars['String']>;
  original_endsWith?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  thumbnail_not?: Maybe<Scalars['String']>;
  thumbnail_in?: Maybe<Array<Scalars['String']>>;
  thumbnail_not_in?: Maybe<Array<Scalars['String']>>;
  thumbnail_contains?: Maybe<Scalars['String']>;
  thumbnail_startsWith?: Maybe<Scalars['String']>;
  thumbnail_endsWith?: Maybe<Scalars['String']>;
  scaled?: Maybe<Scalars['String']>;
  scaled_not?: Maybe<Scalars['String']>;
  scaled_in?: Maybe<Array<Scalars['String']>>;
  scaled_not_in?: Maybe<Array<Scalars['String']>>;
  scaled_contains?: Maybe<Scalars['String']>;
  scaled_startsWith?: Maybe<Scalars['String']>;
  scaled_endsWith?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  documentId_not?: Maybe<Scalars['String']>;
  documentId_in?: Maybe<Array<Scalars['String']>>;
  documentId_not_in?: Maybe<Array<Scalars['String']>>;
  documentId_contains?: Maybe<Scalars['String']>;
  documentId_startsWith?: Maybe<Scalars['String']>;
  documentId_endsWith?: Maybe<Scalars['String']>;
  document?: Maybe<DocumentWhereInput>;
  document_not?: Maybe<DocumentWhereInput>;
  document_in?: Maybe<Array<DocumentWhereInput>>;
  document_not_in?: Maybe<Array<DocumentWhereInput>>;
  property?: Maybe<PropertyWhereInput>;
  property_not?: Maybe<PropertyWhereInput>;
  property_in?: Maybe<Array<PropertyWhereInput>>;
  property_not_in?: Maybe<Array<PropertyWhereInput>>;
  stakeholder?: Maybe<StakeholderWhereInput>;
  stakeholder_not?: Maybe<StakeholderWhereInput>;
  stakeholder_in?: Maybe<Array<StakeholderWhereInput>>;
  stakeholder_not_in?: Maybe<Array<StakeholderWhereInput>>;
  applicationId?: Maybe<Scalars['String']>;
  applicationId_not?: Maybe<Scalars['String']>;
  applicationId_in?: Maybe<Array<Scalars['String']>>;
  applicationId_not_in?: Maybe<Array<Scalars['String']>>;
  applicationId_contains?: Maybe<Scalars['String']>;
  applicationId_startsWith?: Maybe<Scalars['String']>;
  applicationId_endsWith?: Maybe<Scalars['String']>;
  application?: Maybe<ApplicationWhereInput>;
  application_not?: Maybe<ApplicationWhereInput>;
  application_in?: Maybe<Array<ApplicationWhereInput>>;
  application_not_in?: Maybe<Array<ApplicationWhereInput>>;
  postId?: Maybe<Scalars['String']>;
  postId_not?: Maybe<Scalars['String']>;
  postId_in?: Maybe<Array<Scalars['String']>>;
  postId_not_in?: Maybe<Array<Scalars['String']>>;
  postId_contains?: Maybe<Scalars['String']>;
  postId_startsWith?: Maybe<Scalars['String']>;
  postId_endsWith?: Maybe<Scalars['String']>;
  post?: Maybe<PostWhereInput>;
  post_not?: Maybe<PostWhereInput>;
  post_in?: Maybe<Array<PostWhereInput>>;
  post_not_in?: Maybe<Array<PostWhereInput>>;
  userId?: Maybe<Scalars['String']>;
  userId_not?: Maybe<Scalars['String']>;
  userId_in?: Maybe<Array<Scalars['String']>>;
  userId_not_in?: Maybe<Array<Scalars['String']>>;
  userId_contains?: Maybe<Scalars['String']>;
  userId_startsWith?: Maybe<Scalars['String']>;
  userId_endsWith?: Maybe<Scalars['String']>;
  user?: Maybe<UserWhereInput>;
  user_not?: Maybe<UserWhereInput>;
  user_in?: Maybe<Array<UserWhereInput>>;
  user_not_in?: Maybe<Array<UserWhereInput>>;
  propertyListingId?: Maybe<Scalars['String']>;
  propertyListingId_not?: Maybe<Scalars['String']>;
  propertyListingId_in?: Maybe<Array<Scalars['String']>>;
  propertyListingId_not_in?: Maybe<Array<Scalars['String']>>;
  propertyListingId_contains?: Maybe<Scalars['String']>;
  propertyListingId_startsWith?: Maybe<Scalars['String']>;
  propertyListingId_endsWith?: Maybe<Scalars['String']>;
  PropertyListing?: Maybe<PropertyListingWhereInput>;
  PropertyListing_not?: Maybe<PropertyListingWhereInput>;
  PropertyListing_in?: Maybe<Array<PropertyListingWhereInput>>;
  PropertyListing_not_in?: Maybe<Array<PropertyListingWhereInput>>;
  classifiedId?: Maybe<Scalars['String']>;
  classifiedId_not?: Maybe<Scalars['String']>;
  classifiedId_in?: Maybe<Array<Scalars['String']>>;
  classifiedId_not_in?: Maybe<Array<Scalars['String']>>;
  classifiedId_contains?: Maybe<Scalars['String']>;
  classifiedId_startsWith?: Maybe<Scalars['String']>;
  classifiedId_endsWith?: Maybe<Scalars['String']>;
  classified?: Maybe<ClassifiedWhereInput>;
  classified_not?: Maybe<ClassifiedWhereInput>;
  classified_in?: Maybe<Array<ClassifiedWhereInput>>;
  classified_not_in?: Maybe<Array<ClassifiedWhereInput>>;
  neighbourhoodServiceProvider?: Maybe<NeighbourhoodServiceProviderWhereInput>;
  neighbourhoodServiceProvider_not?: Maybe<NeighbourhoodServiceProviderWhereInput>;
  neighbourhoodServiceProvider_in?: Maybe<Array<NeighbourhoodServiceProviderWhereInput>>;
  neighbourhoodServiceProvider_not_in?: Maybe<Array<NeighbourhoodServiceProviderWhereInput>>;
  membership?: Maybe<MembershipWhereInput>;
  membership_not?: Maybe<MembershipWhereInput>;
  membership_in?: Maybe<Array<MembershipWhereInput>>;
  membership_not_in?: Maybe<Array<MembershipWhereInput>>;
  club?: Maybe<ClubWhereInput>;
  club_not?: Maybe<ClubWhereInput>;
  club_in?: Maybe<Array<ClubWhereInput>>;
  club_not_in?: Maybe<Array<ClubWhereInput>>;
  event?: Maybe<EventWhereInput>;
  event_not?: Maybe<EventWhereInput>;
  event_in?: Maybe<Array<EventWhereInput>>;
  event_not_in?: Maybe<Array<EventWhereInput>>;
  serviceReferences?: Maybe<NeighbourhoodServiceReferenceWhereInput>;
  serviceReferences_not?: Maybe<NeighbourhoodServiceReferenceWhereInput>;
  serviceReferences_in?: Maybe<Array<NeighbourhoodServiceReferenceWhereInput>>;
  serviceReferences_not_in?: Maybe<Array<NeighbourhoodServiceReferenceWhereInput>>;
  AND?: Maybe<Array<FileWhereInput>>;
  OR?: Maybe<Array<FileWhereInput>>;
  NOT?: Maybe<Array<FileWhereInput>>;
};

export type Membership = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  fields?: Maybe<Scalars['JSON']>;
  rejectReason?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  document?: Maybe<File>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<Stakeholder>;
  propertyId?: Maybe<Scalars['String']>;
  property?: Maybe<Property>;
  status?: Maybe<ApplicationStatus>;
  type?: Maybe<MembershipType>;
};

export type MembershipCreateInput = {
  deletedAt?: Maybe<Scalars['DateTime']>;
  fields?: Maybe<Scalars['JSON']>;
  rejectReason?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  document?: Maybe<FileCreateInput>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<StakeholderCreateInput>;
  propertyId?: Maybe<Scalars['String']>;
  property?: Maybe<PropertyCreateInput>;
  status?: Maybe<ApplicationStatus>;
  type?: Maybe<MembershipType>;
};

export enum MembershipOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  DeletedAtAsc = 'deletedAt_ASC',
  DeletedAtDesc = 'deletedAt_DESC',
  FieldsAsc = 'fields_ASC',
  FieldsDesc = 'fields_DESC',
  RejectReasonAsc = 'rejectReason_ASC',
  RejectReasonDesc = 'rejectReason_DESC',
  DocumentIdAsc = 'documentId_ASC',
  DocumentIdDesc = 'documentId_DESC',
  DocumentAsc = 'document_ASC',
  DocumentDesc = 'document_DESC',
  StakeholderIdAsc = 'stakeholderId_ASC',
  StakeholderIdDesc = 'stakeholderId_DESC',
  StakeholderAsc = 'stakeholder_ASC',
  StakeholderDesc = 'stakeholder_DESC',
  PropertyIdAsc = 'propertyId_ASC',
  PropertyIdDesc = 'propertyId_DESC',
  PropertyAsc = 'property_ASC',
  PropertyDesc = 'property_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
}

export enum MembershipType {
  GolfMembership = 'GOLF_MEMBERSHIP',
  GymMembership = 'GYM_MEMBERSHIP',
  TennisMembership = 'TENNIS_MEMBERSHIP',
}

export type MembershipUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  fields?: Maybe<Scalars['JSON']>;
  rejectReason?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  document?: Maybe<FileUpdateInput>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<StakeholderUpdateInput>;
  propertyId?: Maybe<Scalars['String']>;
  property?: Maybe<PropertyUpdateInput>;
  status?: Maybe<ApplicationStatus>;
  type?: Maybe<MembershipType>;
};

export type MembershipWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedAt_not?: Maybe<Scalars['DateTime']>;
  deletedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  deletedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  fields?: Maybe<Scalars['JSON']>;
  fields_not?: Maybe<Scalars['JSON']>;
  fields_in?: Maybe<Array<Scalars['JSON']>>;
  fields_not_in?: Maybe<Array<Scalars['JSON']>>;
  rejectReason?: Maybe<Scalars['String']>;
  rejectReason_not?: Maybe<Scalars['String']>;
  rejectReason_in?: Maybe<Array<Scalars['String']>>;
  rejectReason_not_in?: Maybe<Array<Scalars['String']>>;
  rejectReason_contains?: Maybe<Scalars['String']>;
  rejectReason_startsWith?: Maybe<Scalars['String']>;
  rejectReason_endsWith?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  documentId_not?: Maybe<Scalars['String']>;
  documentId_in?: Maybe<Array<Scalars['String']>>;
  documentId_not_in?: Maybe<Array<Scalars['String']>>;
  documentId_contains?: Maybe<Scalars['String']>;
  documentId_startsWith?: Maybe<Scalars['String']>;
  documentId_endsWith?: Maybe<Scalars['String']>;
  document?: Maybe<FileWhereInput>;
  document_not?: Maybe<FileWhereInput>;
  document_in?: Maybe<Array<FileWhereInput>>;
  document_not_in?: Maybe<Array<FileWhereInput>>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholderId_not?: Maybe<Scalars['String']>;
  stakeholderId_in?: Maybe<Array<Scalars['String']>>;
  stakeholderId_not_in?: Maybe<Array<Scalars['String']>>;
  stakeholderId_contains?: Maybe<Scalars['String']>;
  stakeholderId_startsWith?: Maybe<Scalars['String']>;
  stakeholderId_endsWith?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<StakeholderWhereInput>;
  stakeholder_not?: Maybe<StakeholderWhereInput>;
  stakeholder_in?: Maybe<Array<StakeholderWhereInput>>;
  stakeholder_not_in?: Maybe<Array<StakeholderWhereInput>>;
  propertyId?: Maybe<Scalars['String']>;
  propertyId_not?: Maybe<Scalars['String']>;
  propertyId_in?: Maybe<Array<Scalars['String']>>;
  propertyId_not_in?: Maybe<Array<Scalars['String']>>;
  propertyId_contains?: Maybe<Scalars['String']>;
  propertyId_startsWith?: Maybe<Scalars['String']>;
  propertyId_endsWith?: Maybe<Scalars['String']>;
  property?: Maybe<PropertyWhereInput>;
  property_not?: Maybe<PropertyWhereInput>;
  property_in?: Maybe<Array<PropertyWhereInput>>;
  property_not_in?: Maybe<Array<PropertyWhereInput>>;
  status?: Maybe<ApplicationStatus>;
  status_not?: Maybe<ApplicationStatus>;
  status_in?: Maybe<Array<ApplicationStatus>>;
  status_not_in?: Maybe<Array<ApplicationStatus>>;
  type?: Maybe<MembershipType>;
  type_not?: Maybe<MembershipType>;
  type_in?: Maybe<Array<MembershipType>>;
  type_not_in?: Maybe<Array<MembershipType>>;
  AND?: Maybe<Array<MembershipWhereInput>>;
  OR?: Maybe<Array<MembershipWhereInput>>;
  NOT?: Maybe<Array<MembershipWhereInput>>;
};

export type Mutation = {
  root?: Maybe<Scalars['String']>;
  createApplication: Application;
  updateApplication: Application;
  createBooking: Booking;
  updateBooking: Booking;
  createCalendarEvent: CalendarEvent;
  updateCalendarEvent: CalendarEvent;
  createClassified: Classified;
  updateClassified: Classified;
  createClassifiedCategory: ClassifiedCategory;
  updateClassifiedCategory: ClassifiedCategory;
  createClassifiedSubCategory: ClassifiedSubCategory;
  updateClassifiedSubCategory: ClassifiedSubCategory;
  createClub: Club;
  updateClub: Club;
  createComment: Comment;
  updateComment: Comment;
  createContactUs: ContactUs;
  updateContactUs: ContactUs;
  archiveContactUs: ContactUs;
  createDocument: Document;
  updateDocument: Document;
  createEatery: Eatery;
  updateEatery: Eatery;
  createEstateInfo: EstateInfo;
  updateEstateInfo: EstateInfo;
  archiveEstateInfo: EstateInfo;
  createEvent: Event;
  updateEvent: Event;
  createFacility: Facility;
  updateFacility: Facility;
  createFile: File;
  updateFile: File;
  createMembership: Membership;
  updateMembership: Membership;
  createNeighbourhoodService: NeighbourhoodService;
  updateNeighbourhoodService: NeighbourhoodService;
  createNeighbourhoodServiceCategory: NeighbourhoodServiceCategory;
  updateNeighbourhoodServiceCategory: NeighbourhoodServiceCategory;
  createNeighbourhoodServiceProvider: NeighbourhoodServiceProvider;
  updateNeighbourhoodServiceProvider: NeighbourhoodServiceProvider;
  createNeighbourhoodServiceProviderRating: NeighbourhoodServiceProviderRating;
  updateNeighbourhoodServiceProviderRating: NeighbourhoodServiceProviderRating;
  createNeighbourhoodServiceReference: NeighbourhoodServiceReference;
  updateNeighbourhoodServiceReference: NeighbourhoodServiceReference;
  createNeighbourhoodServiceRequest: NeighbourhoodServiceRequest;
  updateNeighbourhoodServiceRequest: NeighbourhoodServiceRequest;
  createNotification: Notification;
  updateNotification: Notification;
  createOrder: Order;
  updateOrder: Order;
  createPass: Pass;
  updatePass: Pass;
  createPDFLibraryItem: PdfLibraryItem;
  updatePDFLibraryItem: PdfLibraryItem;
  createPost: Post;
  updatePost: Post;
  createPostUserRelation: PostUserRelation;
  updatePostUserRelation: PostUserRelation;
  createProduct: Product;
  updateProduct: Product;
  createProperty: Property;
  updateProperty: Property;
  createPropertyListing: PropertyListing;
  updatePropertyListing: PropertyListing;
  createShop: Shop;
  updateShop: Shop;
  createStakeholder: Stakeholder;
  updateStakeholder: Stakeholder;
  createTermsAndConditions: TermsAndConditions;
  updateTermsAndConditions: TermsAndConditions;
  createTicket: Ticket;
  updateTicket: Ticket;
  createUser: User;
  updateUser: User;
  createUtility: Utility;
  updateUtility: Utility;
  createVehicle: Vehicle;
  updateVehicle: Vehicle;
  createVisit: Visit;
  updateVisit: Visit;
  assignTicket?: Maybe<Ticket>;
  authenticateUser: UserAuthenticatePayload;
  authenticateStakeholder: StakeholderAuthenticatePayload;
  /** Creates a stakeholder organised event. */
  createStakeholderVisit?: Maybe<StakeholderVisitCreateResponse>;
  inviteUser: UserInvitePayload;
  /** Initialises the stakeholder password reset process by creating and sending an otp. */
  resetStakeholder: StakeholderResetPayload;
  resetUser: UserResetPayload;
  updateStakeholderProfile?: Maybe<Stakeholder>;
  validateStakeholder: StakeholderValidatePayload;
  validateUser: UserValidatePayload;
};

export type MutationCreateApplicationArgs = {
  data: ApplicationCreateInput;
};

export type MutationUpdateApplicationArgs = {
  id: Scalars['ID'];
  data: ApplicationUpdateInput;
};

export type MutationCreateBookingArgs = {
  data: BookingCreateInput;
};

export type MutationUpdateBookingArgs = {
  id: Scalars['ID'];
  data: BookingUpdateInput;
};

export type MutationCreateCalendarEventArgs = {
  data: CalendarEventCreateInput;
};

export type MutationUpdateCalendarEventArgs = {
  id: Scalars['ID'];
  data: CalendarEventUpdateInput;
};

export type MutationCreateClassifiedArgs = {
  data: ClassifiedCreateInput;
};

export type MutationUpdateClassifiedArgs = {
  id: Scalars['ID'];
  data: ClassifiedUpdateInput;
};

export type MutationCreateClassifiedCategoryArgs = {
  data: ClassifiedCategoryCreateInput;
};

export type MutationUpdateClassifiedCategoryArgs = {
  id: Scalars['ID'];
  data: ClassifiedCategoryUpdateInput;
};

export type MutationCreateClassifiedSubCategoryArgs = {
  data: ClassifiedSubCategoryCreateInput;
};

export type MutationUpdateClassifiedSubCategoryArgs = {
  id: Scalars['ID'];
  data: ClassifiedSubCategoryUpdateInput;
};

export type MutationCreateClubArgs = {
  data: ClubCreateInput;
};

export type MutationUpdateClubArgs = {
  id: Scalars['ID'];
  data: ClubUpdateInput;
};

export type MutationCreateCommentArgs = {
  data: CommentCreateInput;
};

export type MutationUpdateCommentArgs = {
  id: Scalars['ID'];
  data: CommentUpdateInput;
};

export type MutationCreateContactUsArgs = {
  data: ContactUsCreateInput;
};

export type MutationUpdateContactUsArgs = {
  id: Scalars['ID'];
  data: ContactUsUpdateInput;
};

export type MutationArchiveContactUsArgs = {
  id: Scalars['ID'];
};

export type MutationCreateDocumentArgs = {
  data: DocumentCreateInput;
};

export type MutationUpdateDocumentArgs = {
  id: Scalars['ID'];
  data: DocumentUpdateInput;
};

export type MutationCreateEateryArgs = {
  data: EateryCreateInput;
};

export type MutationUpdateEateryArgs = {
  id: Scalars['ID'];
  data: EateryUpdateInput;
};

export type MutationCreateEstateInfoArgs = {
  data: EstateInfoCreateInput;
};

export type MutationUpdateEstateInfoArgs = {
  id: Scalars['ID'];
  data: EstateInfoUpdateInput;
};

export type MutationArchiveEstateInfoArgs = {
  id: Scalars['ID'];
};

export type MutationCreateEventArgs = {
  data: EventCreateInput;
};

export type MutationUpdateEventArgs = {
  id: Scalars['ID'];
  data: EventUpdateInput;
};

export type MutationCreateFacilityArgs = {
  data: FacilityCreateInput;
};

export type MutationUpdateFacilityArgs = {
  id: Scalars['ID'];
  data: FacilityUpdateInput;
};

export type MutationCreateFileArgs = {
  data: FileCreateInput;
};

export type MutationUpdateFileArgs = {
  id: Scalars['ID'];
  data: FileUpdateInput;
};

export type MutationCreateMembershipArgs = {
  data: MembershipCreateInput;
};

export type MutationUpdateMembershipArgs = {
  id: Scalars['ID'];
  data: MembershipUpdateInput;
};

export type MutationCreateNeighbourhoodServiceArgs = {
  data: NeighbourhoodServiceCreateInput;
};

export type MutationUpdateNeighbourhoodServiceArgs = {
  id: Scalars['ID'];
  data: NeighbourhoodServiceUpdateInput;
};

export type MutationCreateNeighbourhoodServiceCategoryArgs = {
  data: NeighbourhoodServiceCategoryCreateInput;
};

export type MutationUpdateNeighbourhoodServiceCategoryArgs = {
  id: Scalars['ID'];
  data: NeighbourhoodServiceCategoryUpdateInput;
};

export type MutationCreateNeighbourhoodServiceProviderArgs = {
  data: NeighbourhoodServiceProviderCreateInput;
};

export type MutationUpdateNeighbourhoodServiceProviderArgs = {
  id: Scalars['ID'];
  data: NeighbourhoodServiceProviderUpdateInput;
};

export type MutationCreateNeighbourhoodServiceProviderRatingArgs = {
  data: NeighbourhoodServiceProviderRatingCreateInput;
};

export type MutationUpdateNeighbourhoodServiceProviderRatingArgs = {
  id: Scalars['ID'];
  data: NeighbourhoodServiceProviderRatingUpdateInput;
};

export type MutationCreateNeighbourhoodServiceReferenceArgs = {
  data: NeighbourhoodServiceReferenceCreateInput;
};

export type MutationUpdateNeighbourhoodServiceReferenceArgs = {
  id: Scalars['ID'];
  data: NeighbourhoodServiceReferenceUpdateInput;
};

export type MutationCreateNeighbourhoodServiceRequestArgs = {
  data: NeighbourhoodServiceRequestCreateInput;
};

export type MutationUpdateNeighbourhoodServiceRequestArgs = {
  id: Scalars['ID'];
  data: NeighbourhoodServiceRequestUpdateInput;
};

export type MutationCreateNotificationArgs = {
  data: NotificationCreateInput;
};

export type MutationUpdateNotificationArgs = {
  id: Scalars['ID'];
  data: NotificationUpdateInput;
};

export type MutationCreateOrderArgs = {
  data: OrderCreateInput;
};

export type MutationUpdateOrderArgs = {
  id: Scalars['ID'];
  data: OrderUpdateInput;
};

export type MutationCreatePassArgs = {
  data: PassCreateInput;
};

export type MutationUpdatePassArgs = {
  id: Scalars['ID'];
  data: PassUpdateInput;
};

export type MutationCreatePdfLibraryItemArgs = {
  data: PdfLibraryItemCreateInput;
};

export type MutationUpdatePdfLibraryItemArgs = {
  id: Scalars['ID'];
  data: PdfLibraryItemUpdateInput;
};

export type MutationCreatePostArgs = {
  data: PostCreateInput;
};

export type MutationUpdatePostArgs = {
  id: Scalars['ID'];
  data: PostUpdateInput;
};

export type MutationCreatePostUserRelationArgs = {
  data: PostUserRelationCreateInput;
};

export type MutationUpdatePostUserRelationArgs = {
  id: Scalars['ID'];
  data: PostUserRelationUpdateInput;
};

export type MutationCreateProductArgs = {
  data: ProductCreateInput;
};

export type MutationUpdateProductArgs = {
  id: Scalars['ID'];
  data: ProductUpdateInput;
};

export type MutationCreatePropertyArgs = {
  data: PropertyCreateInput;
};

export type MutationUpdatePropertyArgs = {
  id: Scalars['ID'];
  data: PropertyUpdateInput;
};

export type MutationCreatePropertyListingArgs = {
  data: PropertyListingCreateInput;
};

export type MutationUpdatePropertyListingArgs = {
  id: Scalars['ID'];
  data: PropertyListingUpdateInput;
};

export type MutationCreateShopArgs = {
  data: ShopCreateInput;
};

export type MutationUpdateShopArgs = {
  id: Scalars['ID'];
  data: ShopUpdateInput;
};

export type MutationCreateStakeholderArgs = {
  data: StakeholderCreateInput;
};

export type MutationUpdateStakeholderArgs = {
  id: Scalars['ID'];
  data: StakeholderUpdateInput;
};

export type MutationCreateTermsAndConditionsArgs = {
  data: TermsAndConditionsCreateInput;
};

export type MutationUpdateTermsAndConditionsArgs = {
  id: Scalars['ID'];
  data: TermsAndConditionsUpdateInput;
};

export type MutationCreateTicketArgs = {
  data: TicketCreateInput;
};

export type MutationUpdateTicketArgs = {
  id: Scalars['ID'];
  data: TicketUpdateInput;
};

export type MutationCreateUserArgs = {
  data: UserCreateInput;
};

export type MutationUpdateUserArgs = {
  id: Scalars['ID'];
  data: UserUpdateInput;
};

export type MutationCreateUtilityArgs = {
  data: UtilityCreateInput;
};

export type MutationUpdateUtilityArgs = {
  id: Scalars['ID'];
  data: UtilityUpdateInput;
};

export type MutationCreateVehicleArgs = {
  data: VehicleCreateInput;
};

export type MutationUpdateVehicleArgs = {
  id: Scalars['ID'];
  data: VehicleUpdateInput;
};

export type MutationCreateVisitArgs = {
  data: VisitCreateInput;
};

export type MutationUpdateVisitArgs = {
  id: Scalars['ID'];
  data: VisitUpdateInput;
};

export type MutationAssignTicketArgs = {
  data?: Maybe<TicketAssignInput>;
};

export type MutationAuthenticateUserArgs = {
  data: UserAuthenticateInput;
};

export type MutationAuthenticateStakeholderArgs = {
  data: StakeholderAuthenticateInput;
};

export type MutationCreateStakeholderVisitArgs = {
  data: StakeholderVisitCreateInput;
};

export type MutationInviteUserArgs = {
  data: UserInviteInput;
};

export type MutationResetStakeholderArgs = {
  data: StakeholderResetInput;
};

export type MutationResetUserArgs = {
  data: UserResetInput;
};

export type MutationUpdateStakeholderProfileArgs = {
  data: StakeholderProfileInput;
};

export type MutationValidateStakeholderArgs = {
  data: StakeholderValidateInput;
};

export type MutationValidateUserArgs = {
  data: UserValidateInput;
};

export type NeighbourhoodService = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  status?: Maybe<NeighbourhoodServiceStatus>;
  categoryId?: Maybe<Scalars['String']>;
  serviceCategory?: Maybe<NeighbourhoodServiceCategory>;
  providers?: Maybe<NeighbourhoodServiceProvider>;
};

export type NeighbourhoodServiceCategory = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  status?: Maybe<NeighbourhoodServiceCategoryStatus>;
  services?: Maybe<NeighbourhoodService>;
};

export type NeighbourhoodServiceCategoryCreateInput = {
  deletedAt?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  status?: Maybe<NeighbourhoodServiceCategoryStatus>;
  services?: Maybe<NeighbourhoodServiceCreateInput>;
};

export enum NeighbourhoodServiceCategoryOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  DeletedAtAsc = 'deletedAt_ASC',
  DeletedAtDesc = 'deletedAt_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  ServicesAsc = 'services_ASC',
  ServicesDesc = 'services_DESC',
}

export enum NeighbourhoodServiceCategoryStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
}

export type NeighbourhoodServiceCategoryUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  status?: Maybe<NeighbourhoodServiceCategoryStatus>;
  services?: Maybe<NeighbourhoodServiceUpdateInput>;
};

export type NeighbourhoodServiceCategoryWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedAt_not?: Maybe<Scalars['DateTime']>;
  deletedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  deletedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Scalars['String']>>;
  title_not_in?: Maybe<Array<Scalars['String']>>;
  title_contains?: Maybe<Scalars['String']>;
  title_startsWith?: Maybe<Scalars['String']>;
  title_endsWith?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  description_not?: Maybe<Scalars['String']>;
  description_in?: Maybe<Array<Scalars['String']>>;
  description_not_in?: Maybe<Array<Scalars['String']>>;
  description_contains?: Maybe<Scalars['String']>;
  description_startsWith?: Maybe<Scalars['String']>;
  description_endsWith?: Maybe<Scalars['String']>;
  status?: Maybe<NeighbourhoodServiceCategoryStatus>;
  status_not?: Maybe<NeighbourhoodServiceCategoryStatus>;
  status_in?: Maybe<Array<NeighbourhoodServiceCategoryStatus>>;
  status_not_in?: Maybe<Array<NeighbourhoodServiceCategoryStatus>>;
  services?: Maybe<NeighbourhoodServiceWhereInput>;
  services_not?: Maybe<NeighbourhoodServiceWhereInput>;
  services_in?: Maybe<Array<NeighbourhoodServiceWhereInput>>;
  services_not_in?: Maybe<Array<NeighbourhoodServiceWhereInput>>;
  AND?: Maybe<Array<NeighbourhoodServiceCategoryWhereInput>>;
  OR?: Maybe<Array<NeighbourhoodServiceCategoryWhereInput>>;
  NOT?: Maybe<Array<NeighbourhoodServiceCategoryWhereInput>>;
};

export type NeighbourhoodServiceCreateInput = {
  deletedAt?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  status?: Maybe<NeighbourhoodServiceStatus>;
  categoryId?: Maybe<Scalars['String']>;
  serviceCategory?: Maybe<NeighbourhoodServiceCategoryCreateInput>;
  providers?: Maybe<NeighbourhoodServiceProviderCreateInput>;
};

export enum NeighbourhoodServiceOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  DeletedAtAsc = 'deletedAt_ASC',
  DeletedAtDesc = 'deletedAt_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  CategoryIdAsc = 'categoryId_ASC',
  CategoryIdDesc = 'categoryId_DESC',
  ServiceCategoryAsc = 'serviceCategory_ASC',
  ServiceCategoryDesc = 'serviceCategory_DESC',
  ProvidersAsc = 'providers_ASC',
  ProvidersDesc = 'providers_DESC',
}

export type NeighbourhoodServiceProvider = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  contactNumber?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  availabilityTimes?: Maybe<Scalars['JSON']>;
  approvalDate?: Maybe<Scalars['DateTime']>;
  rejectReason?: Maybe<Scalars['String']>;
  status?: Maybe<NeighbourhoodServiceProviderStatus>;
  serviceId?: Maybe<Scalars['String']>;
  service?: Maybe<NeighbourhoodService>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<Stakeholder>;
  userId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  imageId?: Maybe<Scalars['String']>;
  image?: Maybe<File>;
  references?: Maybe<NeighbourhoodServiceReference>;
  ratings?: Maybe<NeighbourhoodServiceProviderRating>;
  requests?: Maybe<NeighbourhoodServiceRequest>;
};

export type NeighbourhoodServiceProviderCreateInput = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  contactNumber?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  availabilityTimes?: Maybe<Scalars['JSON']>;
  approvalDate?: Maybe<Scalars['DateTime']>;
  rejectReason?: Maybe<Scalars['String']>;
  status?: Maybe<NeighbourhoodServiceProviderStatus>;
  serviceId?: Maybe<Scalars['String']>;
  service?: Maybe<NeighbourhoodServiceCreateInput>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<StakeholderCreateInput>;
  userId?: Maybe<Scalars['String']>;
  user?: Maybe<UserCreateInput>;
  imageId?: Maybe<Scalars['String']>;
  image?: Maybe<FileCreateInput>;
  references?: Maybe<NeighbourhoodServiceReferenceCreateInput>;
  ratings?: Maybe<NeighbourhoodServiceProviderRatingCreateInput>;
  requests?: Maybe<NeighbourhoodServiceRequestCreateInput>;
};

export enum NeighbourhoodServiceProviderOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  ContactNumberAsc = 'contactNumber_ASC',
  ContactNumberDesc = 'contactNumber_DESC',
  CompanyNameAsc = 'companyName_ASC',
  CompanyNameDesc = 'companyName_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  AvailabilityTimesAsc = 'availabilityTimes_ASC',
  AvailabilityTimesDesc = 'availabilityTimes_DESC',
  ApprovalDateAsc = 'approvalDate_ASC',
  ApprovalDateDesc = 'approvalDate_DESC',
  RejectReasonAsc = 'rejectReason_ASC',
  RejectReasonDesc = 'rejectReason_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  ServiceIdAsc = 'serviceId_ASC',
  ServiceIdDesc = 'serviceId_DESC',
  ServiceAsc = 'service_ASC',
  ServiceDesc = 'service_DESC',
  StakeholderIdAsc = 'stakeholderId_ASC',
  StakeholderIdDesc = 'stakeholderId_DESC',
  StakeholderAsc = 'stakeholder_ASC',
  StakeholderDesc = 'stakeholder_DESC',
  UserIdAsc = 'userId_ASC',
  UserIdDesc = 'userId_DESC',
  UserAsc = 'user_ASC',
  UserDesc = 'user_DESC',
  ImageIdAsc = 'imageId_ASC',
  ImageIdDesc = 'imageId_DESC',
  ImageAsc = 'image_ASC',
  ImageDesc = 'image_DESC',
  ReferencesAsc = 'references_ASC',
  ReferencesDesc = 'references_DESC',
  RatingsAsc = 'ratings_ASC',
  RatingsDesc = 'ratings_DESC',
  RequestsAsc = 'requests_ASC',
  RequestsDesc = 'requests_DESC',
}

export type NeighbourhoodServiceProviderRating = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  rating?: Maybe<Scalars['String']>;
  requesteeId?: Maybe<Scalars['String']>;
  requestee?: Maybe<Stakeholder>;
  providerId?: Maybe<Scalars['String']>;
  provider?: Maybe<NeighbourhoodServiceProvider>;
};

export type NeighbourhoodServiceProviderRatingCreateInput = {
  rating?: Maybe<Scalars['String']>;
  requesteeId?: Maybe<Scalars['String']>;
  requestee?: Maybe<StakeholderCreateInput>;
  providerId?: Maybe<Scalars['String']>;
  provider?: Maybe<NeighbourhoodServiceProviderCreateInput>;
};

export enum NeighbourhoodServiceProviderRatingOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  RatingAsc = 'rating_ASC',
  RatingDesc = 'rating_DESC',
  RequesteeIdAsc = 'requesteeId_ASC',
  RequesteeIdDesc = 'requesteeId_DESC',
  RequesteeAsc = 'requestee_ASC',
  RequesteeDesc = 'requestee_DESC',
  ProviderIdAsc = 'providerId_ASC',
  ProviderIdDesc = 'providerId_DESC',
  ProviderAsc = 'provider_ASC',
  ProviderDesc = 'provider_DESC',
}

export type NeighbourhoodServiceProviderRatingUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  rating?: Maybe<Scalars['String']>;
  requesteeId?: Maybe<Scalars['String']>;
  requestee?: Maybe<StakeholderUpdateInput>;
  providerId?: Maybe<Scalars['String']>;
  provider?: Maybe<NeighbourhoodServiceProviderUpdateInput>;
};

export type NeighbourhoodServiceProviderRatingWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  rating?: Maybe<Scalars['String']>;
  rating_not?: Maybe<Scalars['String']>;
  rating_in?: Maybe<Array<Scalars['String']>>;
  rating_not_in?: Maybe<Array<Scalars['String']>>;
  rating_contains?: Maybe<Scalars['String']>;
  rating_startsWith?: Maybe<Scalars['String']>;
  rating_endsWith?: Maybe<Scalars['String']>;
  requesteeId?: Maybe<Scalars['String']>;
  requesteeId_not?: Maybe<Scalars['String']>;
  requesteeId_in?: Maybe<Array<Scalars['String']>>;
  requesteeId_not_in?: Maybe<Array<Scalars['String']>>;
  requesteeId_contains?: Maybe<Scalars['String']>;
  requesteeId_startsWith?: Maybe<Scalars['String']>;
  requesteeId_endsWith?: Maybe<Scalars['String']>;
  requestee?: Maybe<StakeholderWhereInput>;
  requestee_not?: Maybe<StakeholderWhereInput>;
  requestee_in?: Maybe<Array<StakeholderWhereInput>>;
  requestee_not_in?: Maybe<Array<StakeholderWhereInput>>;
  providerId?: Maybe<Scalars['String']>;
  providerId_not?: Maybe<Scalars['String']>;
  providerId_in?: Maybe<Array<Scalars['String']>>;
  providerId_not_in?: Maybe<Array<Scalars['String']>>;
  providerId_contains?: Maybe<Scalars['String']>;
  providerId_startsWith?: Maybe<Scalars['String']>;
  providerId_endsWith?: Maybe<Scalars['String']>;
  provider?: Maybe<NeighbourhoodServiceProviderWhereInput>;
  provider_not?: Maybe<NeighbourhoodServiceProviderWhereInput>;
  provider_in?: Maybe<Array<NeighbourhoodServiceProviderWhereInput>>;
  provider_not_in?: Maybe<Array<NeighbourhoodServiceProviderWhereInput>>;
  AND?: Maybe<Array<NeighbourhoodServiceProviderRatingWhereInput>>;
  OR?: Maybe<Array<NeighbourhoodServiceProviderRatingWhereInput>>;
  NOT?: Maybe<Array<NeighbourhoodServiceProviderRatingWhereInput>>;
};

export enum NeighbourhoodServiceProviderStatus {
  Draft = 'DRAFT',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Approved = 'APPROVED',
  Archived = 'ARCHIVED',
}

export type NeighbourhoodServiceProviderUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  contactNumber?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  availabilityTimes?: Maybe<Scalars['JSON']>;
  approvalDate?: Maybe<Scalars['DateTime']>;
  rejectReason?: Maybe<Scalars['String']>;
  status?: Maybe<NeighbourhoodServiceProviderStatus>;
  serviceId?: Maybe<Scalars['String']>;
  service?: Maybe<NeighbourhoodServiceUpdateInput>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<StakeholderUpdateInput>;
  userId?: Maybe<Scalars['String']>;
  user?: Maybe<UserUpdateInput>;
  imageId?: Maybe<Scalars['String']>;
  image?: Maybe<FileUpdateInput>;
  references?: Maybe<NeighbourhoodServiceReferenceUpdateInput>;
  ratings?: Maybe<NeighbourhoodServiceProviderRatingUpdateInput>;
  requests?: Maybe<NeighbourhoodServiceRequestUpdateInput>;
};

export type NeighbourhoodServiceProviderWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  firstName?: Maybe<Scalars['String']>;
  firstName_not?: Maybe<Scalars['String']>;
  firstName_in?: Maybe<Array<Scalars['String']>>;
  firstName_not_in?: Maybe<Array<Scalars['String']>>;
  firstName_contains?: Maybe<Scalars['String']>;
  firstName_startsWith?: Maybe<Scalars['String']>;
  firstName_endsWith?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  lastName_not?: Maybe<Scalars['String']>;
  lastName_in?: Maybe<Array<Scalars['String']>>;
  lastName_not_in?: Maybe<Array<Scalars['String']>>;
  lastName_contains?: Maybe<Scalars['String']>;
  lastName_startsWith?: Maybe<Scalars['String']>;
  lastName_endsWith?: Maybe<Scalars['String']>;
  contactNumber?: Maybe<Scalars['String']>;
  contactNumber_not?: Maybe<Scalars['String']>;
  contactNumber_in?: Maybe<Array<Scalars['String']>>;
  contactNumber_not_in?: Maybe<Array<Scalars['String']>>;
  contactNumber_contains?: Maybe<Scalars['String']>;
  contactNumber_startsWith?: Maybe<Scalars['String']>;
  contactNumber_endsWith?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyName_not?: Maybe<Scalars['String']>;
  companyName_in?: Maybe<Array<Scalars['String']>>;
  companyName_not_in?: Maybe<Array<Scalars['String']>>;
  companyName_contains?: Maybe<Scalars['String']>;
  companyName_startsWith?: Maybe<Scalars['String']>;
  companyName_endsWith?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  emailAddress_not?: Maybe<Scalars['String']>;
  emailAddress_in?: Maybe<Array<Scalars['String']>>;
  emailAddress_not_in?: Maybe<Array<Scalars['String']>>;
  emailAddress_contains?: Maybe<Scalars['String']>;
  emailAddress_startsWith?: Maybe<Scalars['String']>;
  emailAddress_endsWith?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  description_not?: Maybe<Scalars['String']>;
  description_in?: Maybe<Array<Scalars['String']>>;
  description_not_in?: Maybe<Array<Scalars['String']>>;
  description_contains?: Maybe<Scalars['String']>;
  description_startsWith?: Maybe<Scalars['String']>;
  description_endsWith?: Maybe<Scalars['String']>;
  availabilityTimes?: Maybe<Scalars['JSON']>;
  availabilityTimes_not?: Maybe<Scalars['JSON']>;
  availabilityTimes_in?: Maybe<Array<Scalars['JSON']>>;
  availabilityTimes_not_in?: Maybe<Array<Scalars['JSON']>>;
  approvalDate?: Maybe<Scalars['DateTime']>;
  approvalDate_not?: Maybe<Scalars['DateTime']>;
  approvalDate_in?: Maybe<Array<Scalars['DateTime']>>;
  approvalDate_not_in?: Maybe<Array<Scalars['DateTime']>>;
  rejectReason?: Maybe<Scalars['String']>;
  rejectReason_not?: Maybe<Scalars['String']>;
  rejectReason_in?: Maybe<Array<Scalars['String']>>;
  rejectReason_not_in?: Maybe<Array<Scalars['String']>>;
  rejectReason_contains?: Maybe<Scalars['String']>;
  rejectReason_startsWith?: Maybe<Scalars['String']>;
  rejectReason_endsWith?: Maybe<Scalars['String']>;
  status?: Maybe<NeighbourhoodServiceProviderStatus>;
  status_not?: Maybe<NeighbourhoodServiceProviderStatus>;
  status_in?: Maybe<Array<NeighbourhoodServiceProviderStatus>>;
  status_not_in?: Maybe<Array<NeighbourhoodServiceProviderStatus>>;
  serviceId?: Maybe<Scalars['String']>;
  serviceId_not?: Maybe<Scalars['String']>;
  serviceId_in?: Maybe<Array<Scalars['String']>>;
  serviceId_not_in?: Maybe<Array<Scalars['String']>>;
  serviceId_contains?: Maybe<Scalars['String']>;
  serviceId_startsWith?: Maybe<Scalars['String']>;
  serviceId_endsWith?: Maybe<Scalars['String']>;
  service?: Maybe<NeighbourhoodServiceWhereInput>;
  service_not?: Maybe<NeighbourhoodServiceWhereInput>;
  service_in?: Maybe<Array<NeighbourhoodServiceWhereInput>>;
  service_not_in?: Maybe<Array<NeighbourhoodServiceWhereInput>>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholderId_not?: Maybe<Scalars['String']>;
  stakeholderId_in?: Maybe<Array<Scalars['String']>>;
  stakeholderId_not_in?: Maybe<Array<Scalars['String']>>;
  stakeholderId_contains?: Maybe<Scalars['String']>;
  stakeholderId_startsWith?: Maybe<Scalars['String']>;
  stakeholderId_endsWith?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<StakeholderWhereInput>;
  stakeholder_not?: Maybe<StakeholderWhereInput>;
  stakeholder_in?: Maybe<Array<StakeholderWhereInput>>;
  stakeholder_not_in?: Maybe<Array<StakeholderWhereInput>>;
  userId?: Maybe<Scalars['String']>;
  userId_not?: Maybe<Scalars['String']>;
  userId_in?: Maybe<Array<Scalars['String']>>;
  userId_not_in?: Maybe<Array<Scalars['String']>>;
  userId_contains?: Maybe<Scalars['String']>;
  userId_startsWith?: Maybe<Scalars['String']>;
  userId_endsWith?: Maybe<Scalars['String']>;
  user?: Maybe<UserWhereInput>;
  user_not?: Maybe<UserWhereInput>;
  user_in?: Maybe<Array<UserWhereInput>>;
  user_not_in?: Maybe<Array<UserWhereInput>>;
  imageId?: Maybe<Scalars['String']>;
  imageId_not?: Maybe<Scalars['String']>;
  imageId_in?: Maybe<Array<Scalars['String']>>;
  imageId_not_in?: Maybe<Array<Scalars['String']>>;
  imageId_contains?: Maybe<Scalars['String']>;
  imageId_startsWith?: Maybe<Scalars['String']>;
  imageId_endsWith?: Maybe<Scalars['String']>;
  image?: Maybe<FileWhereInput>;
  image_not?: Maybe<FileWhereInput>;
  image_in?: Maybe<Array<FileWhereInput>>;
  image_not_in?: Maybe<Array<FileWhereInput>>;
  references?: Maybe<NeighbourhoodServiceReferenceWhereInput>;
  references_not?: Maybe<NeighbourhoodServiceReferenceWhereInput>;
  references_in?: Maybe<Array<NeighbourhoodServiceReferenceWhereInput>>;
  references_not_in?: Maybe<Array<NeighbourhoodServiceReferenceWhereInput>>;
  ratings?: Maybe<NeighbourhoodServiceProviderRatingWhereInput>;
  ratings_not?: Maybe<NeighbourhoodServiceProviderRatingWhereInput>;
  ratings_in?: Maybe<Array<NeighbourhoodServiceProviderRatingWhereInput>>;
  ratings_not_in?: Maybe<Array<NeighbourhoodServiceProviderRatingWhereInput>>;
  requests?: Maybe<NeighbourhoodServiceRequestWhereInput>;
  requests_not?: Maybe<NeighbourhoodServiceRequestWhereInput>;
  requests_in?: Maybe<Array<NeighbourhoodServiceRequestWhereInput>>;
  requests_not_in?: Maybe<Array<NeighbourhoodServiceRequestWhereInput>>;
  AND?: Maybe<Array<NeighbourhoodServiceProviderWhereInput>>;
  OR?: Maybe<Array<NeighbourhoodServiceProviderWhereInput>>;
  NOT?: Maybe<Array<NeighbourhoodServiceProviderWhereInput>>;
};

export type NeighbourhoodServiceReference = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  fullName?: Maybe<Scalars['String']>;
  contactNumber?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  media?: Maybe<File>;
  providerId?: Maybe<Scalars['String']>;
  provider?: Maybe<NeighbourhoodServiceProvider>;
};

export type NeighbourhoodServiceReferenceCreateInput = {
  fullName?: Maybe<Scalars['String']>;
  contactNumber?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  media?: Maybe<FileCreateInput>;
  providerId?: Maybe<Scalars['String']>;
  provider?: Maybe<NeighbourhoodServiceProviderCreateInput>;
};

export enum NeighbourhoodServiceReferenceOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  FullNameAsc = 'fullName_ASC',
  FullNameDesc = 'fullName_DESC',
  ContactNumberAsc = 'contactNumber_ASC',
  ContactNumberDesc = 'contactNumber_DESC',
  MediaIdAsc = 'mediaId_ASC',
  MediaIdDesc = 'mediaId_DESC',
  MediaAsc = 'media_ASC',
  MediaDesc = 'media_DESC',
  ProviderIdAsc = 'providerId_ASC',
  ProviderIdDesc = 'providerId_DESC',
  ProviderAsc = 'provider_ASC',
  ProviderDesc = 'provider_DESC',
}

export type NeighbourhoodServiceReferenceUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  fullName?: Maybe<Scalars['String']>;
  contactNumber?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  media?: Maybe<FileUpdateInput>;
  providerId?: Maybe<Scalars['String']>;
  provider?: Maybe<NeighbourhoodServiceProviderUpdateInput>;
};

export type NeighbourhoodServiceReferenceWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  fullName?: Maybe<Scalars['String']>;
  fullName_not?: Maybe<Scalars['String']>;
  fullName_in?: Maybe<Array<Scalars['String']>>;
  fullName_not_in?: Maybe<Array<Scalars['String']>>;
  fullName_contains?: Maybe<Scalars['String']>;
  fullName_startsWith?: Maybe<Scalars['String']>;
  fullName_endsWith?: Maybe<Scalars['String']>;
  contactNumber?: Maybe<Scalars['String']>;
  contactNumber_not?: Maybe<Scalars['String']>;
  contactNumber_in?: Maybe<Array<Scalars['String']>>;
  contactNumber_not_in?: Maybe<Array<Scalars['String']>>;
  contactNumber_contains?: Maybe<Scalars['String']>;
  contactNumber_startsWith?: Maybe<Scalars['String']>;
  contactNumber_endsWith?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  mediaId_not?: Maybe<Scalars['String']>;
  mediaId_in?: Maybe<Array<Scalars['String']>>;
  mediaId_not_in?: Maybe<Array<Scalars['String']>>;
  mediaId_contains?: Maybe<Scalars['String']>;
  mediaId_startsWith?: Maybe<Scalars['String']>;
  mediaId_endsWith?: Maybe<Scalars['String']>;
  media?: Maybe<FileWhereInput>;
  media_not?: Maybe<FileWhereInput>;
  media_in?: Maybe<Array<FileWhereInput>>;
  media_not_in?: Maybe<Array<FileWhereInput>>;
  providerId?: Maybe<Scalars['String']>;
  providerId_not?: Maybe<Scalars['String']>;
  providerId_in?: Maybe<Array<Scalars['String']>>;
  providerId_not_in?: Maybe<Array<Scalars['String']>>;
  providerId_contains?: Maybe<Scalars['String']>;
  providerId_startsWith?: Maybe<Scalars['String']>;
  providerId_endsWith?: Maybe<Scalars['String']>;
  provider?: Maybe<NeighbourhoodServiceProviderWhereInput>;
  provider_not?: Maybe<NeighbourhoodServiceProviderWhereInput>;
  provider_in?: Maybe<Array<NeighbourhoodServiceProviderWhereInput>>;
  provider_not_in?: Maybe<Array<NeighbourhoodServiceProviderWhereInput>>;
  AND?: Maybe<Array<NeighbourhoodServiceReferenceWhereInput>>;
  OR?: Maybe<Array<NeighbourhoodServiceReferenceWhereInput>>;
  NOT?: Maybe<Array<NeighbourhoodServiceReferenceWhereInput>>;
};

export type NeighbourhoodServiceRequest = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<NeighbourhoodServiceRequestType>;
  status?: Maybe<NeighbourhoodServiceRequestStatus>;
  requestedDate?: Maybe<Scalars['DateTime']>;
  timeComment?: Maybe<Scalars['String']>;
  timeSlot?: Maybe<Scalars['JSON']>;
  rejectReason?: Maybe<Scalars['String']>;
  isFlaggedForReview?: Maybe<Scalars['Boolean']>;
  providerId?: Maybe<Scalars['String']>;
  provider?: Maybe<NeighbourhoodServiceProvider>;
  requesteeId?: Maybe<Scalars['String']>;
  requestee?: Maybe<Stakeholder>;
};

export type NeighbourhoodServiceRequestCreateInput = {
  type?: Maybe<NeighbourhoodServiceRequestType>;
  status?: Maybe<NeighbourhoodServiceRequestStatus>;
  requestedDate?: Maybe<Scalars['DateTime']>;
  timeComment?: Maybe<Scalars['String']>;
  timeSlot?: Maybe<Scalars['JSON']>;
  rejectReason?: Maybe<Scalars['String']>;
  isFlaggedForReview?: Maybe<Scalars['Boolean']>;
  providerId?: Maybe<Scalars['String']>;
  provider?: Maybe<NeighbourhoodServiceProviderCreateInput>;
  requesteeId?: Maybe<Scalars['String']>;
  requestee?: Maybe<StakeholderCreateInput>;
};

export enum NeighbourhoodServiceRequestOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  RequestedDateAsc = 'requestedDate_ASC',
  RequestedDateDesc = 'requestedDate_DESC',
  TimeCommentAsc = 'timeComment_ASC',
  TimeCommentDesc = 'timeComment_DESC',
  TimeSlotAsc = 'timeSlot_ASC',
  TimeSlotDesc = 'timeSlot_DESC',
  RejectReasonAsc = 'rejectReason_ASC',
  RejectReasonDesc = 'rejectReason_DESC',
  IsFlaggedForReviewAsc = 'isFlaggedForReview_ASC',
  IsFlaggedForReviewDesc = 'isFlaggedForReview_DESC',
  ProviderIdAsc = 'providerId_ASC',
  ProviderIdDesc = 'providerId_DESC',
  ProviderAsc = 'provider_ASC',
  ProviderDesc = 'provider_DESC',
  RequesteeIdAsc = 'requesteeId_ASC',
  RequesteeIdDesc = 'requesteeId_DESC',
  RequesteeAsc = 'requestee_ASC',
  RequesteeDesc = 'requestee_DESC',
}

export enum NeighbourhoodServiceRequestStatus {
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Approved = 'APPROVED',
  Archived = 'ARCHIVED',
}

export enum NeighbourhoodServiceRequestType {
  Onceoff = 'ONCEOFF',
  Recurring = 'RECURRING',
}

export type NeighbourhoodServiceRequestUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<NeighbourhoodServiceRequestType>;
  status?: Maybe<NeighbourhoodServiceRequestStatus>;
  requestedDate?: Maybe<Scalars['DateTime']>;
  timeComment?: Maybe<Scalars['String']>;
  timeSlot?: Maybe<Scalars['JSON']>;
  rejectReason?: Maybe<Scalars['String']>;
  isFlaggedForReview?: Maybe<Scalars['Boolean']>;
  providerId?: Maybe<Scalars['String']>;
  provider?: Maybe<NeighbourhoodServiceProviderUpdateInput>;
  requesteeId?: Maybe<Scalars['String']>;
  requestee?: Maybe<StakeholderUpdateInput>;
};

export type NeighbourhoodServiceRequestWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  type?: Maybe<NeighbourhoodServiceRequestType>;
  type_not?: Maybe<NeighbourhoodServiceRequestType>;
  type_in?: Maybe<Array<NeighbourhoodServiceRequestType>>;
  type_not_in?: Maybe<Array<NeighbourhoodServiceRequestType>>;
  status?: Maybe<NeighbourhoodServiceRequestStatus>;
  status_not?: Maybe<NeighbourhoodServiceRequestStatus>;
  status_in?: Maybe<Array<NeighbourhoodServiceRequestStatus>>;
  status_not_in?: Maybe<Array<NeighbourhoodServiceRequestStatus>>;
  requestedDate?: Maybe<Scalars['DateTime']>;
  requestedDate_not?: Maybe<Scalars['DateTime']>;
  requestedDate_in?: Maybe<Array<Scalars['DateTime']>>;
  requestedDate_not_in?: Maybe<Array<Scalars['DateTime']>>;
  timeComment?: Maybe<Scalars['String']>;
  timeComment_not?: Maybe<Scalars['String']>;
  timeComment_in?: Maybe<Array<Scalars['String']>>;
  timeComment_not_in?: Maybe<Array<Scalars['String']>>;
  timeComment_contains?: Maybe<Scalars['String']>;
  timeComment_startsWith?: Maybe<Scalars['String']>;
  timeComment_endsWith?: Maybe<Scalars['String']>;
  timeSlot?: Maybe<Scalars['JSON']>;
  timeSlot_not?: Maybe<Scalars['JSON']>;
  timeSlot_in?: Maybe<Array<Scalars['JSON']>>;
  timeSlot_not_in?: Maybe<Array<Scalars['JSON']>>;
  rejectReason?: Maybe<Scalars['String']>;
  rejectReason_not?: Maybe<Scalars['String']>;
  rejectReason_in?: Maybe<Array<Scalars['String']>>;
  rejectReason_not_in?: Maybe<Array<Scalars['String']>>;
  rejectReason_contains?: Maybe<Scalars['String']>;
  rejectReason_startsWith?: Maybe<Scalars['String']>;
  rejectReason_endsWith?: Maybe<Scalars['String']>;
  isFlaggedForReview?: Maybe<Scalars['Boolean']>;
  isFlaggedForReview_not?: Maybe<Scalars['Boolean']>;
  isFlaggedForReview_in?: Maybe<Array<Scalars['Boolean']>>;
  isFlaggedForReview_not_in?: Maybe<Array<Scalars['Boolean']>>;
  providerId?: Maybe<Scalars['String']>;
  providerId_not?: Maybe<Scalars['String']>;
  providerId_in?: Maybe<Array<Scalars['String']>>;
  providerId_not_in?: Maybe<Array<Scalars['String']>>;
  providerId_contains?: Maybe<Scalars['String']>;
  providerId_startsWith?: Maybe<Scalars['String']>;
  providerId_endsWith?: Maybe<Scalars['String']>;
  provider?: Maybe<NeighbourhoodServiceProviderWhereInput>;
  provider_not?: Maybe<NeighbourhoodServiceProviderWhereInput>;
  provider_in?: Maybe<Array<NeighbourhoodServiceProviderWhereInput>>;
  provider_not_in?: Maybe<Array<NeighbourhoodServiceProviderWhereInput>>;
  requesteeId?: Maybe<Scalars['String']>;
  requesteeId_not?: Maybe<Scalars['String']>;
  requesteeId_in?: Maybe<Array<Scalars['String']>>;
  requesteeId_not_in?: Maybe<Array<Scalars['String']>>;
  requesteeId_contains?: Maybe<Scalars['String']>;
  requesteeId_startsWith?: Maybe<Scalars['String']>;
  requesteeId_endsWith?: Maybe<Scalars['String']>;
  requestee?: Maybe<StakeholderWhereInput>;
  requestee_not?: Maybe<StakeholderWhereInput>;
  requestee_in?: Maybe<Array<StakeholderWhereInput>>;
  requestee_not_in?: Maybe<Array<StakeholderWhereInput>>;
  AND?: Maybe<Array<NeighbourhoodServiceRequestWhereInput>>;
  OR?: Maybe<Array<NeighbourhoodServiceRequestWhereInput>>;
  NOT?: Maybe<Array<NeighbourhoodServiceRequestWhereInput>>;
};

export enum NeighbourhoodServiceStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
}

export type NeighbourhoodServiceUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  status?: Maybe<NeighbourhoodServiceStatus>;
  categoryId?: Maybe<Scalars['String']>;
  serviceCategory?: Maybe<NeighbourhoodServiceCategoryUpdateInput>;
  providers?: Maybe<NeighbourhoodServiceProviderUpdateInput>;
};

export type NeighbourhoodServiceWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedAt_not?: Maybe<Scalars['DateTime']>;
  deletedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  deletedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Scalars['String']>>;
  title_not_in?: Maybe<Array<Scalars['String']>>;
  title_contains?: Maybe<Scalars['String']>;
  title_startsWith?: Maybe<Scalars['String']>;
  title_endsWith?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  description_not?: Maybe<Scalars['String']>;
  description_in?: Maybe<Array<Scalars['String']>>;
  description_not_in?: Maybe<Array<Scalars['String']>>;
  description_contains?: Maybe<Scalars['String']>;
  description_startsWith?: Maybe<Scalars['String']>;
  description_endsWith?: Maybe<Scalars['String']>;
  status?: Maybe<NeighbourhoodServiceStatus>;
  status_not?: Maybe<NeighbourhoodServiceStatus>;
  status_in?: Maybe<Array<NeighbourhoodServiceStatus>>;
  status_not_in?: Maybe<Array<NeighbourhoodServiceStatus>>;
  categoryId?: Maybe<Scalars['String']>;
  categoryId_not?: Maybe<Scalars['String']>;
  categoryId_in?: Maybe<Array<Scalars['String']>>;
  categoryId_not_in?: Maybe<Array<Scalars['String']>>;
  categoryId_contains?: Maybe<Scalars['String']>;
  categoryId_startsWith?: Maybe<Scalars['String']>;
  categoryId_endsWith?: Maybe<Scalars['String']>;
  serviceCategory?: Maybe<NeighbourhoodServiceCategoryWhereInput>;
  serviceCategory_not?: Maybe<NeighbourhoodServiceCategoryWhereInput>;
  serviceCategory_in?: Maybe<Array<NeighbourhoodServiceCategoryWhereInput>>;
  serviceCategory_not_in?: Maybe<Array<NeighbourhoodServiceCategoryWhereInput>>;
  providers?: Maybe<NeighbourhoodServiceProviderWhereInput>;
  providers_not?: Maybe<NeighbourhoodServiceProviderWhereInput>;
  providers_in?: Maybe<Array<NeighbourhoodServiceProviderWhereInput>>;
  providers_not_in?: Maybe<Array<NeighbourhoodServiceProviderWhereInput>>;
  AND?: Maybe<Array<NeighbourhoodServiceWhereInput>>;
  OR?: Maybe<Array<NeighbourhoodServiceWhereInput>>;
  NOT?: Maybe<Array<NeighbourhoodServiceWhereInput>>;
};

export type Notification = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  message?: Maybe<Scalars['String']>;
  type?: Maybe<NotificationType>;
  status?: Maybe<NotificationStatus>;
  metadata?: Maybe<Scalars['JSON']>;
};

export type NotificationCreateInput = {
  message?: Maybe<Scalars['String']>;
  type?: Maybe<NotificationType>;
  status?: Maybe<NotificationStatus>;
  metadata?: Maybe<Scalars['JSON']>;
};

export enum NotificationOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  MessageAsc = 'message_ASC',
  MessageDesc = 'message_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  MetadataAsc = 'metadata_ASC',
  MetadataDesc = 'metadata_DESC',
}

export enum NotificationStatus {
  Sent = 'SENT',
}

export enum NotificationType {
  VisitorAlert = 'VISITOR_ALERT',
}

export type NotificationUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  message?: Maybe<Scalars['String']>;
  type?: Maybe<NotificationType>;
  status?: Maybe<NotificationStatus>;
  metadata?: Maybe<Scalars['JSON']>;
};

export type NotificationWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  message?: Maybe<Scalars['String']>;
  message_not?: Maybe<Scalars['String']>;
  message_in?: Maybe<Array<Scalars['String']>>;
  message_not_in?: Maybe<Array<Scalars['String']>>;
  message_contains?: Maybe<Scalars['String']>;
  message_startsWith?: Maybe<Scalars['String']>;
  message_endsWith?: Maybe<Scalars['String']>;
  type?: Maybe<NotificationType>;
  type_not?: Maybe<NotificationType>;
  type_in?: Maybe<Array<NotificationType>>;
  type_not_in?: Maybe<Array<NotificationType>>;
  status?: Maybe<NotificationStatus>;
  status_not?: Maybe<NotificationStatus>;
  status_in?: Maybe<Array<NotificationStatus>>;
  status_not_in?: Maybe<Array<NotificationStatus>>;
  metadata?: Maybe<Scalars['JSON']>;
  metadata_not?: Maybe<Scalars['JSON']>;
  metadata_in?: Maybe<Array<Scalars['JSON']>>;
  metadata_not_in?: Maybe<Array<Scalars['JSON']>>;
  AND?: Maybe<Array<NotificationWhereInput>>;
  OR?: Maybe<Array<NotificationWhereInput>>;
  NOT?: Maybe<Array<NotificationWhereInput>>;
};

export type Order = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  items?: Maybe<Scalars['JSON']>;
  total?: Maybe<Scalars['Float']>;
  paid?: Maybe<Scalars['Float']>;
  stakeholderId?: Maybe<Scalars['String']>;
  purchaser?: Maybe<Stakeholder>;
  eventId?: Maybe<Scalars['String']>;
  event?: Maybe<Event>;
  tickets?: Maybe<Ticket>;
  passes?: Maybe<Pass>;
};

export type OrderCreateInput = {
  items?: Maybe<Scalars['JSON']>;
  total?: Maybe<Scalars['Float']>;
  paid?: Maybe<Scalars['Float']>;
  stakeholderId?: Maybe<Scalars['String']>;
  purchaser?: Maybe<StakeholderCreateInput>;
  eventId?: Maybe<Scalars['String']>;
  event?: Maybe<EventCreateInput>;
  tickets?: Maybe<TicketCreateInput>;
  passes?: Maybe<PassCreateInput>;
};

export enum OrderOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  ItemsAsc = 'items_ASC',
  ItemsDesc = 'items_DESC',
  TotalAsc = 'total_ASC',
  TotalDesc = 'total_DESC',
  PaidAsc = 'paid_ASC',
  PaidDesc = 'paid_DESC',
  StakeholderIdAsc = 'stakeholderId_ASC',
  StakeholderIdDesc = 'stakeholderId_DESC',
  PurchaserAsc = 'purchaser_ASC',
  PurchaserDesc = 'purchaser_DESC',
  EventIdAsc = 'eventId_ASC',
  EventIdDesc = 'eventId_DESC',
  EventAsc = 'event_ASC',
  EventDesc = 'event_DESC',
  TicketsAsc = 'tickets_ASC',
  TicketsDesc = 'tickets_DESC',
  PassesAsc = 'passes_ASC',
  PassesDesc = 'passes_DESC',
}

export type OrderUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  items?: Maybe<Scalars['JSON']>;
  total?: Maybe<Scalars['Float']>;
  paid?: Maybe<Scalars['Float']>;
  stakeholderId?: Maybe<Scalars['String']>;
  purchaser?: Maybe<StakeholderUpdateInput>;
  eventId?: Maybe<Scalars['String']>;
  event?: Maybe<EventUpdateInput>;
  tickets?: Maybe<TicketUpdateInput>;
  passes?: Maybe<PassUpdateInput>;
};

export type OrderWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  items?: Maybe<Scalars['JSON']>;
  items_not?: Maybe<Scalars['JSON']>;
  items_in?: Maybe<Array<Scalars['JSON']>>;
  items_not_in?: Maybe<Array<Scalars['JSON']>>;
  total?: Maybe<Scalars['Float']>;
  total_not?: Maybe<Scalars['Float']>;
  total_in?: Maybe<Array<Scalars['Float']>>;
  total_not_in?: Maybe<Array<Scalars['Float']>>;
  total_lt?: Maybe<Scalars['Float']>;
  total_lte?: Maybe<Scalars['Float']>;
  total_gt?: Maybe<Scalars['Float']>;
  total_gte?: Maybe<Scalars['Float']>;
  paid?: Maybe<Scalars['Float']>;
  paid_not?: Maybe<Scalars['Float']>;
  paid_in?: Maybe<Array<Scalars['Float']>>;
  paid_not_in?: Maybe<Array<Scalars['Float']>>;
  paid_lt?: Maybe<Scalars['Float']>;
  paid_lte?: Maybe<Scalars['Float']>;
  paid_gt?: Maybe<Scalars['Float']>;
  paid_gte?: Maybe<Scalars['Float']>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholderId_not?: Maybe<Scalars['String']>;
  stakeholderId_in?: Maybe<Array<Scalars['String']>>;
  stakeholderId_not_in?: Maybe<Array<Scalars['String']>>;
  stakeholderId_contains?: Maybe<Scalars['String']>;
  stakeholderId_startsWith?: Maybe<Scalars['String']>;
  stakeholderId_endsWith?: Maybe<Scalars['String']>;
  purchaser?: Maybe<StakeholderWhereInput>;
  purchaser_not?: Maybe<StakeholderWhereInput>;
  purchaser_in?: Maybe<Array<StakeholderWhereInput>>;
  purchaser_not_in?: Maybe<Array<StakeholderWhereInput>>;
  eventId?: Maybe<Scalars['String']>;
  eventId_not?: Maybe<Scalars['String']>;
  eventId_in?: Maybe<Array<Scalars['String']>>;
  eventId_not_in?: Maybe<Array<Scalars['String']>>;
  eventId_contains?: Maybe<Scalars['String']>;
  eventId_startsWith?: Maybe<Scalars['String']>;
  eventId_endsWith?: Maybe<Scalars['String']>;
  event?: Maybe<EventWhereInput>;
  event_not?: Maybe<EventWhereInput>;
  event_in?: Maybe<Array<EventWhereInput>>;
  event_not_in?: Maybe<Array<EventWhereInput>>;
  tickets?: Maybe<TicketWhereInput>;
  tickets_not?: Maybe<TicketWhereInput>;
  tickets_in?: Maybe<Array<TicketWhereInput>>;
  tickets_not_in?: Maybe<Array<TicketWhereInput>>;
  passes?: Maybe<PassWhereInput>;
  passes_not?: Maybe<PassWhereInput>;
  passes_in?: Maybe<Array<PassWhereInput>>;
  passes_not_in?: Maybe<Array<PassWhereInput>>;
  AND?: Maybe<Array<OrderWhereInput>>;
  OR?: Maybe<Array<OrderWhereInput>>;
  NOT?: Maybe<Array<OrderWhereInput>>;
};

export type Pass = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  QRcode?: Maybe<Scalars['String']>;
  validFrom?: Maybe<Scalars['DateTime']>;
  validTo?: Maybe<Scalars['DateTime']>;
  checkins?: Maybe<Scalars['JSON']>;
  type?: Maybe<PassType>;
  stakeholderId?: Maybe<Scalars['String']>;
  holder?: Maybe<Stakeholder>;
  visit?: Maybe<Visit>;
  orderId?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  booking?: Maybe<Booking>;
  bookingId?: Maybe<Scalars['String']>;
  ticket?: Maybe<Ticket>;
};

export type PassCreateInput = {
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  QRcode?: Maybe<Scalars['String']>;
  validFrom?: Maybe<Scalars['DateTime']>;
  validTo?: Maybe<Scalars['DateTime']>;
  checkins?: Maybe<Scalars['JSON']>;
  type?: Maybe<PassType>;
  stakeholderId?: Maybe<Scalars['String']>;
  holder?: Maybe<StakeholderCreateInput>;
  visit?: Maybe<VisitCreateInput>;
  orderId?: Maybe<Scalars['String']>;
  order?: Maybe<OrderCreateInput>;
  booking?: Maybe<BookingCreateInput>;
  bookingId?: Maybe<Scalars['String']>;
  ticket?: Maybe<TicketCreateInput>;
};

export enum PassOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  CodeAsc = 'code_ASC',
  CodeDesc = 'code_DESC',
  QRcodeAsc = 'QRcode_ASC',
  QRcodeDesc = 'QRcode_DESC',
  ValidFromAsc = 'validFrom_ASC',
  ValidFromDesc = 'validFrom_DESC',
  ValidToAsc = 'validTo_ASC',
  ValidToDesc = 'validTo_DESC',
  CheckinsAsc = 'checkins_ASC',
  CheckinsDesc = 'checkins_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  StakeholderIdAsc = 'stakeholderId_ASC',
  StakeholderIdDesc = 'stakeholderId_DESC',
  HolderAsc = 'holder_ASC',
  HolderDesc = 'holder_DESC',
  VisitAsc = 'visit_ASC',
  VisitDesc = 'visit_DESC',
  OrderIdAsc = 'orderId_ASC',
  OrderIdDesc = 'orderId_DESC',
  OrderAsc = 'order_ASC',
  OrderDesc = 'order_DESC',
  BookingAsc = 'booking_ASC',
  BookingDesc = 'booking_DESC',
  BookingIdAsc = 'bookingId_ASC',
  BookingIdDesc = 'bookingId_DESC',
  TicketAsc = 'ticket_ASC',
  TicketDesc = 'ticket_DESC',
}

export enum PassType {
  Event = 'EVENT',
  Booking = 'BOOKING',
  Visit = 'VISIT',
}

export type PassUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  QRcode?: Maybe<Scalars['String']>;
  validFrom?: Maybe<Scalars['DateTime']>;
  validTo?: Maybe<Scalars['DateTime']>;
  checkins?: Maybe<Scalars['JSON']>;
  type?: Maybe<PassType>;
  stakeholderId?: Maybe<Scalars['String']>;
  holder?: Maybe<StakeholderUpdateInput>;
  visit?: Maybe<VisitUpdateInput>;
  orderId?: Maybe<Scalars['String']>;
  order?: Maybe<OrderUpdateInput>;
  booking?: Maybe<BookingUpdateInput>;
  bookingId?: Maybe<Scalars['String']>;
  ticket?: Maybe<TicketUpdateInput>;
};

export type PassWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  name?: Maybe<Scalars['String']>;
  name_not?: Maybe<Scalars['String']>;
  name_in?: Maybe<Array<Scalars['String']>>;
  name_not_in?: Maybe<Array<Scalars['String']>>;
  name_contains?: Maybe<Scalars['String']>;
  name_startsWith?: Maybe<Scalars['String']>;
  name_endsWith?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  code_not?: Maybe<Scalars['String']>;
  code_in?: Maybe<Array<Scalars['String']>>;
  code_not_in?: Maybe<Array<Scalars['String']>>;
  code_contains?: Maybe<Scalars['String']>;
  code_startsWith?: Maybe<Scalars['String']>;
  code_endsWith?: Maybe<Scalars['String']>;
  QRcode?: Maybe<Scalars['String']>;
  QRcode_not?: Maybe<Scalars['String']>;
  QRcode_in?: Maybe<Array<Scalars['String']>>;
  QRcode_not_in?: Maybe<Array<Scalars['String']>>;
  QRcode_contains?: Maybe<Scalars['String']>;
  QRcode_startsWith?: Maybe<Scalars['String']>;
  QRcode_endsWith?: Maybe<Scalars['String']>;
  validFrom?: Maybe<Scalars['DateTime']>;
  validFrom_not?: Maybe<Scalars['DateTime']>;
  validFrom_in?: Maybe<Array<Scalars['DateTime']>>;
  validFrom_not_in?: Maybe<Array<Scalars['DateTime']>>;
  validTo?: Maybe<Scalars['DateTime']>;
  validTo_not?: Maybe<Scalars['DateTime']>;
  validTo_in?: Maybe<Array<Scalars['DateTime']>>;
  validTo_not_in?: Maybe<Array<Scalars['DateTime']>>;
  checkins?: Maybe<Scalars['JSON']>;
  checkins_not?: Maybe<Scalars['JSON']>;
  checkins_in?: Maybe<Array<Scalars['JSON']>>;
  checkins_not_in?: Maybe<Array<Scalars['JSON']>>;
  type?: Maybe<PassType>;
  type_not?: Maybe<PassType>;
  type_in?: Maybe<Array<PassType>>;
  type_not_in?: Maybe<Array<PassType>>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholderId_not?: Maybe<Scalars['String']>;
  stakeholderId_in?: Maybe<Array<Scalars['String']>>;
  stakeholderId_not_in?: Maybe<Array<Scalars['String']>>;
  stakeholderId_contains?: Maybe<Scalars['String']>;
  stakeholderId_startsWith?: Maybe<Scalars['String']>;
  stakeholderId_endsWith?: Maybe<Scalars['String']>;
  holder?: Maybe<StakeholderWhereInput>;
  holder_not?: Maybe<StakeholderWhereInput>;
  holder_in?: Maybe<Array<StakeholderWhereInput>>;
  holder_not_in?: Maybe<Array<StakeholderWhereInput>>;
  visit?: Maybe<VisitWhereInput>;
  visit_not?: Maybe<VisitWhereInput>;
  visit_in?: Maybe<Array<VisitWhereInput>>;
  visit_not_in?: Maybe<Array<VisitWhereInput>>;
  orderId?: Maybe<Scalars['String']>;
  orderId_not?: Maybe<Scalars['String']>;
  orderId_in?: Maybe<Array<Scalars['String']>>;
  orderId_not_in?: Maybe<Array<Scalars['String']>>;
  orderId_contains?: Maybe<Scalars['String']>;
  orderId_startsWith?: Maybe<Scalars['String']>;
  orderId_endsWith?: Maybe<Scalars['String']>;
  order?: Maybe<OrderWhereInput>;
  order_not?: Maybe<OrderWhereInput>;
  order_in?: Maybe<Array<OrderWhereInput>>;
  order_not_in?: Maybe<Array<OrderWhereInput>>;
  booking?: Maybe<BookingWhereInput>;
  booking_not?: Maybe<BookingWhereInput>;
  booking_in?: Maybe<Array<BookingWhereInput>>;
  booking_not_in?: Maybe<Array<BookingWhereInput>>;
  bookingId?: Maybe<Scalars['String']>;
  bookingId_not?: Maybe<Scalars['String']>;
  bookingId_in?: Maybe<Array<Scalars['String']>>;
  bookingId_not_in?: Maybe<Array<Scalars['String']>>;
  bookingId_contains?: Maybe<Scalars['String']>;
  bookingId_startsWith?: Maybe<Scalars['String']>;
  bookingId_endsWith?: Maybe<Scalars['String']>;
  ticket?: Maybe<TicketWhereInput>;
  ticket_not?: Maybe<TicketWhereInput>;
  ticket_in?: Maybe<Array<TicketWhereInput>>;
  ticket_not_in?: Maybe<Array<TicketWhereInput>>;
  AND?: Maybe<Array<PassWhereInput>>;
  OR?: Maybe<Array<PassWhereInput>>;
  NOT?: Maybe<Array<PassWhereInput>>;
};

export enum PdfLibraryCategory {
  EstateRelated = 'ESTATE_RELATED',
  NewResidents = 'NEW_RESIDENTS',
  InformationPack = 'INFORMATION_PACK',
  Constructions = 'CONSTRUCTIONS',
  AccessAndSecurity = 'ACCESS_AND_SECURITY',
  Memberships = 'MEMBERSHIPS',
  General = 'GENERAL',
  EstateInformation = 'ESTATE_INFORMATION',
}

export type PdfLibraryItem = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  category?: Maybe<PdfLibraryCategory>;
};

export type PdfLibraryItemCreateInput = {
  name?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  category?: Maybe<PdfLibraryCategory>;
};

export enum PdfLibraryItemOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  FileAsc = 'file_ASC',
  FileDesc = 'file_DESC',
  CategoryAsc = 'category_ASC',
  CategoryDesc = 'category_DESC',
}

export type PdfLibraryItemUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  category?: Maybe<PdfLibraryCategory>;
};

export type PdfLibraryItemWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  name?: Maybe<Scalars['String']>;
  name_not?: Maybe<Scalars['String']>;
  name_in?: Maybe<Array<Scalars['String']>>;
  name_not_in?: Maybe<Array<Scalars['String']>>;
  name_contains?: Maybe<Scalars['String']>;
  name_startsWith?: Maybe<Scalars['String']>;
  name_endsWith?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  file_not?: Maybe<Scalars['String']>;
  file_in?: Maybe<Array<Scalars['String']>>;
  file_not_in?: Maybe<Array<Scalars['String']>>;
  file_contains?: Maybe<Scalars['String']>;
  file_startsWith?: Maybe<Scalars['String']>;
  file_endsWith?: Maybe<Scalars['String']>;
  category?: Maybe<PdfLibraryCategory>;
  category_not?: Maybe<PdfLibraryCategory>;
  category_in?: Maybe<Array<PdfLibraryCategory>>;
  category_not_in?: Maybe<Array<PdfLibraryCategory>>;
  AND?: Maybe<Array<PdfLibraryItemWhereInput>>;
  OR?: Maybe<Array<PdfLibraryItemWhereInput>>;
  NOT?: Maybe<Array<PdfLibraryItemWhereInput>>;
};

export type Post = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  imageId?: Maybe<Scalars['String']>;
  image?: Maybe<File>;
  status?: Maybe<PostStatus>;
  type?: Maybe<PostType>;
  category?: Maybe<PostCategory>;
  read?: Maybe<Scalars['Boolean']>;
  readBy?: Maybe<Array<Maybe<Stakeholder>>>;
  roles?: Maybe<Array<Maybe<StakeholderRole>>>;
  stakeholders?: Maybe<Array<Maybe<Stakeholder>>>;
};

export enum PostCategory {
  Sports = 'SPORTS',
}

export type PostCreateInput = {
  title?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  imageId?: Maybe<Scalars['String']>;
  image?: Maybe<FileCreateInput>;
  status?: Maybe<PostStatus>;
  type?: Maybe<PostType>;
  category?: Maybe<PostCategory>;
  read?: Maybe<Scalars['Boolean']>;
  readBy?: Maybe<StakeholderCreateInput>;
  roles?: Maybe<Array<Maybe<StakeholderRole>>>;
  stakeholders?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum PostOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  BodyAsc = 'body_ASC',
  BodyDesc = 'body_DESC',
  ImageIdAsc = 'imageId_ASC',
  ImageIdDesc = 'imageId_DESC',
  ImageAsc = 'image_ASC',
  ImageDesc = 'image_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  CategoryAsc = 'category_ASC',
  CategoryDesc = 'category_DESC',
  ReadAsc = 'read_ASC',
  ReadDesc = 'read_DESC',
  ReadByAsc = 'readBy_ASC',
  ReadByDesc = 'readBy_DESC',
  RolesAsc = 'roles_ASC',
  RolesDesc = 'roles_DESC',
  StakeholdersAsc = 'stakeholders_ASC',
  StakeholdersDesc = 'stakeholders_DESC',
}

export enum PostStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Archived = 'ARCHIVED',
}

export enum PostType {
  News = 'NEWS',
  Happening = 'HAPPENING',
  Update = 'UPDATE',
  Faq = 'FAQ',
  Estate = 'ESTATE',
  Newsletter = 'NEWSLETTER',
}

export type PostUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  imageId?: Maybe<Scalars['String']>;
  image?: Maybe<FileUpdateInput>;
  status?: Maybe<PostStatus>;
  type?: Maybe<PostType>;
  category?: Maybe<PostCategory>;
  read?: Maybe<Scalars['Boolean']>;
  readBy?: Maybe<StakeholderUpdateInput>;
  roles?: Maybe<Array<Maybe<StakeholderRole>>>;
  stakeholders?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PostUserRelation = {
  id?: Maybe<Scalars['String']>;
  stakeholderID?: Maybe<Scalars['String']>;
  postID?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
};

export type PostUserRelationCreateInput = {
  stakeholderID?: Maybe<Scalars['String']>;
  postID?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
};

export enum PostUserRelationOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  StakeholderIdAsc = 'stakeholderID_ASC',
  StakeholderIdDesc = 'stakeholderID_DESC',
  PostIdAsc = 'postID_ASC',
  PostIdDesc = 'postID_DESC',
  ReadAsc = 'read_ASC',
  ReadDesc = 'read_DESC',
}

export type PostUserRelationUpdateInput = {
  id?: Maybe<Scalars['String']>;
  stakeholderID?: Maybe<Scalars['String']>;
  postID?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
};

export type PostUserRelationWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  stakeholderID?: Maybe<Scalars['String']>;
  stakeholderID_not?: Maybe<Scalars['String']>;
  stakeholderID_in?: Maybe<Array<Scalars['String']>>;
  stakeholderID_not_in?: Maybe<Array<Scalars['String']>>;
  stakeholderID_contains?: Maybe<Scalars['String']>;
  stakeholderID_startsWith?: Maybe<Scalars['String']>;
  stakeholderID_endsWith?: Maybe<Scalars['String']>;
  postID?: Maybe<Scalars['String']>;
  postID_not?: Maybe<Scalars['String']>;
  postID_in?: Maybe<Array<Scalars['String']>>;
  postID_not_in?: Maybe<Array<Scalars['String']>>;
  postID_contains?: Maybe<Scalars['String']>;
  postID_startsWith?: Maybe<Scalars['String']>;
  postID_endsWith?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
  read_not?: Maybe<Scalars['Boolean']>;
  read_in?: Maybe<Array<Scalars['Boolean']>>;
  read_not_in?: Maybe<Array<Scalars['Boolean']>>;
  AND?: Maybe<Array<PostUserRelationWhereInput>>;
  OR?: Maybe<Array<PostUserRelationWhereInput>>;
  NOT?: Maybe<Array<PostUserRelationWhereInput>>;
};

export type PostWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Scalars['String']>>;
  title_not_in?: Maybe<Array<Scalars['String']>>;
  title_contains?: Maybe<Scalars['String']>;
  title_startsWith?: Maybe<Scalars['String']>;
  title_endsWith?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  body_not?: Maybe<Scalars['String']>;
  body_in?: Maybe<Array<Scalars['String']>>;
  body_not_in?: Maybe<Array<Scalars['String']>>;
  body_contains?: Maybe<Scalars['String']>;
  body_startsWith?: Maybe<Scalars['String']>;
  body_endsWith?: Maybe<Scalars['String']>;
  imageId?: Maybe<Scalars['String']>;
  imageId_not?: Maybe<Scalars['String']>;
  imageId_in?: Maybe<Array<Scalars['String']>>;
  imageId_not_in?: Maybe<Array<Scalars['String']>>;
  imageId_contains?: Maybe<Scalars['String']>;
  imageId_startsWith?: Maybe<Scalars['String']>;
  imageId_endsWith?: Maybe<Scalars['String']>;
  image?: Maybe<FileWhereInput>;
  image_not?: Maybe<FileWhereInput>;
  image_in?: Maybe<Array<FileWhereInput>>;
  image_not_in?: Maybe<Array<FileWhereInput>>;
  status?: Maybe<PostStatus>;
  status_not?: Maybe<PostStatus>;
  status_in?: Maybe<Array<PostStatus>>;
  status_not_in?: Maybe<Array<PostStatus>>;
  type?: Maybe<PostType>;
  type_not?: Maybe<PostType>;
  type_in?: Maybe<Array<PostType>>;
  type_not_in?: Maybe<Array<PostType>>;
  category?: Maybe<PostCategory>;
  category_not?: Maybe<PostCategory>;
  category_in?: Maybe<Array<PostCategory>>;
  category_not_in?: Maybe<Array<PostCategory>>;
  read?: Maybe<Scalars['Boolean']>;
  read_not?: Maybe<Scalars['Boolean']>;
  read_in?: Maybe<Array<Scalars['Boolean']>>;
  read_not_in?: Maybe<Array<Scalars['Boolean']>>;
  readBy?: Maybe<Scalars['String']>;
  readBy_not?: Maybe<Scalars['String']>;
  readBy_in?: Maybe<Array<Scalars['String']>>;
  readBy_not_in?: Maybe<Array<Scalars['String']>>;
  roles?: Maybe<StakeholderRole>;
  roles_not?: Maybe<StakeholderRole>;
  roles_in?: Maybe<Array<StakeholderRole>>;
  roles_not_in?: Maybe<Array<StakeholderRole>>;
  stakeholders?: Maybe<Scalars['String']>;
  stakeholders_not?: Maybe<Scalars['String']>;
  stakeholders_in?: Maybe<Array<Scalars['String']>>;
  stakeholders_not_in?: Maybe<Array<Scalars['String']>>;
  stakeholders_contains?: Maybe<Scalars['String']>;
  stakeholders_startsWith?: Maybe<Scalars['String']>;
  stakeholders_endsWith?: Maybe<Scalars['String']>;
  AND?: Maybe<Array<PostWhereInput>>;
  OR?: Maybe<Array<PostWhereInput>>;
  NOT?: Maybe<Array<PostWhereInput>>;
};

export type Product = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  capacity?: Maybe<Scalars['Int']>;
  eventId?: Maybe<Scalars['String']>;
  event?: Maybe<Event>;
  tickets?: Maybe<Ticket>;
  status?: Maybe<ProductStatus>;
};

export type ProductCreateInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  capacity?: Maybe<Scalars['Int']>;
  eventId?: Maybe<Scalars['String']>;
  event?: Maybe<EventCreateInput>;
  tickets?: Maybe<TicketCreateInput>;
  status?: Maybe<ProductStatus>;
};

export enum ProductOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  PriceAsc = 'price_ASC',
  PriceDesc = 'price_DESC',
  CapacityAsc = 'capacity_ASC',
  CapacityDesc = 'capacity_DESC',
  EventIdAsc = 'eventId_ASC',
  EventIdDesc = 'eventId_DESC',
  EventAsc = 'event_ASC',
  EventDesc = 'event_DESC',
  TicketsAsc = 'tickets_ASC',
  TicketsDesc = 'tickets_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
}

export enum ProductStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

export type ProductUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  capacity?: Maybe<Scalars['Int']>;
  eventId?: Maybe<Scalars['String']>;
  event?: Maybe<EventUpdateInput>;
  tickets?: Maybe<TicketUpdateInput>;
  status?: Maybe<ProductStatus>;
};

export type ProductWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  name?: Maybe<Scalars['String']>;
  name_not?: Maybe<Scalars['String']>;
  name_in?: Maybe<Array<Scalars['String']>>;
  name_not_in?: Maybe<Array<Scalars['String']>>;
  name_contains?: Maybe<Scalars['String']>;
  name_startsWith?: Maybe<Scalars['String']>;
  name_endsWith?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  description_not?: Maybe<Scalars['String']>;
  description_in?: Maybe<Array<Scalars['String']>>;
  description_not_in?: Maybe<Array<Scalars['String']>>;
  description_contains?: Maybe<Scalars['String']>;
  description_startsWith?: Maybe<Scalars['String']>;
  description_endsWith?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  price_not?: Maybe<Scalars['Float']>;
  price_in?: Maybe<Array<Scalars['Float']>>;
  price_not_in?: Maybe<Array<Scalars['Float']>>;
  price_lt?: Maybe<Scalars['Float']>;
  price_lte?: Maybe<Scalars['Float']>;
  price_gt?: Maybe<Scalars['Float']>;
  price_gte?: Maybe<Scalars['Float']>;
  capacity?: Maybe<Scalars['Int']>;
  capacity_not?: Maybe<Scalars['Int']>;
  capacity_in?: Maybe<Array<Scalars['Int']>>;
  capacity_not_in?: Maybe<Array<Scalars['Int']>>;
  capacity_lt?: Maybe<Scalars['Int']>;
  capacity_lte?: Maybe<Scalars['Int']>;
  capacity_gt?: Maybe<Scalars['Int']>;
  capacity_gte?: Maybe<Scalars['Int']>;
  eventId?: Maybe<Scalars['String']>;
  eventId_not?: Maybe<Scalars['String']>;
  eventId_in?: Maybe<Array<Scalars['String']>>;
  eventId_not_in?: Maybe<Array<Scalars['String']>>;
  eventId_contains?: Maybe<Scalars['String']>;
  eventId_startsWith?: Maybe<Scalars['String']>;
  eventId_endsWith?: Maybe<Scalars['String']>;
  event?: Maybe<EventWhereInput>;
  event_not?: Maybe<EventWhereInput>;
  event_in?: Maybe<Array<EventWhereInput>>;
  event_not_in?: Maybe<Array<EventWhereInput>>;
  tickets?: Maybe<TicketWhereInput>;
  tickets_not?: Maybe<TicketWhereInput>;
  tickets_in?: Maybe<Array<TicketWhereInput>>;
  tickets_not_in?: Maybe<Array<TicketWhereInput>>;
  status?: Maybe<ProductStatus>;
  status_not?: Maybe<ProductStatus>;
  status_in?: Maybe<Array<ProductStatus>>;
  status_not_in?: Maybe<Array<ProductStatus>>;
  AND?: Maybe<Array<ProductWhereInput>>;
  OR?: Maybe<Array<ProductWhereInput>>;
  NOT?: Maybe<Array<ProductWhereInput>>;
};

export type Property = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  code?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  valuation?: Maybe<Scalars['Float']>;
  rooms?: Maybe<Scalars['Float']>;
  erfNumber?: Maybe<Scalars['String']>;
  salesAgent?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
  type?: Maybe<PropertyType>;
  status?: Maybe<PropertyStatus>;
  imageId?: Maybe<Scalars['String']>;
  image?: Maybe<File>;
  documents?: Maybe<Document>;
  stakeholders?: Maybe<Stakeholder>;
  applications?: Maybe<Application>;
  memberships?: Maybe<Membership>;
};

export type PropertyCreateInput = {
  code?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  valuation?: Maybe<Scalars['Float']>;
  rooms?: Maybe<Scalars['Float']>;
  erfNumber?: Maybe<Scalars['String']>;
  salesAgent?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
  type?: Maybe<PropertyType>;
  status?: Maybe<PropertyStatus>;
  imageId?: Maybe<Scalars['String']>;
  image?: Maybe<FileCreateInput>;
  documents?: Maybe<DocumentCreateInput>;
  stakeholders?: Maybe<StakeholderCreateInput>;
  applications?: Maybe<ApplicationCreateInput>;
  memberships?: Maybe<MembershipCreateInput>;
};

export type PropertyListing = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  location?: Maybe<Scalars['String']>;
  erfNumber?: Maybe<Scalars['Int']>;
  descriptor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['JSON']>;
  price?: Maybe<Scalars['Float']>;
  status?: Maybe<PropertyListingStatus>;
  images?: Maybe<File>;
};

export type PropertyListingCreateInput = {
  location?: Maybe<Scalars['String']>;
  erfNumber?: Maybe<Scalars['Int']>;
  descriptor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['JSON']>;
  price?: Maybe<Scalars['Float']>;
  status?: Maybe<PropertyListingStatus>;
  images?: Maybe<FileCreateInput>;
};

export enum PropertyListingOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  ErfNumberAsc = 'erfNumber_ASC',
  ErfNumberDesc = 'erfNumber_DESC',
  DescriptorAsc = 'descriptor_ASC',
  DescriptorDesc = 'descriptor_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ContactAsc = 'contact_ASC',
  ContactDesc = 'contact_DESC',
  PriceAsc = 'price_ASC',
  PriceDesc = 'price_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  ImagesAsc = 'images_ASC',
  ImagesDesc = 'images_DESC',
}

export enum PropertyListingStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Archived = 'ARCHIVED',
}

export type PropertyListingUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  location?: Maybe<Scalars['String']>;
  erfNumber?: Maybe<Scalars['Int']>;
  descriptor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['JSON']>;
  price?: Maybe<Scalars['Float']>;
  status?: Maybe<PropertyListingStatus>;
  images?: Maybe<FileUpdateInput>;
};

export type PropertyListingWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  location?: Maybe<Scalars['String']>;
  location_not?: Maybe<Scalars['String']>;
  location_in?: Maybe<Array<Scalars['String']>>;
  location_not_in?: Maybe<Array<Scalars['String']>>;
  location_contains?: Maybe<Scalars['String']>;
  location_startsWith?: Maybe<Scalars['String']>;
  location_endsWith?: Maybe<Scalars['String']>;
  erfNumber?: Maybe<Scalars['Int']>;
  erfNumber_not?: Maybe<Scalars['Int']>;
  erfNumber_in?: Maybe<Array<Scalars['Int']>>;
  erfNumber_not_in?: Maybe<Array<Scalars['Int']>>;
  erfNumber_lt?: Maybe<Scalars['Int']>;
  erfNumber_lte?: Maybe<Scalars['Int']>;
  erfNumber_gt?: Maybe<Scalars['Int']>;
  erfNumber_gte?: Maybe<Scalars['Int']>;
  descriptor?: Maybe<Scalars['String']>;
  descriptor_not?: Maybe<Scalars['String']>;
  descriptor_in?: Maybe<Array<Scalars['String']>>;
  descriptor_not_in?: Maybe<Array<Scalars['String']>>;
  descriptor_contains?: Maybe<Scalars['String']>;
  descriptor_startsWith?: Maybe<Scalars['String']>;
  descriptor_endsWith?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Scalars['String']>>;
  title_not_in?: Maybe<Array<Scalars['String']>>;
  title_contains?: Maybe<Scalars['String']>;
  title_startsWith?: Maybe<Scalars['String']>;
  title_endsWith?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  description_not?: Maybe<Scalars['String']>;
  description_in?: Maybe<Array<Scalars['String']>>;
  description_not_in?: Maybe<Array<Scalars['String']>>;
  description_contains?: Maybe<Scalars['String']>;
  description_startsWith?: Maybe<Scalars['String']>;
  description_endsWith?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['JSON']>;
  contact_not?: Maybe<Scalars['JSON']>;
  contact_in?: Maybe<Array<Scalars['JSON']>>;
  contact_not_in?: Maybe<Array<Scalars['JSON']>>;
  price?: Maybe<Scalars['Float']>;
  price_not?: Maybe<Scalars['Float']>;
  price_in?: Maybe<Array<Scalars['Float']>>;
  price_not_in?: Maybe<Array<Scalars['Float']>>;
  price_lt?: Maybe<Scalars['Float']>;
  price_lte?: Maybe<Scalars['Float']>;
  price_gt?: Maybe<Scalars['Float']>;
  price_gte?: Maybe<Scalars['Float']>;
  status?: Maybe<PropertyListingStatus>;
  status_not?: Maybe<PropertyListingStatus>;
  status_in?: Maybe<Array<PropertyListingStatus>>;
  status_not_in?: Maybe<Array<PropertyListingStatus>>;
  images?: Maybe<FileWhereInput>;
  images_not?: Maybe<FileWhereInput>;
  images_in?: Maybe<Array<FileWhereInput>>;
  images_not_in?: Maybe<Array<FileWhereInput>>;
  AND?: Maybe<Array<PropertyListingWhereInput>>;
  OR?: Maybe<Array<PropertyListingWhereInput>>;
  NOT?: Maybe<Array<PropertyListingWhereInput>>;
};

export enum PropertyOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  CodeAsc = 'code_ASC',
  CodeDesc = 'code_DESC',
  AddressAsc = 'address_ASC',
  AddressDesc = 'address_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  ValuationAsc = 'valuation_ASC',
  ValuationDesc = 'valuation_DESC',
  RoomsAsc = 'rooms_ASC',
  RoomsDesc = 'rooms_DESC',
  ErfNumberAsc = 'erfNumber_ASC',
  ErfNumberDesc = 'erfNumber_DESC',
  SalesAgentAsc = 'salesAgent_ASC',
  SalesAgentDesc = 'salesAgent_DESC',
  SuburbAsc = 'suburb_ASC',
  SuburbDesc = 'suburb_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  ImageIdAsc = 'imageId_ASC',
  ImageIdDesc = 'imageId_DESC',
  ImageAsc = 'image_ASC',
  ImageDesc = 'image_DESC',
  DocumentsAsc = 'documents_ASC',
  DocumentsDesc = 'documents_DESC',
  StakeholdersAsc = 'stakeholders_ASC',
  StakeholdersDesc = 'stakeholders_DESC',
  ApplicationsAsc = 'applications_ASC',
  ApplicationsDesc = 'applications_DESC',
  MembershipsAsc = 'memberships_ASC',
  MembershipsDesc = 'memberships_DESC',
}

export enum PropertyStatus {
  New = 'NEW',
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Occupied = 'OCCUPIED',
}

export enum PropertyType {
  Apartments = 'APARTMENTS',
  CityCentre = 'CITY_CENTRE',
  Cluster = 'CLUSTER',
  CompletedProperty = 'COMPLETED_PROPERTY',
  VacantLand = 'VACANT_LAND',
  CompletedHouse = 'COMPLETED_HOUSE',
  HighDensitySectionalTitleUnit = 'HIGH_DENSITY_SECTIONAL_TITLE_UNIT',
  SectionalTitleOffPlan = 'SECTIONAL_TITLE_OFF_PLAN',
  Unreleased = 'UNRELEASED',
  SectionalTitleCompleted = 'SECTIONAL_TITLE_COMPLETED',
  LandOnly = 'LAND_ONLY',
  Unset = 'UNSET',
}

export type PropertyUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  code?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  valuation?: Maybe<Scalars['Float']>;
  rooms?: Maybe<Scalars['Float']>;
  erfNumber?: Maybe<Scalars['String']>;
  salesAgent?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
  type?: Maybe<PropertyType>;
  status?: Maybe<PropertyStatus>;
  imageId?: Maybe<Scalars['String']>;
  image?: Maybe<FileUpdateInput>;
  documents?: Maybe<DocumentUpdateInput>;
  stakeholders?: Maybe<StakeholderUpdateInput>;
  applications?: Maybe<ApplicationUpdateInput>;
  memberships?: Maybe<MembershipUpdateInput>;
};

export type PropertyWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  code?: Maybe<Scalars['String']>;
  code_not?: Maybe<Scalars['String']>;
  code_in?: Maybe<Array<Scalars['String']>>;
  code_not_in?: Maybe<Array<Scalars['String']>>;
  code_contains?: Maybe<Scalars['String']>;
  code_startsWith?: Maybe<Scalars['String']>;
  code_endsWith?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  address_not?: Maybe<Scalars['String']>;
  address_in?: Maybe<Array<Scalars['String']>>;
  address_not_in?: Maybe<Array<Scalars['String']>>;
  address_contains?: Maybe<Scalars['String']>;
  address_startsWith?: Maybe<Scalars['String']>;
  address_endsWith?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  size_not?: Maybe<Scalars['Float']>;
  size_in?: Maybe<Array<Scalars['Float']>>;
  size_not_in?: Maybe<Array<Scalars['Float']>>;
  size_lt?: Maybe<Scalars['Float']>;
  size_lte?: Maybe<Scalars['Float']>;
  size_gt?: Maybe<Scalars['Float']>;
  size_gte?: Maybe<Scalars['Float']>;
  valuation?: Maybe<Scalars['Float']>;
  valuation_not?: Maybe<Scalars['Float']>;
  valuation_in?: Maybe<Array<Scalars['Float']>>;
  valuation_not_in?: Maybe<Array<Scalars['Float']>>;
  valuation_lt?: Maybe<Scalars['Float']>;
  valuation_lte?: Maybe<Scalars['Float']>;
  valuation_gt?: Maybe<Scalars['Float']>;
  valuation_gte?: Maybe<Scalars['Float']>;
  rooms?: Maybe<Scalars['Float']>;
  rooms_not?: Maybe<Scalars['Float']>;
  rooms_in?: Maybe<Array<Scalars['Float']>>;
  rooms_not_in?: Maybe<Array<Scalars['Float']>>;
  rooms_lt?: Maybe<Scalars['Float']>;
  rooms_lte?: Maybe<Scalars['Float']>;
  rooms_gt?: Maybe<Scalars['Float']>;
  rooms_gte?: Maybe<Scalars['Float']>;
  erfNumber?: Maybe<Scalars['String']>;
  erfNumber_not?: Maybe<Scalars['String']>;
  erfNumber_in?: Maybe<Array<Scalars['String']>>;
  erfNumber_not_in?: Maybe<Array<Scalars['String']>>;
  erfNumber_contains?: Maybe<Scalars['String']>;
  erfNumber_startsWith?: Maybe<Scalars['String']>;
  erfNumber_endsWith?: Maybe<Scalars['String']>;
  salesAgent?: Maybe<Scalars['String']>;
  salesAgent_not?: Maybe<Scalars['String']>;
  salesAgent_in?: Maybe<Array<Scalars['String']>>;
  salesAgent_not_in?: Maybe<Array<Scalars['String']>>;
  salesAgent_contains?: Maybe<Scalars['String']>;
  salesAgent_startsWith?: Maybe<Scalars['String']>;
  salesAgent_endsWith?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
  suburb_not?: Maybe<Scalars['String']>;
  suburb_in?: Maybe<Array<Scalars['String']>>;
  suburb_not_in?: Maybe<Array<Scalars['String']>>;
  suburb_contains?: Maybe<Scalars['String']>;
  suburb_startsWith?: Maybe<Scalars['String']>;
  suburb_endsWith?: Maybe<Scalars['String']>;
  type?: Maybe<PropertyType>;
  type_not?: Maybe<PropertyType>;
  type_in?: Maybe<Array<PropertyType>>;
  type_not_in?: Maybe<Array<PropertyType>>;
  status?: Maybe<PropertyStatus>;
  status_not?: Maybe<PropertyStatus>;
  status_in?: Maybe<Array<PropertyStatus>>;
  status_not_in?: Maybe<Array<PropertyStatus>>;
  imageId?: Maybe<Scalars['String']>;
  imageId_not?: Maybe<Scalars['String']>;
  imageId_in?: Maybe<Array<Scalars['String']>>;
  imageId_not_in?: Maybe<Array<Scalars['String']>>;
  imageId_contains?: Maybe<Scalars['String']>;
  imageId_startsWith?: Maybe<Scalars['String']>;
  imageId_endsWith?: Maybe<Scalars['String']>;
  image?: Maybe<FileWhereInput>;
  image_not?: Maybe<FileWhereInput>;
  image_in?: Maybe<Array<FileWhereInput>>;
  image_not_in?: Maybe<Array<FileWhereInput>>;
  documents?: Maybe<DocumentWhereInput>;
  documents_not?: Maybe<DocumentWhereInput>;
  documents_in?: Maybe<Array<DocumentWhereInput>>;
  documents_not_in?: Maybe<Array<DocumentWhereInput>>;
  stakeholders?: Maybe<StakeholderWhereInput>;
  stakeholders_not?: Maybe<StakeholderWhereInput>;
  stakeholders_in?: Maybe<Array<StakeholderWhereInput>>;
  stakeholders_not_in?: Maybe<Array<StakeholderWhereInput>>;
  applications?: Maybe<ApplicationWhereInput>;
  applications_not?: Maybe<ApplicationWhereInput>;
  applications_in?: Maybe<Array<ApplicationWhereInput>>;
  applications_not_in?: Maybe<Array<ApplicationWhereInput>>;
  memberships?: Maybe<MembershipWhereInput>;
  memberships_not?: Maybe<MembershipWhereInput>;
  memberships_in?: Maybe<Array<MembershipWhereInput>>;
  memberships_not_in?: Maybe<Array<MembershipWhereInput>>;
  AND?: Maybe<Array<PropertyWhereInput>>;
  OR?: Maybe<Array<PropertyWhereInput>>;
  NOT?: Maybe<Array<PropertyWhereInput>>;
};

export type Query = {
  root?: Maybe<Scalars['String']>;
  application?: Maybe<Application>;
  applications: Array<Application>;
  booking?: Maybe<Booking>;
  bookings: Array<Booking>;
  calendarEvent?: Maybe<CalendarEvent>;
  calendarEvents: Array<CalendarEvent>;
  classified?: Maybe<Classified>;
  classifieds: Array<Classified>;
  classifiedCategory?: Maybe<ClassifiedCategory>;
  classifiedCategories: Array<ClassifiedCategory>;
  classifiedSubCategory?: Maybe<ClassifiedSubCategory>;
  classifiedSubCategories: Array<ClassifiedSubCategory>;
  club?: Maybe<Club>;
  clubs: Array<Club>;
  comment?: Maybe<Comment>;
  comments: Array<Comment>;
  contactUs?: Maybe<ContactUs>;
  contactuses: Array<ContactUs>;
  document?: Maybe<Document>;
  documents: Array<Document>;
  eatery?: Maybe<Eatery>;
  eateries: Array<Eatery>;
  estateInfo?: Maybe<EstateInfo>;
  estateInfos: Array<EstateInfo>;
  event?: Maybe<Event>;
  events: Array<Event>;
  facility?: Maybe<Facility>;
  facilities: Array<Facility>;
  file?: Maybe<File>;
  files: Array<File>;
  membership?: Maybe<Membership>;
  memberships: Array<Membership>;
  neighbourhoodService?: Maybe<NeighbourhoodService>;
  neighbourhoodServices: Array<NeighbourhoodService>;
  neighbourhoodServiceCategory?: Maybe<NeighbourhoodServiceCategory>;
  neighbourhoodServiceCategories: Array<NeighbourhoodServiceCategory>;
  neighbourhoodServiceProvider?: Maybe<NeighbourhoodServiceProvider>;
  neighbourhoodServiceProviders: Array<NeighbourhoodServiceProvider>;
  neighbourhoodServiceProviderRating?: Maybe<NeighbourhoodServiceProviderRating>;
  neighbourhoodServiceProviderRatings: Array<NeighbourhoodServiceProviderRating>;
  neighbourhoodServiceReference?: Maybe<NeighbourhoodServiceReference>;
  neighbourhoodServiceReferences: Array<NeighbourhoodServiceReference>;
  neighbourhoodServiceRequest?: Maybe<NeighbourhoodServiceRequest>;
  neighbourhoodServiceRequests: Array<NeighbourhoodServiceRequest>;
  notification?: Maybe<Notification>;
  notifications: Array<Notification>;
  order?: Maybe<Order>;
  orders: Array<Order>;
  pass?: Maybe<Pass>;
  passes: Array<Pass>;
  pDFLibraryItem?: Maybe<PdfLibraryItem>;
  pDFLibraryItems: Array<PdfLibraryItem>;
  post?: Maybe<Post>;
  posts: Array<Post>;
  postUserRelation?: Maybe<PostUserRelation>;
  postUserRelations: Array<PostUserRelation>;
  product?: Maybe<Product>;
  products: Array<Product>;
  property?: Maybe<Property>;
  properties: Array<Property>;
  propertyListing?: Maybe<PropertyListing>;
  propertyListings: Array<PropertyListing>;
  shop?: Maybe<Shop>;
  shops: Array<Shop>;
  stakeholder?: Maybe<Stakeholder>;
  stakeholders: Array<Stakeholder>;
  termsAndCondition?: Maybe<TermsAndConditions>;
  termsAndConditions: Array<TermsAndConditions>;
  ticket?: Maybe<Ticket>;
  tickets: Array<Ticket>;
  user?: Maybe<User>;
  users: Array<User>;
  utility?: Maybe<Utility>;
  utilities: Array<Utility>;
  vehicle?: Maybe<Vehicle>;
  vehicles: Array<Vehicle>;
  visit?: Maybe<Visit>;
  visits: Array<Visit>;
  adminDashboard: AdminDashboard;
  stakeholderProfile: Stakeholder;
  stakeholderVisits?: Maybe<Array<Maybe<Visit>>>;
};

export type QueryApplicationArgs = {
  id: Scalars['ID'];
};

export type QueryApplicationsArgs = {
  where?: Maybe<ApplicationWhereInput>;
  orderBy?: Maybe<ApplicationOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryBookingArgs = {
  id: Scalars['ID'];
};

export type QueryBookingsArgs = {
  where?: Maybe<BookingWhereInput>;
  orderBy?: Maybe<BookingOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryCalendarEventArgs = {
  id: Scalars['ID'];
};

export type QueryCalendarEventsArgs = {
  where?: Maybe<CalendarEventWhereInput>;
  orderBy?: Maybe<CalendarEventOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryClassifiedArgs = {
  id: Scalars['ID'];
};

export type QueryClassifiedsArgs = {
  where?: Maybe<ClassifiedWhereInput>;
  orderBy?: Maybe<ClassifiedOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryClassifiedCategoryArgs = {
  id: Scalars['ID'];
};

export type QueryClassifiedCategoriesArgs = {
  where?: Maybe<ClassifiedCategoryWhereInput>;
  orderBy?: Maybe<ClassifiedCategoryOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryClassifiedSubCategoryArgs = {
  id: Scalars['ID'];
};

export type QueryClassifiedSubCategoriesArgs = {
  where?: Maybe<ClassifiedSubCategoryWhereInput>;
  orderBy?: Maybe<ClassifiedSubCategoryOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryClubArgs = {
  id: Scalars['ID'];
};

export type QueryClubsArgs = {
  where?: Maybe<ClubWhereInput>;
  orderBy?: Maybe<ClubOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryCommentArgs = {
  id: Scalars['ID'];
};

export type QueryCommentsArgs = {
  where?: Maybe<CommentWhereInput>;
  orderBy?: Maybe<CommentOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryContactUsArgs = {
  id: Scalars['ID'];
};

export type QueryContactusesArgs = {
  where?: Maybe<ContactUsWhereInput>;
  orderBy?: Maybe<ContactUsOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryDocumentArgs = {
  id: Scalars['ID'];
};

export type QueryDocumentsArgs = {
  where?: Maybe<DocumentWhereInput>;
  orderBy?: Maybe<DocumentOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryEateryArgs = {
  id: Scalars['ID'];
};

export type QueryEateriesArgs = {
  where?: Maybe<EateryWhereInput>;
  orderBy?: Maybe<EateryOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryEstateInfoArgs = {
  id: Scalars['ID'];
};

export type QueryEstateInfosArgs = {
  where?: Maybe<EstateInfoWhereInput>;
  orderBy?: Maybe<EstateInfoOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryEventArgs = {
  id: Scalars['ID'];
};

export type QueryEventsArgs = {
  where?: Maybe<EventWhereInput>;
  orderBy?: Maybe<EventOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryFacilityArgs = {
  id: Scalars['ID'];
};

export type QueryFacilitiesArgs = {
  where?: Maybe<FacilityWhereInput>;
  orderBy?: Maybe<FacilityOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryFileArgs = {
  id: Scalars['ID'];
};

export type QueryFilesArgs = {
  where?: Maybe<FileWhereInput>;
  orderBy?: Maybe<FileOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryMembershipArgs = {
  id: Scalars['ID'];
};

export type QueryMembershipsArgs = {
  where?: Maybe<MembershipWhereInput>;
  orderBy?: Maybe<MembershipOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryNeighbourhoodServiceArgs = {
  id: Scalars['ID'];
};

export type QueryNeighbourhoodServicesArgs = {
  where?: Maybe<NeighbourhoodServiceWhereInput>;
  orderBy?: Maybe<NeighbourhoodServiceOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryNeighbourhoodServiceCategoryArgs = {
  id: Scalars['ID'];
};

export type QueryNeighbourhoodServiceCategoriesArgs = {
  where?: Maybe<NeighbourhoodServiceCategoryWhereInput>;
  orderBy?: Maybe<NeighbourhoodServiceCategoryOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryNeighbourhoodServiceProviderArgs = {
  id: Scalars['ID'];
};

export type QueryNeighbourhoodServiceProvidersArgs = {
  where?: Maybe<NeighbourhoodServiceProviderWhereInput>;
  orderBy?: Maybe<NeighbourhoodServiceProviderOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryNeighbourhoodServiceProviderRatingArgs = {
  id: Scalars['ID'];
};

export type QueryNeighbourhoodServiceProviderRatingsArgs = {
  where?: Maybe<NeighbourhoodServiceProviderRatingWhereInput>;
  orderBy?: Maybe<NeighbourhoodServiceProviderRatingOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryNeighbourhoodServiceReferenceArgs = {
  id: Scalars['ID'];
};

export type QueryNeighbourhoodServiceReferencesArgs = {
  where?: Maybe<NeighbourhoodServiceReferenceWhereInput>;
  orderBy?: Maybe<NeighbourhoodServiceReferenceOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryNeighbourhoodServiceRequestArgs = {
  id: Scalars['ID'];
};

export type QueryNeighbourhoodServiceRequestsArgs = {
  where?: Maybe<NeighbourhoodServiceRequestWhereInput>;
  orderBy?: Maybe<NeighbourhoodServiceRequestOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryNotificationArgs = {
  id: Scalars['ID'];
};

export type QueryNotificationsArgs = {
  where?: Maybe<NotificationWhereInput>;
  orderBy?: Maybe<NotificationOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryOrderArgs = {
  id: Scalars['ID'];
};

export type QueryOrdersArgs = {
  where?: Maybe<OrderWhereInput>;
  orderBy?: Maybe<OrderOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryPassArgs = {
  id: Scalars['ID'];
};

export type QueryPassesArgs = {
  where?: Maybe<PassWhereInput>;
  orderBy?: Maybe<PassOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryPDfLibraryItemArgs = {
  id: Scalars['ID'];
};

export type QueryPDfLibraryItemsArgs = {
  where?: Maybe<PdfLibraryItemWhereInput>;
  orderBy?: Maybe<PdfLibraryItemOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryPostArgs = {
  id: Scalars['ID'];
};

export type QueryPostsArgs = {
  where?: Maybe<PostWhereInput>;
  orderBy?: Maybe<PostOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryPostUserRelationArgs = {
  id: Scalars['ID'];
};

export type QueryPostUserRelationsArgs = {
  where?: Maybe<PostUserRelationWhereInput>;
  orderBy?: Maybe<PostUserRelationOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryProductArgs = {
  id: Scalars['ID'];
};

export type QueryProductsArgs = {
  where?: Maybe<ProductWhereInput>;
  orderBy?: Maybe<ProductOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryPropertyArgs = {
  id: Scalars['ID'];
};

export type QueryPropertiesArgs = {
  where?: Maybe<PropertyWhereInput>;
  orderBy?: Maybe<PropertyOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryPropertyListingArgs = {
  id: Scalars['ID'];
};

export type QueryPropertyListingsArgs = {
  where?: Maybe<PropertyListingWhereInput>;
  orderBy?: Maybe<PropertyListingOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryShopArgs = {
  id: Scalars['ID'];
};

export type QueryShopsArgs = {
  where?: Maybe<ShopWhereInput>;
  orderBy?: Maybe<ShopOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryStakeholderArgs = {
  id: Scalars['ID'];
};

export type QueryStakeholdersArgs = {
  where?: Maybe<StakeholderWhereInput>;
  orderBy?: Maybe<StakeholderOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryTermsAndConditionArgs = {
  id: Scalars['ID'];
};

export type QueryTermsAndConditionsArgs = {
  where?: Maybe<TermsAndConditionsWhereInput>;
  orderBy?: Maybe<TermsAndConditionsOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryTicketArgs = {
  id: Scalars['ID'];
};

export type QueryTicketsArgs = {
  where?: Maybe<TicketWhereInput>;
  orderBy?: Maybe<TicketOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryUserArgs = {
  id: Scalars['ID'];
};

export type QueryUsersArgs = {
  where?: Maybe<UserWhereInput>;
  orderBy?: Maybe<UserOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryUtilityArgs = {
  id: Scalars['ID'];
};

export type QueryUtilitiesArgs = {
  where?: Maybe<UtilityWhereInput>;
  orderBy?: Maybe<UtilityOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryVehicleArgs = {
  id: Scalars['ID'];
};

export type QueryVehiclesArgs = {
  where?: Maybe<VehicleWhereInput>;
  orderBy?: Maybe<VehicleOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryVisitArgs = {
  id: Scalars['ID'];
};

export type QueryVisitsArgs = {
  where?: Maybe<VisitWhereInput>;
  orderBy?: Maybe<VisitOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type QueryStakeholderVisitsArgs = {
  where?: Maybe<VisitWhereInput>;
  orderBy?: Maybe<VisitOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type Shop = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<ShopStatus>;
  description?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  telephoneNumber?: Maybe<Scalars['String']>;
  whatsappNumber?: Maybe<Scalars['String']>;
  menus?: Maybe<Scalars['JSON']>;
  mondayHours?: Maybe<Scalars['String']>;
  tuesdayHours?: Maybe<Scalars['String']>;
  wednesdayHours?: Maybe<Scalars['String']>;
  thursdayHours?: Maybe<Scalars['String']>;
  fridayHours?: Maybe<Scalars['String']>;
  saturdayHours?: Maybe<Scalars['String']>;
  sundayHours?: Maybe<Scalars['String']>;
  tradingHours?: Maybe<Scalars['String']>;
  isService?: Maybe<Scalars['Boolean']>;
};

export type ShopCreateInput = {
  name?: Maybe<Scalars['String']>;
  status?: Maybe<ShopStatus>;
  description?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  telephoneNumber?: Maybe<Scalars['String']>;
  whatsappNumber?: Maybe<Scalars['String']>;
  menus?: Maybe<Scalars['JSON']>;
  mondayHours?: Maybe<Scalars['String']>;
  tuesdayHours?: Maybe<Scalars['String']>;
  wednesdayHours?: Maybe<Scalars['String']>;
  thursdayHours?: Maybe<Scalars['String']>;
  fridayHours?: Maybe<Scalars['String']>;
  saturdayHours?: Maybe<Scalars['String']>;
  sundayHours?: Maybe<Scalars['String']>;
  tradingHours?: Maybe<Scalars['String']>;
  isService?: Maybe<Scalars['Boolean']>;
};

export enum ShopOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  LogoAsc = 'logo_ASC',
  LogoDesc = 'logo_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  WhatsappNumberAsc = 'whatsappNumber_ASC',
  WhatsappNumberDesc = 'whatsappNumber_DESC',
  MenusAsc = 'menus_ASC',
  MenusDesc = 'menus_DESC',
  MondayHoursAsc = 'mondayHours_ASC',
  MondayHoursDesc = 'mondayHours_DESC',
  TuesdayHoursAsc = 'tuesdayHours_ASC',
  TuesdayHoursDesc = 'tuesdayHours_DESC',
  WednesdayHoursAsc = 'wednesdayHours_ASC',
  WednesdayHoursDesc = 'wednesdayHours_DESC',
  ThursdayHoursAsc = 'thursdayHours_ASC',
  ThursdayHoursDesc = 'thursdayHours_DESC',
  FridayHoursAsc = 'fridayHours_ASC',
  FridayHoursDesc = 'fridayHours_DESC',
  SaturdayHoursAsc = 'saturdayHours_ASC',
  SaturdayHoursDesc = 'saturdayHours_DESC',
  SundayHoursAsc = 'sundayHours_ASC',
  SundayHoursDesc = 'sundayHours_DESC',
  TradingHoursAsc = 'tradingHours_ASC',
  TradingHoursDesc = 'tradingHours_DESC',
  IsServiceAsc = 'isService_ASC',
  IsServiceDesc = 'isService_DESC',
}

export enum ShopStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Archived = 'ARCHIVED',
}

export type ShopUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<ShopStatus>;
  description?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  telephoneNumber?: Maybe<Scalars['String']>;
  whatsappNumber?: Maybe<Scalars['String']>;
  menus?: Maybe<Scalars['JSON']>;
  mondayHours?: Maybe<Scalars['String']>;
  tuesdayHours?: Maybe<Scalars['String']>;
  wednesdayHours?: Maybe<Scalars['String']>;
  thursdayHours?: Maybe<Scalars['String']>;
  fridayHours?: Maybe<Scalars['String']>;
  saturdayHours?: Maybe<Scalars['String']>;
  sundayHours?: Maybe<Scalars['String']>;
  tradingHours?: Maybe<Scalars['String']>;
  isService?: Maybe<Scalars['Boolean']>;
};

export type ShopWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  name?: Maybe<Scalars['String']>;
  name_not?: Maybe<Scalars['String']>;
  name_in?: Maybe<Array<Scalars['String']>>;
  name_not_in?: Maybe<Array<Scalars['String']>>;
  name_contains?: Maybe<Scalars['String']>;
  name_startsWith?: Maybe<Scalars['String']>;
  name_endsWith?: Maybe<Scalars['String']>;
  status?: Maybe<ShopStatus>;
  status_not?: Maybe<ShopStatus>;
  status_in?: Maybe<Array<ShopStatus>>;
  status_not_in?: Maybe<Array<ShopStatus>>;
  description?: Maybe<Scalars['String']>;
  description_not?: Maybe<Scalars['String']>;
  description_in?: Maybe<Array<Scalars['String']>>;
  description_not_in?: Maybe<Array<Scalars['String']>>;
  description_contains?: Maybe<Scalars['String']>;
  description_startsWith?: Maybe<Scalars['String']>;
  description_endsWith?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  logo_not?: Maybe<Scalars['String']>;
  logo_in?: Maybe<Array<Scalars['String']>>;
  logo_not_in?: Maybe<Array<Scalars['String']>>;
  logo_contains?: Maybe<Scalars['String']>;
  logo_startsWith?: Maybe<Scalars['String']>;
  logo_endsWith?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  email_not?: Maybe<Scalars['String']>;
  email_in?: Maybe<Array<Scalars['String']>>;
  email_not_in?: Maybe<Array<Scalars['String']>>;
  email_contains?: Maybe<Scalars['String']>;
  email_startsWith?: Maybe<Scalars['String']>;
  email_endsWith?: Maybe<Scalars['String']>;
  telephoneNumber?: Maybe<Scalars['String']>;
  telephoneNumber_not?: Maybe<Scalars['String']>;
  telephoneNumber_in?: Maybe<Array<Scalars['String']>>;
  telephoneNumber_not_in?: Maybe<Array<Scalars['String']>>;
  telephoneNumber_contains?: Maybe<Scalars['String']>;
  telephoneNumber_startsWith?: Maybe<Scalars['String']>;
  telephoneNumber_endsWith?: Maybe<Scalars['String']>;
  whatsappNumber?: Maybe<Scalars['String']>;
  whatsappNumber_not?: Maybe<Scalars['String']>;
  whatsappNumber_in?: Maybe<Array<Scalars['String']>>;
  whatsappNumber_not_in?: Maybe<Array<Scalars['String']>>;
  whatsappNumber_contains?: Maybe<Scalars['String']>;
  whatsappNumber_startsWith?: Maybe<Scalars['String']>;
  whatsappNumber_endsWith?: Maybe<Scalars['String']>;
  menus?: Maybe<Scalars['JSON']>;
  menus_not?: Maybe<Scalars['JSON']>;
  menus_in?: Maybe<Array<Scalars['JSON']>>;
  menus_not_in?: Maybe<Array<Scalars['JSON']>>;
  mondayHours?: Maybe<Scalars['String']>;
  mondayHours_not?: Maybe<Scalars['String']>;
  mondayHours_in?: Maybe<Array<Scalars['String']>>;
  mondayHours_not_in?: Maybe<Array<Scalars['String']>>;
  mondayHours_contains?: Maybe<Scalars['String']>;
  mondayHours_startsWith?: Maybe<Scalars['String']>;
  mondayHours_endsWith?: Maybe<Scalars['String']>;
  tuesdayHours?: Maybe<Scalars['String']>;
  tuesdayHours_not?: Maybe<Scalars['String']>;
  tuesdayHours_in?: Maybe<Array<Scalars['String']>>;
  tuesdayHours_not_in?: Maybe<Array<Scalars['String']>>;
  tuesdayHours_contains?: Maybe<Scalars['String']>;
  tuesdayHours_startsWith?: Maybe<Scalars['String']>;
  tuesdayHours_endsWith?: Maybe<Scalars['String']>;
  wednesdayHours?: Maybe<Scalars['String']>;
  wednesdayHours_not?: Maybe<Scalars['String']>;
  wednesdayHours_in?: Maybe<Array<Scalars['String']>>;
  wednesdayHours_not_in?: Maybe<Array<Scalars['String']>>;
  wednesdayHours_contains?: Maybe<Scalars['String']>;
  wednesdayHours_startsWith?: Maybe<Scalars['String']>;
  wednesdayHours_endsWith?: Maybe<Scalars['String']>;
  thursdayHours?: Maybe<Scalars['String']>;
  thursdayHours_not?: Maybe<Scalars['String']>;
  thursdayHours_in?: Maybe<Array<Scalars['String']>>;
  thursdayHours_not_in?: Maybe<Array<Scalars['String']>>;
  thursdayHours_contains?: Maybe<Scalars['String']>;
  thursdayHours_startsWith?: Maybe<Scalars['String']>;
  thursdayHours_endsWith?: Maybe<Scalars['String']>;
  fridayHours?: Maybe<Scalars['String']>;
  fridayHours_not?: Maybe<Scalars['String']>;
  fridayHours_in?: Maybe<Array<Scalars['String']>>;
  fridayHours_not_in?: Maybe<Array<Scalars['String']>>;
  fridayHours_contains?: Maybe<Scalars['String']>;
  fridayHours_startsWith?: Maybe<Scalars['String']>;
  fridayHours_endsWith?: Maybe<Scalars['String']>;
  saturdayHours?: Maybe<Scalars['String']>;
  saturdayHours_not?: Maybe<Scalars['String']>;
  saturdayHours_in?: Maybe<Array<Scalars['String']>>;
  saturdayHours_not_in?: Maybe<Array<Scalars['String']>>;
  saturdayHours_contains?: Maybe<Scalars['String']>;
  saturdayHours_startsWith?: Maybe<Scalars['String']>;
  saturdayHours_endsWith?: Maybe<Scalars['String']>;
  sundayHours?: Maybe<Scalars['String']>;
  sundayHours_not?: Maybe<Scalars['String']>;
  sundayHours_in?: Maybe<Array<Scalars['String']>>;
  sundayHours_not_in?: Maybe<Array<Scalars['String']>>;
  sundayHours_contains?: Maybe<Scalars['String']>;
  sundayHours_startsWith?: Maybe<Scalars['String']>;
  sundayHours_endsWith?: Maybe<Scalars['String']>;
  tradingHours?: Maybe<Scalars['String']>;
  tradingHours_not?: Maybe<Scalars['String']>;
  tradingHours_in?: Maybe<Array<Scalars['String']>>;
  tradingHours_not_in?: Maybe<Array<Scalars['String']>>;
  tradingHours_contains?: Maybe<Scalars['String']>;
  tradingHours_startsWith?: Maybe<Scalars['String']>;
  tradingHours_endsWith?: Maybe<Scalars['String']>;
  isService?: Maybe<Scalars['Boolean']>;
  isService_not?: Maybe<Scalars['Boolean']>;
  isService_in?: Maybe<Array<Scalars['Boolean']>>;
  isService_not_in?: Maybe<Array<Scalars['Boolean']>>;
  AND?: Maybe<Array<ShopWhereInput>>;
  OR?: Maybe<Array<ShopWhereInput>>;
  NOT?: Maybe<Array<ShopWhereInput>>;
};

export type Stakeholder = {
  id?: Maybe<Scalars['String']>;
  freshdeskId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  password?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  otp?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['DateTime']>;
  country?: Maybe<Scalars['String']>;
  homeNumber?: Maybe<Scalars['String']>;
  cellNumber?: Maybe<Scalars['String']>;
  unitNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  idNumber?: Maybe<Scalars['String']>;
  residentialAddress?: Maybe<Scalars['String']>;
  postalAddress?: Maybe<Scalars['String']>;
  pushToken?: Maybe<Scalars['String']>;
  cards?: Maybe<Scalars['JSON']>;
  marketing?: Maybe<Scalars['Boolean']>;
  pinCode?: Maybe<Scalars['String']>;
  relation?: Maybe<Scalars['String']>;
  minor?: Maybe<Scalars['Boolean']>;
  acceptedTermsConditions?: Maybe<Scalars['Boolean']>;
  vmsTag?: Maybe<Scalars['String']>;
  role?: Maybe<StakeholderRole>;
  status?: Maybe<StakeholderStatus>;
  imageId?: Maybe<Scalars['String']>;
  image?: Maybe<File>;
  tickets?: Maybe<Ticket>;
  events?: Maybe<Event>;
  documents?: Maybe<Document>;
  properties?: Maybe<Property>;
  applications?: Maybe<Application>;
  memberships?: Maybe<Membership>;
  orders?: Maybe<Order>;
  vehicles?: Maybe<Vehicle>;
  passes?: Maybe<Pass>;
  bookings?: Maybe<Booking>;
  hostings?: Maybe<Visit>;
  visitings?: Maybe<Visit>;
  clubs?: Maybe<Club>;
  clubComments?: Maybe<Comment>;
  classifieds?: Maybe<Classified>;
  neighbourhoodServiceProvider?: Maybe<NeighbourhoodServiceProvider>;
  serviceRatings?: Maybe<NeighbourhoodServiceProviderRating>;
  serviceRequests?: Maybe<NeighbourhoodServiceRequest>;
  readPosts?: Maybe<Post>;
  postId?: Maybe<Scalars['String']>;
  post?: Maybe<Post>;
};

export type StakeholderAuthenticateInput = {
  cellNumber: Scalars['String'];
  password: Scalars['String'];
};

export type StakeholderAuthenticatePayload = {
  token: Scalars['String'];
};

export type StakeholderCreateInput = {
  freshdeskId?: Maybe<Scalars['String']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  password?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  otp?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['DateTime']>;
  country?: Maybe<Scalars['String']>;
  homeNumber?: Maybe<Scalars['String']>;
  cellNumber?: Maybe<Scalars['String']>;
  unitNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  idNumber?: Maybe<Scalars['String']>;
  residentialAddress?: Maybe<Scalars['String']>;
  postalAddress?: Maybe<Scalars['String']>;
  pushToken?: Maybe<Scalars['String']>;
  cards?: Maybe<Scalars['JSON']>;
  marketing?: Maybe<Scalars['Boolean']>;
  pinCode?: Maybe<Scalars['String']>;
  relation?: Maybe<Scalars['String']>;
  minor?: Maybe<Scalars['Boolean']>;
  acceptedTermsConditions?: Maybe<Scalars['Boolean']>;
  vmsTag?: Maybe<Scalars['String']>;
  role?: Maybe<StakeholderRole>;
  status?: Maybe<StakeholderStatus>;
  imageId?: Maybe<Scalars['String']>;
  image?: Maybe<FileCreateInput>;
  tickets?: Maybe<TicketCreateInput>;
  events?: Maybe<EventCreateInput>;
  documents?: Maybe<DocumentCreateInput>;
  properties?: Maybe<PropertyCreateInput>;
  applications?: Maybe<ApplicationCreateInput>;
  memberships?: Maybe<MembershipCreateInput>;
  orders?: Maybe<OrderCreateInput>;
  vehicles?: Maybe<VehicleCreateInput>;
  passes?: Maybe<PassCreateInput>;
  bookings?: Maybe<BookingCreateInput>;
  hostings?: Maybe<VisitCreateInput>;
  visitings?: Maybe<Scalars['String']>;
  clubs?: Maybe<ClubCreateInput>;
  clubComments?: Maybe<CommentCreateInput>;
  classifieds?: Maybe<ClassifiedCreateInput>;
  neighbourhoodServiceProvider?: Maybe<NeighbourhoodServiceProviderCreateInput>;
  serviceRatings?: Maybe<NeighbourhoodServiceProviderRatingCreateInput>;
  serviceRequests?: Maybe<NeighbourhoodServiceRequestCreateInput>;
  readPosts?: Maybe<PostCreateInput>;
  postId?: Maybe<Scalars['String']>;
  post?: Maybe<Scalars['String']>;
};

export enum StakeholderOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  FreshdeskIdAsc = 'freshdeskId_ASC',
  FreshdeskIdDesc = 'freshdeskId_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  ExpiryDateAsc = 'expiryDate_ASC',
  ExpiryDateDesc = 'expiryDate_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  OtpAsc = 'otp_ASC',
  OtpDesc = 'otp_DESC',
  DobAsc = 'dob_ASC',
  DobDesc = 'dob_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  HomeNumberAsc = 'homeNumber_ASC',
  HomeNumberDesc = 'homeNumber_DESC',
  CellNumberAsc = 'cellNumber_ASC',
  CellNumberDesc = 'cellNumber_DESC',
  UnitNumberAsc = 'unitNumber_ASC',
  UnitNumberDesc = 'unitNumber_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  IdNumberAsc = 'idNumber_ASC',
  IdNumberDesc = 'idNumber_DESC',
  ResidentialAddressAsc = 'residentialAddress_ASC',
  ResidentialAddressDesc = 'residentialAddress_DESC',
  PostalAddressAsc = 'postalAddress_ASC',
  PostalAddressDesc = 'postalAddress_DESC',
  PushTokenAsc = 'pushToken_ASC',
  PushTokenDesc = 'pushToken_DESC',
  CardsAsc = 'cards_ASC',
  CardsDesc = 'cards_DESC',
  MarketingAsc = 'marketing_ASC',
  MarketingDesc = 'marketing_DESC',
  PinCodeAsc = 'pinCode_ASC',
  PinCodeDesc = 'pinCode_DESC',
  RelationAsc = 'relation_ASC',
  RelationDesc = 'relation_DESC',
  MinorAsc = 'minor_ASC',
  MinorDesc = 'minor_DESC',
  AcceptedTermsConditionsAsc = 'acceptedTermsConditions_ASC',
  AcceptedTermsConditionsDesc = 'acceptedTermsConditions_DESC',
  VmsTagAsc = 'vmsTag_ASC',
  VmsTagDesc = 'vmsTag_DESC',
  RoleAsc = 'role_ASC',
  RoleDesc = 'role_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  ImageIdAsc = 'imageId_ASC',
  ImageIdDesc = 'imageId_DESC',
  ImageAsc = 'image_ASC',
  ImageDesc = 'image_DESC',
  TicketsAsc = 'tickets_ASC',
  TicketsDesc = 'tickets_DESC',
  EventsAsc = 'events_ASC',
  EventsDesc = 'events_DESC',
  DocumentsAsc = 'documents_ASC',
  DocumentsDesc = 'documents_DESC',
  PropertiesAsc = 'properties_ASC',
  PropertiesDesc = 'properties_DESC',
  ApplicationsAsc = 'applications_ASC',
  ApplicationsDesc = 'applications_DESC',
  MembershipsAsc = 'memberships_ASC',
  MembershipsDesc = 'memberships_DESC',
  OrdersAsc = 'orders_ASC',
  OrdersDesc = 'orders_DESC',
  VehiclesAsc = 'vehicles_ASC',
  VehiclesDesc = 'vehicles_DESC',
  PassesAsc = 'passes_ASC',
  PassesDesc = 'passes_DESC',
  BookingsAsc = 'bookings_ASC',
  BookingsDesc = 'bookings_DESC',
  HostingsAsc = 'hostings_ASC',
  HostingsDesc = 'hostings_DESC',
  VisitingsAsc = 'visitings_ASC',
  VisitingsDesc = 'visitings_DESC',
  ClubsAsc = 'clubs_ASC',
  ClubsDesc = 'clubs_DESC',
  ClubCommentsAsc = 'clubComments_ASC',
  ClubCommentsDesc = 'clubComments_DESC',
  ClassifiedsAsc = 'classifieds_ASC',
  ClassifiedsDesc = 'classifieds_DESC',
  NeighbourhoodServiceProviderAsc = 'neighbourhoodServiceProvider_ASC',
  NeighbourhoodServiceProviderDesc = 'neighbourhoodServiceProvider_DESC',
  ServiceRatingsAsc = 'serviceRatings_ASC',
  ServiceRatingsDesc = 'serviceRatings_DESC',
  ServiceRequestsAsc = 'serviceRequests_ASC',
  ServiceRequestsDesc = 'serviceRequests_DESC',
  ReadPostsAsc = 'readPosts_ASC',
  ReadPostsDesc = 'readPosts_DESC',
  PostIdAsc = 'postId_ASC',
  PostIdDesc = 'postId_DESC',
  PostAsc = 'post_ASC',
  PostDesc = 'post_DESC',
}

export type StakeholderProfileInput = {
  image?: Maybe<FileUpdateInput>;
  pushToken?: Maybe<Scalars['String']>;
  cards?: Maybe<Scalars['JSON']>;
  pinCode?: Maybe<Scalars['String']>;
  status?: Maybe<StakeholderStatus>;
};

export type StakeholderResetInput = {
  /** Cell number, used to identify the user. */
  cellNumber: Scalars['String'];
};

export type StakeholderResetPayload = {
  /** The ID of the stakeholder the reset was initiated for. */
  id: Scalars['String'];
  /** The role of the stakeholder, eg. OWNER, GUEST, etc. */
  role: StakeholderRole;
  /** Stakeholders first name, will be null if GUEST stakeholder's first registration */
  firstName?: Maybe<Scalars['String']>;
  /** Stakeholders last name, will be null if GUEST stakeholder's first registration */
  lastName?: Maybe<Scalars['String']>;
};

export enum StakeholderRole {
  Owner = 'OWNER',
  PropertyManagement = 'PROPERTY_MANAGEMENT',
  Child = 'CHILD',
  Resident = 'RESIDENT',
  Tenant = 'TENANT',
  Contractor = 'CONTRACTOR',
  SubContractor = 'SUB_CONTRACTOR',
  Staff = 'STAFF',
  SteynCityStaff = 'STEYN_CITY_STAFF',
  Guest = 'GUEST',
}

export enum StakeholderStatus {
  New = 'NEW',
  Preapproved = 'PREAPPROVED',
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  SelfArchived = 'SELF_ARCHIVED',
}

export type StakeholderUpdateInput = {
  id?: Maybe<Scalars['String']>;
  freshdeskId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  password?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  otp?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['DateTime']>;
  country?: Maybe<Scalars['String']>;
  homeNumber?: Maybe<Scalars['String']>;
  cellNumber?: Maybe<Scalars['String']>;
  unitNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  idNumber?: Maybe<Scalars['String']>;
  residentialAddress?: Maybe<Scalars['String']>;
  postalAddress?: Maybe<Scalars['String']>;
  pushToken?: Maybe<Scalars['String']>;
  cards?: Maybe<Scalars['JSON']>;
  marketing?: Maybe<Scalars['Boolean']>;
  pinCode?: Maybe<Scalars['String']>;
  relation?: Maybe<Scalars['String']>;
  minor?: Maybe<Scalars['Boolean']>;
  acceptedTermsConditions?: Maybe<Scalars['Boolean']>;
  vmsTag?: Maybe<Scalars['String']>;
  role?: Maybe<StakeholderRole>;
  status?: Maybe<StakeholderStatus>;
  imageId?: Maybe<Scalars['String']>;
  image?: Maybe<FileUpdateInput>;
  tickets?: Maybe<TicketUpdateInput>;
  events?: Maybe<EventUpdateInput>;
  documents?: Maybe<DocumentUpdateInput>;
  properties?: Maybe<PropertyUpdateInput>;
  applications?: Maybe<ApplicationUpdateInput>;
  memberships?: Maybe<MembershipUpdateInput>;
  orders?: Maybe<OrderUpdateInput>;
  vehicles?: Maybe<VehicleUpdateInput>;
  passes?: Maybe<PassUpdateInput>;
  bookings?: Maybe<BookingUpdateInput>;
  hostings?: Maybe<VisitUpdateInput>;
  visitings?: Maybe<Scalars['String']>;
  clubs?: Maybe<ClubUpdateInput>;
  clubComments?: Maybe<CommentUpdateInput>;
  classifieds?: Maybe<ClassifiedUpdateInput>;
  neighbourhoodServiceProvider?: Maybe<NeighbourhoodServiceProviderUpdateInput>;
  serviceRatings?: Maybe<NeighbourhoodServiceProviderRatingUpdateInput>;
  serviceRequests?: Maybe<NeighbourhoodServiceRequestUpdateInput>;
  readPosts?: Maybe<PostUpdateInput>;
  postId?: Maybe<Scalars['String']>;
  post?: Maybe<Scalars['String']>;
};

export type StakeholderValidateInput = {
  id: Scalars['ID'];
  otp: Scalars['String'];
  password: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  idNumber: Scalars['String'];
};

export type StakeholderValidatePayload = {
  token: Scalars['String'];
  isOnboarded: Scalars['Boolean'];
};

export type StakeholderVisitCreateInput = {
  cellNumber: Scalars['String'];
  firstName: Scalars['String'];
  surname: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  location?: Maybe<Scalars['Json']>;
};

export type StakeholderVisitCreateResponse = {
  id: Scalars['String'];
};

export type StakeholderWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  freshdeskId?: Maybe<Scalars['String']>;
  freshdeskId_not?: Maybe<Scalars['String']>;
  freshdeskId_in?: Maybe<Array<Scalars['String']>>;
  freshdeskId_not_in?: Maybe<Array<Scalars['String']>>;
  freshdeskId_contains?: Maybe<Scalars['String']>;
  freshdeskId_startsWith?: Maybe<Scalars['String']>;
  freshdeskId_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  expiryDate_not?: Maybe<Scalars['DateTime']>;
  expiryDate_in?: Maybe<Array<Scalars['DateTime']>>;
  expiryDate_not_in?: Maybe<Array<Scalars['DateTime']>>;
  password?: Maybe<Scalars['String']>;
  password_not?: Maybe<Scalars['String']>;
  password_in?: Maybe<Array<Scalars['String']>>;
  password_not_in?: Maybe<Array<Scalars['String']>>;
  password_contains?: Maybe<Scalars['String']>;
  password_startsWith?: Maybe<Scalars['String']>;
  password_endsWith?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Scalars['String']>>;
  title_not_in?: Maybe<Array<Scalars['String']>>;
  title_contains?: Maybe<Scalars['String']>;
  title_startsWith?: Maybe<Scalars['String']>;
  title_endsWith?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  firstName_not?: Maybe<Scalars['String']>;
  firstName_in?: Maybe<Array<Scalars['String']>>;
  firstName_not_in?: Maybe<Array<Scalars['String']>>;
  firstName_contains?: Maybe<Scalars['String']>;
  firstName_startsWith?: Maybe<Scalars['String']>;
  firstName_endsWith?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  lastName_not?: Maybe<Scalars['String']>;
  lastName_in?: Maybe<Array<Scalars['String']>>;
  lastName_not_in?: Maybe<Array<Scalars['String']>>;
  lastName_contains?: Maybe<Scalars['String']>;
  lastName_startsWith?: Maybe<Scalars['String']>;
  lastName_endsWith?: Maybe<Scalars['String']>;
  otp?: Maybe<Scalars['String']>;
  otp_not?: Maybe<Scalars['String']>;
  otp_in?: Maybe<Array<Scalars['String']>>;
  otp_not_in?: Maybe<Array<Scalars['String']>>;
  otp_contains?: Maybe<Scalars['String']>;
  otp_startsWith?: Maybe<Scalars['String']>;
  otp_endsWith?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['DateTime']>;
  dob_not?: Maybe<Scalars['DateTime']>;
  dob_in?: Maybe<Array<Scalars['DateTime']>>;
  dob_not_in?: Maybe<Array<Scalars['DateTime']>>;
  country?: Maybe<Scalars['String']>;
  country_not?: Maybe<Scalars['String']>;
  country_in?: Maybe<Array<Scalars['String']>>;
  country_not_in?: Maybe<Array<Scalars['String']>>;
  country_contains?: Maybe<Scalars['String']>;
  country_startsWith?: Maybe<Scalars['String']>;
  country_endsWith?: Maybe<Scalars['String']>;
  homeNumber?: Maybe<Scalars['String']>;
  homeNumber_not?: Maybe<Scalars['String']>;
  homeNumber_in?: Maybe<Array<Scalars['String']>>;
  homeNumber_not_in?: Maybe<Array<Scalars['String']>>;
  homeNumber_contains?: Maybe<Scalars['String']>;
  homeNumber_startsWith?: Maybe<Scalars['String']>;
  homeNumber_endsWith?: Maybe<Scalars['String']>;
  cellNumber?: Maybe<Scalars['String']>;
  cellNumber_not?: Maybe<Scalars['String']>;
  cellNumber_in?: Maybe<Array<Scalars['String']>>;
  cellNumber_not_in?: Maybe<Array<Scalars['String']>>;
  cellNumber_contains?: Maybe<Scalars['String']>;
  cellNumber_startsWith?: Maybe<Scalars['String']>;
  cellNumber_endsWith?: Maybe<Scalars['String']>;
  unitNumber?: Maybe<Scalars['String']>;
  unitNumber_not?: Maybe<Scalars['String']>;
  unitNumber_in?: Maybe<Array<Scalars['String']>>;
  unitNumber_not_in?: Maybe<Array<Scalars['String']>>;
  unitNumber_contains?: Maybe<Scalars['String']>;
  unitNumber_startsWith?: Maybe<Scalars['String']>;
  unitNumber_endsWith?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  email_not?: Maybe<Scalars['String']>;
  email_in?: Maybe<Array<Scalars['String']>>;
  email_not_in?: Maybe<Array<Scalars['String']>>;
  email_contains?: Maybe<Scalars['String']>;
  email_startsWith?: Maybe<Scalars['String']>;
  email_endsWith?: Maybe<Scalars['String']>;
  idNumber?: Maybe<Scalars['String']>;
  idNumber_not?: Maybe<Scalars['String']>;
  idNumber_in?: Maybe<Array<Scalars['String']>>;
  idNumber_not_in?: Maybe<Array<Scalars['String']>>;
  idNumber_contains?: Maybe<Scalars['String']>;
  idNumber_startsWith?: Maybe<Scalars['String']>;
  idNumber_endsWith?: Maybe<Scalars['String']>;
  residentialAddress?: Maybe<Scalars['String']>;
  residentialAddress_not?: Maybe<Scalars['String']>;
  residentialAddress_in?: Maybe<Array<Scalars['String']>>;
  residentialAddress_not_in?: Maybe<Array<Scalars['String']>>;
  residentialAddress_contains?: Maybe<Scalars['String']>;
  residentialAddress_startsWith?: Maybe<Scalars['String']>;
  residentialAddress_endsWith?: Maybe<Scalars['String']>;
  postalAddress?: Maybe<Scalars['String']>;
  postalAddress_not?: Maybe<Scalars['String']>;
  postalAddress_in?: Maybe<Array<Scalars['String']>>;
  postalAddress_not_in?: Maybe<Array<Scalars['String']>>;
  postalAddress_contains?: Maybe<Scalars['String']>;
  postalAddress_startsWith?: Maybe<Scalars['String']>;
  postalAddress_endsWith?: Maybe<Scalars['String']>;
  pushToken?: Maybe<Scalars['String']>;
  pushToken_not?: Maybe<Scalars['String']>;
  pushToken_in?: Maybe<Array<Scalars['String']>>;
  pushToken_not_in?: Maybe<Array<Scalars['String']>>;
  pushToken_contains?: Maybe<Scalars['String']>;
  pushToken_startsWith?: Maybe<Scalars['String']>;
  pushToken_endsWith?: Maybe<Scalars['String']>;
  cards?: Maybe<Scalars['JSON']>;
  cards_not?: Maybe<Scalars['JSON']>;
  cards_in?: Maybe<Array<Scalars['JSON']>>;
  cards_not_in?: Maybe<Array<Scalars['JSON']>>;
  marketing?: Maybe<Scalars['Boolean']>;
  marketing_not?: Maybe<Scalars['Boolean']>;
  marketing_in?: Maybe<Array<Scalars['Boolean']>>;
  marketing_not_in?: Maybe<Array<Scalars['Boolean']>>;
  pinCode?: Maybe<Scalars['String']>;
  pinCode_not?: Maybe<Scalars['String']>;
  pinCode_in?: Maybe<Array<Scalars['String']>>;
  pinCode_not_in?: Maybe<Array<Scalars['String']>>;
  pinCode_contains?: Maybe<Scalars['String']>;
  pinCode_startsWith?: Maybe<Scalars['String']>;
  pinCode_endsWith?: Maybe<Scalars['String']>;
  relation?: Maybe<Scalars['String']>;
  relation_not?: Maybe<Scalars['String']>;
  relation_in?: Maybe<Array<Scalars['String']>>;
  relation_not_in?: Maybe<Array<Scalars['String']>>;
  relation_contains?: Maybe<Scalars['String']>;
  relation_startsWith?: Maybe<Scalars['String']>;
  relation_endsWith?: Maybe<Scalars['String']>;
  minor?: Maybe<Scalars['Boolean']>;
  minor_not?: Maybe<Scalars['Boolean']>;
  minor_in?: Maybe<Array<Scalars['Boolean']>>;
  minor_not_in?: Maybe<Array<Scalars['Boolean']>>;
  acceptedTermsConditions?: Maybe<Scalars['Boolean']>;
  acceptedTermsConditions_not?: Maybe<Scalars['Boolean']>;
  acceptedTermsConditions_in?: Maybe<Array<Scalars['Boolean']>>;
  acceptedTermsConditions_not_in?: Maybe<Array<Scalars['Boolean']>>;
  vmsTag?: Maybe<Scalars['String']>;
  vmsTag_not?: Maybe<Scalars['String']>;
  vmsTag_in?: Maybe<Array<Scalars['String']>>;
  vmsTag_not_in?: Maybe<Array<Scalars['String']>>;
  vmsTag_contains?: Maybe<Scalars['String']>;
  vmsTag_startsWith?: Maybe<Scalars['String']>;
  vmsTag_endsWith?: Maybe<Scalars['String']>;
  role?: Maybe<StakeholderRole>;
  role_not?: Maybe<StakeholderRole>;
  role_in?: Maybe<Array<StakeholderRole>>;
  role_not_in?: Maybe<Array<StakeholderRole>>;
  status?: Maybe<StakeholderStatus>;
  status_not?: Maybe<StakeholderStatus>;
  status_in?: Maybe<Array<StakeholderStatus>>;
  status_not_in?: Maybe<Array<StakeholderStatus>>;
  imageId?: Maybe<Scalars['String']>;
  imageId_not?: Maybe<Scalars['String']>;
  imageId_in?: Maybe<Array<Scalars['String']>>;
  imageId_not_in?: Maybe<Array<Scalars['String']>>;
  imageId_contains?: Maybe<Scalars['String']>;
  imageId_startsWith?: Maybe<Scalars['String']>;
  imageId_endsWith?: Maybe<Scalars['String']>;
  image?: Maybe<FileWhereInput>;
  image_not?: Maybe<FileWhereInput>;
  image_in?: Maybe<Array<FileWhereInput>>;
  image_not_in?: Maybe<Array<FileWhereInput>>;
  tickets?: Maybe<TicketWhereInput>;
  tickets_not?: Maybe<TicketWhereInput>;
  tickets_in?: Maybe<Array<TicketWhereInput>>;
  tickets_not_in?: Maybe<Array<TicketWhereInput>>;
  events?: Maybe<EventWhereInput>;
  events_not?: Maybe<EventWhereInput>;
  events_in?: Maybe<Array<EventWhereInput>>;
  events_not_in?: Maybe<Array<EventWhereInput>>;
  documents?: Maybe<DocumentWhereInput>;
  documents_not?: Maybe<DocumentWhereInput>;
  documents_in?: Maybe<Array<DocumentWhereInput>>;
  documents_not_in?: Maybe<Array<DocumentWhereInput>>;
  properties?: Maybe<PropertyWhereInput>;
  properties_not?: Maybe<PropertyWhereInput>;
  properties_in?: Maybe<Array<PropertyWhereInput>>;
  properties_not_in?: Maybe<Array<PropertyWhereInput>>;
  applications?: Maybe<ApplicationWhereInput>;
  applications_not?: Maybe<ApplicationWhereInput>;
  applications_in?: Maybe<Array<ApplicationWhereInput>>;
  applications_not_in?: Maybe<Array<ApplicationWhereInput>>;
  memberships?: Maybe<MembershipWhereInput>;
  memberships_not?: Maybe<MembershipWhereInput>;
  memberships_in?: Maybe<Array<MembershipWhereInput>>;
  memberships_not_in?: Maybe<Array<MembershipWhereInput>>;
  orders?: Maybe<OrderWhereInput>;
  orders_not?: Maybe<OrderWhereInput>;
  orders_in?: Maybe<Array<OrderWhereInput>>;
  orders_not_in?: Maybe<Array<OrderWhereInput>>;
  vehicles?: Maybe<VehicleWhereInput>;
  vehicles_not?: Maybe<VehicleWhereInput>;
  vehicles_in?: Maybe<Array<VehicleWhereInput>>;
  vehicles_not_in?: Maybe<Array<VehicleWhereInput>>;
  passes?: Maybe<PassWhereInput>;
  passes_not?: Maybe<PassWhereInput>;
  passes_in?: Maybe<Array<PassWhereInput>>;
  passes_not_in?: Maybe<Array<PassWhereInput>>;
  bookings?: Maybe<BookingWhereInput>;
  bookings_not?: Maybe<BookingWhereInput>;
  bookings_in?: Maybe<Array<BookingWhereInput>>;
  bookings_not_in?: Maybe<Array<BookingWhereInput>>;
  hostings?: Maybe<VisitWhereInput>;
  hostings_not?: Maybe<VisitWhereInput>;
  hostings_in?: Maybe<Array<VisitWhereInput>>;
  hostings_not_in?: Maybe<Array<VisitWhereInput>>;
  visitings?: Maybe<Scalars['String']>;
  visitings_not?: Maybe<Scalars['String']>;
  visitings_in?: Maybe<Array<Scalars['String']>>;
  visitings_not_in?: Maybe<Array<Scalars['String']>>;
  visitings_contains?: Maybe<Scalars['String']>;
  visitings_startsWith?: Maybe<Scalars['String']>;
  visitings_endsWith?: Maybe<Scalars['String']>;
  clubs?: Maybe<ClubWhereInput>;
  clubs_not?: Maybe<ClubWhereInput>;
  clubs_in?: Maybe<Array<ClubWhereInput>>;
  clubs_not_in?: Maybe<Array<ClubWhereInput>>;
  clubComments?: Maybe<CommentWhereInput>;
  clubComments_not?: Maybe<CommentWhereInput>;
  clubComments_in?: Maybe<Array<CommentWhereInput>>;
  clubComments_not_in?: Maybe<Array<CommentWhereInput>>;
  classifieds?: Maybe<ClassifiedWhereInput>;
  classifieds_not?: Maybe<ClassifiedWhereInput>;
  classifieds_in?: Maybe<Array<ClassifiedWhereInput>>;
  classifieds_not_in?: Maybe<Array<ClassifiedWhereInput>>;
  neighbourhoodServiceProvider?: Maybe<NeighbourhoodServiceProviderWhereInput>;
  neighbourhoodServiceProvider_not?: Maybe<NeighbourhoodServiceProviderWhereInput>;
  neighbourhoodServiceProvider_in?: Maybe<Array<NeighbourhoodServiceProviderWhereInput>>;
  neighbourhoodServiceProvider_not_in?: Maybe<Array<NeighbourhoodServiceProviderWhereInput>>;
  serviceRatings?: Maybe<NeighbourhoodServiceProviderRatingWhereInput>;
  serviceRatings_not?: Maybe<NeighbourhoodServiceProviderRatingWhereInput>;
  serviceRatings_in?: Maybe<Array<NeighbourhoodServiceProviderRatingWhereInput>>;
  serviceRatings_not_in?: Maybe<Array<NeighbourhoodServiceProviderRatingWhereInput>>;
  serviceRequests?: Maybe<NeighbourhoodServiceRequestWhereInput>;
  serviceRequests_not?: Maybe<NeighbourhoodServiceRequestWhereInput>;
  serviceRequests_in?: Maybe<Array<NeighbourhoodServiceRequestWhereInput>>;
  serviceRequests_not_in?: Maybe<Array<NeighbourhoodServiceRequestWhereInput>>;
  readPosts?: Maybe<PostWhereInput>;
  readPosts_not?: Maybe<PostWhereInput>;
  readPosts_in?: Maybe<Array<PostWhereInput>>;
  readPosts_not_in?: Maybe<Array<PostWhereInput>>;
  postId?: Maybe<Scalars['String']>;
  postId_not?: Maybe<Scalars['String']>;
  postId_in?: Maybe<Array<Scalars['String']>>;
  postId_not_in?: Maybe<Array<Scalars['String']>>;
  postId_contains?: Maybe<Scalars['String']>;
  postId_startsWith?: Maybe<Scalars['String']>;
  postId_endsWith?: Maybe<Scalars['String']>;
  post?: Maybe<Scalars['String']>;
  post_not?: Maybe<Scalars['String']>;
  post_in?: Maybe<Array<Scalars['String']>>;
  post_not_in?: Maybe<Array<Scalars['String']>>;
  post_contains?: Maybe<Scalars['String']>;
  post_startsWith?: Maybe<Scalars['String']>;
  post_endsWith?: Maybe<Scalars['String']>;
  AND?: Maybe<Array<StakeholderWhereInput>>;
  OR?: Maybe<Array<StakeholderWhereInput>>;
  NOT?: Maybe<Array<StakeholderWhereInput>>;
};

export type Subscription = {
  root?: Maybe<Scalars['String']>;
};

export type TermsAndConditions = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  body?: Maybe<Scalars['String']>;
};

export type TermsAndConditionsCreateInput = {
  body?: Maybe<Scalars['String']>;
};

export enum TermsAndConditionsOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  BodyAsc = 'body_ASC',
  BodyDesc = 'body_DESC',
}

export type TermsAndConditionsUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  body?: Maybe<Scalars['String']>;
};

export type TermsAndConditionsWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  body?: Maybe<Scalars['String']>;
  body_not?: Maybe<Scalars['String']>;
  body_in?: Maybe<Array<Scalars['String']>>;
  body_not_in?: Maybe<Array<Scalars['String']>>;
  body_contains?: Maybe<Scalars['String']>;
  body_startsWith?: Maybe<Scalars['String']>;
  body_endsWith?: Maybe<Scalars['String']>;
  AND?: Maybe<Array<TermsAndConditionsWhereInput>>;
  OR?: Maybe<Array<TermsAndConditionsWhereInput>>;
  NOT?: Maybe<Array<TermsAndConditionsWhereInput>>;
};

export type Ticket = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<Stakeholder>;
  eventId?: Maybe<Scalars['String']>;
  event?: Maybe<Event>;
  orderId?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  productId?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  passId?: Maybe<Scalars['String']>;
  pass?: Maybe<Pass>;
};

export type TicketAssignInput = {
  productId: Scalars['ID'];
  recipientId: Scalars['ID'];
  complimentary?: Maybe<Scalars['Boolean']>;
};

export type TicketCreateInput = {
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<StakeholderCreateInput>;
  eventId?: Maybe<Scalars['String']>;
  event?: Maybe<EventCreateInput>;
  orderId?: Maybe<Scalars['String']>;
  order?: Maybe<OrderCreateInput>;
  productId?: Maybe<Scalars['String']>;
  product?: Maybe<ProductCreateInput>;
  passId?: Maybe<Scalars['String']>;
  pass?: Maybe<PassCreateInput>;
};

export enum TicketOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  StakeholderIdAsc = 'stakeholderId_ASC',
  StakeholderIdDesc = 'stakeholderId_DESC',
  StakeholderAsc = 'stakeholder_ASC',
  StakeholderDesc = 'stakeholder_DESC',
  EventIdAsc = 'eventId_ASC',
  EventIdDesc = 'eventId_DESC',
  EventAsc = 'event_ASC',
  EventDesc = 'event_DESC',
  OrderIdAsc = 'orderId_ASC',
  OrderIdDesc = 'orderId_DESC',
  OrderAsc = 'order_ASC',
  OrderDesc = 'order_DESC',
  ProductIdAsc = 'productId_ASC',
  ProductIdDesc = 'productId_DESC',
  ProductAsc = 'product_ASC',
  ProductDesc = 'product_DESC',
  PassIdAsc = 'passId_ASC',
  PassIdDesc = 'passId_DESC',
  PassAsc = 'pass_ASC',
  PassDesc = 'pass_DESC',
}

export type TicketUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<StakeholderUpdateInput>;
  eventId?: Maybe<Scalars['String']>;
  event?: Maybe<EventUpdateInput>;
  orderId?: Maybe<Scalars['String']>;
  order?: Maybe<OrderUpdateInput>;
  productId?: Maybe<Scalars['String']>;
  product?: Maybe<ProductUpdateInput>;
  passId?: Maybe<Scalars['String']>;
  pass?: Maybe<PassUpdateInput>;
};

export type TicketWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholderId_not?: Maybe<Scalars['String']>;
  stakeholderId_in?: Maybe<Array<Scalars['String']>>;
  stakeholderId_not_in?: Maybe<Array<Scalars['String']>>;
  stakeholderId_contains?: Maybe<Scalars['String']>;
  stakeholderId_startsWith?: Maybe<Scalars['String']>;
  stakeholderId_endsWith?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<StakeholderWhereInput>;
  stakeholder_not?: Maybe<StakeholderWhereInput>;
  stakeholder_in?: Maybe<Array<StakeholderWhereInput>>;
  stakeholder_not_in?: Maybe<Array<StakeholderWhereInput>>;
  eventId?: Maybe<Scalars['String']>;
  eventId_not?: Maybe<Scalars['String']>;
  eventId_in?: Maybe<Array<Scalars['String']>>;
  eventId_not_in?: Maybe<Array<Scalars['String']>>;
  eventId_contains?: Maybe<Scalars['String']>;
  eventId_startsWith?: Maybe<Scalars['String']>;
  eventId_endsWith?: Maybe<Scalars['String']>;
  event?: Maybe<EventWhereInput>;
  event_not?: Maybe<EventWhereInput>;
  event_in?: Maybe<Array<EventWhereInput>>;
  event_not_in?: Maybe<Array<EventWhereInput>>;
  orderId?: Maybe<Scalars['String']>;
  orderId_not?: Maybe<Scalars['String']>;
  orderId_in?: Maybe<Array<Scalars['String']>>;
  orderId_not_in?: Maybe<Array<Scalars['String']>>;
  orderId_contains?: Maybe<Scalars['String']>;
  orderId_startsWith?: Maybe<Scalars['String']>;
  orderId_endsWith?: Maybe<Scalars['String']>;
  order?: Maybe<OrderWhereInput>;
  order_not?: Maybe<OrderWhereInput>;
  order_in?: Maybe<Array<OrderWhereInput>>;
  order_not_in?: Maybe<Array<OrderWhereInput>>;
  productId?: Maybe<Scalars['String']>;
  productId_not?: Maybe<Scalars['String']>;
  productId_in?: Maybe<Array<Scalars['String']>>;
  productId_not_in?: Maybe<Array<Scalars['String']>>;
  productId_contains?: Maybe<Scalars['String']>;
  productId_startsWith?: Maybe<Scalars['String']>;
  productId_endsWith?: Maybe<Scalars['String']>;
  product?: Maybe<ProductWhereInput>;
  product_not?: Maybe<ProductWhereInput>;
  product_in?: Maybe<Array<ProductWhereInput>>;
  product_not_in?: Maybe<Array<ProductWhereInput>>;
  passId?: Maybe<Scalars['String']>;
  passId_not?: Maybe<Scalars['String']>;
  passId_in?: Maybe<Array<Scalars['String']>>;
  passId_not_in?: Maybe<Array<Scalars['String']>>;
  passId_contains?: Maybe<Scalars['String']>;
  passId_startsWith?: Maybe<Scalars['String']>;
  passId_endsWith?: Maybe<Scalars['String']>;
  pass?: Maybe<PassWhereInput>;
  pass_not?: Maybe<PassWhereInput>;
  pass_in?: Maybe<Array<PassWhereInput>>;
  pass_not_in?: Maybe<Array<PassWhereInput>>;
  AND?: Maybe<Array<TicketWhereInput>>;
  OR?: Maybe<Array<TicketWhereInput>>;
  NOT?: Maybe<Array<TicketWhereInput>>;
};

export type User = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  authCode?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  otp?: Maybe<Scalars['String']>;
  role?: Maybe<UserRole>;
  cellNumber?: Maybe<Scalars['String']>;
  status?: Maybe<UserStatus>;
  comments?: Maybe<Comment>;
  classifieds?: Maybe<Classified>;
  neighbourhoodServiceProvider?: Maybe<NeighbourhoodServiceProvider>;
  image?: Maybe<File>;
};

export type UserAuthenticateInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type UserAuthenticatePayload = {
  token: Scalars['String'];
};

export type UserCreateInput = {
  email?: Maybe<Scalars['String']>;
  authCode?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  otp?: Maybe<Scalars['String']>;
  role?: Maybe<UserRole>;
  cellNumber?: Maybe<Scalars['String']>;
  status?: Maybe<UserStatus>;
  comments?: Maybe<CommentCreateInput>;
  classifieds?: Maybe<ClassifiedCreateInput>;
  neighbourhoodServiceProvider?: Maybe<NeighbourhoodServiceProviderCreateInput>;
  image?: Maybe<FileCreateInput>;
};

export type UserInviteInput = {
  email: Scalars['String'];
  role: UserRole;
  vendorId?: Maybe<Scalars['ID']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type UserInvitePayload = {
  id: Scalars['String'];
};

export enum UserOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  AuthCodeAsc = 'authCode_ASC',
  AuthCodeDesc = 'authCode_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  OtpAsc = 'otp_ASC',
  OtpDesc = 'otp_DESC',
  RoleAsc = 'role_ASC',
  RoleDesc = 'role_DESC',
  CellNumberAsc = 'cellNumber_ASC',
  CellNumberDesc = 'cellNumber_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  CommentsAsc = 'comments_ASC',
  CommentsDesc = 'comments_DESC',
  ClassifiedsAsc = 'classifieds_ASC',
  ClassifiedsDesc = 'classifieds_DESC',
  NeighbourhoodServiceProviderAsc = 'neighbourhoodServiceProvider_ASC',
  NeighbourhoodServiceProviderDesc = 'neighbourhoodServiceProvider_DESC',
  ImageAsc = 'image_ASC',
  ImageDesc = 'image_DESC',
}

export type UserResetInput = {
  email: Scalars['String'];
};

export type UserResetPayload = {
  id: Scalars['String'];
};

export enum UserRole {
  Admin = 'ADMIN',
  Superadmin = 'SUPERADMIN',
  EventAdmin = 'EVENT_ADMIN',
  EventManager = 'EVENT_MANAGER',
  VendorAdmin = 'VENDOR_ADMIN',
  VendorUser = 'VENDOR_USER',
  SecurityGuard = 'SECURITY_GUARD',
  SecurityAdmin = 'SECURITY_ADMIN',
  StakeholderAdmin = 'STAKEHOLDER_ADMIN',
  ContentAdmin = 'CONTENT_ADMIN',
  ClubAdmin = 'CLUB_ADMIN',
  SalesAgent = 'SALES_AGENT',
}

export enum UserStatus {
  New = 'NEW',
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

export type UserUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  authCode?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  otp?: Maybe<Scalars['String']>;
  role?: Maybe<UserRole>;
  cellNumber?: Maybe<Scalars['String']>;
  status?: Maybe<UserStatus>;
  comments?: Maybe<CommentUpdateInput>;
  classifieds?: Maybe<ClassifiedUpdateInput>;
  neighbourhoodServiceProvider?: Maybe<NeighbourhoodServiceProviderUpdateInput>;
  image?: Maybe<FileUpdateInput>;
};

export type UserValidateInput = {
  id: Scalars['ID'];
  otp: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  password: Scalars['String'];
};

export type UserValidatePayload = {
  token: Scalars['String'];
};

export type UserWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  email?: Maybe<Scalars['String']>;
  email_not?: Maybe<Scalars['String']>;
  email_in?: Maybe<Array<Scalars['String']>>;
  email_not_in?: Maybe<Array<Scalars['String']>>;
  email_contains?: Maybe<Scalars['String']>;
  email_startsWith?: Maybe<Scalars['String']>;
  email_endsWith?: Maybe<Scalars['String']>;
  authCode?: Maybe<Scalars['String']>;
  authCode_not?: Maybe<Scalars['String']>;
  authCode_in?: Maybe<Array<Scalars['String']>>;
  authCode_not_in?: Maybe<Array<Scalars['String']>>;
  authCode_contains?: Maybe<Scalars['String']>;
  authCode_startsWith?: Maybe<Scalars['String']>;
  authCode_endsWith?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  password_not?: Maybe<Scalars['String']>;
  password_in?: Maybe<Array<Scalars['String']>>;
  password_not_in?: Maybe<Array<Scalars['String']>>;
  password_contains?: Maybe<Scalars['String']>;
  password_startsWith?: Maybe<Scalars['String']>;
  password_endsWith?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  firstName_not?: Maybe<Scalars['String']>;
  firstName_in?: Maybe<Array<Scalars['String']>>;
  firstName_not_in?: Maybe<Array<Scalars['String']>>;
  firstName_contains?: Maybe<Scalars['String']>;
  firstName_startsWith?: Maybe<Scalars['String']>;
  firstName_endsWith?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  lastName_not?: Maybe<Scalars['String']>;
  lastName_in?: Maybe<Array<Scalars['String']>>;
  lastName_not_in?: Maybe<Array<Scalars['String']>>;
  lastName_contains?: Maybe<Scalars['String']>;
  lastName_startsWith?: Maybe<Scalars['String']>;
  lastName_endsWith?: Maybe<Scalars['String']>;
  otp?: Maybe<Scalars['String']>;
  otp_not?: Maybe<Scalars['String']>;
  otp_in?: Maybe<Array<Scalars['String']>>;
  otp_not_in?: Maybe<Array<Scalars['String']>>;
  otp_contains?: Maybe<Scalars['String']>;
  otp_startsWith?: Maybe<Scalars['String']>;
  otp_endsWith?: Maybe<Scalars['String']>;
  role?: Maybe<UserRole>;
  role_not?: Maybe<UserRole>;
  role_in?: Maybe<Array<UserRole>>;
  role_not_in?: Maybe<Array<UserRole>>;
  cellNumber?: Maybe<Scalars['String']>;
  cellNumber_not?: Maybe<Scalars['String']>;
  cellNumber_in?: Maybe<Array<Scalars['String']>>;
  cellNumber_not_in?: Maybe<Array<Scalars['String']>>;
  cellNumber_contains?: Maybe<Scalars['String']>;
  cellNumber_startsWith?: Maybe<Scalars['String']>;
  cellNumber_endsWith?: Maybe<Scalars['String']>;
  status?: Maybe<UserStatus>;
  status_not?: Maybe<UserStatus>;
  status_in?: Maybe<Array<UserStatus>>;
  status_not_in?: Maybe<Array<UserStatus>>;
  comments?: Maybe<CommentWhereInput>;
  comments_not?: Maybe<CommentWhereInput>;
  comments_in?: Maybe<Array<CommentWhereInput>>;
  comments_not_in?: Maybe<Array<CommentWhereInput>>;
  classifieds?: Maybe<ClassifiedWhereInput>;
  classifieds_not?: Maybe<ClassifiedWhereInput>;
  classifieds_in?: Maybe<Array<ClassifiedWhereInput>>;
  classifieds_not_in?: Maybe<Array<ClassifiedWhereInput>>;
  neighbourhoodServiceProvider?: Maybe<NeighbourhoodServiceProviderWhereInput>;
  neighbourhoodServiceProvider_not?: Maybe<NeighbourhoodServiceProviderWhereInput>;
  neighbourhoodServiceProvider_in?: Maybe<Array<NeighbourhoodServiceProviderWhereInput>>;
  neighbourhoodServiceProvider_not_in?: Maybe<Array<NeighbourhoodServiceProviderWhereInput>>;
  image?: Maybe<FileWhereInput>;
  image_not?: Maybe<FileWhereInput>;
  image_in?: Maybe<Array<FileWhereInput>>;
  image_not_in?: Maybe<Array<FileWhereInput>>;
  AND?: Maybe<Array<UserWhereInput>>;
  OR?: Maybe<Array<UserWhereInput>>;
  NOT?: Maybe<Array<UserWhereInput>>;
};

export type Utility = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  telephoneNumber?: Maybe<Scalars['String']>;
  whatsappNumber?: Maybe<Scalars['String']>;
  menus?: Maybe<Scalars['JSON']>;
  mondayHours?: Maybe<Scalars['String']>;
  tuesdayHours?: Maybe<Scalars['String']>;
  wednesdayHours?: Maybe<Scalars['String']>;
  thursdayHours?: Maybe<Scalars['String']>;
  fridayHours?: Maybe<Scalars['String']>;
  saturdayHours?: Maybe<Scalars['String']>;
  sundayHours?: Maybe<Scalars['String']>;
  tradingHours?: Maybe<Scalars['String']>;
};

export type UtilityCreateInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  telephoneNumber?: Maybe<Scalars['String']>;
  whatsappNumber?: Maybe<Scalars['String']>;
  menus?: Maybe<Scalars['JSON']>;
  mondayHours?: Maybe<Scalars['String']>;
  tuesdayHours?: Maybe<Scalars['String']>;
  wednesdayHours?: Maybe<Scalars['String']>;
  thursdayHours?: Maybe<Scalars['String']>;
  fridayHours?: Maybe<Scalars['String']>;
  saturdayHours?: Maybe<Scalars['String']>;
  sundayHours?: Maybe<Scalars['String']>;
  tradingHours?: Maybe<Scalars['String']>;
};

export enum UtilityOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  LogoAsc = 'logo_ASC',
  LogoDesc = 'logo_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  WhatsappNumberAsc = 'whatsappNumber_ASC',
  WhatsappNumberDesc = 'whatsappNumber_DESC',
  MenusAsc = 'menus_ASC',
  MenusDesc = 'menus_DESC',
  MondayHoursAsc = 'mondayHours_ASC',
  MondayHoursDesc = 'mondayHours_DESC',
  TuesdayHoursAsc = 'tuesdayHours_ASC',
  TuesdayHoursDesc = 'tuesdayHours_DESC',
  WednesdayHoursAsc = 'wednesdayHours_ASC',
  WednesdayHoursDesc = 'wednesdayHours_DESC',
  ThursdayHoursAsc = 'thursdayHours_ASC',
  ThursdayHoursDesc = 'thursdayHours_DESC',
  FridayHoursAsc = 'fridayHours_ASC',
  FridayHoursDesc = 'fridayHours_DESC',
  SaturdayHoursAsc = 'saturdayHours_ASC',
  SaturdayHoursDesc = 'saturdayHours_DESC',
  SundayHoursAsc = 'sundayHours_ASC',
  SundayHoursDesc = 'sundayHours_DESC',
  TradingHoursAsc = 'tradingHours_ASC',
  TradingHoursDesc = 'tradingHours_DESC',
}

export type UtilityUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  telephoneNumber?: Maybe<Scalars['String']>;
  whatsappNumber?: Maybe<Scalars['String']>;
  menus?: Maybe<Scalars['JSON']>;
  mondayHours?: Maybe<Scalars['String']>;
  tuesdayHours?: Maybe<Scalars['String']>;
  wednesdayHours?: Maybe<Scalars['String']>;
  thursdayHours?: Maybe<Scalars['String']>;
  fridayHours?: Maybe<Scalars['String']>;
  saturdayHours?: Maybe<Scalars['String']>;
  sundayHours?: Maybe<Scalars['String']>;
  tradingHours?: Maybe<Scalars['String']>;
};

export type UtilityWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  name?: Maybe<Scalars['String']>;
  name_not?: Maybe<Scalars['String']>;
  name_in?: Maybe<Array<Scalars['String']>>;
  name_not_in?: Maybe<Array<Scalars['String']>>;
  name_contains?: Maybe<Scalars['String']>;
  name_startsWith?: Maybe<Scalars['String']>;
  name_endsWith?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  description_not?: Maybe<Scalars['String']>;
  description_in?: Maybe<Array<Scalars['String']>>;
  description_not_in?: Maybe<Array<Scalars['String']>>;
  description_contains?: Maybe<Scalars['String']>;
  description_startsWith?: Maybe<Scalars['String']>;
  description_endsWith?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  logo_not?: Maybe<Scalars['String']>;
  logo_in?: Maybe<Array<Scalars['String']>>;
  logo_not_in?: Maybe<Array<Scalars['String']>>;
  logo_contains?: Maybe<Scalars['String']>;
  logo_startsWith?: Maybe<Scalars['String']>;
  logo_endsWith?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  email_not?: Maybe<Scalars['String']>;
  email_in?: Maybe<Array<Scalars['String']>>;
  email_not_in?: Maybe<Array<Scalars['String']>>;
  email_contains?: Maybe<Scalars['String']>;
  email_startsWith?: Maybe<Scalars['String']>;
  email_endsWith?: Maybe<Scalars['String']>;
  telephoneNumber?: Maybe<Scalars['String']>;
  telephoneNumber_not?: Maybe<Scalars['String']>;
  telephoneNumber_in?: Maybe<Array<Scalars['String']>>;
  telephoneNumber_not_in?: Maybe<Array<Scalars['String']>>;
  telephoneNumber_contains?: Maybe<Scalars['String']>;
  telephoneNumber_startsWith?: Maybe<Scalars['String']>;
  telephoneNumber_endsWith?: Maybe<Scalars['String']>;
  whatsappNumber?: Maybe<Scalars['String']>;
  whatsappNumber_not?: Maybe<Scalars['String']>;
  whatsappNumber_in?: Maybe<Array<Scalars['String']>>;
  whatsappNumber_not_in?: Maybe<Array<Scalars['String']>>;
  whatsappNumber_contains?: Maybe<Scalars['String']>;
  whatsappNumber_startsWith?: Maybe<Scalars['String']>;
  whatsappNumber_endsWith?: Maybe<Scalars['String']>;
  menus?: Maybe<Scalars['JSON']>;
  menus_not?: Maybe<Scalars['JSON']>;
  menus_in?: Maybe<Array<Scalars['JSON']>>;
  menus_not_in?: Maybe<Array<Scalars['JSON']>>;
  mondayHours?: Maybe<Scalars['String']>;
  mondayHours_not?: Maybe<Scalars['String']>;
  mondayHours_in?: Maybe<Array<Scalars['String']>>;
  mondayHours_not_in?: Maybe<Array<Scalars['String']>>;
  mondayHours_contains?: Maybe<Scalars['String']>;
  mondayHours_startsWith?: Maybe<Scalars['String']>;
  mondayHours_endsWith?: Maybe<Scalars['String']>;
  tuesdayHours?: Maybe<Scalars['String']>;
  tuesdayHours_not?: Maybe<Scalars['String']>;
  tuesdayHours_in?: Maybe<Array<Scalars['String']>>;
  tuesdayHours_not_in?: Maybe<Array<Scalars['String']>>;
  tuesdayHours_contains?: Maybe<Scalars['String']>;
  tuesdayHours_startsWith?: Maybe<Scalars['String']>;
  tuesdayHours_endsWith?: Maybe<Scalars['String']>;
  wednesdayHours?: Maybe<Scalars['String']>;
  wednesdayHours_not?: Maybe<Scalars['String']>;
  wednesdayHours_in?: Maybe<Array<Scalars['String']>>;
  wednesdayHours_not_in?: Maybe<Array<Scalars['String']>>;
  wednesdayHours_contains?: Maybe<Scalars['String']>;
  wednesdayHours_startsWith?: Maybe<Scalars['String']>;
  wednesdayHours_endsWith?: Maybe<Scalars['String']>;
  thursdayHours?: Maybe<Scalars['String']>;
  thursdayHours_not?: Maybe<Scalars['String']>;
  thursdayHours_in?: Maybe<Array<Scalars['String']>>;
  thursdayHours_not_in?: Maybe<Array<Scalars['String']>>;
  thursdayHours_contains?: Maybe<Scalars['String']>;
  thursdayHours_startsWith?: Maybe<Scalars['String']>;
  thursdayHours_endsWith?: Maybe<Scalars['String']>;
  fridayHours?: Maybe<Scalars['String']>;
  fridayHours_not?: Maybe<Scalars['String']>;
  fridayHours_in?: Maybe<Array<Scalars['String']>>;
  fridayHours_not_in?: Maybe<Array<Scalars['String']>>;
  fridayHours_contains?: Maybe<Scalars['String']>;
  fridayHours_startsWith?: Maybe<Scalars['String']>;
  fridayHours_endsWith?: Maybe<Scalars['String']>;
  saturdayHours?: Maybe<Scalars['String']>;
  saturdayHours_not?: Maybe<Scalars['String']>;
  saturdayHours_in?: Maybe<Array<Scalars['String']>>;
  saturdayHours_not_in?: Maybe<Array<Scalars['String']>>;
  saturdayHours_contains?: Maybe<Scalars['String']>;
  saturdayHours_startsWith?: Maybe<Scalars['String']>;
  saturdayHours_endsWith?: Maybe<Scalars['String']>;
  sundayHours?: Maybe<Scalars['String']>;
  sundayHours_not?: Maybe<Scalars['String']>;
  sundayHours_in?: Maybe<Array<Scalars['String']>>;
  sundayHours_not_in?: Maybe<Array<Scalars['String']>>;
  sundayHours_contains?: Maybe<Scalars['String']>;
  sundayHours_startsWith?: Maybe<Scalars['String']>;
  sundayHours_endsWith?: Maybe<Scalars['String']>;
  tradingHours?: Maybe<Scalars['String']>;
  tradingHours_not?: Maybe<Scalars['String']>;
  tradingHours_in?: Maybe<Array<Scalars['String']>>;
  tradingHours_not_in?: Maybe<Array<Scalars['String']>>;
  tradingHours_contains?: Maybe<Scalars['String']>;
  tradingHours_startsWith?: Maybe<Scalars['String']>;
  tradingHours_endsWith?: Maybe<Scalars['String']>;
  AND?: Maybe<Array<UtilityWhereInput>>;
  OR?: Maybe<Array<UtilityWhereInput>>;
  NOT?: Maybe<Array<UtilityWhereInput>>;
};

export type Vehicle = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  color?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
  registration?: Maybe<Scalars['String']>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<Stakeholder>;
};

export type VehicleCreateInput = {
  color?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
  registration?: Maybe<Scalars['String']>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<StakeholderCreateInput>;
};

export enum VehicleOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  ColorAsc = 'color_ASC',
  ColorDesc = 'color_DESC',
  MakeAsc = 'make_ASC',
  MakeDesc = 'make_DESC',
  YearAsc = 'year_ASC',
  YearDesc = 'year_DESC',
  RegistrationAsc = 'registration_ASC',
  RegistrationDesc = 'registration_DESC',
  StakeholderIdAsc = 'stakeholderId_ASC',
  StakeholderIdDesc = 'stakeholderId_DESC',
  StakeholderAsc = 'stakeholder_ASC',
  StakeholderDesc = 'stakeholder_DESC',
}

export type VehicleUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  color?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
  registration?: Maybe<Scalars['String']>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<StakeholderUpdateInput>;
};

export type VehicleWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  color?: Maybe<Scalars['String']>;
  color_not?: Maybe<Scalars['String']>;
  color_in?: Maybe<Array<Scalars['String']>>;
  color_not_in?: Maybe<Array<Scalars['String']>>;
  color_contains?: Maybe<Scalars['String']>;
  color_startsWith?: Maybe<Scalars['String']>;
  color_endsWith?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  make_not?: Maybe<Scalars['String']>;
  make_in?: Maybe<Array<Scalars['String']>>;
  make_not_in?: Maybe<Array<Scalars['String']>>;
  make_contains?: Maybe<Scalars['String']>;
  make_startsWith?: Maybe<Scalars['String']>;
  make_endsWith?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
  year_not?: Maybe<Scalars['Int']>;
  year_in?: Maybe<Array<Scalars['Int']>>;
  year_not_in?: Maybe<Array<Scalars['Int']>>;
  year_lt?: Maybe<Scalars['Int']>;
  year_lte?: Maybe<Scalars['Int']>;
  year_gt?: Maybe<Scalars['Int']>;
  year_gte?: Maybe<Scalars['Int']>;
  registration?: Maybe<Scalars['String']>;
  registration_not?: Maybe<Scalars['String']>;
  registration_in?: Maybe<Array<Scalars['String']>>;
  registration_not_in?: Maybe<Array<Scalars['String']>>;
  registration_contains?: Maybe<Scalars['String']>;
  registration_startsWith?: Maybe<Scalars['String']>;
  registration_endsWith?: Maybe<Scalars['String']>;
  stakeholderId?: Maybe<Scalars['String']>;
  stakeholderId_not?: Maybe<Scalars['String']>;
  stakeholderId_in?: Maybe<Array<Scalars['String']>>;
  stakeholderId_not_in?: Maybe<Array<Scalars['String']>>;
  stakeholderId_contains?: Maybe<Scalars['String']>;
  stakeholderId_startsWith?: Maybe<Scalars['String']>;
  stakeholderId_endsWith?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<StakeholderWhereInput>;
  stakeholder_not?: Maybe<StakeholderWhereInput>;
  stakeholder_in?: Maybe<Array<StakeholderWhereInput>>;
  stakeholder_not_in?: Maybe<Array<StakeholderWhereInput>>;
  AND?: Maybe<Array<VehicleWhereInput>>;
  OR?: Maybe<Array<VehicleWhereInput>>;
  NOT?: Maybe<Array<VehicleWhereInput>>;
};

export type Visit = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  hostId?: Maybe<Scalars['String']>;
  host?: Maybe<Stakeholder>;
  guestId?: Maybe<Scalars['String']>;
  guest?: Maybe<Stakeholder>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  passId?: Maybe<Scalars['String']>;
  pass?: Maybe<Pass>;
  location?: Maybe<Scalars['JSON']>;
};

export type VisitCreateInput = {
  hostId?: Maybe<Scalars['String']>;
  host?: Maybe<StakeholderCreateInput>;
  guestId?: Maybe<Scalars['String']>;
  guest?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  passId?: Maybe<Scalars['String']>;
  pass?: Maybe<PassCreateInput>;
  location?: Maybe<Scalars['JSON']>;
};

export enum VisitOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  HostIdAsc = 'hostId_ASC',
  HostIdDesc = 'hostId_DESC',
  HostAsc = 'host_ASC',
  HostDesc = 'host_DESC',
  GuestIdAsc = 'guestId_ASC',
  GuestIdDesc = 'guestId_DESC',
  GuestAsc = 'guest_ASC',
  GuestDesc = 'guest_DESC',
  StartDateAsc = 'startDate_ASC',
  StartDateDesc = 'startDate_DESC',
  EndDateAsc = 'endDate_ASC',
  EndDateDesc = 'endDate_DESC',
  PassIdAsc = 'passId_ASC',
  PassIdDesc = 'passId_DESC',
  PassAsc = 'pass_ASC',
  PassDesc = 'pass_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
}

export type VisitUpdateInput = {
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  hostId?: Maybe<Scalars['String']>;
  host?: Maybe<StakeholderUpdateInput>;
  guestId?: Maybe<Scalars['String']>;
  guest?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  passId?: Maybe<Scalars['String']>;
  pass?: Maybe<PassUpdateInput>;
  location?: Maybe<Scalars['JSON']>;
};

export type VisitWhereInput = {
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Scalars['String']>>;
  id_not_in?: Maybe<Array<Scalars['String']>>;
  id_contains?: Maybe<Scalars['String']>;
  id_startsWith?: Maybe<Scalars['String']>;
  id_endsWith?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  hostId?: Maybe<Scalars['String']>;
  hostId_not?: Maybe<Scalars['String']>;
  hostId_in?: Maybe<Array<Scalars['String']>>;
  hostId_not_in?: Maybe<Array<Scalars['String']>>;
  hostId_contains?: Maybe<Scalars['String']>;
  hostId_startsWith?: Maybe<Scalars['String']>;
  hostId_endsWith?: Maybe<Scalars['String']>;
  host?: Maybe<StakeholderWhereInput>;
  host_not?: Maybe<StakeholderWhereInput>;
  host_in?: Maybe<Array<StakeholderWhereInput>>;
  host_not_in?: Maybe<Array<StakeholderWhereInput>>;
  guestId?: Maybe<Scalars['String']>;
  guestId_not?: Maybe<Scalars['String']>;
  guestId_in?: Maybe<Array<Scalars['String']>>;
  guestId_not_in?: Maybe<Array<Scalars['String']>>;
  guestId_contains?: Maybe<Scalars['String']>;
  guestId_startsWith?: Maybe<Scalars['String']>;
  guestId_endsWith?: Maybe<Scalars['String']>;
  guest?: Maybe<Scalars['String']>;
  guest_not?: Maybe<Scalars['String']>;
  guest_in?: Maybe<Array<Scalars['String']>>;
  guest_not_in?: Maybe<Array<Scalars['String']>>;
  guest_contains?: Maybe<Scalars['String']>;
  guest_startsWith?: Maybe<Scalars['String']>;
  guest_endsWith?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  startDate_not?: Maybe<Scalars['DateTime']>;
  startDate_in?: Maybe<Array<Scalars['DateTime']>>;
  startDate_not_in?: Maybe<Array<Scalars['DateTime']>>;
  endDate?: Maybe<Scalars['DateTime']>;
  endDate_not?: Maybe<Scalars['DateTime']>;
  endDate_in?: Maybe<Array<Scalars['DateTime']>>;
  endDate_not_in?: Maybe<Array<Scalars['DateTime']>>;
  endDate_gt?: Maybe<Scalars['DateTime']>;
  endDate_gte?: Maybe<Scalars['DateTime']>;
  endDate_lt?: Maybe<Scalars['DateTime']>;
  endDate_lte?: Maybe<Scalars['DateTime']>;
  passId?: Maybe<Scalars['String']>;
  passId_not?: Maybe<Scalars['String']>;
  passId_in?: Maybe<Array<Scalars['String']>>;
  passId_not_in?: Maybe<Array<Scalars['String']>>;
  passId_contains?: Maybe<Scalars['String']>;
  passId_startsWith?: Maybe<Scalars['String']>;
  passId_endsWith?: Maybe<Scalars['String']>;
  pass?: Maybe<PassWhereInput>;
  pass_not?: Maybe<PassWhereInput>;
  pass_in?: Maybe<Array<PassWhereInput>>;
  pass_not_in?: Maybe<Array<PassWhereInput>>;
  location?: Maybe<Scalars['JSON']>;
  location_not?: Maybe<Scalars['JSON']>;
  location_in?: Maybe<Array<Scalars['JSON']>>;
  location_not_in?: Maybe<Array<Scalars['JSON']>>;
  AND?: Maybe<Array<VisitWhereInput>>;
  OR?: Maybe<Array<VisitWhereInput>>;
  NOT?: Maybe<Array<VisitWhereInput>>;
};

export type ArchiveContactUsMutationVariables = {
  id: Scalars['ID'];
};

export type ArchiveContactUsMutation = { __typename?: 'Mutation' } & {
  archiveContactUs: { __typename?: 'ContactUs' } & Pick<ContactUs, 'id'>;
};

export type ArchiveEstateInfoMutationVariables = {
  id: Scalars['ID'];
};

export type ArchiveEstateInfoMutation = { __typename?: 'Mutation' } & {
  archiveEstateInfo: { __typename?: 'EstateInfo' } & Pick<EstateInfo, 'id'>;
};

export type AssignTicketMutationVariables = {
  productId: Scalars['ID'];
  recipientId: Scalars['ID'];
  complimentary?: Maybe<Scalars['Boolean']>;
};

export type AssignTicketMutation = { __typename?: 'Mutation' } & {
  assignTicket: Maybe<
    { __typename?: 'Ticket' } & Pick<Ticket, 'id'> & {
        product: Maybe<{ __typename?: 'Product' } & Pick<Product, 'id'>>;
        stakeholder: Maybe<{ __typename?: 'Stakeholder' } & Pick<Stakeholder, 'id'>>;
        event: Maybe<{ __typename?: 'Event' } & Pick<Event, 'id'>>;
      }
  >;
};

export type AuthenticateUserMutationVariables = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type AuthenticateUserMutation = { __typename?: 'Mutation' } & {
  authenticateUser: { __typename?: 'UserAuthenticatePayload' } & Pick<UserAuthenticatePayload, 'token'>;
};

export type CreateApplicationMutationVariables = {
  fields?: Maybe<Scalars['JSON']>;
  type: ApplicationType;
  stakeholderId: Scalars['String'];
  propertyId: Scalars['String'];
};

export type CreateApplicationMutation = { __typename?: 'Mutation' } & {
  createApplication: { __typename?: 'Application' } & Pick<
    Application,
    'id' | 'createdAt' | 'updatedAt' | 'fields' | 'status' | 'type'
  > & {
      stakeholder: Maybe<{ __typename?: 'Stakeholder' } & Pick<Stakeholder, 'id'>>;
      property: Maybe<{ __typename?: 'Property' } & Pick<Property, 'id'>>;
    };
};

export type CreateCalendarEventMutationVariables = {
  data: EventCreateInput;
};

export type CreateCalendarEventMutation = { __typename?: 'Mutation' } & {
  createEvent: { __typename?: 'Event' } & Pick<
    Event,
    'id' | 'createdAt' | 'updatedAt' | 'name' | 'description' | 'location' | 'status' | 'startDate' | 'endDate'
  > & { image: Maybe<{ __typename?: 'File' } & Pick<File, 'id' | 'original'>> };
};

export type CreateContactUsMutationVariables = {
  data: ContactUsCreateInput;
};

export type CreateContactUsMutation = { __typename?: 'Mutation' } & {
  createContactUs: { __typename?: 'ContactUs' } & Pick<ContactUs, 'id' | 'name' | 'number' | 'email' | 'status'>;
};

export type CreateEateryMutationVariables = {
  data: EateryCreateInput;
};

export type CreateEateryMutation = { __typename?: 'Mutation' } & {
  createEatery: { __typename?: 'Eatery' } & Pick<Eatery, 'id' | 'name' | 'status' | 'menus'>;
};

export type CreateEstateInfoMutationVariables = {
  data: EstateInfoCreateInput;
};

export type CreateEstateInfoMutation = { __typename?: 'Mutation' } & {
  createEstateInfo: { __typename?: 'EstateInfo' } & Pick<
    EstateInfo,
    'id' | 'title' | 'image' | 'pdf' | 'status' | 'createdAt' | 'updatedAt'
  >;
};

export type CreateEventMutationVariables = {
  name: Scalars['String'];
  type?: Maybe<EventType>;
  host: Scalars['String'];
  location: Scalars['String'];
  startDate: Scalars['DateTime'];
  accessStartDate?: Maybe<Scalars['DateTime']>;
  accessEndDate?: Maybe<Scalars['DateTime']>;
  endDate: Scalars['DateTime'];
  description: Scalars['String'];
  hostLogo?: Maybe<Scalars['String']>;
  status?: Maybe<EventStatus>;
  reminders?: Maybe<Scalars['Boolean']>;
};

export type CreateEventMutation = { __typename?: 'Mutation' } & {
  createEvent: { __typename?: 'Event' } & Pick<
    Event,
    | 'id'
    | 'createdAt'
    | 'updatedAt'
    | 'name'
    | 'type'
    | 'host'
    | 'location'
    | 'startDate'
    | 'accessStartDate'
    | 'accessEndDate'
    | 'endDate'
    | 'description'
    | 'hostLogo'
    | 'links'
    | 'status'
    | 'children'
    | 'reminders'
  > & {
      attendees: Maybe<{ __typename?: 'Stakeholder' } & Pick<Stakeholder, 'id' | 'cellNumber' | 'email'>>;
      image: Maybe<{ __typename?: 'File' } & Pick<File, 'id' | 'original' | 'scaled' | 'thumbnail'>>;
    };
};

export type CreateFacilityMutationVariables = {
  data: FacilityCreateInput;
};

export type CreateFacilityMutation = { __typename?: 'Mutation' } & {
  createFacility: { __typename?: 'Facility' } & Pick<Facility, 'id' | 'name' | 'status'>;
};

export type CreateGuestMutationVariables = {
  cellNumber: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['DateTime']>;
  residentialAddress?: Maybe<Scalars['String']>;
};

export type CreateGuestMutation = { __typename?: 'Mutation' } & {
  createStakeholder: { __typename?: 'Stakeholder' } & Pick<
    Stakeholder,
    | 'createdAt'
    | 'updatedAt'
    | 'id'
    | 'cellNumber'
    | 'firstName'
    | 'lastName'
    | 'email'
    | 'dob'
    | 'residentialAddress'
    | 'role'
  > & { image: Maybe<{ __typename?: 'File' } & Pick<File, 'id' | 'original' | 'scaled' | 'thumbnail'>> };
};

export type CreatePdfLibraryItemMutationVariables = {
  name: Scalars['String'];
  file: Scalars['String'];
  category: PdfLibraryCategory;
};

export type CreatePdfLibraryItemMutation = { __typename?: 'Mutation' } & {
  createPDFLibraryItem: { __typename?: 'PDFLibraryItem' } & Pick<PdfLibraryItem, 'id'>;
};

export type CreatePostMutationVariables = {
  data: PostCreateInput;
};

export type CreatePostMutation = { __typename?: 'Mutation' } & {
  createPost: { __typename?: 'Post' } & Pick<
    Post,
    'createdAt' | 'id' | 'updatedAt' | 'title' | 'body' | 'status' | 'type' | 'category' | 'roles' | 'read'
  > & { image: Maybe<{ __typename?: 'File' } & Pick<File, 'id' | 'original'>> };
};

export type CreateProductMutationVariables = {
  input: ProductCreateInput;
};

export type CreateProductMutation = { __typename?: 'Mutation' } & {
  createProduct: { __typename?: 'Product' } & Pick<
    Product,
    'createdAt' | 'id' | 'updatedAt' | 'name' | 'description' | 'price' | 'capacity'
  > & { event: Maybe<{ __typename?: 'Event' } & Pick<Event, 'id'>> };
};

export type CreatePropertyMutationVariables = {
  address: Scalars['String'];
  size: Scalars['Float'];
  code: Scalars['String'];
  suburb?: Maybe<Scalars['String']>;
  valuation?: Maybe<Scalars['Float']>;
  rooms: Scalars['Float'];
  erfNumber?: Maybe<Scalars['String']>;
  salesAgent: Scalars['String'];
  status?: Maybe<PropertyStatus>;
  imageId?: Maybe<Scalars['String']>;
  image?: Maybe<FileCreateInput>;
  documents?: Maybe<DocumentCreateInput>;
  stakeholders?: Maybe<StakeholderCreateInput>;
  applications?: Maybe<ApplicationCreateInput>;
  memberships?: Maybe<MembershipCreateInput>;
  type?: Maybe<PropertyType>;
};

export type CreatePropertyMutation = { __typename?: 'Mutation' } & {
  createProperty: { __typename?: 'Property' } & Pick<
    Property,
    | 'createdAt'
    | 'id'
    | 'updatedAt'
    | 'address'
    | 'size'
    | 'code'
    | 'suburb'
    | 'valuation'
    | 'rooms'
    | 'erfNumber'
    | 'salesAgent'
    | 'status'
    | 'type'
  >;
};

export type CreatePropertyListingMutationVariables = {
  location?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['JSON']>;
  price?: Maybe<Scalars['Float']>;
  erfNumber?: Maybe<Scalars['Int']>;
  descriptor?: Maybe<Scalars['String']>;
  status?: Maybe<PropertyListingStatus>;
  images?: Maybe<FileCreateInput>;
};

export type CreatePropertyListingMutation = { __typename?: 'Mutation' } & {
  createPropertyListing: { __typename?: 'PropertyListing' } & Pick<
    PropertyListing,
    | 'id'
    | 'updatedAt'
    | 'createdAt'
    | 'location'
    | 'title'
    | 'description'
    | 'contact'
    | 'price'
    | 'erfNumber'
    | 'status'
  > & { images: Maybe<{ __typename?: 'File' } & Pick<File, 'id' | 'original' | 'scaled' | 'thumbnail'>> };
};

export type CreateShopMutationVariables = {
  data: ShopCreateInput;
};

export type CreateShopMutation = { __typename?: 'Mutation' } & {
  createShop: { __typename?: 'Shop' } & Pick<Shop, 'id' | 'name' | 'status' | 'isService'>;
};

export type CreateStakeholderMutationVariables = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  dob: Scalars['DateTime'];
  country: Scalars['String'];
  homeNumber: Scalars['String'];
  cellNumber: Scalars['String'];
  email: Scalars['String'];
  idNumber: Scalars['String'];
  residentialAddress: Scalars['String'];
  postalAddress: Scalars['String'];
  status: StakeholderStatus;
  role: StakeholderRole;
};

export type CreateStakeholderMutation = { __typename?: 'Mutation' } & {
  createStakeholder: { __typename?: 'Stakeholder' } & Pick<
    Stakeholder,
    | 'createdAt'
    | 'updatedAt'
    | 'id'
    | 'firstName'
    | 'lastName'
    | 'dob'
    | 'country'
    | 'cellNumber'
    | 'email'
    | 'idNumber'
    | 'residentialAddress'
    | 'postalAddress'
    | 'status'
    | 'role'
  >;
};

export type InviteUserMutationVariables = {
  email: Scalars['String'];
  role: UserRole;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type InviteUserMutation = { __typename?: 'Mutation' } & {
  inviteUser: { __typename?: 'UserInvitePayload' } & Pick<UserInvitePayload, 'id'>;
};

export type PublishPropertyListingMutationVariables = {
  id: Scalars['ID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  location?: Maybe<Scalars['String']>;
  erfNumber?: Maybe<Scalars['Int']>;
  descriptor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['JSON']>;
  price?: Maybe<Scalars['Float']>;
  status?: Maybe<PropertyListingStatus>;
  images?: Maybe<FileUpdateInput>;
};

export type PublishPropertyListingMutation = { __typename?: 'Mutation' } & {
  updatePropertyListing: { __typename?: 'PropertyListing' } & Pick<PropertyListing, 'id' | 'status'>;
};

export type ResetUserPasswordMutationVariables = {
  email: Scalars['String'];
};

export type ResetUserPasswordMutation = { __typename?: 'Mutation' } & {
  resetUser: { __typename?: 'UserResetPayload' } & Pick<UserResetPayload, 'id'>;
};

export type UpdateApplicationMutationVariables = {
  fields?: Maybe<Scalars['JSON']>;
  rejectReason?: Maybe<Scalars['String']>;
  type?: Maybe<ApplicationType>;
  status?: Maybe<ApplicationStatus>;
  document?: Maybe<FileUpdateInput>;
  id: Scalars['ID'];
};

export type UpdateApplicationMutation = { __typename?: 'Mutation' } & {
  updateApplication: { __typename?: 'Application' } & Pick<
    Application,
    'id' | 'createdAt' | 'updatedAt' | 'fields' | 'rejectReason' | 'status' | 'type'
  > & {
      document: Maybe<{ __typename?: 'File' } & Pick<File, 'id'>>;
      stakeholder: Maybe<{ __typename?: 'Stakeholder' } & Pick<Stakeholder, 'id'>>;
      property: Maybe<{ __typename?: 'Property' } & Pick<Property, 'id'>>;
    };
};

export type UpdateCalendarEventMutationVariables = {
  id: Scalars['ID'];
  data: EventUpdateInput;
};

export type UpdateCalendarEventMutation = { __typename?: 'Mutation' } & {
  updateEvent: { __typename?: 'Event' } & Pick<
    Event,
    'id' | 'createdAt' | 'updatedAt' | 'name' | 'description' | 'location' | 'status' | 'startDate' | 'endDate'
  > & { image: Maybe<{ __typename?: 'File' } & Pick<File, 'id' | 'original'>> };
};

export type UpdateContactUsMutationVariables = {
  updateContactUsId: Scalars['ID'];
  data: ContactUsUpdateInput;
};

export type UpdateContactUsMutation = { __typename?: 'Mutation' } & {
  updateContactUs: { __typename?: 'ContactUs' } & Pick<ContactUs, 'id' | 'name' | 'number' | 'email' | 'status'>;
};

export type UpdateEateryMutationVariables = {
  id: Scalars['ID'];
  data: EateryUpdateInput;
};

export type UpdateEateryMutation = { __typename?: 'Mutation' } & {
  updateEatery: { __typename?: 'Eatery' } & Pick<Eatery, 'id' | 'name' | 'status'>;
};

export type UpdateEstateInfoMutationVariables = {
  id: Scalars['ID'];
  data: EstateInfoUpdateInput;
};

export type UpdateEstateInfoMutation = { __typename?: 'Mutation' } & {
  updateEstateInfo: { __typename?: 'EstateInfo' } & Pick<
    EstateInfo,
    'id' | 'title' | 'image' | 'pdf' | 'status' | 'createdAt' | 'updatedAt'
  >;
};

export type UpdateEventMutationVariables = {
  id: Scalars['ID'];
  data: EventUpdateInput;
};

export type UpdateEventMutation = { __typename?: 'Mutation' } & {
  updateEvent: { __typename?: 'Event' } & Pick<
    Event,
    | 'id'
    | 'createdAt'
    | 'updatedAt'
    | 'name'
    | 'type'
    | 'host'
    | 'location'
    | 'startDate'
    | 'endDate'
    | 'accessStartDate'
    | 'accessEndDate'
    | 'description'
    | 'hostLogo'
    | 'status'
    | 'reminders'
  > & {
      attendees: Maybe<
        { __typename?: 'Stakeholder' } & Pick<
          Stakeholder,
          'id' | 'cellNumber' | 'email' | 'status' | 'firstName' | 'lastName'
        >
      >;
      image: Maybe<{ __typename?: 'File' } & Pick<File, 'id' | 'original' | 'scaled' | 'thumbnail'>>;
    };
};

export type UpdateFacilityMutationVariables = {
  id: Scalars['ID'];
  data: FacilityUpdateInput;
};

export type UpdateFacilityMutation = { __typename?: 'Mutation' } & {
  updateFacility: { __typename?: 'Facility' } & Pick<Facility, 'id' | 'name' | 'status'>;
};

export type UpdatePostMutationVariables = {
  id: Scalars['ID'];
  data: PostUpdateInput;
};

export type UpdatePostMutation = { __typename?: 'Mutation' } & {
  updatePost: { __typename?: 'Post' } & Pick<
    Post,
    'createdAt' | 'id' | 'updatedAt' | 'title' | 'body' | 'status' | 'type' | 'category' | 'roles'
  > & { image: Maybe<{ __typename?: 'File' } & Pick<File, 'id' | 'original' | 'scaled' | 'thumbnail'>> };
};

export type UpdatePropertyMutationVariables = {
  id: Scalars['ID'];
  address?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  valuation?: Maybe<Scalars['Float']>;
  code?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
  image?: Maybe<FileUpdateInput>;
  rooms?: Maybe<Scalars['Float']>;
  erfNumber?: Maybe<Scalars['String']>;
  salesAgent?: Maybe<Scalars['String']>;
  status?: Maybe<PropertyStatus>;
  stakeholders?: Maybe<StakeholderUpdateInput>;
  type?: Maybe<PropertyType>;
};

export type UpdatePropertyMutation = { __typename?: 'Mutation' } & {
  updateProperty: { __typename?: 'Property' } & Pick<
    Property,
    | 'createdAt'
    | 'updatedAt'
    | 'id'
    | 'address'
    | 'size'
    | 'valuation'
    | 'code'
    | 'suburb'
    | 'rooms'
    | 'erfNumber'
    | 'salesAgent'
    | 'status'
    | 'type'
  > & {
      image: Maybe<{ __typename?: 'File' } & Pick<File, 'id' | 'original' | 'scaled' | 'thumbnail' | 'id'>>;
      stakeholders: Maybe<
        { __typename?: 'Stakeholder' } & Pick<
          Stakeholder,
          | 'createdAt'
          | 'updatedAt'
          | 'id'
          | 'firstName'
          | 'lastName'
          | 'dob'
          | 'country'
          | 'homeNumber'
          | 'cellNumber'
          | 'email'
          | 'idNumber'
          | 'residentialAddress'
          | 'postalAddress'
          | 'status'
          | 'role'
        >
      >;
    };
};

export type UpdatePropertyDocumentMutationVariables = {
  id: Scalars['ID'];
  status?: Maybe<DocumentStatus>;
  name?: Maybe<Scalars['String']>;
};

export type UpdatePropertyDocumentMutation = { __typename?: 'Mutation' } & {
  updateDocument: { __typename?: 'Document' } & Pick<Document, 'createdAt' | 'id' | 'updatedAt' | 'status' | 'name'>;
};

export type UpdatePropertyListingMutationVariables = {
  id: Scalars['ID'];
  location?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['JSON']>;
  price?: Maybe<Scalars['Float']>;
  erfNumber?: Maybe<Scalars['Int']>;
  descriptor?: Maybe<Scalars['String']>;
  status?: Maybe<PropertyListingStatus>;
  images?: Maybe<FileUpdateInput>;
};

export type UpdatePropertyListingMutation = { __typename?: 'Mutation' } & {
  updatePropertyListing: { __typename?: 'PropertyListing' } & Pick<
    PropertyListing,
    | 'id'
    | 'updatedAt'
    | 'createdAt'
    | 'location'
    | 'title'
    | 'description'
    | 'contact'
    | 'price'
    | 'erfNumber'
    | 'descriptor'
    | 'status'
  > & { images: Maybe<{ __typename?: 'File' } & Pick<File, 'id' | 'original' | 'scaled' | 'thumbnail'>> };
};

export type UpdateShopMutationVariables = {
  data: ShopUpdateInput;
  id: Scalars['ID'];
};

export type UpdateShopMutation = { __typename?: 'Mutation' } & {
  updateShop: { __typename?: 'Shop' } & Pick<Shop, 'id' | 'name' | 'status'>;
};

export type UpdateStakeholderMutationVariables = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['DateTime']>;
  country?: Maybe<Scalars['String']>;
  homeNumber?: Maybe<Scalars['String']>;
  cellNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  idNumber?: Maybe<Scalars['String']>;
  residentialAddress?: Maybe<Scalars['String']>;
  postalAddress?: Maybe<Scalars['String']>;
  unitNumber?: Maybe<Scalars['String']>;
  status?: Maybe<StakeholderStatus>;
  role?: Maybe<StakeholderRole>;
  id: Scalars['ID'];
  properties?: Maybe<PropertyUpdateInput>;
};

export type UpdateStakeholderMutation = { __typename?: 'Mutation' } & {
  updateStakeholder: { __typename?: 'Stakeholder' } & Pick<
    Stakeholder,
    | 'createdAt'
    | 'updatedAt'
    | 'id'
    | 'firstName'
    | 'lastName'
    | 'dob'
    | 'country'
    | 'cellNumber'
    | 'email'
    | 'idNumber'
    | 'residentialAddress'
    | 'postalAddress'
    | 'unitNumber'
    | 'status'
    | 'role'
  > & {
      properties: Maybe<
        { __typename?: 'Property' } & Pick<
          Property,
          | 'createdAt'
          | 'id'
          | 'code'
          | 'updatedAt'
          | 'address'
          | 'size'
          | 'valuation'
          | 'rooms'
          | 'erfNumber'
          | 'status'
          | 'salesAgent'
        >
      >;
    };
};

export type UpdateUserMutationVariables = {
  id: Scalars['ID'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  role?: Maybe<UserRole>;
  status?: Maybe<UserStatus>;
  image?: Maybe<FileUpdateInput>;
  authCode?: Maybe<Scalars['String']>;
};

export type UpdateUserMutation = { __typename?: 'Mutation' } & {
  updateUser: { __typename?: 'User' } & Pick<
    User,
    | 'createdAt'
    | 'updatedAt'
    | 'id'
    | 'firstName'
    | 'lastName'
    | 'email'
    | 'password'
    | 'otp'
    | 'status'
    | 'role'
    | 'authCode'
  > & { image: Maybe<{ __typename?: 'File' } & Pick<File, 'id' | 'original' | 'scaled' | 'thumbnail'>> };
};

export type ValidateAdminUserMutationVariables = {
  id: Scalars['ID'];
  otp: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  password: Scalars['String'];
};

export type ValidateAdminUserMutation = { __typename?: 'Mutation' } & {
  validateUser: { __typename?: 'UserValidatePayload' } & Pick<UserValidatePayload, 'token'>;
};

export type AdminDashboardQueryVariables = {};

export type AdminDashboardQuery = { __typename?: 'Query' } & {
  adminDashboard: { __typename?: 'AdminDashboard' } & Pick<AdminDashboard, 'properties' | 'events' | 'users'> & {
      accessEntries: Maybe<Array<Maybe<{ __typename?: 'Pass' } & Pick<Pass, 'id' | 'validFrom'>>>>;
    };
};

export type AllPropertiesQueryVariables = {
  searchTerm?: Maybe<Scalars['String']>;
  filterTerm?: Maybe<Array<PropertyType>>;
};

export type AllPropertiesQuery = { __typename?: 'Query' } & {
  properties: Array<
    { __typename?: 'Property' } & Pick<
      Property,
      | 'createdAt'
      | 'id'
      | 'updatedAt'
      | 'address'
      | 'size'
      | 'valuation'
      | 'suburb'
      | 'rooms'
      | 'erfNumber'
      | 'status'
      | 'salesAgent'
      | 'type'
    >
  >;
};

export type GetAllApplicationsQueryVariables = {
  status?: Maybe<ApplicationStatus>;
  searchTerm?: Maybe<Scalars['String']>;
  filterTerm?: Maybe<Array<ApplicationType>>;
};

export type GetAllApplicationsQuery = { __typename?: 'Query' } & {
  applications: Array<
    { __typename?: 'Application' } & Pick<
      Application,
      'id' | 'createdAt' | 'updatedAt' | 'fields' | 'status' | 'type'
    > & {
        stakeholder: Maybe<{ __typename?: 'Stakeholder' } & Pick<Stakeholder, 'id' | 'firstName' | 'lastName'>>;
        property: Maybe<{ __typename?: 'Property' } & Pick<Property, 'address' | 'id'>>;
      }
  >;
};

export type CalendarEventsQueryVariables = {};

export type CalendarEventsQuery = { __typename?: 'Query' } & {
  events: Array<
    { __typename?: 'Event' } & Pick<
      Event,
      'id' | 'createdAt' | 'updatedAt' | 'name' | 'description' | 'location' | 'status' | 'startDate' | 'endDate'
    > & { image: Maybe<{ __typename?: 'File' } & Pick<File, 'id' | 'scaled' | 'thumbnail' | 'original'>> }
  >;
};

export type GetAllContactUsQueryVariables = {
  searchTerm?: Maybe<Scalars['String']>;
};

export type GetAllContactUsQuery = { __typename?: 'Query' } & {
  contactuses: Array<
    { __typename?: 'ContactUs' } & Pick<ContactUs, 'id' | 'createdAt' | 'updatedAt' | 'name' | 'number' | 'email'>
  >;
};

export type GetAllEateriesQueryVariables = {
  statusFilter?: Maybe<EateryStatus>;
  searchTerm?: Maybe<Scalars['String']>;
};

export type GetAllEateriesQuery = { __typename?: 'Query' } & {
  eateries: Array<
    { __typename?: 'Eatery' } & Pick<
      Eatery,
      | 'id'
      | 'name'
      | 'status'
      | 'description'
      | 'logo'
      | 'email'
      | 'telephoneNumber'
      | 'whatsappNumber'
      | 'mondayHours'
      | 'tuesdayHours'
      | 'wednesdayHours'
      | 'thursdayHours'
      | 'fridayHours'
      | 'saturdayHours'
      | 'sundayHours'
    >
  >;
};

export type GetAllEventsQueryVariables = {
  where?: Maybe<EventWhereInput>;
};

export type GetAllEventsQuery = { __typename?: 'Query' } & {
  events: Array<
    { __typename?: 'Event' } & Pick<
      Event,
      | 'createdAt'
      | 'id'
      | 'updatedAt'
      | 'name'
      | 'type'
      | 'host'
      | 'location'
      | 'startDate'
      | 'endDate'
      | 'accessStartDate'
      | 'accessEndDate'
      | 'description'
      | 'links'
      | 'status'
    >
  >;
};

export type GetAllFacilitiesQueryVariables = {
  statusFilter?: Maybe<FacilityStatus>;
  searchTerm?: Maybe<Scalars['String']>;
};

export type GetAllFacilitiesQuery = { __typename?: 'Query' } & {
  facilities: Array<
    { __typename?: 'Facility' } & Pick<
      Facility,
      | 'id'
      | 'name'
      | 'status'
      | 'description'
      | 'logo'
      | 'email'
      | 'telephoneNumber'
      | 'whatsappNumber'
      | 'mondayHours'
      | 'tuesdayHours'
      | 'wednesdayHours'
      | 'thursdayHours'
      | 'fridayHours'
      | 'saturdayHours'
      | 'sundayHours'
      | 'tradingHours'
    >
  >;
};

export type GetAllGuestsQueryVariables = {
  searchTerm?: Maybe<Scalars['String']>;
  status?: Maybe<StakeholderStatus>;
};

export type GetAllGuestsQuery = { __typename?: 'Query' } & {
  stakeholders: Array<
    { __typename?: 'Stakeholder' } & Pick<
      Stakeholder,
      | 'createdAt'
      | 'id'
      | 'updatedAt'
      | 'firstName'
      | 'lastName'
      | 'dob'
      | 'cellNumber'
      | 'email'
      | 'residentialAddress'
      | 'status'
      | 'role'
    > & { passes: Maybe<{ __typename?: 'Pass' } & Pick<Pass, 'id' | 'name' | 'validFrom' | 'validTo' | 'type'>> }
  >;
};

export type GetAllPostsQueryVariables = {
  type?: Maybe<PostType>;
  searchTerm?: Maybe<Scalars['String']>;
  categoryFilter?: Maybe<Array<PostCategory>>;
  statusFilter?: Maybe<PostStatus>;
};

export type GetAllPostsQuery = { __typename?: 'Query' } & {
  posts: Array<
    { __typename?: 'Post' } & Pick<
      Post,
      'createdAt' | 'id' | 'updatedAt' | 'title' | 'body' | 'status' | 'type' | 'category' | 'roles'
    > & {
        image: Maybe<{ __typename?: 'File' } & Pick<File, 'createdAt' | 'id' | 'updatedAt' | 'thumbnail' | 'scaled'>>;
      }
  >;
};

export type GetAllPropertyListingQueryVariables = {
  searchTerm?: Maybe<Scalars['String']>;
  statusFilter?: Maybe<Array<PropertyListingStatus>>;
};

export type GetAllPropertyListingQuery = { __typename?: 'Query' } & {
  propertyListings: Array<
    { __typename?: 'PropertyListing' } & Pick<
      PropertyListing,
      | 'createdAt'
      | 'updatedAt'
      | 'id'
      | 'location'
      | 'title'
      | 'description'
      | 'contact'
      | 'price'
      | 'erfNumber'
      | 'descriptor'
      | 'status'
    > & { images: Maybe<{ __typename?: 'File' } & Pick<File, 'id' | 'original' | 'scaled' | 'thumbnail'>> }
  >;
};

export type GetAllShopsQueryVariables = {
  statusFilter?: Maybe<ShopStatus>;
  searchTerm?: Maybe<Scalars['String']>;
};

export type GetAllShopsQuery = { __typename?: 'Query' } & {
  shops: Array<
    { __typename?: 'Shop' } & Pick<
      Shop,
      | 'id'
      | 'name'
      | 'description'
      | 'status'
      | 'logo'
      | 'email'
      | 'telephoneNumber'
      | 'whatsappNumber'
      | 'menus'
      | 'tradingHours'
      | 'mondayHours'
      | 'tuesdayHours'
      | 'wednesdayHours'
      | 'thursdayHours'
      | 'fridayHours'
      | 'saturdayHours'
      | 'sundayHours'
      | 'isService'
    >
  >;
};

export type GetAllStakeholdersQueryVariables = {
  order?: Maybe<StakeholderOrderByInput>;
  role?: Maybe<StakeholderRole>;
  searchTerm?: Maybe<Scalars['String']>;
  status?: Maybe<StakeholderStatus>;
};

export type GetAllStakeholdersQuery = { __typename?: 'Query' } & {
  stakeholders: Array<
    { __typename?: 'Stakeholder' } & Pick<
      Stakeholder,
      | 'createdAt'
      | 'id'
      | 'updatedAt'
      | 'firstName'
      | 'lastName'
      | 'dob'
      | 'country'
      | 'homeNumber'
      | 'cellNumber'
      | 'email'
      | 'idNumber'
      | 'residentialAddress'
      | 'postalAddress'
      | 'unitNumber'
      | 'status'
      | 'role'
    > & {
        properties: Maybe<
          { __typename?: 'Property' } & Pick<
            Property,
            | 'createdAt'
            | 'id'
            | 'code'
            | 'updatedAt'
            | 'address'
            | 'size'
            | 'valuation'
            | 'rooms'
            | 'erfNumber'
            | 'status'
            | 'salesAgent'
          >
        >;
      }
  >;
};

export type GetAllUsersQueryVariables = {
  searchTerm?: Maybe<Scalars['String']>;
  filterTerm?: Maybe<UserRole>;
};

export type GetAllUsersQuery = { __typename?: 'Query' } & {
  users: Array<
    { __typename?: 'User' } & Pick<
      User,
      'createdAt' | 'id' | 'updatedAt' | 'email' | 'firstName' | 'lastName' | 'authCode' | 'status' | 'role'
    >
  >;
};

export type GetApplicationQueryVariables = {
  id: Scalars['ID'];
};

export type GetApplicationQuery = { __typename?: 'Query' } & {
  application: Maybe<
    { __typename?: 'Application' } & Pick<
      Application,
      'id' | 'createdAt' | 'updatedAt' | 'fields' | 'status' | 'type'
    > & {
        document: Maybe<{ __typename?: 'File' } & Pick<File, 'id' | 'original'>>;
        stakeholder: Maybe<
          { __typename?: 'Stakeholder' } & Pick<
            Stakeholder,
            'id' | 'firstName' | 'lastName' | 'idNumber' | 'cellNumber' | 'country' | 'dob' | 'email'
          >
        >;
        property: Maybe<{ __typename?: 'Property' } & Pick<Property, 'address' | 'id'>>;
      }
  >;
};

export type GetCalendarEventQueryVariables = {
  id: Scalars['ID'];
};

export type GetCalendarEventQuery = { __typename?: 'Query' } & {
  event: Maybe<
    { __typename?: 'Event' } & Pick<
      Event,
      | 'id'
      | 'createdAt'
      | 'updatedAt'
      | 'name'
      | 'description'
      | 'location'
      | 'status'
      | 'startDate'
      | 'host'
      | 'endDate'
    > & { image: Maybe<{ __typename?: 'File' } & Pick<File, 'id' | 'original' | 'scaled' | 'thumbnail'>> }
  >;
};

export type ContactUsQueryVariables = {
  contactUsId: Scalars['ID'];
};

export type ContactUsQuery = { __typename?: 'Query' } & {
  contactUs: Maybe<
    { __typename?: 'ContactUs' } & Pick<ContactUs, 'id' | 'createdAt' | 'updatedAt' | 'name' | 'number' | 'email'>
  >;
};

export type GetEateryQueryVariables = {
  id: Scalars['ID'];
};

export type GetEateryQuery = { __typename?: 'Query' } & {
  eatery: Maybe<
    { __typename?: 'Eatery' } & Pick<
      Eatery,
      | 'id'
      | 'createdAt'
      | 'updatedAt'
      | 'name'
      | 'status'
      | 'description'
      | 'logo'
      | 'email'
      | 'telephoneNumber'
      | 'whatsappNumber'
      | 'menus'
      | 'mondayHours'
      | 'tuesdayHours'
      | 'wednesdayHours'
      | 'thursdayHours'
      | 'fridayHours'
      | 'saturdayHours'
      | 'sundayHours'
      | 'tradingHours'
      | 'xtradingHours'
    >
  >;
};

export type GetEstateInfoQueryVariables = {
  id: Scalars['ID'];
};

export type GetEstateInfoQuery = { __typename?: 'Query' } & {
  estateInfo: Maybe<
    { __typename?: 'EstateInfo' } & Pick<
      EstateInfo,
      'id' | 'title' | 'image' | 'pdf' | 'status' | 'createdAt' | 'updatedAt'
    >
  >;
};

export type GetFacilityQueryVariables = {
  id: Scalars['ID'];
};

export type GetFacilityQuery = { __typename?: 'Query' } & {
  facility: Maybe<
    { __typename?: 'Facility' } & Pick<
      Facility,
      | 'id'
      | 'name'
      | 'status'
      | 'description'
      | 'logo'
      | 'email'
      | 'telephoneNumber'
      | 'whatsappNumber'
      | 'mondayHours'
      | 'tuesdayHours'
      | 'wednesdayHours'
      | 'thursdayHours'
      | 'fridayHours'
      | 'saturdayHours'
      | 'sundayHours'
      | 'tradingHours'
    >
  >;
};

export type GetGuestQueryVariables = {
  id: Scalars['ID'];
};

export type GetGuestQuery = { __typename?: 'Query' } & {
  stakeholder: Maybe<
    { __typename?: 'Stakeholder' } & Pick<
      Stakeholder,
      | 'createdAt'
      | 'id'
      | 'updatedAt'
      | 'firstName'
      | 'lastName'
      | 'dob'
      | 'cellNumber'
      | 'email'
      | 'residentialAddress'
      | 'status'
      | 'role'
    > & {
        image: Maybe<{ __typename?: 'File' } & Pick<File, 'id' | 'original' | 'scaled' | 'thumbnail'>>;
        visitings: Maybe<
          { __typename?: 'Visit' } & Pick<Visit, 'id'> & {
              pass: Maybe<
                { __typename?: 'Pass' } & Pick<Pass, 'id'> & {
                    visit: Maybe<
                      { __typename?: 'Visit' } & Pick<Visit, 'id'> & {
                          host: Maybe<
                            { __typename?: 'Stakeholder' } & Pick<
                              Stakeholder,
                              'id' | 'firstName' | 'lastName' | 'cellNumber'
                            >
                          >;
                        }
                    >;
                  }
              >;
            }
        >;
      }
  >;
};

export type GetAllEstateInfosQueryVariables = {
  searchTerm?: Maybe<Scalars['String']>;
};

export type GetAllEstateInfosQuery = { __typename?: 'Query' } & {
  estateInfos: Array<
    { __typename?: 'EstateInfo' } & Pick<EstateInfo, 'id' | 'createdAt' | 'updatedAt' | 'title' | 'image' | 'pdf'>
  >;
};

export type GetPostQueryVariables = {
  id: Scalars['ID'];
};

export type GetPostQuery = { __typename?: 'Query' } & {
  post: Maybe<
    { __typename?: 'Post' } & Pick<
      Post,
      'createdAt' | 'id' | 'updatedAt' | 'title' | 'body' | 'status' | 'type' | 'category' | 'roles'
    > & { image: Maybe<{ __typename?: 'File' } & Pick<File, 'id' | 'scaled' | 'original' | 'thumbnail'>> }
  >;
};

export type GetProductsQueryVariables = {
  id: Scalars['String'];
};

export type GetProductsQuery = { __typename?: 'Query' } & {
  products: Array<
    { __typename?: 'Product' } & Pick<Product, 'id' | 'name' | 'price' | 'capacity'> & {
        event: Maybe<{ __typename?: 'Event' } & Pick<Event, 'id'>>;
      }
  >;
};

export type GetPropertyQueryVariables = {
  id: Scalars['ID'];
  role?: Maybe<StakeholderRole>;
  searchTerm?: Maybe<Scalars['String']>;
};

export type GetPropertyQuery = { __typename?: 'Query' } & {
  property: Maybe<
    { __typename?: 'Property' } & Pick<
      Property,
      | 'createdAt'
      | 'id'
      | 'code'
      | 'updatedAt'
      | 'address'
      | 'size'
      | 'valuation'
      | 'suburb'
      | 'rooms'
      | 'erfNumber'
      | 'status'
      | 'type'
    > & {
        documents: Maybe<
          { __typename?: 'Document' } & Pick<Document, 'id' | 'name' | 'status'> & {
              file: Maybe<{ __typename?: 'File' } & Pick<File, 'id' | 'original'>>;
            }
        >;
        image: Maybe<{ __typename?: 'File' } & Pick<File, 'id' | 'scaled' | 'original' | 'thumbnail'>>;
      }
  >;
};

export type GetPropertyDocumentsQueryVariables = {
  id: Scalars['String'];
  billing?: Maybe<Scalars['Boolean']>;
  searchTerm?: Maybe<Scalars['String']>;
  filterTerm?: Maybe<Array<DocumentStatus>>;
};

export type GetPropertyDocumentsQuery = { __typename?: 'Query' } & {
  documents: Array<
    { __typename?: 'Document' } & Pick<Document, 'id' | 'createdAt' | 'updatedAt' | 'name' | 'billing' | 'status'> & {
        file: Maybe<{ __typename?: 'File' } & Pick<File, 'id' | 'original'>>;
      }
  >;
};

export type GetPropertyListingQueryVariables = {
  id: Scalars['ID'];
};

export type GetPropertyListingQuery = { __typename?: 'Query' } & {
  propertyListing: Maybe<
    { __typename?: 'PropertyListing' } & Pick<
      PropertyListing,
      | 'createdAt'
      | 'updatedAt'
      | 'id'
      | 'location'
      | 'title'
      | 'description'
      | 'contact'
      | 'price'
      | 'erfNumber'
      | 'descriptor'
      | 'status'
    > & { images: Maybe<{ __typename?: 'File' } & Pick<File, 'id' | 'original' | 'scaled' | 'thumbnail'>> }
  >;
};

export type GetShopQueryVariables = {
  id: Scalars['ID'];
};

export type GetShopQuery = { __typename?: 'Query' } & {
  shop: Maybe<
    { __typename?: 'Shop' } & Pick<
      Shop,
      | 'id'
      | 'name'
      | 'description'
      | 'status'
      | 'logo'
      | 'email'
      | 'telephoneNumber'
      | 'whatsappNumber'
      | 'menus'
      | 'tradingHours'
      | 'mondayHours'
      | 'tuesdayHours'
      | 'wednesdayHours'
      | 'thursdayHours'
      | 'fridayHours'
      | 'saturdayHours'
      | 'sundayHours'
    >
  >;
};

export type GetStakeholderQueryVariables = {
  id: Scalars['ID'];
};

export type GetStakeholderQuery = { __typename?: 'Query' } & {
  stakeholder: Maybe<
    { __typename?: 'Stakeholder' } & Pick<
      Stakeholder,
      | 'createdAt'
      | 'id'
      | 'updatedAt'
      | 'firstName'
      | 'lastName'
      | 'dob'
      | 'country'
      | 'homeNumber'
      | 'cellNumber'
      | 'email'
      | 'idNumber'
      | 'residentialAddress'
      | 'postalAddress'
      | 'unitNumber'
      | 'status'
      | 'role'
      | 'vmsTag'
    > & {
        image: Maybe<{ __typename?: 'File' } & Pick<File, 'id' | 'original' | 'scaled' | 'thumbnail'>>;
        documents: Maybe<
          { __typename?: 'Document' } & Pick<Document, 'id' | 'name' | 'status'> & {
              file: Maybe<{ __typename?: 'File' } & Pick<File, 'id' | 'original' | 'scaled'>>;
            }
        >;
      }
  >;
};

export type GetStakeholderDocumentsQueryVariables = {
  id: Scalars['String'];
  billing?: Maybe<Scalars['Boolean']>;
  searchTerm?: Maybe<Scalars['String']>;
  filterTerm?: Maybe<DocumentStatus>;
};

export type GetStakeholderDocumentsQuery = { __typename?: 'Query' } & {
  documents: Array<
    { __typename?: 'Document' } & Pick<Document, 'id' | 'createdAt' | 'updatedAt' | 'name' | 'billing' | 'status'> & {
        file: Maybe<{ __typename?: 'File' } & Pick<File, 'id' | 'original'>>;
      }
  >;
};

export type GetUserQueryVariables = {
  id: Scalars['ID'];
};

export type GetUserQuery = { __typename?: 'Query' } & {
  user: Maybe<
    { __typename?: 'User' } & Pick<
      User,
      | 'createdAt'
      | 'id'
      | 'updatedAt'
      | 'firstName'
      | 'authCode'
      | 'lastName'
      | 'email'
      | 'password'
      | 'status'
      | 'role'
    > & { image: Maybe<{ __typename?: 'File' } & Pick<File, 'original' | 'scaled' | 'thumbnail' | 'id'>> }
  >;
};

export type SearchPropertiesQueryVariables = {
  text?: Maybe<Scalars['String']>;
};

export type SearchPropertiesQuery = { __typename?: 'Query' } & {
  properties: Array<
    { __typename?: 'Property' } & Pick<Property, 'createdAt' | 'address' | 'id' | 'erfNumber' | 'suburb' | 'code'>
  >;
};

export type SearchStakeholdersQueryVariables = {
  text: Scalars['String'];
};

export type SearchStakeholdersQuery = { __typename?: 'Query' } & {
  stakeholders: Array<
    { __typename?: 'Stakeholder' } & Pick<
      Stakeholder,
      | 'id'
      | 'firstName'
      | 'lastName'
      | 'homeNumber'
      | 'cellNumber'
      | 'email'
      | 'idNumber'
      | 'residentialAddress'
      | 'postalAddress'
      | 'role'
    >
  >;
};

import gql from 'graphql-tag';
import * as React from 'react';
import * as ReactApollo from 'react-apollo';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const ArchiveContactUsDocument = gql`
  mutation ArchiveContactUs($id: ID!) {
    archiveContactUs(id: $id) {
      id
    }
  }
`;
export type ArchiveContactUsMutationFn = ReactApollo.MutationFn<
  ArchiveContactUsMutation,
  ArchiveContactUsMutationVariables
>;

export const ArchiveContactUsComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<ArchiveContactUsMutation, ArchiveContactUsMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: ArchiveContactUsMutationVariables }
) => (
  <ReactApollo.Mutation<ArchiveContactUsMutation, ArchiveContactUsMutationVariables>
    mutation={ArchiveContactUsDocument}
    {...props}
  />
);

export type ArchiveContactUsProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<ArchiveContactUsMutation, ArchiveContactUsMutationVariables>
> &
  TChildProps;
export function withArchiveContactUs<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    ArchiveContactUsMutation,
    ArchiveContactUsMutationVariables,
    ArchiveContactUsProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    ArchiveContactUsMutation,
    ArchiveContactUsMutationVariables,
    ArchiveContactUsProps<TChildProps>
  >(ArchiveContactUsDocument, {
    alias: 'withArchiveContactUs',
    ...operationOptions,
  });
}
export const ArchiveEstateInfoDocument = gql`
  mutation ArchiveEstateInfo($id: ID!) {
    archiveEstateInfo(id: $id) {
      id
    }
  }
`;
export type ArchiveEstateInfoMutationFn = ReactApollo.MutationFn<
  ArchiveEstateInfoMutation,
  ArchiveEstateInfoMutationVariables
>;

export const ArchiveEstateInfoComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<ArchiveEstateInfoMutation, ArchiveEstateInfoMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: ArchiveEstateInfoMutationVariables }
) => (
  <ReactApollo.Mutation<ArchiveEstateInfoMutation, ArchiveEstateInfoMutationVariables>
    mutation={ArchiveEstateInfoDocument}
    {...props}
  />
);

export type ArchiveEstateInfoProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<ArchiveEstateInfoMutation, ArchiveEstateInfoMutationVariables>
> &
  TChildProps;
export function withArchiveEstateInfo<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    ArchiveEstateInfoMutation,
    ArchiveEstateInfoMutationVariables,
    ArchiveEstateInfoProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    ArchiveEstateInfoMutation,
    ArchiveEstateInfoMutationVariables,
    ArchiveEstateInfoProps<TChildProps>
  >(ArchiveEstateInfoDocument, {
    alias: 'withArchiveEstateInfo',
    ...operationOptions,
  });
}
export const AssignTicketDocument = gql`
  mutation AssignTicket($productId: ID!, $recipientId: ID!, $complimentary: Boolean) {
    assignTicket(data: { productId: $productId, recipientId: $recipientId, complimentary: $complimentary }) {
      id
      product {
        id
      }
      stakeholder {
        id
      }
      event {
        id
      }
    }
  }
`;
export type AssignTicketMutationFn = ReactApollo.MutationFn<AssignTicketMutation, AssignTicketMutationVariables>;

export const AssignTicketComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<AssignTicketMutation, AssignTicketMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: AssignTicketMutationVariables }
) => (
  <ReactApollo.Mutation<AssignTicketMutation, AssignTicketMutationVariables>
    mutation={AssignTicketDocument}
    {...props}
  />
);

export type AssignTicketProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<AssignTicketMutation, AssignTicketMutationVariables>
> &
  TChildProps;
export function withAssignTicket<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    AssignTicketMutation,
    AssignTicketMutationVariables,
    AssignTicketProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    AssignTicketMutation,
    AssignTicketMutationVariables,
    AssignTicketProps<TChildProps>
  >(AssignTicketDocument, {
    alias: 'withAssignTicket',
    ...operationOptions,
  });
}
export const AuthenticateUserDocument = gql`
  mutation AuthenticateUser($email: String!, $password: String!) {
    authenticateUser(data: { email: $email, password: $password }) {
      token
    }
  }
`;
export type AuthenticateUserMutationFn = ReactApollo.MutationFn<
  AuthenticateUserMutation,
  AuthenticateUserMutationVariables
>;

export const AuthenticateUserComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<AuthenticateUserMutation, AuthenticateUserMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: AuthenticateUserMutationVariables }
) => (
  <ReactApollo.Mutation<AuthenticateUserMutation, AuthenticateUserMutationVariables>
    mutation={AuthenticateUserDocument}
    {...props}
  />
);

export type AuthenticateUserProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<AuthenticateUserMutation, AuthenticateUserMutationVariables>
> &
  TChildProps;
export function withAuthenticateUser<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    AuthenticateUserMutation,
    AuthenticateUserMutationVariables,
    AuthenticateUserProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    AuthenticateUserMutation,
    AuthenticateUserMutationVariables,
    AuthenticateUserProps<TChildProps>
  >(AuthenticateUserDocument, {
    alias: 'withAuthenticateUser',
    ...operationOptions,
  });
}
export const CreateApplicationDocument = gql`
  mutation CreateApplication($fields: JSON, $type: ApplicationType!, $stakeholderId: String!, $propertyId: String!) {
    createApplication(data: { fields: $fields, type: $type, stakeholderId: $stakeholderId, propertyId: $propertyId }) {
      id
      createdAt
      updatedAt
      fields
      stakeholder {
        id
      }
      property {
        id
      }
      status
      type
    }
  }
`;
export type CreateApplicationMutationFn = ReactApollo.MutationFn<
  CreateApplicationMutation,
  CreateApplicationMutationVariables
>;

export const CreateApplicationComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<CreateApplicationMutation, CreateApplicationMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: CreateApplicationMutationVariables }
) => (
  <ReactApollo.Mutation<CreateApplicationMutation, CreateApplicationMutationVariables>
    mutation={CreateApplicationDocument}
    {...props}
  />
);

export type CreateApplicationProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<CreateApplicationMutation, CreateApplicationMutationVariables>
> &
  TChildProps;
export function withCreateApplication<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    CreateApplicationMutation,
    CreateApplicationMutationVariables,
    CreateApplicationProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    CreateApplicationMutation,
    CreateApplicationMutationVariables,
    CreateApplicationProps<TChildProps>
  >(CreateApplicationDocument, {
    alias: 'withCreateApplication',
    ...operationOptions,
  });
}
export const CreateCalendarEventDocument = gql`
  mutation CreateCalendarEvent($data: EventCreateInput!) {
    createEvent(data: $data) {
      id
      createdAt
      updatedAt
      name
      description
      location
      status
      startDate
      endDate
      image {
        id
        original
      }
    }
  }
`;
export type CreateCalendarEventMutationFn = ReactApollo.MutationFn<
  CreateCalendarEventMutation,
  CreateCalendarEventMutationVariables
>;

export const CreateCalendarEventComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<CreateCalendarEventMutation, CreateCalendarEventMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: CreateCalendarEventMutationVariables }
) => (
  <ReactApollo.Mutation<CreateCalendarEventMutation, CreateCalendarEventMutationVariables>
    mutation={CreateCalendarEventDocument}
    {...props}
  />
);

export type CreateCalendarEventProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<CreateCalendarEventMutation, CreateCalendarEventMutationVariables>
> &
  TChildProps;
export function withCreateCalendarEvent<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    CreateCalendarEventMutation,
    CreateCalendarEventMutationVariables,
    CreateCalendarEventProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    CreateCalendarEventMutation,
    CreateCalendarEventMutationVariables,
    CreateCalendarEventProps<TChildProps>
  >(CreateCalendarEventDocument, {
    alias: 'withCreateCalendarEvent',
    ...operationOptions,
  });
}
export const CreateContactUsDocument = gql`
  mutation CreateContactUs($data: ContactUsCreateInput!) {
    createContactUs(data: $data) {
      id
      name
      number
      email
      status
    }
  }
`;
export type CreateContactUsMutationFn = ReactApollo.MutationFn<
  CreateContactUsMutation,
  CreateContactUsMutationVariables
>;

export const CreateContactUsComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<CreateContactUsMutation, CreateContactUsMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: CreateContactUsMutationVariables }
) => (
  <ReactApollo.Mutation<CreateContactUsMutation, CreateContactUsMutationVariables>
    mutation={CreateContactUsDocument}
    {...props}
  />
);

export type CreateContactUsProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<CreateContactUsMutation, CreateContactUsMutationVariables>
> &
  TChildProps;
export function withCreateContactUs<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    CreateContactUsMutation,
    CreateContactUsMutationVariables,
    CreateContactUsProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    CreateContactUsMutation,
    CreateContactUsMutationVariables,
    CreateContactUsProps<TChildProps>
  >(CreateContactUsDocument, {
    alias: 'withCreateContactUs',
    ...operationOptions,
  });
}
export const CreateEateryDocument = gql`
  mutation CreateEatery($data: EateryCreateInput!) {
    createEatery(data: $data) {
      id
      name
      status
      menus
    }
  }
`;
export type CreateEateryMutationFn = ReactApollo.MutationFn<CreateEateryMutation, CreateEateryMutationVariables>;

export const CreateEateryComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<CreateEateryMutation, CreateEateryMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: CreateEateryMutationVariables }
) => (
  <ReactApollo.Mutation<CreateEateryMutation, CreateEateryMutationVariables>
    mutation={CreateEateryDocument}
    {...props}
  />
);

export type CreateEateryProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<CreateEateryMutation, CreateEateryMutationVariables>
> &
  TChildProps;
export function withCreateEatery<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    CreateEateryMutation,
    CreateEateryMutationVariables,
    CreateEateryProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    CreateEateryMutation,
    CreateEateryMutationVariables,
    CreateEateryProps<TChildProps>
  >(CreateEateryDocument, {
    alias: 'withCreateEatery',
    ...operationOptions,
  });
}
export const CreateEstateInfoDocument = gql`
  mutation CreateEstateInfo($data: EstateInfoCreateInput!) {
    createEstateInfo(data: $data) {
      id
      title
      image
      pdf
      status
      createdAt
      updatedAt
    }
  }
`;
export type CreateEstateInfoMutationFn = ReactApollo.MutationFn<
  CreateEstateInfoMutation,
  CreateEstateInfoMutationVariables
>;

export const CreateEstateInfoComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<CreateEstateInfoMutation, CreateEstateInfoMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: CreateEstateInfoMutationVariables }
) => (
  <ReactApollo.Mutation<CreateEstateInfoMutation, CreateEstateInfoMutationVariables>
    mutation={CreateEstateInfoDocument}
    {...props}
  />
);

export type CreateEstateInfoProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<CreateEstateInfoMutation, CreateEstateInfoMutationVariables>
> &
  TChildProps;
export function withCreateEstateInfo<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    CreateEstateInfoMutation,
    CreateEstateInfoMutationVariables,
    CreateEstateInfoProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    CreateEstateInfoMutation,
    CreateEstateInfoMutationVariables,
    CreateEstateInfoProps<TChildProps>
  >(CreateEstateInfoDocument, {
    alias: 'withCreateEstateInfo',
    ...operationOptions,
  });
}
export const CreateEventDocument = gql`
  mutation CreateEvent(
    $name: String!
    $type: EventType
    $host: String!
    $location: String!
    $startDate: DateTime!
    $accessStartDate: DateTime
    $accessEndDate: DateTime
    $endDate: DateTime!
    $description: String!
    $hostLogo: String
    $status: EventStatus
    $reminders: Boolean
  ) {
    createEvent(
      data: {
        name: $name
        type: $type
        host: $host
        location: $location
        startDate: $startDate
        accessStartDate: $accessStartDate
        accessEndDate: $accessEndDate
        endDate: $endDate
        description: $description
        hostLogo: $hostLogo
        status: $status
        reminders: $reminders
      }
    ) {
      id
      createdAt
      updatedAt
      name
      type
      host
      location
      startDate
      accessStartDate
      accessEndDate
      endDate
      description
      hostLogo
      links
      status
      children
      reminders
      attendees {
        id
        cellNumber
        email
      }
      image {
        id
        original
        scaled
        thumbnail
      }
    }
  }
`;
export type CreateEventMutationFn = ReactApollo.MutationFn<CreateEventMutation, CreateEventMutationVariables>;

export const CreateEventComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<CreateEventMutation, CreateEventMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: CreateEventMutationVariables }
) => (
  <ReactApollo.Mutation<CreateEventMutation, CreateEventMutationVariables> mutation={CreateEventDocument} {...props} />
);

export type CreateEventProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<CreateEventMutation, CreateEventMutationVariables>
> &
  TChildProps;
export function withCreateEvent<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    CreateEventMutation,
    CreateEventMutationVariables,
    CreateEventProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    CreateEventMutation,
    CreateEventMutationVariables,
    CreateEventProps<TChildProps>
  >(CreateEventDocument, {
    alias: 'withCreateEvent',
    ...operationOptions,
  });
}
export const CreateFacilityDocument = gql`
  mutation CreateFacility($data: FacilityCreateInput!) {
    createFacility(data: $data) {
      id
      name
      status
    }
  }
`;
export type CreateFacilityMutationFn = ReactApollo.MutationFn<CreateFacilityMutation, CreateFacilityMutationVariables>;

export const CreateFacilityComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<CreateFacilityMutation, CreateFacilityMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: CreateFacilityMutationVariables }
) => (
  <ReactApollo.Mutation<CreateFacilityMutation, CreateFacilityMutationVariables>
    mutation={CreateFacilityDocument}
    {...props}
  />
);

export type CreateFacilityProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<CreateFacilityMutation, CreateFacilityMutationVariables>
> &
  TChildProps;
export function withCreateFacility<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    CreateFacilityMutation,
    CreateFacilityMutationVariables,
    CreateFacilityProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    CreateFacilityMutation,
    CreateFacilityMutationVariables,
    CreateFacilityProps<TChildProps>
  >(CreateFacilityDocument, {
    alias: 'withCreateFacility',
    ...operationOptions,
  });
}
export const CreateGuestDocument = gql`
  mutation CreateGuest(
    $cellNumber: String!
    $firstName: String
    $lastName: String
    $email: String
    $dob: DateTime
    $residentialAddress: String
  ) {
    createStakeholder(
      data: {
        cellNumber: $cellNumber
        firstName: $firstName
        lastName: $lastName
        email: $email
        dob: $dob
        residentialAddress: $residentialAddress
        role: GUEST
      }
    ) {
      createdAt
      updatedAt
      id
      cellNumber
      firstName
      lastName
      email
      dob
      residentialAddress
      image {
        id
        original
        scaled
        thumbnail
      }
      role
    }
  }
`;
export type CreateGuestMutationFn = ReactApollo.MutationFn<CreateGuestMutation, CreateGuestMutationVariables>;

export const CreateGuestComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<CreateGuestMutation, CreateGuestMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: CreateGuestMutationVariables }
) => (
  <ReactApollo.Mutation<CreateGuestMutation, CreateGuestMutationVariables> mutation={CreateGuestDocument} {...props} />
);

export type CreateGuestProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<CreateGuestMutation, CreateGuestMutationVariables>
> &
  TChildProps;
export function withCreateGuest<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    CreateGuestMutation,
    CreateGuestMutationVariables,
    CreateGuestProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    CreateGuestMutation,
    CreateGuestMutationVariables,
    CreateGuestProps<TChildProps>
  >(CreateGuestDocument, {
    alias: 'withCreateGuest',
    ...operationOptions,
  });
}
export const CreatePdfLibraryItemDocument = gql`
  mutation createPDFLibraryItem($name: String!, $file: String!, $category: PDFLibraryCategory!) {
    createPDFLibraryItem(data: { name: $name, file: $file, category: $category }) {
      id
    }
  }
`;
export type CreatePdfLibraryItemMutationFn = ReactApollo.MutationFn<
  CreatePdfLibraryItemMutation,
  CreatePdfLibraryItemMutationVariables
>;

export const CreatePdfLibraryItemComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<CreatePdfLibraryItemMutation, CreatePdfLibraryItemMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: CreatePdfLibraryItemMutationVariables }
) => (
  <ReactApollo.Mutation<CreatePdfLibraryItemMutation, CreatePdfLibraryItemMutationVariables>
    mutation={CreatePdfLibraryItemDocument}
    {...props}
  />
);

export type CreatePdfLibraryItemProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<CreatePdfLibraryItemMutation, CreatePdfLibraryItemMutationVariables>
> &
  TChildProps;
export function withCreatePdfLibraryItem<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    CreatePdfLibraryItemMutation,
    CreatePdfLibraryItemMutationVariables,
    CreatePdfLibraryItemProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    CreatePdfLibraryItemMutation,
    CreatePdfLibraryItemMutationVariables,
    CreatePdfLibraryItemProps<TChildProps>
  >(CreatePdfLibraryItemDocument, {
    alias: 'withCreatePdfLibraryItem',
    ...operationOptions,
  });
}
export const CreatePostDocument = gql`
  mutation CreatePost($data: PostCreateInput!) {
    createPost(data: $data) {
      createdAt
      id
      updatedAt
      title
      body
      status
      type
      category
      roles
      read
      image {
        id
        original
      }
    }
  }
`;
export type CreatePostMutationFn = ReactApollo.MutationFn<CreatePostMutation, CreatePostMutationVariables>;

export const CreatePostComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<CreatePostMutation, CreatePostMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: CreatePostMutationVariables }
) => <ReactApollo.Mutation<CreatePostMutation, CreatePostMutationVariables> mutation={CreatePostDocument} {...props} />;

export type CreatePostProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<CreatePostMutation, CreatePostMutationVariables>
> &
  TChildProps;
export function withCreatePost<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    CreatePostMutation,
    CreatePostMutationVariables,
    CreatePostProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    CreatePostMutation,
    CreatePostMutationVariables,
    CreatePostProps<TChildProps>
  >(CreatePostDocument, {
    alias: 'withCreatePost',
    ...operationOptions,
  });
}
export const CreateProductDocument = gql`
  mutation CreateProduct($input: ProductCreateInput!) {
    createProduct(data: $input) {
      createdAt
      id
      updatedAt
      name
      description
      price
      capacity
      event {
        id
      }
    }
  }
`;
export type CreateProductMutationFn = ReactApollo.MutationFn<CreateProductMutation, CreateProductMutationVariables>;

export const CreateProductComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<CreateProductMutation, CreateProductMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: CreateProductMutationVariables }
) => (
  <ReactApollo.Mutation<CreateProductMutation, CreateProductMutationVariables>
    mutation={CreateProductDocument}
    {...props}
  />
);

export type CreateProductProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<CreateProductMutation, CreateProductMutationVariables>
> &
  TChildProps;
export function withCreateProduct<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    CreateProductMutation,
    CreateProductMutationVariables,
    CreateProductProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    CreateProductMutation,
    CreateProductMutationVariables,
    CreateProductProps<TChildProps>
  >(CreateProductDocument, {
    alias: 'withCreateProduct',
    ...operationOptions,
  });
}
export const CreatePropertyDocument = gql`
  mutation CreateProperty(
    $address: String!
    $size: Float!
    $code: String!
    $suburb: String
    $valuation: Float
    $rooms: Float!
    $erfNumber: String
    $salesAgent: String!
    $status: PropertyStatus
    $imageId: String
    $image: FileCreateInput
    $documents: DocumentCreateInput
    $stakeholders: StakeholderCreateInput
    $applications: ApplicationCreateInput
    $memberships: MembershipCreateInput
    $type: PropertyType
  ) {
    createProperty(
      data: {
        address: $address
        size: $size
        code: $code
        suburb: $suburb
        valuation: $valuation
        rooms: $rooms
        erfNumber: $erfNumber
        salesAgent: $salesAgent
        status: $status
        imageId: $imageId
        image: $image
        documents: $documents
        stakeholders: $stakeholders
        applications: $applications
        memberships: $memberships
        type: $type
      }
    ) {
      createdAt
      id
      updatedAt
      address
      size
      code
      suburb
      valuation
      rooms
      erfNumber
      salesAgent
      status
      type
    }
  }
`;
export type CreatePropertyMutationFn = ReactApollo.MutationFn<CreatePropertyMutation, CreatePropertyMutationVariables>;

export const CreatePropertyComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<CreatePropertyMutation, CreatePropertyMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: CreatePropertyMutationVariables }
) => (
  <ReactApollo.Mutation<CreatePropertyMutation, CreatePropertyMutationVariables>
    mutation={CreatePropertyDocument}
    {...props}
  />
);

export type CreatePropertyProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<CreatePropertyMutation, CreatePropertyMutationVariables>
> &
  TChildProps;
export function withCreateProperty<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    CreatePropertyMutation,
    CreatePropertyMutationVariables,
    CreatePropertyProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    CreatePropertyMutation,
    CreatePropertyMutationVariables,
    CreatePropertyProps<TChildProps>
  >(CreatePropertyDocument, {
    alias: 'withCreateProperty',
    ...operationOptions,
  });
}
export const CreatePropertyListingDocument = gql`
  mutation CreatePropertyListing(
    $location: String
    $title: String
    $description: String
    $contact: JSON
    $price: Float
    $erfNumber: Int
    $descriptor: String
    $status: PropertyListingStatus
    $images: FileCreateInput
  ) {
    createPropertyListing(
      data: {
        location: $location
        title: $title
        description: $description
        contact: $contact
        price: $price
        erfNumber: $erfNumber
        descriptor: $descriptor
        status: $status
        images: $images
      }
    ) {
      id
      updatedAt
      createdAt
      location
      title
      description
      contact
      price
      erfNumber
      status
      images {
        id
        original
        scaled
        thumbnail
      }
    }
  }
`;
export type CreatePropertyListingMutationFn = ReactApollo.MutationFn<
  CreatePropertyListingMutation,
  CreatePropertyListingMutationVariables
>;

export const CreatePropertyListingComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<CreatePropertyListingMutation, CreatePropertyListingMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: CreatePropertyListingMutationVariables }
) => (
  <ReactApollo.Mutation<CreatePropertyListingMutation, CreatePropertyListingMutationVariables>
    mutation={CreatePropertyListingDocument}
    {...props}
  />
);

export type CreatePropertyListingProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<CreatePropertyListingMutation, CreatePropertyListingMutationVariables>
> &
  TChildProps;
export function withCreatePropertyListing<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    CreatePropertyListingMutation,
    CreatePropertyListingMutationVariables,
    CreatePropertyListingProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    CreatePropertyListingMutation,
    CreatePropertyListingMutationVariables,
    CreatePropertyListingProps<TChildProps>
  >(CreatePropertyListingDocument, {
    alias: 'withCreatePropertyListing',
    ...operationOptions,
  });
}
export const CreateShopDocument = gql`
  mutation CreateShop($data: ShopCreateInput!) {
    createShop(data: $data) {
      id
      name
      status
      isService
    }
  }
`;
export type CreateShopMutationFn = ReactApollo.MutationFn<CreateShopMutation, CreateShopMutationVariables>;

export const CreateShopComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<CreateShopMutation, CreateShopMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: CreateShopMutationVariables }
) => <ReactApollo.Mutation<CreateShopMutation, CreateShopMutationVariables> mutation={CreateShopDocument} {...props} />;

export type CreateShopProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<CreateShopMutation, CreateShopMutationVariables>
> &
  TChildProps;
export function withCreateShop<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    CreateShopMutation,
    CreateShopMutationVariables,
    CreateShopProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    CreateShopMutation,
    CreateShopMutationVariables,
    CreateShopProps<TChildProps>
  >(CreateShopDocument, {
    alias: 'withCreateShop',
    ...operationOptions,
  });
}
export const CreateStakeholderDocument = gql`
  mutation CreateStakeholder(
    $firstName: String!
    $lastName: String!
    $dob: DateTime!
    $country: String!
    $homeNumber: String!
    $cellNumber: String!
    $email: String!
    $idNumber: String!
    $residentialAddress: String!
    $postalAddress: String!
    $status: StakeholderStatus!
    $role: StakeholderRole!
  ) {
    createStakeholder(
      data: {
        firstName: $firstName
        lastName: $lastName
        dob: $dob
        country: $country
        homeNumber: $homeNumber
        cellNumber: $cellNumber
        email: $email
        idNumber: $idNumber
        residentialAddress: $residentialAddress
        postalAddress: $postalAddress
        status: $status
        role: $role
      }
    ) {
      createdAt
      updatedAt
      id
      firstName
      lastName
      dob
      country
      cellNumber
      email
      idNumber
      residentialAddress
      postalAddress
      status
      role
    }
  }
`;
export type CreateStakeholderMutationFn = ReactApollo.MutationFn<
  CreateStakeholderMutation,
  CreateStakeholderMutationVariables
>;

export const CreateStakeholderComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<CreateStakeholderMutation, CreateStakeholderMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: CreateStakeholderMutationVariables }
) => (
  <ReactApollo.Mutation<CreateStakeholderMutation, CreateStakeholderMutationVariables>
    mutation={CreateStakeholderDocument}
    {...props}
  />
);

export type CreateStakeholderProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<CreateStakeholderMutation, CreateStakeholderMutationVariables>
> &
  TChildProps;
export function withCreateStakeholder<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    CreateStakeholderMutation,
    CreateStakeholderMutationVariables,
    CreateStakeholderProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    CreateStakeholderMutation,
    CreateStakeholderMutationVariables,
    CreateStakeholderProps<TChildProps>
  >(CreateStakeholderDocument, {
    alias: 'withCreateStakeholder',
    ...operationOptions,
  });
}
export const InviteUserDocument = gql`
  mutation InviteUser($email: String!, $role: UserRole!, $firstName: String, $lastName: String) {
    inviteUser(data: { email: $email, role: $role, firstName: $firstName, lastName: $lastName }) {
      id
    }
  }
`;
export type InviteUserMutationFn = ReactApollo.MutationFn<InviteUserMutation, InviteUserMutationVariables>;

export const InviteUserComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<InviteUserMutation, InviteUserMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: InviteUserMutationVariables }
) => <ReactApollo.Mutation<InviteUserMutation, InviteUserMutationVariables> mutation={InviteUserDocument} {...props} />;

export type InviteUserProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<InviteUserMutation, InviteUserMutationVariables>
> &
  TChildProps;
export function withInviteUser<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    InviteUserMutation,
    InviteUserMutationVariables,
    InviteUserProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    InviteUserMutation,
    InviteUserMutationVariables,
    InviteUserProps<TChildProps>
  >(InviteUserDocument, {
    alias: 'withInviteUser',
    ...operationOptions,
  });
}
export const PublishPropertyListingDocument = gql`
  mutation PublishPropertyListing(
    $id: ID!
    $createdAt: DateTime
    $updatedAt: DateTime
    $location: String
    $erfNumber: Int
    $descriptor: String
    $title: String
    $description: String
    $contact: JSON
    $price: Float
    $status: PropertyListingStatus
    $images: FileUpdateInput
  ) {
    updatePropertyListing(
      data: {
        createdAt: $createdAt
        updatedAt: $updatedAt
        location: $location
        erfNumber: $erfNumber
        descriptor: $descriptor
        title: $title
        description: $description
        contact: $contact
        price: $price
        status: $status
        images: $images
      }
      id: $id
    ) {
      id
      status
    }
  }
`;
export type PublishPropertyListingMutationFn = ReactApollo.MutationFn<
  PublishPropertyListingMutation,
  PublishPropertyListingMutationVariables
>;

export const PublishPropertyListingComponent = (
  props: Omit<
    Omit<
      ReactApollo.MutationProps<PublishPropertyListingMutation, PublishPropertyListingMutationVariables>,
      'mutation'
    >,
    'variables'
  > & { variables?: PublishPropertyListingMutationVariables }
) => (
  <ReactApollo.Mutation<PublishPropertyListingMutation, PublishPropertyListingMutationVariables>
    mutation={PublishPropertyListingDocument}
    {...props}
  />
);

export type PublishPropertyListingProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<PublishPropertyListingMutation, PublishPropertyListingMutationVariables>
> &
  TChildProps;
export function withPublishPropertyListing<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    PublishPropertyListingMutation,
    PublishPropertyListingMutationVariables,
    PublishPropertyListingProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    PublishPropertyListingMutation,
    PublishPropertyListingMutationVariables,
    PublishPropertyListingProps<TChildProps>
  >(PublishPropertyListingDocument, {
    alias: 'withPublishPropertyListing',
    ...operationOptions,
  });
}
export const ResetUserPasswordDocument = gql`
  mutation ResetUserPassword($email: String!) {
    resetUser(data: { email: $email }) {
      id
    }
  }
`;
export type ResetUserPasswordMutationFn = ReactApollo.MutationFn<
  ResetUserPasswordMutation,
  ResetUserPasswordMutationVariables
>;

export const ResetUserPasswordComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: ResetUserPasswordMutationVariables }
) => (
  <ReactApollo.Mutation<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>
    mutation={ResetUserPasswordDocument}
    {...props}
  />
);

export type ResetUserPasswordProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>
> &
  TChildProps;
export function withResetUserPassword<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    ResetUserPasswordMutation,
    ResetUserPasswordMutationVariables,
    ResetUserPasswordProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    ResetUserPasswordMutation,
    ResetUserPasswordMutationVariables,
    ResetUserPasswordProps<TChildProps>
  >(ResetUserPasswordDocument, {
    alias: 'withResetUserPassword',
    ...operationOptions,
  });
}
export const UpdateApplicationDocument = gql`
  mutation UpdateApplication(
    $fields: JSON
    $rejectReason: String
    $type: ApplicationType
    $status: ApplicationStatus
    $document: FileUpdateInput
    $id: ID!
  ) {
    updateApplication(
      id: $id
      data: { fields: $fields, rejectReason: $rejectReason, type: $type, status: $status, document: $document }
    ) {
      id
      createdAt
      updatedAt
      fields
      rejectReason
      document {
        id
      }
      stakeholder {
        id
      }
      property {
        id
      }
      status
      type
    }
  }
`;
export type UpdateApplicationMutationFn = ReactApollo.MutationFn<
  UpdateApplicationMutation,
  UpdateApplicationMutationVariables
>;

export const UpdateApplicationComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<UpdateApplicationMutation, UpdateApplicationMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: UpdateApplicationMutationVariables }
) => (
  <ReactApollo.Mutation<UpdateApplicationMutation, UpdateApplicationMutationVariables>
    mutation={UpdateApplicationDocument}
    {...props}
  />
);

export type UpdateApplicationProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<UpdateApplicationMutation, UpdateApplicationMutationVariables>
> &
  TChildProps;
export function withUpdateApplication<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    UpdateApplicationMutation,
    UpdateApplicationMutationVariables,
    UpdateApplicationProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    UpdateApplicationMutation,
    UpdateApplicationMutationVariables,
    UpdateApplicationProps<TChildProps>
  >(UpdateApplicationDocument, {
    alias: 'withUpdateApplication',
    ...operationOptions,
  });
}
export const UpdateCalendarEventDocument = gql`
  mutation UpdateCalendarEvent($id: ID!, $data: EventUpdateInput!) {
    updateEvent(id: $id, data: $data) {
      id
      createdAt
      updatedAt
      name
      description
      location
      status
      startDate
      endDate
      image {
        id
        original
      }
    }
  }
`;
export type UpdateCalendarEventMutationFn = ReactApollo.MutationFn<
  UpdateCalendarEventMutation,
  UpdateCalendarEventMutationVariables
>;

export const UpdateCalendarEventComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<UpdateCalendarEventMutation, UpdateCalendarEventMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: UpdateCalendarEventMutationVariables }
) => (
  <ReactApollo.Mutation<UpdateCalendarEventMutation, UpdateCalendarEventMutationVariables>
    mutation={UpdateCalendarEventDocument}
    {...props}
  />
);

export type UpdateCalendarEventProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<UpdateCalendarEventMutation, UpdateCalendarEventMutationVariables>
> &
  TChildProps;
export function withUpdateCalendarEvent<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    UpdateCalendarEventMutation,
    UpdateCalendarEventMutationVariables,
    UpdateCalendarEventProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    UpdateCalendarEventMutation,
    UpdateCalendarEventMutationVariables,
    UpdateCalendarEventProps<TChildProps>
  >(UpdateCalendarEventDocument, {
    alias: 'withUpdateCalendarEvent',
    ...operationOptions,
  });
}
export const UpdateContactUsDocument = gql`
  mutation UpdateContactUs($updateContactUsId: ID!, $data: ContactUsUpdateInput!) {
    updateContactUs(id: $updateContactUsId, data: $data) {
      id
      name
      number
      email
      status
    }
  }
`;
export type UpdateContactUsMutationFn = ReactApollo.MutationFn<
  UpdateContactUsMutation,
  UpdateContactUsMutationVariables
>;

export const UpdateContactUsComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<UpdateContactUsMutation, UpdateContactUsMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: UpdateContactUsMutationVariables }
) => (
  <ReactApollo.Mutation<UpdateContactUsMutation, UpdateContactUsMutationVariables>
    mutation={UpdateContactUsDocument}
    {...props}
  />
);

export type UpdateContactUsProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<UpdateContactUsMutation, UpdateContactUsMutationVariables>
> &
  TChildProps;
export function withUpdateContactUs<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    UpdateContactUsMutation,
    UpdateContactUsMutationVariables,
    UpdateContactUsProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    UpdateContactUsMutation,
    UpdateContactUsMutationVariables,
    UpdateContactUsProps<TChildProps>
  >(UpdateContactUsDocument, {
    alias: 'withUpdateContactUs',
    ...operationOptions,
  });
}
export const UpdateEateryDocument = gql`
  mutation UpdateEatery($id: ID!, $data: EateryUpdateInput!) {
    updateEatery(id: $id, data: $data) {
      id
      name
      status
    }
  }
`;
export type UpdateEateryMutationFn = ReactApollo.MutationFn<UpdateEateryMutation, UpdateEateryMutationVariables>;

export const UpdateEateryComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<UpdateEateryMutation, UpdateEateryMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: UpdateEateryMutationVariables }
) => (
  <ReactApollo.Mutation<UpdateEateryMutation, UpdateEateryMutationVariables>
    mutation={UpdateEateryDocument}
    {...props}
  />
);

export type UpdateEateryProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<UpdateEateryMutation, UpdateEateryMutationVariables>
> &
  TChildProps;
export function withUpdateEatery<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    UpdateEateryMutation,
    UpdateEateryMutationVariables,
    UpdateEateryProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    UpdateEateryMutation,
    UpdateEateryMutationVariables,
    UpdateEateryProps<TChildProps>
  >(UpdateEateryDocument, {
    alias: 'withUpdateEatery',
    ...operationOptions,
  });
}
export const UpdateEstateInfoDocument = gql`
  mutation UpdateEstateInfo($id: ID!, $data: EstateInfoUpdateInput!) {
    updateEstateInfo(id: $id, data: $data) {
      id
      title
      image
      pdf
      status
      createdAt
      updatedAt
    }
  }
`;
export type UpdateEstateInfoMutationFn = ReactApollo.MutationFn<
  UpdateEstateInfoMutation,
  UpdateEstateInfoMutationVariables
>;

export const UpdateEstateInfoComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<UpdateEstateInfoMutation, UpdateEstateInfoMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: UpdateEstateInfoMutationVariables }
) => (
  <ReactApollo.Mutation<UpdateEstateInfoMutation, UpdateEstateInfoMutationVariables>
    mutation={UpdateEstateInfoDocument}
    {...props}
  />
);

export type UpdateEstateInfoProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<UpdateEstateInfoMutation, UpdateEstateInfoMutationVariables>
> &
  TChildProps;
export function withUpdateEstateInfo<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    UpdateEstateInfoMutation,
    UpdateEstateInfoMutationVariables,
    UpdateEstateInfoProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    UpdateEstateInfoMutation,
    UpdateEstateInfoMutationVariables,
    UpdateEstateInfoProps<TChildProps>
  >(UpdateEstateInfoDocument, {
    alias: 'withUpdateEstateInfo',
    ...operationOptions,
  });
}
export const UpdateEventDocument = gql`
  mutation UpdateEvent($id: ID!, $data: EventUpdateInput!) {
    updateEvent(data: $data, id: $id) {
      id
      createdAt
      updatedAt
      name
      type
      host
      location
      startDate
      endDate
      accessStartDate
      accessEndDate
      description
      hostLogo
      status
      reminders
      attendees {
        id
        cellNumber
        email
        status
        firstName
        lastName
      }
      image {
        id
        original
        scaled
        thumbnail
      }
    }
  }
`;
export type UpdateEventMutationFn = ReactApollo.MutationFn<UpdateEventMutation, UpdateEventMutationVariables>;

export const UpdateEventComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<UpdateEventMutation, UpdateEventMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: UpdateEventMutationVariables }
) => (
  <ReactApollo.Mutation<UpdateEventMutation, UpdateEventMutationVariables> mutation={UpdateEventDocument} {...props} />
);

export type UpdateEventProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<UpdateEventMutation, UpdateEventMutationVariables>
> &
  TChildProps;
export function withUpdateEvent<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    UpdateEventMutation,
    UpdateEventMutationVariables,
    UpdateEventProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    UpdateEventMutation,
    UpdateEventMutationVariables,
    UpdateEventProps<TChildProps>
  >(UpdateEventDocument, {
    alias: 'withUpdateEvent',
    ...operationOptions,
  });
}
export const UpdateFacilityDocument = gql`
  mutation UpdateFacility($id: ID!, $data: FacilityUpdateInput!) {
    updateFacility(id: $id, data: $data) {
      id
      name
      status
    }
  }
`;
export type UpdateFacilityMutationFn = ReactApollo.MutationFn<UpdateFacilityMutation, UpdateFacilityMutationVariables>;

export const UpdateFacilityComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<UpdateFacilityMutation, UpdateFacilityMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: UpdateFacilityMutationVariables }
) => (
  <ReactApollo.Mutation<UpdateFacilityMutation, UpdateFacilityMutationVariables>
    mutation={UpdateFacilityDocument}
    {...props}
  />
);

export type UpdateFacilityProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<UpdateFacilityMutation, UpdateFacilityMutationVariables>
> &
  TChildProps;
export function withUpdateFacility<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    UpdateFacilityMutation,
    UpdateFacilityMutationVariables,
    UpdateFacilityProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    UpdateFacilityMutation,
    UpdateFacilityMutationVariables,
    UpdateFacilityProps<TChildProps>
  >(UpdateFacilityDocument, {
    alias: 'withUpdateFacility',
    ...operationOptions,
  });
}
export const UpdatePostDocument = gql`
  mutation UpdatePost($id: ID!, $data: PostUpdateInput!) {
    updatePost(data: $data, id: $id) {
      createdAt
      id
      updatedAt
      title
      body
      status
      type
      category
      image {
        id
        original
        scaled
        thumbnail
      }
      roles
    }
  }
`;
export type UpdatePostMutationFn = ReactApollo.MutationFn<UpdatePostMutation, UpdatePostMutationVariables>;

export const UpdatePostComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<UpdatePostMutation, UpdatePostMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: UpdatePostMutationVariables }
) => <ReactApollo.Mutation<UpdatePostMutation, UpdatePostMutationVariables> mutation={UpdatePostDocument} {...props} />;

export type UpdatePostProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<UpdatePostMutation, UpdatePostMutationVariables>
> &
  TChildProps;
export function withUpdatePost<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    UpdatePostMutation,
    UpdatePostMutationVariables,
    UpdatePostProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    UpdatePostMutation,
    UpdatePostMutationVariables,
    UpdatePostProps<TChildProps>
  >(UpdatePostDocument, {
    alias: 'withUpdatePost',
    ...operationOptions,
  });
}
export const UpdatePropertyDocument = gql`
  mutation UpdateProperty(
    $id: ID!
    $address: String
    $size: Float
    $valuation: Float
    $code: String
    $suburb: String
    $image: FileUpdateInput
    $rooms: Float
    $erfNumber: String
    $salesAgent: String
    $status: PropertyStatus
    $stakeholders: StakeholderUpdateInput
    $type: PropertyType
  ) {
    updateProperty(
      data: {
        address: $address
        size: $size
        valuation: $valuation
        code: $code
        suburb: $suburb
        image: $image
        rooms: $rooms
        erfNumber: $erfNumber
        salesAgent: $salesAgent
        status: $status
        stakeholders: $stakeholders
        type: $type
      }
      id: $id
    ) {
      createdAt
      updatedAt
      id
      address
      size
      valuation
      code
      suburb
      image {
        id
        original
        scaled
        thumbnail
        id
      }
      rooms
      erfNumber
      salesAgent
      status
      stakeholders {
        createdAt
        updatedAt
        id
        firstName
        lastName
        dob
        country
        homeNumber
        cellNumber
        email
        idNumber
        residentialAddress
        postalAddress
        status
        role
      }
      type
    }
  }
`;
export type UpdatePropertyMutationFn = ReactApollo.MutationFn<UpdatePropertyMutation, UpdatePropertyMutationVariables>;

export const UpdatePropertyComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<UpdatePropertyMutation, UpdatePropertyMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: UpdatePropertyMutationVariables }
) => (
  <ReactApollo.Mutation<UpdatePropertyMutation, UpdatePropertyMutationVariables>
    mutation={UpdatePropertyDocument}
    {...props}
  />
);

export type UpdatePropertyProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<UpdatePropertyMutation, UpdatePropertyMutationVariables>
> &
  TChildProps;
export function withUpdateProperty<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    UpdatePropertyMutation,
    UpdatePropertyMutationVariables,
    UpdatePropertyProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    UpdatePropertyMutation,
    UpdatePropertyMutationVariables,
    UpdatePropertyProps<TChildProps>
  >(UpdatePropertyDocument, {
    alias: 'withUpdateProperty',
    ...operationOptions,
  });
}
export const UpdatePropertyDocumentDocument = gql`
  mutation UpdatePropertyDocument($id: ID!, $status: DocumentStatus, $name: String) {
    updateDocument(id: $id, data: { status: $status, name: $name }) {
      createdAt
      id
      updatedAt
      status
      name
    }
  }
`;
export type UpdatePropertyDocumentMutationFn = ReactApollo.MutationFn<
  UpdatePropertyDocumentMutation,
  UpdatePropertyDocumentMutationVariables
>;

export const UpdatePropertyDocumentComponent = (
  props: Omit<
    Omit<
      ReactApollo.MutationProps<UpdatePropertyDocumentMutation, UpdatePropertyDocumentMutationVariables>,
      'mutation'
    >,
    'variables'
  > & { variables?: UpdatePropertyDocumentMutationVariables }
) => (
  <ReactApollo.Mutation<UpdatePropertyDocumentMutation, UpdatePropertyDocumentMutationVariables>
    mutation={UpdatePropertyDocumentDocument}
    {...props}
  />
);

export type UpdatePropertyDocumentProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<UpdatePropertyDocumentMutation, UpdatePropertyDocumentMutationVariables>
> &
  TChildProps;
export function withUpdatePropertyDocument<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    UpdatePropertyDocumentMutation,
    UpdatePropertyDocumentMutationVariables,
    UpdatePropertyDocumentProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    UpdatePropertyDocumentMutation,
    UpdatePropertyDocumentMutationVariables,
    UpdatePropertyDocumentProps<TChildProps>
  >(UpdatePropertyDocumentDocument, {
    alias: 'withUpdatePropertyDocument',
    ...operationOptions,
  });
}
export const UpdatePropertyListingDocument = gql`
  mutation UpdatePropertyListing(
    $id: ID!
    $location: String
    $title: String
    $description: String
    $contact: JSON
    $price: Float
    $erfNumber: Int
    $descriptor: String
    $status: PropertyListingStatus
    $images: FileUpdateInput
  ) {
    updatePropertyListing(
      data: {
        location: $location
        title: $title
        description: $description
        price: $price
        erfNumber: $erfNumber
        descriptor: $descriptor
        status: $status
        images: $images
        contact: $contact
      }
      id: $id
    ) {
      id
      updatedAt
      createdAt
      location
      title
      description
      contact
      price
      erfNumber
      descriptor
      status
      images {
        id
        original
        scaled
        thumbnail
      }
    }
  }
`;
export type UpdatePropertyListingMutationFn = ReactApollo.MutationFn<
  UpdatePropertyListingMutation,
  UpdatePropertyListingMutationVariables
>;

export const UpdatePropertyListingComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<UpdatePropertyListingMutation, UpdatePropertyListingMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: UpdatePropertyListingMutationVariables }
) => (
  <ReactApollo.Mutation<UpdatePropertyListingMutation, UpdatePropertyListingMutationVariables>
    mutation={UpdatePropertyListingDocument}
    {...props}
  />
);

export type UpdatePropertyListingProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<UpdatePropertyListingMutation, UpdatePropertyListingMutationVariables>
> &
  TChildProps;
export function withUpdatePropertyListing<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    UpdatePropertyListingMutation,
    UpdatePropertyListingMutationVariables,
    UpdatePropertyListingProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    UpdatePropertyListingMutation,
    UpdatePropertyListingMutationVariables,
    UpdatePropertyListingProps<TChildProps>
  >(UpdatePropertyListingDocument, {
    alias: 'withUpdatePropertyListing',
    ...operationOptions,
  });
}
export const UpdateShopDocument = gql`
  mutation UpdateShop($data: ShopUpdateInput!, $id: ID!) {
    updateShop(id: $id, data: $data) {
      id
      name
      status
    }
  }
`;
export type UpdateShopMutationFn = ReactApollo.MutationFn<UpdateShopMutation, UpdateShopMutationVariables>;

export const UpdateShopComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<UpdateShopMutation, UpdateShopMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: UpdateShopMutationVariables }
) => <ReactApollo.Mutation<UpdateShopMutation, UpdateShopMutationVariables> mutation={UpdateShopDocument} {...props} />;

export type UpdateShopProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<UpdateShopMutation, UpdateShopMutationVariables>
> &
  TChildProps;
export function withUpdateShop<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    UpdateShopMutation,
    UpdateShopMutationVariables,
    UpdateShopProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    UpdateShopMutation,
    UpdateShopMutationVariables,
    UpdateShopProps<TChildProps>
  >(UpdateShopDocument, {
    alias: 'withUpdateShop',
    ...operationOptions,
  });
}
export const UpdateStakeholderDocument = gql`
  mutation UpdateStakeholder(
    $firstName: String
    $lastName: String
    $dob: DateTime
    $country: String
    $homeNumber: String
    $cellNumber: String
    $email: String
    $idNumber: String
    $residentialAddress: String
    $postalAddress: String
    $unitNumber: String
    $status: StakeholderStatus
    $role: StakeholderRole
    $id: ID!
    $properties: PropertyUpdateInput
  ) {
    updateStakeholder(
      data: {
        firstName: $firstName
        lastName: $lastName
        dob: $dob
        country: $country
        homeNumber: $homeNumber
        cellNumber: $cellNumber
        email: $email
        idNumber: $idNumber
        residentialAddress: $residentialAddress
        postalAddress: $postalAddress
        unitNumber: $unitNumber
        status: $status
        role: $role
        properties: $properties
      }
      id: $id
    ) {
      createdAt
      updatedAt
      id
      firstName
      lastName
      dob
      country
      cellNumber
      email
      idNumber
      residentialAddress
      postalAddress
      unitNumber
      status
      role
      properties {
        createdAt
        id
        code
        updatedAt
        address
        size
        valuation
        rooms
        erfNumber
        status
        salesAgent
      }
    }
  }
`;
export type UpdateStakeholderMutationFn = ReactApollo.MutationFn<
  UpdateStakeholderMutation,
  UpdateStakeholderMutationVariables
>;

export const UpdateStakeholderComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<UpdateStakeholderMutation, UpdateStakeholderMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: UpdateStakeholderMutationVariables }
) => (
  <ReactApollo.Mutation<UpdateStakeholderMutation, UpdateStakeholderMutationVariables>
    mutation={UpdateStakeholderDocument}
    {...props}
  />
);

export type UpdateStakeholderProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<UpdateStakeholderMutation, UpdateStakeholderMutationVariables>
> &
  TChildProps;
export function withUpdateStakeholder<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    UpdateStakeholderMutation,
    UpdateStakeholderMutationVariables,
    UpdateStakeholderProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    UpdateStakeholderMutation,
    UpdateStakeholderMutationVariables,
    UpdateStakeholderProps<TChildProps>
  >(UpdateStakeholderDocument, {
    alias: 'withUpdateStakeholder',
    ...operationOptions,
  });
}
export const UpdateUserDocument = gql`
  mutation UpdateUser(
    $id: ID!
    $firstName: String
    $lastName: String
    $email: String
    $password: String
    $role: UserRole
    $status: UserStatus
    $image: FileUpdateInput
    $authCode: String
  ) {
    updateUser(
      data: {
        firstName: $firstName
        lastName: $lastName
        email: $email
        password: $password
        role: $role
        status: $status
        image: $image
        authCode: $authCode
      }
      id: $id
    ) {
      createdAt
      updatedAt
      id
      firstName
      lastName
      email
      password
      otp
      status
      role
      authCode
      image {
        id
        original
        scaled
        thumbnail
      }
    }
  }
`;
export type UpdateUserMutationFn = ReactApollo.MutationFn<UpdateUserMutation, UpdateUserMutationVariables>;

export const UpdateUserComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<UpdateUserMutation, UpdateUserMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: UpdateUserMutationVariables }
) => <ReactApollo.Mutation<UpdateUserMutation, UpdateUserMutationVariables> mutation={UpdateUserDocument} {...props} />;

export type UpdateUserProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<UpdateUserMutation, UpdateUserMutationVariables>
> &
  TChildProps;
export function withUpdateUser<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    UpdateUserMutation,
    UpdateUserMutationVariables,
    UpdateUserProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    UpdateUserMutation,
    UpdateUserMutationVariables,
    UpdateUserProps<TChildProps>
  >(UpdateUserDocument, {
    alias: 'withUpdateUser',
    ...operationOptions,
  });
}
export const ValidateAdminUserDocument = gql`
  mutation ValidateAdminUser($id: ID!, $otp: String!, $firstName: String, $lastName: String, $password: String!) {
    validateUser(data: { id: $id, otp: $otp, firstName: $firstName, lastName: $lastName, password: $password }) {
      token
    }
  }
`;
export type ValidateAdminUserMutationFn = ReactApollo.MutationFn<
  ValidateAdminUserMutation,
  ValidateAdminUserMutationVariables
>;

export const ValidateAdminUserComponent = (
  props: Omit<
    Omit<ReactApollo.MutationProps<ValidateAdminUserMutation, ValidateAdminUserMutationVariables>, 'mutation'>,
    'variables'
  > & { variables?: ValidateAdminUserMutationVariables }
) => (
  <ReactApollo.Mutation<ValidateAdminUserMutation, ValidateAdminUserMutationVariables>
    mutation={ValidateAdminUserDocument}
    {...props}
  />
);

export type ValidateAdminUserProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<ValidateAdminUserMutation, ValidateAdminUserMutationVariables>
> &
  TChildProps;
export function withValidateAdminUser<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    ValidateAdminUserMutation,
    ValidateAdminUserMutationVariables,
    ValidateAdminUserProps<TChildProps>
  >
) {
  return ReactApollo.withMutation<
    TProps,
    ValidateAdminUserMutation,
    ValidateAdminUserMutationVariables,
    ValidateAdminUserProps<TChildProps>
  >(ValidateAdminUserDocument, {
    alias: 'withValidateAdminUser',
    ...operationOptions,
  });
}
export const AdminDashboardDocument = gql`
  query AdminDashboard {
    adminDashboard {
      properties
      events
      users
      accessEntries {
        id
        validFrom
      }
    }
  }
`;

export const AdminDashboardComponent = (
  props: Omit<Omit<ReactApollo.QueryProps<AdminDashboardQuery, AdminDashboardQueryVariables>, 'query'>, 'variables'> & {
    variables?: AdminDashboardQueryVariables;
  }
) => <ReactApollo.Query<AdminDashboardQuery, AdminDashboardQueryVariables> query={AdminDashboardDocument} {...props} />;

export type AdminDashboardProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<AdminDashboardQuery, AdminDashboardQueryVariables>
> &
  TChildProps;
export function withAdminDashboard<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    AdminDashboardQuery,
    AdminDashboardQueryVariables,
    AdminDashboardProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<
    TProps,
    AdminDashboardQuery,
    AdminDashboardQueryVariables,
    AdminDashboardProps<TChildProps>
  >(AdminDashboardDocument, {
    alias: 'withAdminDashboard',
    ...operationOptions,
  });
}
export const AllPropertiesDocument = gql`
  query AllProperties($searchTerm: String, $filterTerm: [PropertyType!]) {
    properties(
      orderBy: updatedAt_DESC
      where: {
        OR: [
          { type_in: $filterTerm }
          { address_contains: $searchTerm }
          { code_contains: $searchTerm }
          { salesAgent_contains: $searchTerm }
          { code_contains: $searchTerm }
          { suburb_contains: $searchTerm }
        ]
      }
    ) {
      createdAt
      id
      updatedAt
      address
      size
      valuation
      suburb
      rooms
      erfNumber
      status
      salesAgent
      type
    }
  }
`;

export const AllPropertiesComponent = (
  props: Omit<Omit<ReactApollo.QueryProps<AllPropertiesQuery, AllPropertiesQueryVariables>, 'query'>, 'variables'> & {
    variables?: AllPropertiesQueryVariables;
  }
) => <ReactApollo.Query<AllPropertiesQuery, AllPropertiesQueryVariables> query={AllPropertiesDocument} {...props} />;

export type AllPropertiesProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<AllPropertiesQuery, AllPropertiesQueryVariables>
> &
  TChildProps;
export function withAllProperties<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    AllPropertiesQuery,
    AllPropertiesQueryVariables,
    AllPropertiesProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<
    TProps,
    AllPropertiesQuery,
    AllPropertiesQueryVariables,
    AllPropertiesProps<TChildProps>
  >(AllPropertiesDocument, {
    alias: 'withAllProperties',
    ...operationOptions,
  });
}
export const GetAllApplicationsDocument = gql`
  query GetAllApplications($status: ApplicationStatus, $searchTerm: String, $filterTerm: [ApplicationType!]) {
    applications(
      orderBy: updatedAt_DESC
      where: {
        status: $status
        type_in: $filterTerm
        OR: [
          { rejectReason_contains: $searchTerm }
          {
            stakeholder: {
              OR: [
                { firstName_contains: $searchTerm }
                { lastName_contains: $searchTerm }
                { email_contains: $searchTerm }
                { residentialAddress_contains: $searchTerm }
              ]
            }
          }
          {
            property: {
              OR: [
                { address_contains: $searchTerm }
                { salesAgent_contains: $searchTerm }
                { suburb_contains: $searchTerm }
              ]
            }
          }
        ]
      }
    ) {
      id
      createdAt
      updatedAt
      fields
      status
      type
      stakeholder {
        id
        firstName
        lastName
      }
      property {
        address
        id
      }
    }
  }
`;

export const GetAllApplicationsComponent = (
  props: Omit<
    Omit<ReactApollo.QueryProps<GetAllApplicationsQuery, GetAllApplicationsQueryVariables>, 'query'>,
    'variables'
  > & { variables?: GetAllApplicationsQueryVariables }
) => (
  <ReactApollo.Query<GetAllApplicationsQuery, GetAllApplicationsQueryVariables>
    query={GetAllApplicationsDocument}
    {...props}
  />
);

export type GetAllApplicationsProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<GetAllApplicationsQuery, GetAllApplicationsQueryVariables>
> &
  TChildProps;
export function withGetAllApplications<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    GetAllApplicationsQuery,
    GetAllApplicationsQueryVariables,
    GetAllApplicationsProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<
    TProps,
    GetAllApplicationsQuery,
    GetAllApplicationsQueryVariables,
    GetAllApplicationsProps<TChildProps>
  >(GetAllApplicationsDocument, {
    alias: 'withGetAllApplications',
    ...operationOptions,
  });
}
export const CalendarEventsDocument = gql`
  query CalendarEvents {
    events {
      id
      createdAt
      updatedAt
      name
      description
      location
      status
      startDate
      endDate
      image {
        id
        scaled
        thumbnail
        original
      }
    }
  }
`;

export const CalendarEventsComponent = (
  props: Omit<Omit<ReactApollo.QueryProps<CalendarEventsQuery, CalendarEventsQueryVariables>, 'query'>, 'variables'> & {
    variables?: CalendarEventsQueryVariables;
  }
) => <ReactApollo.Query<CalendarEventsQuery, CalendarEventsQueryVariables> query={CalendarEventsDocument} {...props} />;

export type CalendarEventsProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<CalendarEventsQuery, CalendarEventsQueryVariables>
> &
  TChildProps;
export function withCalendarEvents<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    CalendarEventsQuery,
    CalendarEventsQueryVariables,
    CalendarEventsProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<
    TProps,
    CalendarEventsQuery,
    CalendarEventsQueryVariables,
    CalendarEventsProps<TChildProps>
  >(CalendarEventsDocument, {
    alias: 'withCalendarEvents',
    ...operationOptions,
  });
}
export const GetAllContactUsDocument = gql`
  query GetAllContactUs($searchTerm: String) {
    contactuses(
      orderBy: name_ASC
      where: { OR: [{ name_contains: $searchTerm }, { number_contains: $searchTerm }, { email_contains: $searchTerm }] }
    ) {
      id
      createdAt
      updatedAt
      name
      number
      email
    }
  }
`;

export const GetAllContactUsComponent = (
  props: Omit<
    Omit<ReactApollo.QueryProps<GetAllContactUsQuery, GetAllContactUsQueryVariables>, 'query'>,
    'variables'
  > & { variables?: GetAllContactUsQueryVariables }
) => (
  <ReactApollo.Query<GetAllContactUsQuery, GetAllContactUsQueryVariables> query={GetAllContactUsDocument} {...props} />
);

export type GetAllContactUsProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<GetAllContactUsQuery, GetAllContactUsQueryVariables>
> &
  TChildProps;
export function withGetAllContactUs<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    GetAllContactUsQuery,
    GetAllContactUsQueryVariables,
    GetAllContactUsProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<
    TProps,
    GetAllContactUsQuery,
    GetAllContactUsQueryVariables,
    GetAllContactUsProps<TChildProps>
  >(GetAllContactUsDocument, {
    alias: 'withGetAllContactUs',
    ...operationOptions,
  });
}
export const GetAllEateriesDocument = gql`
  query GetAllEateries($statusFilter: EateryStatus, $searchTerm: String) {
    eateries(
      orderBy: name_ASC
      where: { status: $statusFilter, OR: [{ name_contains: $searchTerm }, { description_contains: $searchTerm }] }
    ) {
      id
      name
      status
      description
      logo
      email
      telephoneNumber
      whatsappNumber
      mondayHours
      tuesdayHours
      wednesdayHours
      thursdayHours
      fridayHours
      saturdayHours
      sundayHours
    }
  }
`;

export const GetAllEateriesComponent = (
  props: Omit<Omit<ReactApollo.QueryProps<GetAllEateriesQuery, GetAllEateriesQueryVariables>, 'query'>, 'variables'> & {
    variables?: GetAllEateriesQueryVariables;
  }
) => <ReactApollo.Query<GetAllEateriesQuery, GetAllEateriesQueryVariables> query={GetAllEateriesDocument} {...props} />;

export type GetAllEateriesProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<GetAllEateriesQuery, GetAllEateriesQueryVariables>
> &
  TChildProps;
export function withGetAllEateries<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    GetAllEateriesQuery,
    GetAllEateriesQueryVariables,
    GetAllEateriesProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<
    TProps,
    GetAllEateriesQuery,
    GetAllEateriesQueryVariables,
    GetAllEateriesProps<TChildProps>
  >(GetAllEateriesDocument, {
    alias: 'withGetAllEateries',
    ...operationOptions,
  });
}
export const GetAllEventsDocument = gql`
  query GetAllEvents($where: EventWhereInput) {
    events(orderBy: updatedAt_DESC, where: $where) {
      createdAt
      id
      updatedAt
      name
      type
      host
      location
      startDate
      endDate
      accessStartDate
      accessEndDate
      description
      links
      status
    }
  }
`;

export const GetAllEventsComponent = (
  props: Omit<Omit<ReactApollo.QueryProps<GetAllEventsQuery, GetAllEventsQueryVariables>, 'query'>, 'variables'> & {
    variables?: GetAllEventsQueryVariables;
  }
) => <ReactApollo.Query<GetAllEventsQuery, GetAllEventsQueryVariables> query={GetAllEventsDocument} {...props} />;

export type GetAllEventsProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<GetAllEventsQuery, GetAllEventsQueryVariables>
> &
  TChildProps;
export function withGetAllEvents<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    GetAllEventsQuery,
    GetAllEventsQueryVariables,
    GetAllEventsProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<TProps, GetAllEventsQuery, GetAllEventsQueryVariables, GetAllEventsProps<TChildProps>>(
    GetAllEventsDocument,
    {
      alias: 'withGetAllEvents',
      ...operationOptions,
    }
  );
}
export const GetAllFacilitiesDocument = gql`
  query GetAllFacilities($statusFilter: FacilityStatus, $searchTerm: String) {
    facilities(
      orderBy: name_ASC
      where: { status: $statusFilter, OR: [{ name_contains: $searchTerm }, { description_contains: $searchTerm }] }
    ) {
      id
      name
      status
      description
      logo
      email
      telephoneNumber
      whatsappNumber
      mondayHours
      tuesdayHours
      wednesdayHours
      thursdayHours
      fridayHours
      saturdayHours
      sundayHours
      tradingHours
    }
  }
`;

export const GetAllFacilitiesComponent = (
  props: Omit<
    Omit<ReactApollo.QueryProps<GetAllFacilitiesQuery, GetAllFacilitiesQueryVariables>, 'query'>,
    'variables'
  > & { variables?: GetAllFacilitiesQueryVariables }
) => (
  <ReactApollo.Query<GetAllFacilitiesQuery, GetAllFacilitiesQueryVariables>
    query={GetAllFacilitiesDocument}
    {...props}
  />
);

export type GetAllFacilitiesProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<GetAllFacilitiesQuery, GetAllFacilitiesQueryVariables>
> &
  TChildProps;
export function withGetAllFacilities<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    GetAllFacilitiesQuery,
    GetAllFacilitiesQueryVariables,
    GetAllFacilitiesProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<
    TProps,
    GetAllFacilitiesQuery,
    GetAllFacilitiesQueryVariables,
    GetAllFacilitiesProps<TChildProps>
  >(GetAllFacilitiesDocument, {
    alias: 'withGetAllFacilities',
    ...operationOptions,
  });
}
export const GetAllGuestsDocument = gql`
  query GetAllGuests($searchTerm: String, $status: StakeholderStatus) {
    stakeholders(
      orderBy: updatedAt_DESC
      where: {
        role: GUEST
        status: $status
        OR: [
          { firstName_contains: $searchTerm }
          { lastName_contains: $searchTerm }
          { email_contains: $searchTerm }
          { cellNumber_contains: $searchTerm }
          { residentialAddress_contains: $searchTerm }
        ]
      }
    ) {
      createdAt
      id
      updatedAt
      firstName
      lastName
      dob
      cellNumber
      email
      residentialAddress
      status
      role
      passes {
        id
        name
        validFrom
        validTo
        type
      }
    }
  }
`;

export const GetAllGuestsComponent = (
  props: Omit<Omit<ReactApollo.QueryProps<GetAllGuestsQuery, GetAllGuestsQueryVariables>, 'query'>, 'variables'> & {
    variables?: GetAllGuestsQueryVariables;
  }
) => <ReactApollo.Query<GetAllGuestsQuery, GetAllGuestsQueryVariables> query={GetAllGuestsDocument} {...props} />;

export type GetAllGuestsProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<GetAllGuestsQuery, GetAllGuestsQueryVariables>
> &
  TChildProps;
export function withGetAllGuests<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    GetAllGuestsQuery,
    GetAllGuestsQueryVariables,
    GetAllGuestsProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<TProps, GetAllGuestsQuery, GetAllGuestsQueryVariables, GetAllGuestsProps<TChildProps>>(
    GetAllGuestsDocument,
    {
      alias: 'withGetAllGuests',
      ...operationOptions,
    }
  );
}
export const GetAllPostsDocument = gql`
  query GetAllPosts($type: PostType, $searchTerm: String, $categoryFilter: [PostCategory!], $statusFilter: PostStatus) {
    posts(
      orderBy: updatedAt_DESC
      where: {
        type: $type
        category_in: $categoryFilter
        status: $statusFilter
        OR: [{ body_contains: $searchTerm }, { title_contains: $searchTerm }]
      }
    ) {
      createdAt
      id
      updatedAt
      title
      body
      status
      type
      category
      roles
      image {
        createdAt
        id
        updatedAt
        thumbnail
        scaled
      }
    }
  }
`;

export const GetAllPostsComponent = (
  props: Omit<Omit<ReactApollo.QueryProps<GetAllPostsQuery, GetAllPostsQueryVariables>, 'query'>, 'variables'> & {
    variables?: GetAllPostsQueryVariables;
  }
) => <ReactApollo.Query<GetAllPostsQuery, GetAllPostsQueryVariables> query={GetAllPostsDocument} {...props} />;

export type GetAllPostsProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<GetAllPostsQuery, GetAllPostsQueryVariables>
> &
  TChildProps;
export function withGetAllPosts<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    GetAllPostsQuery,
    GetAllPostsQueryVariables,
    GetAllPostsProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<TProps, GetAllPostsQuery, GetAllPostsQueryVariables, GetAllPostsProps<TChildProps>>(
    GetAllPostsDocument,
    {
      alias: 'withGetAllPosts',
      ...operationOptions,
    }
  );
}
export const GetAllPropertyListingDocument = gql`
  query GetAllPropertyListing($searchTerm: String, $statusFilter: [PropertyListingStatus!]) {
    propertyListings(
      orderBy: updatedAt_DESC
      where: {
        status_in: $statusFilter
        OR: [{ title_contains: $searchTerm }, { location_contains: $searchTerm }, { description_contains: $searchTerm }]
      }
    ) {
      createdAt
      updatedAt
      id
      location
      title
      description
      contact
      price
      erfNumber
      descriptor
      status
      images {
        id
        original
        scaled
        thumbnail
      }
    }
  }
`;

export const GetAllPropertyListingComponent = (
  props: Omit<
    Omit<ReactApollo.QueryProps<GetAllPropertyListingQuery, GetAllPropertyListingQueryVariables>, 'query'>,
    'variables'
  > & { variables?: GetAllPropertyListingQueryVariables }
) => (
  <ReactApollo.Query<GetAllPropertyListingQuery, GetAllPropertyListingQueryVariables>
    query={GetAllPropertyListingDocument}
    {...props}
  />
);

export type GetAllPropertyListingProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<GetAllPropertyListingQuery, GetAllPropertyListingQueryVariables>
> &
  TChildProps;
export function withGetAllPropertyListing<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    GetAllPropertyListingQuery,
    GetAllPropertyListingQueryVariables,
    GetAllPropertyListingProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<
    TProps,
    GetAllPropertyListingQuery,
    GetAllPropertyListingQueryVariables,
    GetAllPropertyListingProps<TChildProps>
  >(GetAllPropertyListingDocument, {
    alias: 'withGetAllPropertyListing',
    ...operationOptions,
  });
}
export const GetAllShopsDocument = gql`
  query GetAllShops($statusFilter: ShopStatus, $searchTerm: String) {
    shops(
      orderBy: name_ASC
      where: { status: $statusFilter, OR: [{ name_contains: $searchTerm }, { description_contains: $searchTerm }] }
    ) {
      id
      name
      description
      status
      logo
      email
      telephoneNumber
      whatsappNumber
      menus
      tradingHours
      mondayHours
      tuesdayHours
      wednesdayHours
      thursdayHours
      fridayHours
      saturdayHours
      sundayHours
      isService
    }
  }
`;

export const GetAllShopsComponent = (
  props: Omit<Omit<ReactApollo.QueryProps<GetAllShopsQuery, GetAllShopsQueryVariables>, 'query'>, 'variables'> & {
    variables?: GetAllShopsQueryVariables;
  }
) => <ReactApollo.Query<GetAllShopsQuery, GetAllShopsQueryVariables> query={GetAllShopsDocument} {...props} />;

export type GetAllShopsProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<GetAllShopsQuery, GetAllShopsQueryVariables>
> &
  TChildProps;
export function withGetAllShops<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    GetAllShopsQuery,
    GetAllShopsQueryVariables,
    GetAllShopsProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<TProps, GetAllShopsQuery, GetAllShopsQueryVariables, GetAllShopsProps<TChildProps>>(
    GetAllShopsDocument,
    {
      alias: 'withGetAllShops',
      ...operationOptions,
    }
  );
}
export const GetAllStakeholdersDocument = gql`
  query GetAllStakeholders(
    $order: StakeholderOrderByInput
    $role: StakeholderRole
    $searchTerm: String
    $status: StakeholderStatus
  ) {
    stakeholders(
      orderBy: $order
      where: {
        role: $role
        role_not_in: [GUEST]
        status: $status
        OR: [
          { firstName_contains: $searchTerm }
          { lastName_contains: $searchTerm }
          { email_contains: $searchTerm }
          { cellNumber_contains: $searchTerm }
          { residentialAddress_contains: $searchTerm }
          { idNumber_contains: $searchTerm }
        ]
      }
    ) {
      createdAt
      id
      updatedAt
      firstName
      lastName
      dob
      country
      homeNumber
      cellNumber
      email
      idNumber
      residentialAddress
      postalAddress
      unitNumber
      status
      role
      properties {
        createdAt
        id
        code
        updatedAt
        address
        size
        valuation
        rooms
        erfNumber
        status
        salesAgent
      }
    }
  }
`;

export const GetAllStakeholdersComponent = (
  props: Omit<
    Omit<ReactApollo.QueryProps<GetAllStakeholdersQuery, GetAllStakeholdersQueryVariables>, 'query'>,
    'variables'
  > & { variables?: GetAllStakeholdersQueryVariables }
) => (
  <ReactApollo.Query<GetAllStakeholdersQuery, GetAllStakeholdersQueryVariables>
    query={GetAllStakeholdersDocument}
    {...props}
  />
);

export type GetAllStakeholdersProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<GetAllStakeholdersQuery, GetAllStakeholdersQueryVariables>
> &
  TChildProps;
export function withGetAllStakeholders<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    GetAllStakeholdersQuery,
    GetAllStakeholdersQueryVariables,
    GetAllStakeholdersProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<
    TProps,
    GetAllStakeholdersQuery,
    GetAllStakeholdersQueryVariables,
    GetAllStakeholdersProps<TChildProps>
  >(GetAllStakeholdersDocument, {
    alias: 'withGetAllStakeholders',
    ...operationOptions,
  });
}
export const GetAllUsersDocument = gql`
  query GetAllUsers($searchTerm: String, $filterTerm: UserRole) {
    users(
      orderBy: updatedAt_DESC
      where: {
        role: $filterTerm
        role_not_in: [VENDOR_ADMIN, VENDOR_USER]
        OR: [{ email_contains: $searchTerm }, { firstName_contains: $searchTerm }, { lastName_contains: $searchTerm }]
      }
    ) {
      createdAt
      id
      updatedAt
      email
      firstName
      lastName
      authCode
      status
      role
    }
  }
`;

export const GetAllUsersComponent = (
  props: Omit<Omit<ReactApollo.QueryProps<GetAllUsersQuery, GetAllUsersQueryVariables>, 'query'>, 'variables'> & {
    variables?: GetAllUsersQueryVariables;
  }
) => <ReactApollo.Query<GetAllUsersQuery, GetAllUsersQueryVariables> query={GetAllUsersDocument} {...props} />;

export type GetAllUsersProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<GetAllUsersQuery, GetAllUsersQueryVariables>
> &
  TChildProps;
export function withGetAllUsers<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    GetAllUsersQuery,
    GetAllUsersQueryVariables,
    GetAllUsersProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<TProps, GetAllUsersQuery, GetAllUsersQueryVariables, GetAllUsersProps<TChildProps>>(
    GetAllUsersDocument,
    {
      alias: 'withGetAllUsers',
      ...operationOptions,
    }
  );
}
export const GetApplicationDocument = gql`
  query GetApplication($id: ID!) {
    application(id: $id) {
      id
      createdAt
      updatedAt
      fields
      status
      type
      document {
        id
        original
      }
      stakeholder {
        id
        firstName
        lastName
        idNumber
        cellNumber
        country
        dob
        email
      }
      property {
        address
        id
      }
    }
  }
`;

export const GetApplicationComponent = (
  props: Omit<Omit<ReactApollo.QueryProps<GetApplicationQuery, GetApplicationQueryVariables>, 'query'>, 'variables'> & {
    variables: GetApplicationQueryVariables;
  }
) => <ReactApollo.Query<GetApplicationQuery, GetApplicationQueryVariables> query={GetApplicationDocument} {...props} />;

export type GetApplicationProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<GetApplicationQuery, GetApplicationQueryVariables>
> &
  TChildProps;
export function withGetApplication<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    GetApplicationQuery,
    GetApplicationQueryVariables,
    GetApplicationProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<
    TProps,
    GetApplicationQuery,
    GetApplicationQueryVariables,
    GetApplicationProps<TChildProps>
  >(GetApplicationDocument, {
    alias: 'withGetApplication',
    ...operationOptions,
  });
}
export const GetCalendarEventDocument = gql`
  query GetCalendarEvent($id: ID!) {
    event(id: $id) {
      id
      createdAt
      updatedAt
      name
      description
      location
      status
      startDate
      host
      endDate
      image {
        id
        original
        scaled
        thumbnail
      }
    }
  }
`;

export const GetCalendarEventComponent = (
  props: Omit<
    Omit<ReactApollo.QueryProps<GetCalendarEventQuery, GetCalendarEventQueryVariables>, 'query'>,
    'variables'
  > & { variables: GetCalendarEventQueryVariables }
) => (
  <ReactApollo.Query<GetCalendarEventQuery, GetCalendarEventQueryVariables>
    query={GetCalendarEventDocument}
    {...props}
  />
);

export type GetCalendarEventProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<GetCalendarEventQuery, GetCalendarEventQueryVariables>
> &
  TChildProps;
export function withGetCalendarEvent<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    GetCalendarEventQuery,
    GetCalendarEventQueryVariables,
    GetCalendarEventProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<
    TProps,
    GetCalendarEventQuery,
    GetCalendarEventQueryVariables,
    GetCalendarEventProps<TChildProps>
  >(GetCalendarEventDocument, {
    alias: 'withGetCalendarEvent',
    ...operationOptions,
  });
}
export const ContactUsDocument = gql`
  query ContactUs($contactUsId: ID!) {
    contactUs(id: $contactUsId) {
      id
      createdAt
      updatedAt
      name
      number
      email
    }
  }
`;

export const ContactUsComponent = (
  props: Omit<Omit<ReactApollo.QueryProps<ContactUsQuery, ContactUsQueryVariables>, 'query'>, 'variables'> & {
    variables: ContactUsQueryVariables;
  }
) => <ReactApollo.Query<ContactUsQuery, ContactUsQueryVariables> query={ContactUsDocument} {...props} />;

export type ContactUsProps<TChildProps = {}> = Partial<ReactApollo.DataProps<ContactUsQuery, ContactUsQueryVariables>> &
  TChildProps;
export function withContactUs<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    ContactUsQuery,
    ContactUsQueryVariables,
    ContactUsProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<TProps, ContactUsQuery, ContactUsQueryVariables, ContactUsProps<TChildProps>>(
    ContactUsDocument,
    {
      alias: 'withContactUs',
      ...operationOptions,
    }
  );
}
export const GetEateryDocument = gql`
  query GetEatery($id: ID!) {
    eatery(id: $id) {
      id
      createdAt
      updatedAt
      name
      status
      description
      logo
      email
      telephoneNumber
      whatsappNumber
      menus
      mondayHours
      tuesdayHours
      wednesdayHours
      thursdayHours
      fridayHours
      saturdayHours
      sundayHours
      tradingHours
      xtradingHours
    }
  }
`;

export const GetEateryComponent = (
  props: Omit<Omit<ReactApollo.QueryProps<GetEateryQuery, GetEateryQueryVariables>, 'query'>, 'variables'> & {
    variables: GetEateryQueryVariables;
  }
) => <ReactApollo.Query<GetEateryQuery, GetEateryQueryVariables> query={GetEateryDocument} {...props} />;

export type GetEateryProps<TChildProps = {}> = Partial<ReactApollo.DataProps<GetEateryQuery, GetEateryQueryVariables>> &
  TChildProps;
export function withGetEatery<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    GetEateryQuery,
    GetEateryQueryVariables,
    GetEateryProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<TProps, GetEateryQuery, GetEateryQueryVariables, GetEateryProps<TChildProps>>(
    GetEateryDocument,
    {
      alias: 'withGetEatery',
      ...operationOptions,
    }
  );
}
export const GetEstateInfoDocument = gql`
  query GetEstateInfo($id: ID!) {
    estateInfo(id: $id) {
      id
      title
      image
      pdf
      status
      createdAt
      updatedAt
    }
  }
`;

export const GetEstateInfoComponent = (
  props: Omit<Omit<ReactApollo.QueryProps<GetEstateInfoQuery, GetEstateInfoQueryVariables>, 'query'>, 'variables'> & {
    variables: GetEstateInfoQueryVariables;
  }
) => <ReactApollo.Query<GetEstateInfoQuery, GetEstateInfoQueryVariables> query={GetEstateInfoDocument} {...props} />;

export type GetEstateInfoProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<GetEstateInfoQuery, GetEstateInfoQueryVariables>
> &
  TChildProps;
export function withGetEstateInfo<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    GetEstateInfoQuery,
    GetEstateInfoQueryVariables,
    GetEstateInfoProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<
    TProps,
    GetEstateInfoQuery,
    GetEstateInfoQueryVariables,
    GetEstateInfoProps<TChildProps>
  >(GetEstateInfoDocument, {
    alias: 'withGetEstateInfo',
    ...operationOptions,
  });
}
export const GetFacilityDocument = gql`
  query GetFacility($id: ID!) {
    facility(id: $id) {
      id
      name
      status
      description
      logo
      email
      telephoneNumber
      whatsappNumber
      mondayHours
      tuesdayHours
      wednesdayHours
      thursdayHours
      fridayHours
      saturdayHours
      sundayHours
      tradingHours
    }
  }
`;

export const GetFacilityComponent = (
  props: Omit<Omit<ReactApollo.QueryProps<GetFacilityQuery, GetFacilityQueryVariables>, 'query'>, 'variables'> & {
    variables: GetFacilityQueryVariables;
  }
) => <ReactApollo.Query<GetFacilityQuery, GetFacilityQueryVariables> query={GetFacilityDocument} {...props} />;

export type GetFacilityProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<GetFacilityQuery, GetFacilityQueryVariables>
> &
  TChildProps;
export function withGetFacility<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    GetFacilityQuery,
    GetFacilityQueryVariables,
    GetFacilityProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<TProps, GetFacilityQuery, GetFacilityQueryVariables, GetFacilityProps<TChildProps>>(
    GetFacilityDocument,
    {
      alias: 'withGetFacility',
      ...operationOptions,
    }
  );
}
export const GetGuestDocument = gql`
  query GetGuest($id: ID!) {
    stakeholder(id: $id) {
      createdAt
      id
      updatedAt
      firstName
      lastName
      dob
      cellNumber
      email
      residentialAddress
      status
      role
      image {
        id
        original
        scaled
        thumbnail
      }
      visitings {
        id
        pass {
          id
          visit {
            id
            host {
              id
              firstName
              lastName
              cellNumber
            }
          }
        }
      }
    }
  }
`;

export const GetGuestComponent = (
  props: Omit<Omit<ReactApollo.QueryProps<GetGuestQuery, GetGuestQueryVariables>, 'query'>, 'variables'> & {
    variables: GetGuestQueryVariables;
  }
) => <ReactApollo.Query<GetGuestQuery, GetGuestQueryVariables> query={GetGuestDocument} {...props} />;

export type GetGuestProps<TChildProps = {}> = Partial<ReactApollo.DataProps<GetGuestQuery, GetGuestQueryVariables>> &
  TChildProps;
export function withGetGuest<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    GetGuestQuery,
    GetGuestQueryVariables,
    GetGuestProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<TProps, GetGuestQuery, GetGuestQueryVariables, GetGuestProps<TChildProps>>(
    GetGuestDocument,
    {
      alias: 'withGetGuest',
      ...operationOptions,
    }
  );
}
export const GetAllEstateInfosDocument = gql`
  query GetAllEstateInfos($searchTerm: String) {
    estateInfos(orderBy: title_ASC, where: { OR: [{ title_contains: $searchTerm }] }) {
      id
      createdAt
      updatedAt
      title
      image
      pdf
    }
  }
`;

export const GetAllEstateInfosComponent = (
  props: Omit<
    Omit<ReactApollo.QueryProps<GetAllEstateInfosQuery, GetAllEstateInfosQueryVariables>, 'query'>,
    'variables'
  > & { variables?: GetAllEstateInfosQueryVariables }
) => (
  <ReactApollo.Query<GetAllEstateInfosQuery, GetAllEstateInfosQueryVariables>
    query={GetAllEstateInfosDocument}
    {...props}
  />
);

export type GetAllEstateInfosProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<GetAllEstateInfosQuery, GetAllEstateInfosQueryVariables>
> &
  TChildProps;
export function withGetAllEstateInfos<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    GetAllEstateInfosQuery,
    GetAllEstateInfosQueryVariables,
    GetAllEstateInfosProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<
    TProps,
    GetAllEstateInfosQuery,
    GetAllEstateInfosQueryVariables,
    GetAllEstateInfosProps<TChildProps>
  >(GetAllEstateInfosDocument, {
    alias: 'withGetAllEstateInfos',
    ...operationOptions,
  });
}
export const GetPostDocument = gql`
  query GetPost($id: ID!) {
    post(id: $id) {
      createdAt
      id
      updatedAt
      title
      body
      status
      type
      category
      roles
      image {
        id
        scaled
        original
        thumbnail
      }
    }
  }
`;

export const GetPostComponent = (
  props: Omit<Omit<ReactApollo.QueryProps<GetPostQuery, GetPostQueryVariables>, 'query'>, 'variables'> & {
    variables: GetPostQueryVariables;
  }
) => <ReactApollo.Query<GetPostQuery, GetPostQueryVariables> query={GetPostDocument} {...props} />;

export type GetPostProps<TChildProps = {}> = Partial<ReactApollo.DataProps<GetPostQuery, GetPostQueryVariables>> &
  TChildProps;
export function withGetPost<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<TProps, GetPostQuery, GetPostQueryVariables, GetPostProps<TChildProps>>
) {
  return ReactApollo.withQuery<TProps, GetPostQuery, GetPostQueryVariables, GetPostProps<TChildProps>>(
    GetPostDocument,
    {
      alias: 'withGetPost',
      ...operationOptions,
    }
  );
}
export const GetProductsDocument = gql`
  query GetProducts($id: String!) {
    products(where: { id: $id }) {
      id
      name
      price
      capacity
      event {
        id
      }
    }
  }
`;

export const GetProductsComponent = (
  props: Omit<Omit<ReactApollo.QueryProps<GetProductsQuery, GetProductsQueryVariables>, 'query'>, 'variables'> & {
    variables: GetProductsQueryVariables;
  }
) => <ReactApollo.Query<GetProductsQuery, GetProductsQueryVariables> query={GetProductsDocument} {...props} />;

export type GetProductsProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<GetProductsQuery, GetProductsQueryVariables>
> &
  TChildProps;
export function withGetProducts<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    GetProductsQuery,
    GetProductsQueryVariables,
    GetProductsProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<TProps, GetProductsQuery, GetProductsQueryVariables, GetProductsProps<TChildProps>>(
    GetProductsDocument,
    {
      alias: 'withGetProducts',
      ...operationOptions,
    }
  );
}
export const GetPropertyDocument = gql`
  query GetProperty($id: ID!, $role: StakeholderRole, $searchTerm: String) {
    property(id: $id) {
      createdAt
      id
      code
      updatedAt
      address
      size
      valuation
      suburb
      rooms
      erfNumber
      status
      documents {
        id
        name
        status
        file {
          id
          original
        }
      }
      image {
        id
        scaled
        original
        thumbnail
      }
      type
    }
  }
`;

export const GetPropertyComponent = (
  props: Omit<Omit<ReactApollo.QueryProps<GetPropertyQuery, GetPropertyQueryVariables>, 'query'>, 'variables'> & {
    variables: GetPropertyQueryVariables;
  }
) => <ReactApollo.Query<GetPropertyQuery, GetPropertyQueryVariables> query={GetPropertyDocument} {...props} />;

export type GetPropertyProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<GetPropertyQuery, GetPropertyQueryVariables>
> &
  TChildProps;
export function withGetProperty<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    GetPropertyQuery,
    GetPropertyQueryVariables,
    GetPropertyProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<TProps, GetPropertyQuery, GetPropertyQueryVariables, GetPropertyProps<TChildProps>>(
    GetPropertyDocument,
    {
      alias: 'withGetProperty',
      ...operationOptions,
    }
  );
}
export const GetPropertyDocumentsDocument = gql`
  query GetPropertyDocuments($id: String!, $billing: Boolean, $searchTerm: String, $filterTerm: [DocumentStatus!]) {
    documents(
      orderBy: updatedAt_DESC
      where: { property: { id: $id }, billing: $billing, name_contains: $searchTerm, status_in: $filterTerm }
    ) {
      id
      createdAt
      updatedAt
      name
      billing
      status
      file {
        id
        original
      }
    }
  }
`;

export const GetPropertyDocumentsComponent = (
  props: Omit<
    Omit<ReactApollo.QueryProps<GetPropertyDocumentsQuery, GetPropertyDocumentsQueryVariables>, 'query'>,
    'variables'
  > & { variables: GetPropertyDocumentsQueryVariables }
) => (
  <ReactApollo.Query<GetPropertyDocumentsQuery, GetPropertyDocumentsQueryVariables>
    query={GetPropertyDocumentsDocument}
    {...props}
  />
);

export type GetPropertyDocumentsProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<GetPropertyDocumentsQuery, GetPropertyDocumentsQueryVariables>
> &
  TChildProps;
export function withGetPropertyDocuments<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    GetPropertyDocumentsQuery,
    GetPropertyDocumentsQueryVariables,
    GetPropertyDocumentsProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<
    TProps,
    GetPropertyDocumentsQuery,
    GetPropertyDocumentsQueryVariables,
    GetPropertyDocumentsProps<TChildProps>
  >(GetPropertyDocumentsDocument, {
    alias: 'withGetPropertyDocuments',
    ...operationOptions,
  });
}
export const GetPropertyListingDocument = gql`
  query GetPropertyListing($id: ID!) {
    propertyListing(id: $id) {
      createdAt
      updatedAt
      id
      location
      title
      description
      contact
      price
      erfNumber
      descriptor
      status
      images {
        id
        original
        scaled
        thumbnail
      }
    }
  }
`;

export const GetPropertyListingComponent = (
  props: Omit<
    Omit<ReactApollo.QueryProps<GetPropertyListingQuery, GetPropertyListingQueryVariables>, 'query'>,
    'variables'
  > & { variables: GetPropertyListingQueryVariables }
) => (
  <ReactApollo.Query<GetPropertyListingQuery, GetPropertyListingQueryVariables>
    query={GetPropertyListingDocument}
    {...props}
  />
);

export type GetPropertyListingProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<GetPropertyListingQuery, GetPropertyListingQueryVariables>
> &
  TChildProps;
export function withGetPropertyListing<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    GetPropertyListingQuery,
    GetPropertyListingQueryVariables,
    GetPropertyListingProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<
    TProps,
    GetPropertyListingQuery,
    GetPropertyListingQueryVariables,
    GetPropertyListingProps<TChildProps>
  >(GetPropertyListingDocument, {
    alias: 'withGetPropertyListing',
    ...operationOptions,
  });
}
export const GetShopDocument = gql`
  query GetShop($id: ID!) {
    shop(id: $id) {
      id
      name
      description
      status
      logo
      email
      telephoneNumber
      whatsappNumber
      menus
      tradingHours
      mondayHours
      tuesdayHours
      wednesdayHours
      thursdayHours
      fridayHours
      saturdayHours
      sundayHours
    }
  }
`;

export const GetShopComponent = (
  props: Omit<Omit<ReactApollo.QueryProps<GetShopQuery, GetShopQueryVariables>, 'query'>, 'variables'> & {
    variables: GetShopQueryVariables;
  }
) => <ReactApollo.Query<GetShopQuery, GetShopQueryVariables> query={GetShopDocument} {...props} />;

export type GetShopProps<TChildProps = {}> = Partial<ReactApollo.DataProps<GetShopQuery, GetShopQueryVariables>> &
  TChildProps;
export function withGetShop<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<TProps, GetShopQuery, GetShopQueryVariables, GetShopProps<TChildProps>>
) {
  return ReactApollo.withQuery<TProps, GetShopQuery, GetShopQueryVariables, GetShopProps<TChildProps>>(
    GetShopDocument,
    {
      alias: 'withGetShop',
      ...operationOptions,
    }
  );
}
export const GetStakeholderDocument = gql`
  query GetStakeholder($id: ID!) {
    stakeholder(id: $id) {
      createdAt
      id
      updatedAt
      firstName
      lastName
      dob
      country
      homeNumber
      cellNumber
      email
      idNumber
      residentialAddress
      postalAddress
      unitNumber
      status
      role
      vmsTag
      image {
        id
        original
        scaled
        thumbnail
      }
      documents {
        id
        name
        status
        file {
          id
          original
          scaled
        }
      }
    }
  }
`;

export const GetStakeholderComponent = (
  props: Omit<Omit<ReactApollo.QueryProps<GetStakeholderQuery, GetStakeholderQueryVariables>, 'query'>, 'variables'> & {
    variables: GetStakeholderQueryVariables;
  }
) => <ReactApollo.Query<GetStakeholderQuery, GetStakeholderQueryVariables> query={GetStakeholderDocument} {...props} />;

export type GetStakeholderProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<GetStakeholderQuery, GetStakeholderQueryVariables>
> &
  TChildProps;
export function withGetStakeholder<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    GetStakeholderQuery,
    GetStakeholderQueryVariables,
    GetStakeholderProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<
    TProps,
    GetStakeholderQuery,
    GetStakeholderQueryVariables,
    GetStakeholderProps<TChildProps>
  >(GetStakeholderDocument, {
    alias: 'withGetStakeholder',
    ...operationOptions,
  });
}
export const GetStakeholderDocumentsDocument = gql`
  query GetStakeholderDocuments($id: String!, $billing: Boolean, $searchTerm: String, $filterTerm: DocumentStatus) {
    documents(
      orderBy: updatedAt_DESC
      where: { stakeholder: { id: $id }, billing: $billing, name_contains: $searchTerm, status: $filterTerm }
    ) {
      id
      createdAt
      updatedAt
      name
      billing
      status
      file {
        id
        original
      }
    }
  }
`;

export const GetStakeholderDocumentsComponent = (
  props: Omit<
    Omit<ReactApollo.QueryProps<GetStakeholderDocumentsQuery, GetStakeholderDocumentsQueryVariables>, 'query'>,
    'variables'
  > & { variables: GetStakeholderDocumentsQueryVariables }
) => (
  <ReactApollo.Query<GetStakeholderDocumentsQuery, GetStakeholderDocumentsQueryVariables>
    query={GetStakeholderDocumentsDocument}
    {...props}
  />
);

export type GetStakeholderDocumentsProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<GetStakeholderDocumentsQuery, GetStakeholderDocumentsQueryVariables>
> &
  TChildProps;
export function withGetStakeholderDocuments<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    GetStakeholderDocumentsQuery,
    GetStakeholderDocumentsQueryVariables,
    GetStakeholderDocumentsProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<
    TProps,
    GetStakeholderDocumentsQuery,
    GetStakeholderDocumentsQueryVariables,
    GetStakeholderDocumentsProps<TChildProps>
  >(GetStakeholderDocumentsDocument, {
    alias: 'withGetStakeholderDocuments',
    ...operationOptions,
  });
}
export const GetUserDocument = gql`
  query GetUser($id: ID!) {
    user(id: $id) {
      createdAt
      id
      updatedAt
      firstName
      authCode
      image {
        original
        scaled
        thumbnail
        id
      }
      lastName
      email
      password
      status
      role
    }
  }
`;

export const GetUserComponent = (
  props: Omit<Omit<ReactApollo.QueryProps<GetUserQuery, GetUserQueryVariables>, 'query'>, 'variables'> & {
    variables: GetUserQueryVariables;
  }
) => <ReactApollo.Query<GetUserQuery, GetUserQueryVariables> query={GetUserDocument} {...props} />;

export type GetUserProps<TChildProps = {}> = Partial<ReactApollo.DataProps<GetUserQuery, GetUserQueryVariables>> &
  TChildProps;
export function withGetUser<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<TProps, GetUserQuery, GetUserQueryVariables, GetUserProps<TChildProps>>
) {
  return ReactApollo.withQuery<TProps, GetUserQuery, GetUserQueryVariables, GetUserProps<TChildProps>>(
    GetUserDocument,
    {
      alias: 'withGetUser',
      ...operationOptions,
    }
  );
}
export const SearchPropertiesDocument = gql`
  query searchProperties($text: String) {
    properties(
      where: {
        OR: [
          { address_contains: $text }
          { code_contains: $text }
          { erfNumber_contains: $text }
          { suburb_contains: $text }
        ]
      }
    ) {
      createdAt
      address
      id
      erfNumber
      suburb
      code
    }
  }
`;

export const SearchPropertiesComponent = (
  props: Omit<
    Omit<ReactApollo.QueryProps<SearchPropertiesQuery, SearchPropertiesQueryVariables>, 'query'>,
    'variables'
  > & { variables?: SearchPropertiesQueryVariables }
) => (
  <ReactApollo.Query<SearchPropertiesQuery, SearchPropertiesQueryVariables>
    query={SearchPropertiesDocument}
    {...props}
  />
);

export type SearchPropertiesProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<SearchPropertiesQuery, SearchPropertiesQueryVariables>
> &
  TChildProps;
export function withSearchProperties<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    SearchPropertiesQuery,
    SearchPropertiesQueryVariables,
    SearchPropertiesProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<
    TProps,
    SearchPropertiesQuery,
    SearchPropertiesQueryVariables,
    SearchPropertiesProps<TChildProps>
  >(SearchPropertiesDocument, {
    alias: 'withSearchProperties',
    ...operationOptions,
  });
}
export const SearchStakeholdersDocument = gql`
  query searchStakeholders($text: String!) {
    stakeholders(
      where: {
        OR: [
          { firstName_contains: $text }
          { lastName_contains: $text }
          { email_contains: $text }
          { idNumber_contains: $text }
          { postalAddress_contains: $text }
          { residentialAddress_contains: $text }
          { cellNumber_contains: $text }
        ]
      }
    ) {
      id
      firstName
      lastName
      homeNumber
      cellNumber
      email
      idNumber
      residentialAddress
      postalAddress
      role
    }
  }
`;

export const SearchStakeholdersComponent = (
  props: Omit<
    Omit<ReactApollo.QueryProps<SearchStakeholdersQuery, SearchStakeholdersQueryVariables>, 'query'>,
    'variables'
  > & { variables: SearchStakeholdersQueryVariables }
) => (
  <ReactApollo.Query<SearchStakeholdersQuery, SearchStakeholdersQueryVariables>
    query={SearchStakeholdersDocument}
    {...props}
  />
);

export type SearchStakeholdersProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<SearchStakeholdersQuery, SearchStakeholdersQueryVariables>
> &
  TChildProps;
export function withSearchStakeholders<TProps, TChildProps = {}>(
  operationOptions?: ReactApollo.OperationOption<
    TProps,
    SearchStakeholdersQuery,
    SearchStakeholdersQueryVariables,
    SearchStakeholdersProps<TChildProps>
  >
) {
  return ReactApollo.withQuery<
    TProps,
    SearchStakeholdersQuery,
    SearchStakeholdersQueryVariables,
    SearchStakeholdersProps<TChildProps>
  >(SearchStakeholdersDocument, {
    alias: 'withSearchStakeholders',
    ...operationOptions,
  });
}



// WEBPACK FOOTER //
// ./src/generated/graphql.tsx